/*! Copyright (c) 2016 madai */
var madai = madai || {}; madai["web"] = madai["web"] || {}; madai["web"]["product"] = madai["web"]["product"] || {}; madai["web"]["product"]["App"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	//import from '../../form/reducer';
	
	var _dialog = __webpack_require__(2);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(5);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _lodashObjectMerge = __webpack_require__(7);
	
	var _lodashObjectMerge2 = _interopRequireDefault(_lodashObjectMerge);
	
	var _micromd = __webpack_require__(40);
	
	var _micromd2 = _interopRequireDefault(_micromd);
	
	var _domainUUID = __webpack_require__(44);
	
	var _domainUUID2 = _interopRequireDefault(_domainUUID);
	
	var _domainToUrl = __webpack_require__(45);
	
	var _domainToUrl2 = _interopRequireDefault(_domainToUrl);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainBuildHeightNotifier = __webpack_require__(50);
	
	var _domainBuildHeightNotifier2 = _interopRequireDefault(_domainBuildHeightNotifier);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainLattice = __webpack_require__(171);
	
	var _domainLattice2 = _interopRequireDefault(_domainLattice);
	
	var _domainBehaviour = __webpack_require__(231);
	
	var _domainBehaviour2 = _interopRequireDefault(_domainBehaviour);
	
	var _domainTripGoal = __webpack_require__(239);
	
	var _domainTripGoal2 = _interopRequireDefault(_domainTripGoal);
	
	var _domainAuthorization = __webpack_require__(164);
	
	var _domainAuthorization2 = _interopRequireDefault(_domainAuthorization);
	
	var _domainBehaviour_Response = __webpack_require__(240);
	
	var _domainBehaviour_Response2 = _interopRequireDefault(_domainBehaviour_Response);
	
	var _domainBehaviour_Needed = __webpack_require__(241);
	
	var _domainBehaviour_Needed2 = _interopRequireDefault(_domainBehaviour_Needed);
	
	var _domainBehaviour_Ok = __webpack_require__(242);
	
	var _domainBehaviour_Ok2 = _interopRequireDefault(_domainBehaviour_Ok);
	
	var _domainBehaviour_Ko = __webpack_require__(243);
	
	var _domainBehaviour_Ko2 = _interopRequireDefault(_domainBehaviour_Ko);
	
	var _domainCaptcha = __webpack_require__(244);
	
	var _domainCaptcha2 = _interopRequireDefault(_domainCaptcha);
	
	var _domainReducer = __webpack_require__(172);
	
	var _domainReducer2 = _interopRequireDefault(_domainReducer);
	
	var _domainAnonymous = __webpack_require__(78);
	
	var _domainAnonymous2 = _interopRequireDefault(_domainAnonymous);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainVerified = __webpack_require__(111);
	
	var _domainVerified2 = _interopRequireDefault(_domainVerified);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainLoad_districts = __webpack_require__(245);
	
	var _domainLoad_districts2 = _interopRequireDefault(_domainLoad_districts);
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainTarget = __webpack_require__(248);
	
	var _domainTarget2 = _interopRequireDefault(_domainTarget);
	
	var _domainSocial_target = __webpack_require__(250);
	
	var _domainSocial_target2 = _interopRequireDefault(_domainSocial_target);
	
	var _domainSetPurlCookies = __webpack_require__(251);
	
	var _domainSetPurlCookies2 = _interopRequireDefault(_domainSetPurlCookies);
	
	var _domainSetSessionIdCookies = __webpack_require__(253);
	
	var _domainSetSessionIdCookies2 = _interopRequireDefault(_domainSetSessionIdCookies);
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _domainCancel_target = __webpack_require__(263);
	
	var _domainCancel_target2 = _interopRequireDefault(_domainCancel_target);
	
	var _domainSharePurchase = __webpack_require__(264);
	
	var _domainSharePurchase2 = _interopRequireDefault(_domainSharePurchase);
	
	var _domainOrder = __webpack_require__(266);
	
	var _domainOrder2 = _interopRequireDefault(_domainOrder);
	
	var _domainDatetime = __webpack_require__(61);
	
	var _domainDatetime2 = _interopRequireDefault(_domainDatetime);
	
	var _domainAttach_server = __webpack_require__(270);
	
	var _domainAttach_server2 = _interopRequireDefault(_domainAttach_server);
	
	var _domainServer = __webpack_require__(281);
	
	var _domainServer2 = _interopRequireDefault(_domainServer);
	
	var _domainGoogle_analytics = __webpack_require__(285);
	
	var _domainGoogle_analytics2 = _interopRequireDefault(_domainGoogle_analytics);
	
	var _domainIsModal = __webpack_require__(51);
	
	var _domainIsModal2 = _interopRequireDefault(_domainIsModal);
	
	var _utilSetBackground = __webpack_require__(286);
	
	var _utilSetBackground2 = _interopRequireDefault(_utilSetBackground);
	
	var _utilDoShare = __webpack_require__(287);
	
	var _utilDoShare2 = _interopRequireDefault(_utilDoShare);
	
	var _createCallback = __webpack_require__(288);
	
	var _createCallback2 = _interopRequireDefault(_createCallback);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _componentsConsoleMessage = __webpack_require__(289);
	
	var _componentsConsoleMessage2 = _interopRequireDefault(_componentsConsoleMessage);
	
	var _componentsMessage = __webpack_require__(290);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsShare = __webpack_require__(291);
	
	var _componentsShare2 = _interopRequireDefault(_componentsShare);
	
	var _componentsAlert = __webpack_require__(233);
	
	var _componentsAlert2 = _interopRequireDefault(_componentsAlert);
	
	var _componentsConfirm = __webpack_require__(232);
	
	var _componentsConfirm2 = _interopRequireDefault(_componentsConfirm);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _componentsHTMLComponent = __webpack_require__(167);
	
	var _componentsHTMLComponent2 = _interopRequireDefault(_componentsHTMLComponent);
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _routeProduct = __webpack_require__(292);
	
	var _routeProduct2 = _interopRequireDefault(_routeProduct);
	
	var _routeWidgetProduct = __webpack_require__(329);
	
	var _routeWidgetProduct2 = _interopRequireDefault(_routeWidgetProduct);
	
	var _routeRegister = __webpack_require__(333);
	
	var _routeRegister2 = _interopRequireDefault(_routeRegister);
	
	var _routeLogin = __webpack_require__(338);
	
	var _routeLogin2 = _interopRequireDefault(_routeLogin);
	
	var _routeRcsPrivacy = __webpack_require__(341);
	
	var _routeRcsPrivacy2 = _interopRequireDefault(_routeRcsPrivacy);
	
	var _routeChangePassword = __webpack_require__(344);
	
	var _routeChangePassword2 = _interopRequireDefault(_routeChangePassword);
	
	var _routePurchases = __webpack_require__(347);
	
	var _routePurchases2 = _interopRequireDefault(_routePurchases);
	
	var _routeAccount = __webpack_require__(359);
	
	var _routeAccount2 = _interopRequireDefault(_routeAccount);
	
	var _routeResendPassword = __webpack_require__(362);
	
	var _routeResendPassword2 = _interopRequireDefault(_routeResendPassword);
	
	var _routeNoCookies = __webpack_require__(365);
	
	var _routeNoCookies2 = _interopRequireDefault(_routeNoCookies);
	
	var _routeRequestPin = __webpack_require__(367);
	
	var _routeRequestPin2 = _interopRequireDefault(_routeRequestPin);
	
	var _routeInsertPin = __webpack_require__(368);
	
	var _routeInsertPin2 = _interopRequireDefault(_routeInsertPin);
	
	var _routeVerify = __webpack_require__(369);
	
	var _routeVerify2 = _interopRequireDefault(_routeVerify);
	
	var _routeProductNotAvailable = __webpack_require__(370);
	
	var _routeProductNotAvailable2 = _interopRequireDefault(_routeProductNotAvailable);
	
	var _routeItemSold = __webpack_require__(371);
	
	var _routeItemSold2 = _interopRequireDefault(_routeItemSold);
	
	var _routeWidgetItemSold = __webpack_require__(372);
	
	var _routeWidgetItemSold2 = _interopRequireDefault(_routeWidgetItemSold);
	
	var _routeChangeLattice = __webpack_require__(373);
	
	var _routeChangeLattice2 = _interopRequireDefault(_routeChangeLattice);
	
	var _routeApproveOrderError = __webpack_require__(374);
	
	var _routeApproveOrderError2 = _interopRequireDefault(_routeApproveOrderError);
	
	var _routePurchase = __webpack_require__(375);
	
	var _routePurchase2 = _interopRequireDefault(_routePurchase);
	
	var _routeBuildOrder = __webpack_require__(382);
	
	var _routeBuildOrder2 = _interopRequireDefault(_routeBuildOrder);
	
	var _routeReducer = __webpack_require__(392);
	
	var _routeReducer2 = _interopRequireDefault(_routeReducer);
	
	var _routeWidgetReducer = __webpack_require__(393);
	
	var _routeWidgetReducer2 = _interopRequireDefault(_routeWidgetReducer);
	
	var _routeApproveOrder = __webpack_require__(394);
	
	var _routeApproveOrder2 = _interopRequireDefault(_routeApproveOrder);
	
	var _routeCaptcha = __webpack_require__(396);
	
	var _routeCaptcha2 = _interopRequireDefault(_routeCaptcha);
	
	var _routeWidgetCaptcha = __webpack_require__(397);
	
	var _routeWidgetCaptcha2 = _interopRequireDefault(_routeWidgetCaptcha);
	
	var _routeUnexpectedError = __webpack_require__(398);
	
	var _routeUnexpectedError2 = _interopRequireDefault(_routeUnexpectedError);
	
	var _parseQuerystring = __webpack_require__(252);
	
	var _parseQuerystring2 = _interopRequireDefault(_parseQuerystring);
	
	var _jsdkTemplate = __webpack_require__(399);
	
	var _jsdkTemplate2 = _interopRequireDefault(_jsdkTemplate);
	
	__webpack_require__(400);
	
	_tcomb2['default'].form.Form.templates = _jsdkTemplate2['default'];
	
	var Trip = _tcomb2['default'].struct({
	  goal: _domainTripGoal2['default'],
	  authorization: _domainAuthorization2['default'],
	  reducer_id: _tcomb2['default'].maybe(_domainUUID2['default']),
	  lattice_id: _tcomb2['default'].maybe(_domainUUID2['default']),
	  timestamp: _domainDatetime2['default'],
	  old_price: _tcomb2['default'].maybe(_tcomb2['default'].Number)
	}, 'Trip');
	
	Trip.LOCAL_STORAGE_KEY = "Trip";
	Trip.DURATION_MIN = 10;
	Trip.DURATION_MILLIS = Trip.DURATION_MIN * 60 * 1000;
	
	Trip.create = function (args) {
	  args = (0, _lodashObjectMerge2['default'])(args, { timestamp: new Date().getTime() });
	  var trip = new Trip(args);
	  Trip.save(trip);
	  return trip;
	};
	
	Trip.save = function (trip) {
	  sessionStorage.setItem(Trip.LOCAL_STORAGE_KEY, JSON.stringify(trip));
	};
	
	Trip.remove = function () {
	  sessionStorage.removeItem(Trip.LOCAL_STORAGE_KEY);
	};
	
	Trip.get = function () {
	  var objTrip = sessionStorage.getItem(Trip.LOCAL_STORAGE_KEY);
	  if (objTrip) {
	    var trip = new Trip(JSON.parse(objTrip));
	    if (trip.isValid()) {
	      return trip;
	    } else {
	      Trip.remove();
	      return null;
	    }
	  }
	  return null;
	};
	
	Trip.prototype.isValid = function () {
	  var now = new Date().getTime();
	  return now < this.timestamp + Trip.DURATION_MILLIS;
	};
	
	Trip.prototype.next = function (user, locale) {
	  switch (this.goal) {
	    case 'BuildOrderRoute':
	      if (_domainAnonymous2['default'].is(user)) {
	        return new RegisterRoute((0, _domainGet_bundle2['default'])(locale).landing.before_buy);
	      } else if (_domainRegistered2['default'].is(user) && this.authorization === 'verified') {
	        return new RequestPinRoute();
	      }
	      return new BuildOrderRoute();
	    case 'ReducerRoute':
	      if (_domainAnonymous2['default'].is(user) && this.authorization !== 'anonymous') {
	        return new RegisterRoute((0, _domainGet_bundle2['default'])(locale).landing.before_reduce);
	      } else if (_domainRegistered2['default'].is(user) && this.authorization === 'verified') {
	        return new RequestPinRoute(null);
	      } else {
	        return new ReducerRoute(this.lattice_id, this.reducer_id, this.old_price);
	      }
	  }
	};
	
	var Widget = _jsdk2['default'].Widget;
	
	// FIXME
	_jsdk2['default'].Message.prototype.bundle = function (locale) {
	  return (0, _domainGet_bundle2['default'])(locale).template_message;
	};
	
	function getInitialRoute(err, product, user, locale, behaviour) {
	  if (err) {
	    _tcomb2['default'].assert(_tcomb2['default'].maybe(_tcomb2['default'].Str).is(err));
	    return new LoginRoute(_react2['default'].createElement(
	      _componentsAlert2['default'],
	      { type: 'error' },
	      err,
	      '>'
	    ));
	  } else {
	    if (product.is_available()) {
	      var trip = Trip.get();
	      if (trip) {
	        return trip.next(user, locale);
	      } else {
	        // SOLO PER RCS
	        if (product.locale.toJSON() === 'it_IT' && user.rcs_privacy_needed) {
	          return new RcsPrivacyRoute();
	        } else {
	          // se c'è un behavior nella bootstrap (quindi, si assume che ci sia reducer=true) navigo sul reducer
	          if (behaviour) {
	            return new ReducerRoute(behaviour.lattice_id, behaviour.reducer_id);
	          } else {
	            // se non c'è un behavior nella bootstrap navigo sulla product
	            return new ProductRoute(null, null, true);
	          }
	        }
	      }
	    } else {
	      return new ProductNotAvailableRoute();
	    }
	  }
	}
	
	var doAcceptCookies = function doAcceptCookies() {
	  _cookiesJs2['default'].set('accept_cookies', true, {
	    path: '/'
	  });
	  document.getElementById('cookies_disclaimer').style.display = 'none';
	};
	
	var on_start = function on_start() {
	  // imposta il background del body se c'è una sponsorizzazione
	
	  if (this.lattice) {
	    (0, _utilSetBackground2['default'])(this.lattice.sponsor);
	  }
	
	  // comunica con il container quando l'applicazione è ospitata in una modale
	  // e se il container supporta l'api post
	  this.height_notifier = (0, _domainBuildHeightNotifier2['default'])(this);
	  document.getElementsByTagName('body')[0].click = this.height_notifier;
	  // polling per essere sicuro che la finestra si ridimensioni se contiene
	  // delle immagini pesanti da caricare
	  setInterval(this.height_notifier, 500);
	};
	
	var App = (function (_EventEmitter) {
	  _inherits(App, _EventEmitter);
	
	  _createClass(App, [{
	    key: 'addLike',
	    value: function addLike(id) {
	      _domainReducer2['default'].add_like(id);
	    }
	  }, {
	    key: 'removeLike',
	    value: function removeLike(id) {
	      _domainReducer2['default'].remove_like(id);
	    }
	  }, {
	    key: 'addGplus',
	    value: function addGplus(id) {
	      _domainReducer2['default'].add_gplus(id);
	    }
	  }, {
	    key: 'removeGplus',
	    value: function removeGplus(id) {
	      _domainReducer2['default'].remove_gplus(id);
	    }
	  }, {
	    key: 'resolveCaptcha',
	    value: function resolveCaptcha() {
	      var route = this.route;
	      // lattice_fake aggiunto per non cambiare l'endopoint del captcha.
	      // Abbiamo aggiunto il captcha agli anomini per evitare che il bot lanciato da dos possa inserire milioni di righe nella "discount log"
	      if (route.lattice_id === 'bd69ee00-2703-11e6-bdf4-0800200c9a66') {
	        this.transact(new ProductRoute());
	      } else {
	        this.transact(new ReducerRoute(route.lattice_id, route.reducer_id));
	      }
	    }
	  }, {
	    key: 'Share_Purchase',
	    value: function Share_Purchase() {
	      return _domainSharePurchase2['default'];
	    }
	  }], [{
	    key: 'go',
	    value: function go(mountNode, options) {
	      (0, _domainSetPurlCookies2['default'])();
	      (0, _domainSetSessionIdCookies2['default'])();
	      var server = new _domainServer2['default'](options.api_url);
	      (0, _domainAttach_server2['default'])(server);
	      options.locale = _domainLocale2['default'].of(options.locale);
	      if (options.user && options.user.com_locale) {
	        options.user.com_locale = _domainLocale2['default'].of(options.user.com_locale);
	      }
	      options.user = (0, _domainUser2['default'])(options.user);
	
	      options.product = _domainProduct2['default'].of(options.product);
	      _cookiesJs2['default'].set('product_id', options.product.id, {
	        path: '/'
	      });
	      options.lattice = options.lattice ? _domainLattice2['default'].of(options.lattice) : null;
	      options.route = getInitialRoute(options.err, options.product, options.user, options.locale, options.behaviour);
	
	      // devo nascondere il link al catalogo?
	      var params = (0, _parseQuerystring2['default'])(location.search);
	      if (params.is_catalog_hidden === 'true') {
	        options.lattice_url = null;
	      }
	
	      var app = new App(mountNode, server, options);
	
	      // # monitoraggio
	      var googleAnalytics = new _domainGoogle_analytics2['default']();
	
	      function getPageview(name, args) {
	        args = args || {};
	        var lattice_id = app.lattice ? app.lattice.id : null;
	        if (app.route.name === 'reducer') {
	          lattice_id = app.route.lattice_id;
	        }
	
	        var url = (0, _domainToUrl2['default'])('product/' + name, _tcomb2['default'].mixin({
	          locale: app.locale.toJSON(),
	          lattice_id: lattice_id,
	          is_modal: (0, _domainIsModal2['default'])(),
	          is_widget: app.is_widget,
	          profile: _domainAnonymous2['default'].is(app.user) ? 'anonymous' : _domainRegistered2['default'].is(app.user) ? 'registered' : 'verified',
	          qs: location.search,
	          reducer_id: app.route.name === 'reducer' ? app.route.reducer_id : null,
	          session_id: _cookiesJs2['default'].get('session-id'),
	          now: new Date().getTime()
	        }, args, true));
	        return url;
	      }
	
	      // emitted when route changes
	      app.on('route:change', function (route) {
	        googleAnalytics.track_pageview(getPageview(route.name));
	      });
	
	      // completamento di un reducer diviso per skip e ok
	      app.on('do_reduce', function (args) {
	        var behaviour = args[0];
	        var behaviour_ok = args[1];
	        if (behaviour) {
	          googleAnalytics.track_pageview(getPageview(behaviour.value ? 'reducer_ok' : 'reducer_skip', {
	            reducer_id: behaviour.reducer_id
	          }));
	        }
	        if (behaviour_ok.lead_url) {
	          var url = behaviour_ok.lead_url + '?date=' + new Date().getTime();
	          $('<img/>').attr('src', url).css('display', 'none').appendTo('body');
	        }
	      });
	
	      // registrazione avvenuta con successo
	      app.on('do_register', function () {
	        googleAnalytics.track_pageview(getPageview('do_register'));
	      });
	
	      // acquisto di un prodotto
	      app.on('do_approve_order', function (args) {
	        var product_id = args[0];
	        // iframe per tracciare acquisto del prodotto '522f43c4-d377-434c-b70c-da06183a6f6d' di RCS - corriere versione digitale
	        // e del prodotto '69261ff0-01b0-4bac-ac98-dc70d31f2c2a' gazzetta
	        if (true) {
	          var RCS_product_ids = ['e62c7256-74dd-40f4-a1b9-a2990afccdc8'];
	          if (RCS_product_ids.indexOf(product_id) !== -1) {
	            $('<iframe src="https://launch1.co/serve?action=install&site_event_id=932902918&advertiser_id=9050" scrolling="no" frameborder="0" width="1" height="1"></iframe>').css('display', 'none').appendTo('body');
	            $('<img height="1" width="1" alt="" style="display:none" src="https://www.facebook.com/offsite_event.php?id=6014435267752&value=0.00&currency=EUR" />').appendTo('body');
	          }
	        }
	        googleAnalytics.track_pageview(getPageview('do_approve_order'));
	      });
	
	      // click sui share
	      app.on('go_share', function (args) {
	        var type = args[0];
	        googleAnalytics.track_pageview(getPageview('go_share', {
	          type: type
	        }));
	      });
	
	      // click login facebook e google
	      app.on('go_social_login', function (args) {
	        var type = args[0];
	        googleAnalytics.track_pageview(getPageview('go_social_login', {
	          type: type
	        }));
	      });
	
	      // verifica avvenuta con successo
	      app.on('do_verify', function () {
	        googleAnalytics.track_pageview(getPageview('do_verify'));
	      });
	
	      // messaggio good fellow
	      // messaggio min price
	      // messaggio sold out
	      // messaggio expired
	      // messaggi del registered
	      app.on('message', function (args) {
	        var type = args[0];
	        googleAnalytics.track_pageview(getPageview('message', {
	          type: type
	        }));
	      });
	
	      app.on('do_share_purchase', function (type) {
	        googleAnalytics.track_pageview(getPageview('do_share_purchase', {
	          type: type
	        }));
	      });
	
	      app.transact(options.route);
	
	      on_start.bind(app)();
	
	      return app;
	    }
	  }]);
	
	  function App(mountNode, server, options) {
	    _classCallCheck(this, App);
	
	    _get(Object.getPrototypeOf(App.prototype), 'constructor', this).call(this);
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.api_url));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.lib_url));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.social_url));
	    _tcomb2['default'].assert(_tcomb2['default'].maybe(_tcomb2['default'].Str).is(options.lattice_url));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.like_url));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.gplus_url));
	    _tcomb2['default'].assert(_domainLocale2['default'].is(options.locale));
	    _tcomb2['default'].assert(_domainUser2['default'].is(options.user));
	    _tcomb2['default'].assert(_tcomb2['default'].Obj.is(options.route));
	    _tcomb2['default'].assert(_domainProduct2['default'].is(options.product));
	    _tcomb2['default'].assert(_tcomb2['default'].maybe(_domainLattice2['default']).is(options.lattice));
	    _tcomb2['default'].assert(_tcomb2['default'].Bool.is(options.is_corp));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.share_purchase_url));
	    _tcomb2['default'].assert(_tcomb2['default'].maybe(_tcomb2['default'].Str).is(options.lattices_url));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.captcha_url));
	    _tcomb2['default'].assert(_tcomb2['default'].Bool.is(options.is_widget));
	
	    //cache dei reticoli
	    options.lattices = {};
	
	    _jsdk2['default'].mixin(this, options);
	    this.mountNode = mountNode;
	    this.server = server;
	    this.height_notifier = (0, _domainBuildHeightNotifier2['default'])(this);
	  }
	
	  // perchè ciotta non vuole fare un controllo tra stringhe, facendo cosi, si crea un enum "YES", "NO", "".
	
	  _createClass(App, [{
	    key: 'stop',
	    value: function stop() {
	      if (this.widget instanceof Widget) {
	        this.widget.stop();
	        this.widget = null;
	      } else {
	        _reactDom2['default'].unmountComponentAtNode(this.mountNode);
	      }
	    }
	  }, {
	    key: 'scroll',
	    value: function scroll(route) {
	      var _this = this;
	
	      var isProductRouteAfterReducerRoute = function isProductRouteAfterReducerRoute() {
	        return route.name === 'product' && route.old_price !== undefined && !_this.is_widget;
	      };
	
	      if (isProductRouteAfterReducerRoute()) {
	        this.scrollToConsoleTop();
	      } else {
	        this.scrollToTop();
	      }
	    }
	  }, {
	    key: 'scrollToConsoleTop',
	    value: function scrollToConsoleTop() {
	      window.scrollTo(0, $('#console').offset().top - 10);
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'transact',
	    value: function transact(route) {
	      var _this2 = this;
	
	      this.stop();
	      this.route = route;
	      route.to_widget(this, function (widget) {
	        if (_react2['default'].isValidElement(widget)) {
	          _this2.mountNode = document.getElementById('app');
	          _reactDom2['default'].render(widget, _this2.mountNode);
	        } else {
	          _this2.mountNode.innerHTML = widget.to_html();
	          widget.start();
	          _this2.widget = widget;
	        }
	        _this2.emit('route:change', route);
	        _this2.height_notifier();
	        _this2.scroll(route);
	      });
	    }
	  }, {
	    key: 'go_unexpected_err',
	    value: function go_unexpected_err(err) {
	      this.transact(new UnexpectedErrorRoute(err));
	    }
	  }, {
	    key: 'getThemeBtnColor',
	    value: function getThemeBtnColor() {
	      return this.lattice ? this.lattice.theme_btn_color : null;
	    }
	  }, {
	    key: 'getThemeBgColor',
	    value: function getThemeBgColor() {
	      return this.lattice ? this.lattice.theme_bg_color : null;
	    }
	  }, {
	    key: 'getThemeBtnFontColor',
	    value: function getThemeBtnFontColor() {
	      return this.lattice ? this.lattice.theme_btn_font_color : null;
	    }
	  }, {
	    key: 'getThemeBgFontColor',
	    value: function getThemeBgFontColor() {
	      return this.lattice ? this.lattice.theme_bg_font_color : null;
	    }
	  }, {
	    key: 'getBgSponsorColor',
	    value: function getBgSponsorColor() {
	      if (this.lattice && this.lattice.sponsor && this.lattice.sponsor.bg_color) {
	        return this.lattice.sponsor.bg_color;
	      } else {
	        return this.getThemeBtnColor();
	      }
	    }
	
	    // Siccome i reticoli possono essere piuttosto corposi, implemento una
	    // cache dei reticoli per id e locale in modo che una volta caricati
	    // non siano richiesti una seconda volta via HTTP
	
	  }, {
	    key: 'load_lattice',
	    value: function load_lattice(lattice_id, callback) {
	      _tcomb2['default'].assert(_domainUUID2['default'].is(lattice_id));
	      _tcomb2['default'].assert(_tcomb2['default'].Func.is(callback));
	      var app = this;
	      if (app.lattices[lattice_id]) {
	        callback(app.lattices[lattice_id]);
	      } else {
	        var errorHandler = function errorHandler(err) {
	          app.go_unexpected_err(err);
	        };
	        var successHandler = function successHandler(lattice) {
	          app.lattices[lattice.id] = lattice;
	          callback(lattice);
	        };
	        _domainLattice2['default'].load(lattice_id, (0, _createCallback2['default'])(successHandler, errorHandler));
	      }
	    }
	  }, {
	    key: 'reduce',
	
	    // Questo è il singolo punto in cui il flusso passa quando si attua una
	    // riduzione. Viene chiamato sia sul check, nel qual caso behaviour sarà
	    // null, sia quando il consumer completa un reducer.
	    // Il Server può rispondere in modo positivo, nel qual caso manderà un
	    // aggiornamento del runtime del prodotto corrente, oppure con la richiesta
	    // di completare un certo reducer di un certo reticolo
	    value: function reduce(behaviour, _old_price) {
	      _tcomb2['default'].assert(_tcomb2['default'].maybe(_domainBehaviour2['default']).is(behaviour));
	      var app = this;
	      var locale = app.locale;
	      //const old_price = app.product.runtime.price;
	      var errorHandler = function errorHandler(err) {
	        if (err) {
	          switch (err.name) {
	            case 'access denied':
	              app.go_expired_session(locale);
	              break;
	            case 'invalid feedback':
	              var error_message = locale.language_bundle().validation.any;
	              $('#' + err.response_error.feedback_id + '_error').html(error_message);
	              //$('#' + err.response_error.component_id).focus();
	              break;
	            default:
	              app.go_unexpected_err(err);
	          }
	        }
	      };
	      var successHandler = function successHandler(res) {
	        _tcomb2['default'].assert(_domainBehaviour_Response2['default'].is(res));
	
	        if (_domainBehaviour_Needed2['default'].is(res)) {
	          (function () {
	
	            //
	            // il server vuole un nuovo reducer per poter ridurre!
	            //
	            // nel caso questo reducer appartenga ad un reticolo
	            // diverso da quello corrente passo dalla change_lattice
	            // (questa riga non ha piu senso nella versione open) ma solo se l'utente non è un Registered in modo da non frammentargli l'esperienza utente
	
	            // se il reducer_id è un reticolo che ha una componente con una email mappata e se l'utente è registered, devo fare una redirect sulla RegisterRoute
	
	            var lattice_id = res.lattice_id;
	            var reducer_id = res.reducer_id;
	
	            var do_show_change_lattice = app.lattice && app.lattice.id !== lattice_id &&
	            //!Registered.is(app.user) &&  commentato per la nuova versione
	            !app.is_corp;
	
	            if (do_show_change_lattice) {
	              app.transact(new ChangeLatticeRoute(lattice_id, reducer_id));
	              app.lattice = null;
	              (0, _utilSetBackground2['default'])(null);
	            } else {
	              //app.transact(new ReducerRoute(lattice_id, reducer_id));
	              app.load_lattice(lattice_id, function (lattice) {
	                _tcomb2['default'].assert(_domainLattice2['default'].is(lattice));
	                var reducer = _jsdk2['default'].find(lattice.reducers, reducer_id);
	
	                var route = Trip.create({
	                  goal: "ReducerRoute",
	                  authorization: reducer.authorization,
	                  reducer_id: reducer_id,
	                  lattice_id: lattice_id,
	                  old_price: _old_price
	                }).next(app.user, locale);
	
	                app.transact(route);
	              });
	            }
	          })();
	        } else if (_domainBehaviour_Ok2['default'].is(res)) {
	          (function () {
	            //
	            // riduzione avvenuta con successo !
	            //
	            //
	            // per tutte le tipologia di utenti: controllo che non ci sia stata una item sold
	            // guardando se i deal sono cambiati e nel caso lo mando sull'apposita interfaccia
	            // ma non se il prodotto è andato in sold out
	            //
	            // in ogni caso rinnovo il prodotto con il nuovo runtime
	
	            app.emit('do_reduce', [behaviour, res]);
	            var old_price = app.product.runtime.price;
	            var product = app.product.replace_runtime(res.runtime);
	            var state = null;
	
	            // c'è stata una item sold se non c'erano deals e adesso ci sono
	            // oppure se l'ultimo deal ha come delta un intero minore
	            var prev_len = app.product.runtime.lasts.length;
	            var is_item_sold = prev_len === 0 && product.runtime.lasts.length > 0 || prev_len > 0 && app.product.runtime.lasts[0].tick < product.runtime.lasts[0].tick;
	            var is_sold_out = product.runtime.is_sold_out;
	
	            if (is_item_sold && !is_sold_out) {
	              state = new ItemSoldRoute();
	            } else {
	              var msg = null;
	              if (res.is_good_fellow) {
	                if (app.lattices_url) {
	                  var tmp = (0, _micromd2['default'])((0, _domainGet_bundle2['default'])(app.locale)['template_message']['product.goodfellow_more_lattices']);
	                  var _msg = _jsdk2['default'].template(tmp, _jsdk2['default'].template.mustache)({
	                    go_lattices: "<button  id=\"go_more_lattices\" onclick='location.href=\"" + app.lattices_url + "\"' style=\"background-color:" + app.getThemeBtnColor() + "\" \">" + (0, _domainGet_bundle2['default'])(locale).navigation.go_lattices + "</button>"
	                  });
	                  msg = _react2['default'].createElement(
	                    _componentsConsoleMessage2['default'],
	                    null,
	                    _react2['default'].createElement(
	                      _componentsHTMLComponent2['default'],
	                      null,
	                      _msg
	                    )
	                  );
	                  app.emit('message', ['good_fellow_more_lattices']);
	                  state = new ProductRoute(msg, old_price);
	                } else {
	                  var getGoodFellowMessage = function getGoodFellowMessage() {
	                    if (app.is_widget) {
	                      return (0, _domainGet_bundle2['default'])(app.locale)['template_message']['product.goodfellow.short'];
	                    }
	                    return (0, _domainGet_bundle2['default'])(app.locale)['template_message']['product.goodfellow'];
	                  };
	
	                  var getShare = function getShare() {
	                    if (app.is_widget) {
	                      return null;
	                    }
	                    return _react2['default'].createElement(
	                      'div',
	                      { id: 'share_offer' },
	                      _react2['default'].createElement(_componentsShare2['default'], { doShowShare: true, doShare: (0, _utilDoShare2['default'])(app) })
	                    );
	                  };
	
	                  msg = _react2['default'].createElement(
	                    _componentsConsoleMessage2['default'],
	                    null,
	                    _react2['default'].createElement(
	                      _componentsMarkdownComponent2['default'],
	                      null,
	                      getGoodFellowMessage()
	                    ),
	                    getShare()
	                  );
	                  app.emit('message', ['good_fellow']);
	                  state = new ProductRoute(msg, old_price);
	                }
	              }
	
	              //app.reduce(null);
	
	              //state = new ProductRoute(msg, old_price);
	              //state = new ReducerRoute(res.lattice_id, res.reducer_id);
	            }
	
	            app.product = product;
	            if (state) {
	              app.transact(state);
	            } else if (!app.is_widget) {
	              var btnReducer = document.getElementById('do_reduce');
	              btnReducer.disabled = true;
	              //app.transact(new ReducerRoute(app.route.lattice_id, app.route.reducer_id));
	              setTimeout(function () {
	                app.reduce(null, old_price);
	              }, 1000);
	            } else {
	              app.transact(new ProductRoute(null, old_price));
	            }
	          })();
	        } else if (_domainBehaviour_Ko2['default'].is(res)) {
	          // reducer ko
	          // fix per impedire l'ulitizzo di campagne diverse su più tab
	          // commentata la riga sottostanta in data 31 maggio per evitare l'errore in console
	          // modalRequire.Alert.go(locale, 500, micromd(get_bundle(locale).template_message.reducer_ko));
	        } else if (_domainCaptcha2['default'].is(res)) {
	            // Captcha
	            app.transact(new CaptchaRoute(res.lattice_id, res.reducer_id));
	          }
	      };
	      var _callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	
	      _domainReducer2['default'].do_reduce(app.product.id, behaviour, _callback, {
	        product_id: app.product.id,
	        behaviour: JSON.stringify(behaviour)
	      });
	    }
	  }, {
	    key: 'go_expired_session',
	
	    // da chiamare quando si riceve una access denied da una chiamata alle api sotto autenticazione
	    value: function go_expired_session(locale) {
	      this.user = (0, _domainUser2['default'])({
	        profile: 'anonymous'
	      });
	      var bundle = (0, _domainGet_bundle2['default'])(locale).template_message;
	      this.transact(new LoginRoute(_react2['default'].createElement(
	        _componentsAlert2['default'],
	        { type: 'error' },
	        bundle['expired_session']
	      )));
	    }
	  }, {
	    key: 'sponsor',
	    value: function sponsor() {
	      var app = this;
	      return app.lattice ? app.lattice.sponsor : null;
	    }
	  }, {
	    key: 'widget',
	    value: function widget() {
	      var app = this;
	      return app.lattice ? app.lattice.widget : null;
	    }
	  }, {
	    key: 'partners',
	    value: function partners() {
	      var app = this;
	      return app.lattice ? app.lattice.partners : null;
	    }
	  }, {
	    key: 'getMiniSiteURL',
	    value: function getMiniSiteURL() {
	      var location = window.location;
	      var PRODUCT_URL = location.pathname;
	      var params = (0, _parseQuerystring2['default'])(location.search);
	      var newParams = {};
	      if (params.lattice) {
	        newParams['lattice'] = params.lattice;
	      }
	      if (params.utm_campaign) {
	        newParams['utm_campaign'] = params.utm_campaign;
	      }
	      if (params.utm_medium) {
	        newParams['utm_medium'] = params.utm_medium + '_widget_exit';
	      }
	      if (params.utm_source) {
	        newParams['utm_source'] = params.utm_source;
	      }
	      return location.origin + (0, _domainToUrl2['default'])(PRODUCT_URL, newParams);
	    }
	  }, {
	    key: 'openMiniSite',
	    value: function openMiniSite() {
	      window.open(this.getMiniSiteURL());
	    }
	  }]);
	
	  return App;
	})(_events.EventEmitter);
	
	exports['default'] = App;
	
	function adapt_privacy_value(value) {
	  _tcomb2['default'].assert(_tcomb2['default'].maybe(_tcomb2['default'].Str).is(value));
	  var tmp = {
	    "true": "YES",
	    "false": "NO"
	  };
	  return tmp[value] ? tmp[value] : '';
	}
	
	// - account non esistente: invio email pwd
	// - account attivo: invio email warning
	// - account cancellato: invio email support
	// - email non formalmente valida: errore su login
	
	function do_register(app) {
	  return function (email, privacy_rcs, privacy_other, privacy_tracking) {
	    var errorHandler = function errorHandler(err) {
	      if (err) {
	        switch (err.name) {
	          case 'invalid emailAddress':
	            var msg = (0, _lodashStringTemplate2['default'])((0, _domainGet_bundle2['default'])(app.locale)['template_message']['invalid emailAddress'])({
	              email: email
	            });
	            app.transact(new LoginRoute(_react2['default'].createElement(
	              _componentsAlert2['default'],
	              { type: 'error' },
	              msg
	            )));
	            break;
	          default:
	            app.go_unexpected_err(err);
	        }
	      }
	    };
	    var successHandler = function successHandler() {
	      app.emit('do_register');
	      var msg = (0, _lodashStringTemplate2['default'])((0, _domainGet_bundle2['default'])(app.locale)['template_message']['register.done'])({
	        email: email
	      });
	      app.transact(new LoginRoute(_react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: app.getThemeBgColor(), fontColor: app.getThemeBgFontColor() },
	        _react2['default'].createElement(
	          _componentsMarkdownComponent2['default'],
	          null,
	          msg
	        )
	      )));
	    };
	    var callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	    app.user.do_register(email, app.locale, adapt_privacy_value(privacy_rcs), adapt_privacy_value(privacy_other), adapt_privacy_value(privacy_tracking), callback);
	  };
	}
	
	var goChangePassword = function goChangePassword(app) {
	  return function () {
	    app.transact(new ChangePasswordRoute());
	  };
	};
	
	var doLogout = function doLogout(app) {
	  var errorHandler = function errorHandler(err) {
	    if (err) {
	      app.go_unexpected_err(err);
	    }
	  };
	  var successHandler = function successHandler(user) {
	    app.user = user;
	    app.transact(new RegisterRoute());
	  };
	  return function () {
	    app.user.do_logout((0, _createCallback2['default'])(successHandler, errorHandler));
	  };
	};
	
	var goPurchases = function goPurchases(app) {
	  return function () {
	    app.transact(new PurchasesRoute());
	  };
	};
	
	var goAccount = function goAccount(app) {
	  return function () {
	    (0, _domainLoad_districts2['default'])(app.lib_url, app.user.country, function () {
	      app.transact(new AccountRoute());
	    });
	  };
	};
	
	var goCatalog = function goCatalog(app) {
	  var qs = (0, _parseQuerystring2['default'])(location.search);
	  if (qs.is_catalog_hidden /* messo eventualmente dalla modale */) {
	      return null;
	    } else if (app.lattice_url) {
	    return function () {
	      if (_cookiesJs2['default'].get("product_id")) {
	        _cookiesJs2['default'].expire('product_id');
	      }
	      location.href = app.lattice_url;
	    };
	  } else if (app.lattice && !!app.lattice.is_white_label) {
	    return null;
	  } else {
	    return function () {
	      location.href = (0, _domainGetMadaiURL2['default'])(); //+ app.locale.country.toLowerCase();
	    };
	  }
	};
	
	var goLattices = function goLattices(app) {
	  if (!app.lattices_url) {
	    return null;
	  } else {
	    return function () {
	      location.href = app.lattices_url;
	    };
	  }
	};
	
	var goProduct = function goProduct(app) {
	  return function () {
	    app.transact(new ProductRoute());
	  };
	};
	
	function go_facebook(app) {
	  var errorHandler = function errorHandler(err) {
	    if (err) {
	      app.go_unexpected_err(err);
	    }
	  };
	  var successHandler = function successHandler(url) {
	    app.emit('go_social_login', ['facebook']);
	    window.top.location.href = url;
	  };
	  var callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	  return function () {
	    app.user.load_facebook((0, _domainSocial_target2['default'])(app), app.locale, callback);
	  };
	}
	
	function go_google(app) {
	  var errorHandler = function errorHandler(err) {
	    if (err) {
	      app.go_unexpected_err(err);
	    }
	  };
	  var successHandler = function successHandler(url) {
	    app.emit('go_social_login', ['google']);
	    window.top.location.href = url;
	  };
	  var callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	  return function () {
	    app.user.load_google((0, _domainSocial_target2['default'])(app), app.locale, callback);
	  };
	}
	
	function go_microsoft(app) {
	  var errorHandler = function errorHandler(err) {
	    if (err) {
	      app.go_unexpected_err(err);
	    }
	  };
	  var successHandler = function successHandler(url) {
	    app.emit('go_social_login', ['microsoft']);
	    window.top.location.href = url;
	  };
	  var callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	  return function () {
	    app.user.load_microsoft((0, _domainSocial_target2['default'])(app), app.locale, callback);
	  };
	}
	
	function go_twitter(app) {
	  var errorHandler = function errorHandler(err) {
	    if (err) {
	      app.go_unexpected_err(err);
	    }
	  };
	  var successHandler = function successHandler(url) {
	    app.emit('go_social_login', ['twitter']);
	    window.top.location.href = url;
	  };
	  var callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	
	  var getLatticeId = function getLatticeId() {
	    return app.lattice ? app.lattice.id : null;
	  };
	
	  return function () {
	    app.user.load_twitter((0, _domainSocial_target2['default'])(app), app.locale, getLatticeId(), callback);
	  };
	}
	
	// ------
	// routes
	// ------
	
	var UnexpectedErrorRoute = (function () {
	  function UnexpectedErrorRoute(err) {
	    _classCallCheck(this, UnexpectedErrorRoute);
	
	    this.name = 'unexpected_error';
	    this.err = err;
	  }
	
	  _createClass(UnexpectedErrorRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	
	      var doRefresh = function doRefresh() {
	        location.reload();
	      };
	
	      callback(_react2['default'].createElement(_routeUnexpectedError2['default'], {
	        sponsor: app.sponsor(),
	        locale: app.locale,
	        err: this.err,
	        doAcceptCookies: doAcceptCookies,
	        doRefresh: doRefresh }));
	    }
	  }]);
	
	  return UnexpectedErrorRoute;
	})();
	
	var ChangeLatticeRoute = (function () {
	  function ChangeLatticeRoute(lattice_id, reducer_id) {
	    _classCallCheck(this, ChangeLatticeRoute);
	
	    this.name = 'change_lattice';
	    this.lattice_id = lattice_id;
	    this.reducer_id = reducer_id;
	  }
	
	  _createClass(ChangeLatticeRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	
	      var locale = app.locale;
	      var self = this;
	      var goReducer = function goReducer() {
	        app.transact(new ReducerRoute(self.lattice_id, self.reducer_id));
	      };
	
	      callback(_react2['default'].createElement(_routeChangeLattice2['default'], {
	        locale: locale,
	        product: app.product,
	        sponsor: app.sponsor(),
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        goReducer: goReducer,
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return ChangeLatticeRoute;
	})();
	
	var ProductNotAvailableRoute = (function () {
	  function ProductNotAvailableRoute() {
	    _classCallCheck(this, ProductNotAvailableRoute);
	
	    this.name = 'product_not_available';
	  }
	
	  _createClass(ProductNotAvailableRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	
	      callback(_react2['default'].createElement(_routeProductNotAvailable2['default'], {
	        locale: locale,
	        product: app.product,
	        sponsor: app.sponsor(),
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        showLatticeUrl: app.lattice_url !== null,
	        goCatalog: goCatalog(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return ProductNotAvailableRoute;
	})();
	
	var ProductRoute = (function () {
	  function ProductRoute(message, old_price, showLucidTutorial) {
	    _classCallCheck(this, ProductRoute);
	
	    this.name = 'product';
	    this.message = message;
	    this.old_price = old_price;
	    this.showLucidTutorial = showLucidTutorial;
	    var params = (0, _parseQuerystring2['default'])(location.search);
	    this.from = params.from;
	    this.status = params.status;
	  }
	
	  _createClass(ProductRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this3 = this;
	
	      var locale = app.locale;
	      var product = app.product;
	      var user = app.user;
	      var is_widget = app.is_widget;
	
	      var is_sold_out = product.runtime.is_sold_out;
	      var is_expired = product.is_expired();
	
	      var doShowConsole = function doShowConsole() {
	        return !is_sold_out && !is_expired;
	      };
	
	      var doShowShare = function doShowShare() {
	        return !is_sold_out && !is_expired && !is_widget;
	      };
	
	      var getConsoleMessage = function getConsoleMessage() {
	        var message = undefined;
	        var bundle = (0, _domainGet_bundle2['default'])(locale).template_message;
	        if (is_sold_out) {
	          app.emit('message', ['is_sold_out']);
	          message = _react2['default'].createElement(
	            _componentsConsoleMessage2['default'],
	            null,
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle['product.is_sold_out']
	            )
	          );
	        } else if (is_expired) {
	          app.emit('message', ['is_expired']);
	          message = _react2['default'].createElement(
	            _componentsConsoleMessage2['default'],
	            null,
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle['product.is_expired']
	            )
	          );
	        } else if (product.runtime.price <= product.min_price) {
	          app.emit('message', ['min_price']);
	          message = _react2['default'].createElement(
	            _componentsConsoleMessage2['default'],
	            null,
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle['product.min_price']
	            )
	          );
	        } else if (_this3.message) {
	          message = _this3.message;
	        }
	
	        return message;
	      };
	
	      var getAdvBoxes = function getAdvBoxes() {
	        return app.lattice && app.lattice.adv_boxes ? app.lattice.adv_boxes : [];
	      };
	
	      var doReduce = function doReduce() {
	        app.reduce(null);
	      };
	
	      var goBuildOrder = function goBuildOrder() {
	        if (app.is_widget) {
	          return app.openMiniSite();
	        }
	
	        var route = Trip.create({
	          goal: "BuildOrderRoute",
	          authorization: product.authorization
	        }).next(user, locale);
	
	        app.transact(route);
	      };
	
	      var goPurchase = function goPurchase(purchase_id) {
	        app.transact(new PurchaseRoute(purchase_id));
	      };
	
	      var goLogin = function goLogin() {
	        app.transact(new LoginRoute());
	      };
	
	      var showLucidTutorial = function showLucidTutorial() {
	        if (['lucid', 'pollfish'].indexOf(app.route.from) !== -1 && app.route.showLucidTutorial) {
	          return true;
	        } else {
	          return false;
	        }
	      };
	      var statusLucidTutorial = function statusLucidTutorial() {
	        if (!showLucidTutorial()) {
	          return null;
	        }
	        // ok-ko
	        return app.route.status;
	      };
	
	      //pixel di atterraggio
	      // iframe per tracciare atterraggio sui prodotti '77e18721-aac2-40ac-b2c6-0d3e4df93979', 'a3c09827-3665-4f8e-97d3-96d6fde945ed' di CartaSi
	      if (true) {
	        var CartaSi_product_ids = ['77e18721-aac2-40ac-b2c6-0d3e4df93979', 'a3c09827-3665-4f8e-97d3-96d6fde945ed'];
	        if (CartaSi_product_ids.indexOf(product.id) !== -1) {
	          $('<img src="https://track.adform.net/Serving/TrackPoint/?pm=572854&ADFPageName=Mysi&ADFdivider=|" width="1" height="1" alt="" />').appendTo('body');
	        }
	        var IBL_product_ids = ['a8d02ce8-d600-4d3e-9390-faf53ee0fa4c', 'd316d5dc-ce5b-41c6-a96b-db1314fa514f', '4f028a81-773b-416a-8c2a-b6b416308706', '1686c579-73b6-430b-90ee-9e87c5fdafae', 'c2847349-0dfe-4ea8-815c-317a3673b1b2', '16bb7c57-f970-4c86-bb2e-0240be16f59d'];
	        if (IBL_product_ids.indexOf(product.id) !== -1) {
	          $('<img src="https://track.adform.net/Serving/TrackPoint/?pm=64073&ADFPageName=Conversion%20page&ADFdivider=|" width="1" height="1" alt="" />').appendTo('body');
	        }
	      }
	
	      if (app.is_widget) {
	        callback(_react2['default'].createElement(_routeWidgetProduct2['default'], {
	          locale: locale,
	          product: product,
	          message: getConsoleMessage(),
	          oldPrice: app.route.old_price,
	          doShowConsole: doShowConsole(),
	          doReduce: doReduce,
	          goBuildOrder: goBuildOrder,
	          goPurchase: goPurchase,
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          widget: app.widget(),
	          miniSiteURL: app.getMiniSiteURL() }));
	      } else {
	        callback(_react2['default'].createElement(_routeProduct2['default'], {
	          locale: locale,
	          product: product,
	          user: user,
	          sponsor: app.sponsor(),
	          message: getConsoleMessage(),
	          oldPrice: app.route.old_price,
	          doShowConsole: doShowConsole(),
	          doShowShare: doShowShare(),
	          advBoxes: getAdvBoxes(),
	          partners: app.partners(),
	          doReduce: doReduce,
	          doShare: (0, _utilDoShare2['default'])(app),
	          goBuildOrder: goBuildOrder,
	          goPurchase: goPurchase,
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          doAcceptCookies: doAcceptCookies,
	          goLogin: goLogin,
	          goAccount: goAccount(app),
	          goPurchases: goPurchases(app),
	          goChangePassword: goChangePassword(app),
	          doLogout: doLogout(app),
	          goCatalog: goCatalog(app),
	          goLattices: goLattices(app),
	          showLucidTutorial: showLucidTutorial(),
	          statusLucidTutorial: statusLucidTutorial() }));
	      }
	    }
	  }]);
	
	  return ProductRoute;
	})();
	
	var NoCookiesRoute = (function () {
	  function NoCookiesRoute() {
	    _classCallCheck(this, NoCookiesRoute);
	
	    this.name = 'no_cookies';
	  }
	
	  _createClass(NoCookiesRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      callback(_react2['default'].createElement(_routeNoCookies2['default'], { locale: app.locale }));
	    }
	  }]);
	
	  return NoCookiesRoute;
	})();
	
	var ReducerRoute = (function () {
	  function ReducerRoute(lattice_id, reducer_id, old_price) {
	    _classCallCheck(this, ReducerRoute);
	
	    this.name = 'reducer';
	    this.lattice_id = lattice_id;
	    this.reducer_id = reducer_id;
	    this.old_price = old_price;
	  }
	
	  _createClass(ReducerRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this4 = this;
	
	      Trip.remove();
	      var locale = app.locale;
	      var lattice_id = this.lattice_id;
	      var user = app.user;
	
	      app.load_lattice(lattice_id, function (lattice) {
	        _tcomb2['default'].assert(_domainLattice2['default'].is(lattice));
	        (0, _domainLoad_districts2['default'])(app.lib_url, user.country, function () {
	
	          var do_reduce = function do_reduce(value) {
	            app.reduce(reducer.getReducerBehaviour(lattice_id, value));
	          };
	
	          var do_skip = function do_skip() {
	            app.reduce(reducer.getSkipBehaviour(lattice_id));
	          };
	
	          var goBuildOrder = function goBuildOrder() {
	            if (app.is_widget) {
	              return app.openMiniSite();
	            }
	
	            var route = Trip.create({
	              goal: "BuildOrderRoute",
	              authorization: app.product.authorization
	            }).next(user, locale);
	
	            app.transact(route);
	          };
	
	          var goPurchase = function goPurchase(purchase_id) {
	            app.transact(new PurchaseRoute(purchase_id));
	          };
	
	          var reducer = _jsdk2['default'].find(lattice.reducers, _this4.reducer_id);
	
	          var context = {
	            user: user,
	            fields: _domainUser2['default'].to_fields(user, locale)
	          };
	
	          if (app.is_widget) {
	            callback(_react2['default'].createElement(_routeWidgetReducer2['default'], {
	              locale: locale,
	              sponsor: app.sponsor(),
	              reducer: reducer,
	              context: context,
	              like_url: app.like_url,
	              gplus_url: app.gplus_url,
	              do_reduce: do_reduce,
	              do_skip: do_skip,
	              goPurchase: goPurchase,
	              themeBgColor: app.getThemeBgColor(),
	              themeBtnColor: app.getThemeBtnColor(),
	              themeBgFontColor: app.getThemeBgFontColor(),
	              themeBtnFontColor: app.getThemeBtnFontColor(),
	              widget: app.widget(),
	              miniSiteURL: app.getMiniSiteURL()
	            }));
	          } else {
	            callback(_react2['default'].createElement(_routeReducer2['default'], {
	              locale: locale,
	              user: user,
	              product: app.product,
	              sponsor: app.sponsor(),
	              reducer: reducer,
	              context: context,
	              like_url: app.like_url,
	              gplus_url: app.gplus_url,
	              go_product: goProduct(app),
	              do_reduce: do_reduce,
	              do_skip: do_skip,
	              goPurchase: goPurchase,
	              themeBgColor: app.getThemeBgColor(),
	              themeBtnColor: app.getThemeBtnColor(),
	              themeBgFontColor: app.getThemeBgFontColor(),
	              themeBtnFontColor: app.getThemeBtnFontColor(),
	              goAccount: goAccount(app),
	              goPurchases: goPurchases(app),
	              goChangePassword: goChangePassword(app),
	              doLogout: doLogout(app),
	              doAcceptCookies: doAcceptCookies,
	              partners: app.partners(),
	              oldPrice: app.route.old_price,
	              // message=
	              goBuildOrder: goBuildOrder
	              // goPurchase=
	            }));
	          }
	        });
	      });
	    }
	  }]);
	
	  return ReducerRoute;
	})();
	
	var LoginRoute = (function () {
	  function LoginRoute(message) {
	    _classCallCheck(this, LoginRoute);
	
	    this.name = 'login';
	    this.message = message;
	  }
	
	  _createClass(LoginRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale)['template_message'];
	
	      var goResendPassword = function goResendPassword() {
	        app.transact(new ResendPasswordRoute());
	      };
	
	      var goRegister = function goRegister() {
	        app.transact(new RegisterRoute());
	      };
	
	      var doLogin = function doLogin(email, password) {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            switch (err.name) {
	              case 'account deleted':
	              case 'invalid emailAddress':
	                var msg = (0, _lodashStringTemplate2['default'])(bundle[err.message])({
	                  email: email
	                });
	                app.transact(new LoginRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  msg
	                )));
	                break;
	              case 'access denied':
	                app.transact(new LoginRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  bundle['login.access denied']
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          }
	        };
	
	        var successHandler = function successHandler(user) {
	          var errorHandlerLoadRuntime = function errorHandlerLoadRuntime(err) {
	            if (err) {
	              app.go_unexpected_err(err);
	            }
	          };
	          var successHandlerLoadRuntime = function successHandlerLoadRuntime(product) {
	            app.user = user;
	            app.product = product;
	
	            var trip = Trip.get();
	            if (trip) {
	              app.transact(trip.next(user, locale));
	            } else {
	              // SOLO PER RCS
	              if (product.locale.toJSON() === 'it_IT' && user.rcs_privacy_needed) {
	                app.transact(new RcsPrivacyRoute());
	              } else {
	                app.transact(new ProductRoute());
	              }
	            }
	          };
	          app.product.load_runtime((0, _createCallback2['default'])(successHandlerLoadRuntime, errorHandlerLoadRuntime));
	        };
	        app.user.do_login(email, password, (0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      callback(_react2['default'].createElement(_routeLogin2['default'], {
	        locale: locale,
	        message: this.message,
	        sponsor: app.sponsor(),
	        themeBgColor: app.getThemeBgColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        goRegister: goRegister,
	        doAcceptCookies: doAcceptCookies,
	        doLogin: doLogin,
	        goResendPassword: goResendPassword,
	        goProduct: goProduct(app),
	        goFacebook: go_facebook(app),
	        goGoogle: go_google(app),
	        goMicrosoft: go_microsoft(app),
	        goTwitter: go_twitter(app),
	        partners: app.partners() }));
	    }
	  }]);
	
	  return LoginRoute;
	})();
	
	var RegisterRoute = (function () {
	  function RegisterRoute(message) {
	    _classCallCheck(this, RegisterRoute);
	
	    this.name = 'register';
	    this.message = message;
	  }
	
	  _createClass(RegisterRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	
	      var hasThirdPartiesPrivacy = function hasThirdPartiesPrivacy() {
	        return app.lattice ? app.lattice.has_third_parties_privacy : false;
	      };
	
	      var goLogin = function goLogin() {
	        app.transact(new LoginRoute());
	      };
	
	      callback(_react2['default'].createElement(_routeRegister2['default'], {
	        locale: locale,
	        message: this.message,
	        sponsor: app.sponsor(),
	        themeBgColor: app.getThemeBgColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        goFacebook: go_facebook(app),
	        goGoogle: go_google(app),
	        goMicrosoft: go_microsoft(app),
	        goTwitter: go_twitter(app),
	        doRegister: do_register(app),
	        hasThirdPartiesPrivacy: hasThirdPartiesPrivacy(),
	        goLogin: goLogin,
	        goCatalog: goCatalog(app),
	        goProduct: goProduct(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return RegisterRoute;
	})();
	
	var RcsPrivacyRoute = (function () {
	  function RcsPrivacyRoute() {
	    _classCallCheck(this, RcsPrivacyRoute);
	
	    this.name = 'rcs_privacy';
	  }
	
	  _createClass(RcsPrivacyRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	
	      var doAcceptRcsPrivacy = function doAcceptRcsPrivacy() {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            app.go_unexpected_err(err);
	          }
	        };
	        var successHandler = function successHandler(user) {
	          app.user = user;
	          app.transact(new ProductRoute());
	        };
	        app.user.do_accept_rcs_privacy((0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      callback(_react2['default'].createElement(_routeRcsPrivacy2['default'], {
	        locale: locale,
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        sponsor: app.sponsor(),
	        doAcceptRcsPrivacy: doAcceptRcsPrivacy,
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return RcsPrivacyRoute;
	})();
	
	var ResendPasswordRoute = (function () {
	  function ResendPasswordRoute(message) {
	    _classCallCheck(this, ResendPasswordRoute);
	
	    this.name = 'resend_password';
	    this.message = message;
	  }
	
	  _createClass(ResendPasswordRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	
	      var doResendPassword = function doResendPassword(email) {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            switch (err.name) {
	              case 'invalid emailAddress':
	                var msg = (0, _lodashStringTemplate2['default'])(bundle['template_message']['invalid emailAddress'])({
	                  email: email
	                });
	                app.transact(new ResendPasswordRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  msg
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          }
	        };
	        var successHandler = function successHandler() {
	          var msg = (0, _lodashStringTemplate2['default'])(bundle['template_message']['resend_password.done'])({
	            email: email
	          });
	          app.transact(new LoginRoute(_react2['default'].createElement(
	            _componentsMessage2['default'],
	            { bgColor: app.getThemeBgColor(), fontColor: app.getThemeBgFontColor() },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              msg
	            )
	          )));
	        };
	        app.user.do_resend_password(email, (0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      var goLogin = function goLogin() {
	        app.transact(new LoginRoute());
	      };
	
	      callback(_react2['default'].createElement(_routeResendPassword2['default'], {
	        locale: locale,
	        sponsor: app.sponsor(),
	        message: this.message,
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        doResendPassword: doResendPassword,
	        goLogin: goLogin,
	        goProduct: goProduct(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return ResendPasswordRoute;
	})();
	
	var AccountRoute = (function () {
	  function AccountRoute(message) {
	    _classCallCheck(this, AccountRoute);
	
	    this.name = 'account';
	    this.message = message;
	  }
	
	  _createClass(AccountRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this5 = this;
	
	      var locale = app.locale;
	      var user = app.user;
	
	      (0, _domainLoad_districts2['default'])(app.lib_url, user.country, function (districts) {
	
	        var loadDistricts = function loadDistricts(country, callback) {
	          (0, _domainLoad_districts2['default'])(app.lib_url, country, callback);
	        };
	
	        var doUpdateAccount = function doUpdateAccount(name, surname, gender, birth_date, country, district, zip, com_locale) {
	          var errorHandler = function errorHandler(err) {
	            if (err) {
	              switch (err.name) {
	                case 'access denied':
	                  app.go_expired_session(app.locale);
	                  break;
	                default:
	                  app.go_unexpected_err(err);
	              }
	            }
	          };
	          var successHandler = function successHandler(user) {
	            (0, _domainLoad_districts2['default'])(app.lib_url, country, function () {
	              app.user = user;
	              var bundle = (0, _domainGet_bundle2['default'])(locale);
	              app.transact(new AccountRoute(_react2['default'].createElement(
	                _componentsAlert2['default'],
	                { type: 'success' },
	                bundle['template_message']['account.done']
	              )));
	            });
	          };
	          var _callback = (0, _createCallback2['default'])(successHandler, errorHandler);
	          app.user.do_update_account(name, surname, gender, birth_date, country, district, zip, _domainLocale2['default'].of(com_locale), _callback);
	        };
	
	        callback(_react2['default'].createElement(_routeAccount2['default'], {
	          locale: locale,
	          user: user,
	          districts: districts,
	          sponsor: app.sponsor(),
	          message: _this5.message,
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          doUpdateAccount: doUpdateAccount,
	          doAcceptCookies: doAcceptCookies,
	          loadDistricts: loadDistricts,
	          goAccount: goAccount(app),
	          goPurchases: goPurchases(app),
	          goChangePassword: goChangePassword(app),
	          doLogout: doLogout(app),
	          goProduct: goProduct(app),
	          partners: app.partners() }));
	      });
	    }
	  }]);
	
	  return AccountRoute;
	})();
	
	var PurchasesRoute = (function () {
	  function PurchasesRoute() {
	    _classCallCheck(this, PurchasesRoute);
	
	    this.name = 'purchases';
	  }
	
	  _createClass(PurchasesRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var goPurchase = function goPurchase(purchase_id) {
	        app.transact(new PurchaseRoute(purchase_id));
	      };
	
	      var errorHandler = function errorHandler(err) {
	        if (err) {
	          switch (err.name) {
	            case 'access denied':
	              app.go_expired_session(app.locale);
	              break;
	            default:
	              app.go_unexpected_err(err);
	          }
	        }
	      };
	
	      var successHandler = function successHandler(purchases) {
	        callback(_react2['default'].createElement(_routePurchases2['default'], {
	          locale: app.locale,
	          purchases: purchases,
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          goPurchase: goPurchase,
	          sponsor: app.sponsor(),
	          user: app.user,
	          doAcceptCookies: doAcceptCookies,
	          goAccount: goAccount(app),
	          goPurchases: goPurchases(app),
	          goChangePassword: goChangePassword(app),
	          doLogout: doLogout(app),
	          goProduct: goProduct(app),
	          partners: app.partners() }));
	      };
	
	      app.user.load_purchases((0, _createCallback2['default'])(successHandler, errorHandler));
	    }
	  }]);
	
	  return PurchasesRoute;
	})();
	
	var PurchaseRoute = (function () {
	  function PurchaseRoute(purchase_id, message) {
	    _classCallCheck(this, PurchaseRoute);
	
	    this.name = 'purchase';
	    this.purchase_id = purchase_id;
	    this.message = message;
	  }
	
	  _createClass(PurchaseRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this6 = this;
	
	      var locale = app.locale;
	      var purchase_id = this.purchase_id;
	
	      var errorHandler = function errorHandler(err) {
	        if (err) {
	          switch (err.name) {
	            case 'access denied':
	              app.go_expired_session(locale);
	              break;
	            default:
	              app.go_unexpected_err(err);
	          }
	        }
	      };
	
	      var successHandler = function successHandler(purchase) {
	        _domainSharePurchase2['default'].create(app.share_purchase_url, locale, purchase, function () {
	          return true;
	        });
	
	        var doSendGiftCardCode = function doSendGiftCardCode(gift_card_code) {
	          var bundle = (0, _domainGet_bundle2['default'])(locale);
	          var cbk = function cbk(b) {
	            if (b) {
	              var errorHandlerDoSend = function errorHandlerDoSend(err) {
	                if (err) {
	                  switch (err.name) {
	                    case 'access denied':
	                      app.go_expired_session(locale);
	                      break;
	                    case 'gift card error':
	                      app.transact(new PurchaseRoute(purchase_id, _react2['default'].createElement(
	                        _componentsAlert2['default'],
	                        { type: 'error' },
	                        _react2['default'].createElement(
	                          _componentsMarkdownComponent2['default'],
	                          null,
	                          bundle['template_message']['purchase.gift card error']
	                        )
	                      )));
	                      break;
	                    default:
	                      app.go_unexpected_err(err);
	                  }
	                }
	              };
	              var successHandlerDoSend = function successHandlerDoSend(res) {
	                app.transact(new PurchaseRoute(res.purchase_id));
	              };
	              app.user.do_send_gift_card_code(purchase_id, (0, _domainTarget2['default'])(app), (0, _domainCancel_target2['default'])(app, purchase_id), gift_card_code, (0, _createCallback2['default'])(successHandlerDoSend, errorHandlerDoSend));
	            } else {
	              _reactDom2['default'].unmountComponentAtNode(document.getElementById('modal-container'));
	            }
	          };
	          _reactDom2['default'].render(_react2['default'].createElement(
	            _componentsConfirm2['default'],
	            { callback: cbk, locale: locale, width: '600', title: bundle.order.gift_card.confirm_title },
	            _react2['default'].createElement(
	              _componentsAlert2['default'],
	              { type: 'warning' },
	              _react2['default'].createElement(
	                _componentsMarkdownComponent2['default'],
	                null,
	                bundle.order.gift_card.confirm_body
	              )
	            )
	          ), document.getElementById('modal-container'));
	        };
	
	        callback(_react2['default'].createElement(_routePurchase2['default'], {
	          locale: locale,
	          message: _this6.message,
	          purchase: purchase,
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          user: app.user,
	          sponsor: app.sponsor(),
	          share_purchase: _domainSharePurchase2['default'].current.html(),
	          custom_payments: purchase.custom_payments || [],
	          pending_purchase_message: purchase.pending_purchase_message,
	          doSendGiftCardCode: doSendGiftCardCode,
	          doAcceptCookies: doAcceptCookies,
	          goAccount: goAccount(app),
	          goPurchases: goPurchases(app),
	          goChangePassword: goChangePassword(app),
	          doLogout: doLogout(app),
	          goProduct: goProduct(app),
	          partners: app.partners() }));
	      };
	      app.user.load_purchase(purchase_id, (0, _domainTarget2['default'])(app, purchase_id), (0, _domainCancel_target2['default'])(app), (0, _createCallback2['default'])(successHandler, errorHandler));
	    }
	  }]);
	
	  return PurchaseRoute;
	})();
	
	var ChangePasswordRoute = (function () {
	  function ChangePasswordRoute(message) {
	    _classCallCheck(this, ChangePasswordRoute);
	
	    this.name = 'change_password';
	    this.message = message;
	  }
	
	  _createClass(ChangePasswordRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale)['template_message'];
	
	      var doChangePassword = function doChangePassword(old_password, new_password) {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            switch (err.name) {
	              case 'access denied':
	                app.go_expired_session(locale);
	                break;
	              case 'invalid old password':
	              case 'invalid new password':
	                app.transact(new ChangePasswordRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  bundle['change_password.' + err.name]
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          }
	        };
	        var successHandler = function successHandler() {
	          app.transact(new ChangePasswordRoute(_react2['default'].createElement(
	            _componentsAlert2['default'],
	            { type: 'success' },
	            bundle['change_password.done']
	          )));
	        };
	        app.user.do_change_password(old_password, new_password, (0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      callback(_react2['default'].createElement(_routeChangePassword2['default'], {
	        user: app.user,
	        sponsor: app.sponsor(),
	        locale: locale,
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        message: this.message,
	        doChangePassword: doChangePassword,
	        goAccount: goAccount(app),
	        goChangePassword: goChangePassword(app),
	        goPurchases: goPurchases(app),
	        doLogout: doLogout(app),
	        doAcceptCookies: doAcceptCookies,
	        goProduct: goProduct(app),
	        partners: app.partners() }));
	    }
	  }]);
	
	  return ChangePasswordRoute;
	})();
	
	var BuildOrderRoute = (function () {
	  function BuildOrderRoute(order) {
	    _classCallCheck(this, BuildOrderRoute);
	
	    this.name = 'build_order';
	    this.order = order;
	  }
	
	  _createClass(BuildOrderRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      Trip.remove();
	      var goApproveOrder = function goApproveOrder(contact, invoice) {
	        var locale = app.locale;
	        var product = app.product;
	        var user = app.user;
	        var obj = {
	          locale: locale,
	          domicile: null,
	          coupon: null,
	          invoice: null
	        };
	
	        if (product.is_coupon) {
	          obj.coupon = {
	            name: contact.coupon_name,
	            surname: contact.coupon_surname,
	            email: user.email,
	            mobile: _domainVerified2['default'].is(user) ? user.mobile : contact.mobile,
	            mobile_country: _domainVerified2['default'].is(user) ? user.country : contact.mobile_country
	          };
	        } else {
	          var shipping = _jsdk2['default'].copy(contact.shipping_id ? _jsdk2['default'].find(product.shippings, contact.shipping_id) : product.shippings[0]);
	
	          obj.domicile = {
	            name: contact.name,
	            surname: contact.surname,
	            address: contact.address,
	            co: contact.co,
	            town: contact.town,
	            district: contact.district,
	            zip: contact.zip,
	            email: user.email,
	            mobile: _domainVerified2['default'].is(user) ? user.mobile : contact.mobile,
	            alt_email: contact.alt_email,
	            alt_mobile: contact.alt_mobile,
	            shipping: shipping,
	            mobile_country: _domainVerified2['default'].is(user) ? user.country : contact.mobile_country
	          };
	        }
	
	        // aggiungo la sezione relativa alla fattura solo se il prodotto
	        // lo ammette AND l'utente ha selezionato che desidera la fattura
	        if (product.is_invoiced && invoice) {
	          obj.invoice = {
	            name: invoice.invoice_name,
	            vat: invoice.invoice_vat,
	            address: invoice.invoice_address,
	            town: invoice.invoice_town,
	            district: invoice.invoice_district,
	            zip: invoice.invoice_zip,
	            country: invoice.invoice_country
	          };
	        }
	        var order = (0, _domainOrder2['default'])(obj);
	        app.transact(new ApproveOrderRoute(order, null));
	      };
	
	      var order = this.order;
	
	      if (!order) {
	        order = app.product.is_coupon ? {
	          locale: app.locale,
	          domicile: null,
	          coupon: {
	            name: app.user.name,
	            surname: app.user.surname,
	            email: app.user.email,
	            mobile: app.user.mobile,
	            mobile_country: app.user.mobile_country
	          },
	          invoice: null
	        } : {
	          locale: app.locale,
	          domicile: {
	            name: app.user.name,
	            surname: app.user.surname,
	            email: app.user.email,
	            mobile: app.user.mobile,
	            shipping: app.product.shippings.length === 1 ? app.product.shippings[0] : null
	          },
	          coupon: null,
	          invoice: null
	        };
	      }
	
	      callback(_react2['default'].createElement(_routeBuildOrder2['default'], {
	        locale: app.locale,
	        product: app.product,
	        user: app.user,
	        sponsor: app.sponsor(),
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        order: order,
	        goApproveOrder: goApproveOrder,
	        goProduct: goProduct(app),
	        goAccount: goAccount(app),
	        goPurchases: goPurchases(app),
	        goChangePassword: goChangePassword(app),
	        doLogout: doLogout(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return BuildOrderRoute;
	})();
	
	var ApproveOrderRoute = (function () {
	  function ApproveOrderRoute(order, message) {
	    _classCallCheck(this, ApproveOrderRoute);
	
	    this.name = 'approve_order';
	    this.order = order;
	    this.message = message;
	  }
	
	  _createClass(ApproveOrderRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var product = app.product;
	      var order = this.order;
	
	      var goBuildOrder = function goBuildOrder() {
	        app.transact(new BuildOrderRoute(order));
	      };
	
	      var doApproveOrder = function doApproveOrder() {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            switch (err.name) {
	              case 'invalid emailAddress':
	                _dialog2['default'].Alert.go(locale, 300, "L'indirizzo email non è valido");
	                break;
	              case 'access denied':
	                app.go_expired_session(locale);
	                break;
	              case 'product sold out':
	              case 'out of time':
	              case 'invalid price':
	              case 'item sold':
	              case 'max items reached':
	              case 'pending payment':
	                product.load_runtime(function (gerr, p) {
	                  if (gerr) {
	                    app.go_unexpected_err(gerr);
	                  } else {
	                    app.product = p;
	                    app.transact(new ApproveOrderErrorRoute(err));
	                  }
	                }, {
	                  product_id: app.product.id
	                });
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          }
	        };
	        var successHandler = function successHandler(obj) {
	          app.emit('do_approve_order', [product.id]);
	          app.product = obj.product;
	          app.transact(new PurchaseRoute(obj.purchase_id));
	        };
	        app.user.do_approve_order(product, order, (0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      callback(_react2['default'].createElement(_routeApproveOrder2['default'], {
	        locale: locale,
	        product: product,
	        user: app.user,
	        sponsor: app.sponsor(),
	        order: order,
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        message: this.message,
	        goBuildOrder: goBuildOrder,
	        doApproveOrder: doApproveOrder,
	        goProduct: goProduct(app),
	        goAccount: goAccount(app),
	        goPurchases: goPurchases(app),
	        goChangePassword: goChangePassword(app),
	        doLogout: doLogout(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return ApproveOrderRoute;
	})();
	
	var RequestPinRoute = (function () {
	  function RequestPinRoute(message) {
	    _classCallCheck(this, RequestPinRoute);
	
	    this.name = 'request_pin';
	    this.message = message;
	  }
	
	  _createClass(RequestPinRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var doRequestPin = function doRequestPin(country, mobile) {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            switch (err.name) {
	              case 'access denied':
	                app.go_expired_session(locale);
	                break;
	              case 'invalid mobile':
	              case 'account deleted':
	              case 'sms timeout':
	                var msg = (0, _lodashStringTemplate2['default'])((0, _domainGet_bundle2['default'])(app.locale)['template_message']['request_pin.' + err.name])({
	                  mobile: _domainCountries2['default'].format_mobile(country, mobile)
	                });
	                app.transact(new RequestPinRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  msg
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          }
	        };
	        var successHandler = function successHandler() {
	          app.transact(new InsertPinRoute(country, mobile));
	        };
	        app.user.do_request_pin(country, mobile, (0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      callback(_react2['default'].createElement(_routeRequestPin2['default'], {
	        locale: locale,
	        currency: app.product.currency,
	        message: this.message,
	        doRequestPin: doRequestPin,
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        user: app.user,
	        sponsor: app.sponsor(),
	        goProduct: goProduct(app),
	        goPurchases: goPurchases(app),
	        goChangePassword: goChangePassword(app),
	        doLogout: doLogout(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return RequestPinRoute;
	})();
	
	var ApproveOrderErrorRoute = (function () {
	  function ApproveOrderErrorRoute(err) {
	    _classCallCheck(this, ApproveOrderErrorRoute);
	
	    this.name = 'approve_order_error';
	    this.err = err;
	  }
	
	  _createClass(ApproveOrderErrorRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var goPurchases = function goPurchases() {
	        app.transact(new PurchasesRoute());
	      };
	
	      callback(_react2['default'].createElement(_routeApproveOrderError2['default'], {
	        locale: app.locale,
	        err: this.err,
	        sponsor: app.sponsor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        goPurchases: goPurchases,
	        goCatalog: goCatalog(app),
	        goProduct: goProduct(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return ApproveOrderErrorRoute;
	})();
	
	var ItemSoldRoute = (function () {
	  function ItemSoldRoute() {
	    _classCallCheck(this, ItemSoldRoute);
	
	    this.name = 'item_sold';
	  }
	
	  _createClass(ItemSoldRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      if (app.is_widget) {
	        callback(_react2['default'].createElement(_routeWidgetItemSold2['default'], {
	          locale: app.locale,
	          sponsor: app.sponsor(),
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          product: app.product,
	          goProduct: goProduct(app),
	          widget: app.widget(),
	          miniSiteURL: app.getMiniSiteURL() }));
	      } else {
	        callback(_react2['default'].createElement(_routeItemSold2['default'], {
	          locale: app.locale,
	          sponsor: app.sponsor(),
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          product: app.product,
	          goProduct: goProduct(app),
	          doShare: (0, _utilDoShare2['default'])(app),
	          doAcceptCookies: doAcceptCookies,
	          partners: app.partners() }));
	      }
	    }
	  }]);
	
	  return ItemSoldRoute;
	})();
	
	var InsertPinRoute = (function () {
	  function InsertPinRoute(country, mobile, message) {
	    _classCallCheck(this, InsertPinRoute);
	
	    this.name = 'insert_pin';
	    this.country = country;
	    this.mobile = mobile;
	    this.message = message;
	  }
	
	  _createClass(InsertPinRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var country = this.country;
	      var mobile = this.mobile;
	      var doInsertPin = function doInsertPin(pin) {
	        var errorHandler = function errorHandler(err) {
	          if (err) {
	            switch (err.name) {
	              case 'access denied':
	                app.go_expired_session(locale);
	                break;
	              case 'invalid pin':
	                var msg = (0, _domainGet_bundle2['default'])(locale)['template_message']['insert_pin.invalid pin'];
	                app.transact(new InsertPinRoute(country, mobile, _react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  _react2['default'].createElement(
	                    _componentsMarkdownComponent2['default'],
	                    null,
	                    msg
	                  )
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          }
	        };
	        var successHandler = function successHandler() {
	          (0, _domainLoad_districts2['default'])(app.lib_url, app.locale.country, function () {
	            app.transact(new VerifyRoute());
	          });
	        };
	        app.user.do_insert_pin(pin, (0, _createCallback2['default'])(successHandler, errorHandler));
	      };
	
	      callback(_react2['default'].createElement(_routeInsertPin2['default'], {
	        locale: locale,
	        country: country,
	        mobile: mobile,
	        sponsor: app.sponsor(),
	        message: this.message,
	        themeBgColor: app.getThemeBgColor(),
	        themeBtnColor: app.getThemeBtnColor(),
	        themeBgFontColor: app.getThemeBgFontColor(),
	        themeBtnFontColor: app.getThemeBtnFontColor(),
	        doInsertPin: doInsertPin,
	        user: app.user,
	        goProduct: goProduct(app),
	        goPurchases: goPurchases(app),
	        goChangePassword: goChangePassword(app),
	        doLogout: doLogout(app),
	        doAcceptCookies: doAcceptCookies,
	        partners: app.partners() }));
	    }
	  }]);
	
	  return InsertPinRoute;
	})();
	
	var VerifyRoute = (function () {
	  function VerifyRoute() {
	    _classCallCheck(this, VerifyRoute);
	
	    this.name = 'verify';
	  }
	
	  _createClass(VerifyRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      (0, _domainLoad_districts2['default'])(app.lib_url, locale.country, function (districts) {
	        var loadDistricts = function loadDistricts(country, callback) {
	          (0, _domainLoad_districts2['default'])(app.lib_url, country, callback);
	        };
	
	        var doVerify = function doVerify(gender, birth_date, country, district, zip) {
	          var errorHandler = function errorHandler(err) {
	            if (err) {
	              switch (err.name) {
	                case 'access denied':
	                  app.go_expired_session(locale);
	                  break;
	                default:
	                  app.go_unexpected_err(err);
	              }
	            }
	          };
	          var successHandler = function successHandler(user) {
	            app.emit('do_verify');
	            app.user = user;
	            var errorHandlerLoadRuntime = function errorHandlerLoadRuntime(err) {
	              app.go_unexpected_err(err);
	            };
	            var successHandlerLoadRuntime = function successHandlerLoadRuntime(product) {
	              app.product = product;
	              app.transact(Trip.get().next(user, locale));
	            };
	            app.product.load_runtime((0, _createCallback2['default'])(successHandlerLoadRuntime, errorHandlerLoadRuntime));
	          };
	          app.user.do_verify(gender, birth_date, country, district, zip, (0, _createCallback2['default'])(successHandler, errorHandler));
	        };
	        callback(_react2['default'].createElement(_routeVerify2['default'], {
	          locale: locale,
	          districts: districts,
	          country: locale.country,
	          sponsor: app.sponsor(),
	          themeBgColor: app.getThemeBgColor(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBgFontColor: app.getThemeBgFontColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor(),
	          loadDistricts: loadDistricts,
	          lib_url: app.lib_url,
	          doVerify: doVerify,
	          user: app.user,
	          goProduct: goProduct(app),
	          goPurchases: goPurchases(app),
	          goChangePassword: goChangePassword(app),
	          doLogout: doLogout(app),
	          doAcceptCookies: doAcceptCookies,
	          partners: app.partners() }));
	      });
	    }
	  }]);
	
	  return VerifyRoute;
	})();
	
	var CaptchaRoute = (function () {
	  function CaptchaRoute(lattice_id, reducer_id) {
	    _classCallCheck(this, CaptchaRoute);
	
	    this.name = 'captcha';
	    this.lattice_id = lattice_id;
	    this.reducer_id = reducer_id;
	  }
	
	  _createClass(CaptchaRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this7 = this;
	
	      var getCaptchaUrl = function getCaptchaUrl() {
	        return app.captcha_url + '/' + _this7.lattice_id;
	      };
	
	      var locale = app.locale;
	      var user = app.user;
	
	      if (app.is_widget) {
	        callback(_react2['default'].createElement(_routeWidgetCaptcha2['default'], {
	          locale: locale,
	          captcha_url: getCaptchaUrl(),
	          widget: app.widget()
	        }));
	      } else {
	        callback(_react2['default'].createElement(_routeCaptcha2['default'], {
	          locale: locale,
	          user: user,
	          sponsor: app.sponsor(),
	          go_product: goProduct(app),
	          goAccount: goAccount(app),
	          goPurchases: goPurchases(app),
	          goChangePassword: goChangePassword(app),
	          doLogout: doLogout(app),
	          doAcceptCookies: doAcceptCookies,
	          partners: app.partners(),
	          captcha_url: getCaptchaUrl(),
	          themeBtnColor: app.getThemeBtnColor(),
	          themeBtnFontColor: app.getThemeBtnFontColor()
	        }));
	      }
	    }
	  }]);
	
	  return CaptchaRoute;
	})();
	
	module.exports = App;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	//debugger;
	'use strict';
	
	function assert(guard, message) {
	  if (!guard) {
	    throw new Error(message || 'assert failed');
	  }
	  return guard;
	}
	
	function Nil(x) {
	  assert(Nil.is(x), x + ' is not a Nil');
	  return x;
	}
	
	Nil.is = function (x) {
	  return x === null || x === void 0;
	};
	
	Nil.of = Nil;
	
	function Str(x) {
	  assert(Str.is(x), x + " is not a Str");
	  return x;
	}
	
	Str.is = function (x) {
	  return typeof x === 'string' || x && x.constructor === String;
	};
	
	Str.of = Str;
	
	function Num(x) {
	  assert(Num.is(x), x + " is not a Num");
	  return x;
	}
	
	Num.is = function (x) {
	  return (typeof x === 'number' || x && x.constructor === Number) && isFinite(x) && !isNaN(x);
	};
	
	Num.of = Num;
	
	function Bool(x) {
	  assert(Bool.is(x), x + " is not a Bool");
	  return x;
	}
	
	Bool.is = function (x) {
	  return x === true || x === false;
	};
	
	Bool.of = Bool;
	
	function Arr(x) {
	  assert(Arr.is(x), x + " is not a Arr");
	  return x;
	}
	
	Arr.is = function (x) {
	  return x instanceof Array;
	};
	
	Arr.of = Arr;
	
	Arr.of_length = function (n) {
	  var arr = [];
	  for (var i = 0; i < n; i++) {
	    arr[i] = null;
	  }
	  return arr;
	};
	
	function Obj(x) {
	  assert(Obj.is(x), x + " is not a Obj");
	  return x;
	}
	
	Obj.is = function (x) {
	  return x && x instanceof Object && !Arr.is(x);
	};
	
	Obj.of = Obj;
	
	function Func(x) {
	  assert(Func.is(x), x + " is not a Func");
	  return x;
	}
	
	Func.is = function (x) {
	  return typeof x === 'function';
	};
	
	Func.of = Func;
	
	function Err(x) {
	  assert(Err.is(x), x + " is not a Err");
	  return x;
	}
	
	Err.is = function (x) {
	  return x instanceof Error;
	};
	
	Err.of = function (x) {
	  assert(Obj.is(x));
	  return mixin(new Error(), x);
	};
	
	function List(type) {
	  assert(Func.is(type));
	
	  function List(x) {
	    assert(List.is(x));
	    return x;
	  }
	
	  List.is = function (x) {
	    return Arr.is(x) && all(x, function (e) {
	      return type.is(e);
	    });
	  };
	
	  List.of = function (xs) {
	    assert(Arr.is(xs));
	    return List(xs.map(type.of));
	  };
	
	  return List;
	}
	
	function Enum(elements) {
	  assert(List(Str).is(elements));
	
	  function Enum(x) {
	    assert(Enum.is(x));
	    return x;
	  }
	
	  Enum.elements = elements;
	  Enum.index = to_obj(elements);
	
	  Enum.is = function (x) {
	    return Str.is(x) && x in Enum.index;
	  };
	
	  Enum.of = Enum;
	
	  return Enum;
	}
	
	function Subtype(type, p) {
	  assert(Func.is(type));
	  assert(Func.is(p));
	
	  function Subtype(x) {
	    // eslint-disable-line no-unused-vars
	    assert(Subtype.is(x));
	    return x;
	  }
	
	  Subtype.is = function (x) {
	    return type.is(x) && p(x);
	  };
	
	  Subtype.of = function (x) {
	    return type.of(x);
	  };
	
	  return Subtype;
	}
	
	function Union(types) {
	  assert(List(Func).is(types));
	
	  function Union(x) {
	    assert(Union.is(x));
	    return x;
	  }
	
	  Union.types = types;
	
	  Union.is = function (x) {
	    return any(Union.types, function (type) {
	      return type.is(x);
	    });
	  };
	
	  // in generale non è possibile stabilire come fare
	  // la funzione di deserializzazione di una unione
	  // occorre definirla di volta in volta
	  Union.of = function () {
	    assert(false, 'you must provide a custom of()');
	  };
	
	  return Union;
	}
	
	function Maybe(type) {
	
	  var Maybe = function Maybe(x) {
	    assert(Maybe.is(x));
	    return x;
	  };
	
	  Maybe.is = function (x) {
	    return Nil.is(x) || type.is(x);
	  };
	
	  Maybe.of = function (obj) {
	    assert(Func.is(type.of));
	    return Nil.is(obj) ? null : type.of(obj);
	  };
	
	  return Maybe;
	}
	
	function Tuple(types) {
	  assert(List(Func).is(types));
	
	  function Tuple(x) {
	    assert(Tuple.is(x));
	    return x;
	  }
	
	  Tuple.is = function (x) {
	    return Arr.is(x) && x.length === types.length && all(x, function (e, i) {
	      return types[i].is(e);
	    });
	  };
	
	  Tuple.of = function (xs) {
	    return Tuple(xs.map(function (x, i) {
	      return types[i].of(x);
	    }));
	  };
	
	  return Tuple;
	}
	
	function Dict(K, V) {
	
	  var Dict = function Dict(x) {
	    assert(Dict.is(x));
	    return x;
	  };
	
	  Dict.is = function (x) {
	    if (!Obj.is(x)) {
	      return false;
	    }
	    for (var k in x) {
	      if (x.hasOwnProperty(k)) {
	        if (!K.is(k)) {
	          return false;
	        }
	        if (!V.is(x[k])) {
	          return false;
	        }
	      }
	    }
	    return true;
	  };
	
	  Dict.of = function (x) {
	    assert(Obj.is(x));
	
	    var ret = {};
	    for (var k in x) {
	      if (x.hasOwnProperty(k)) {
	        ret[K.of(k)] = V.of(x[k]);
	      }
	    }
	    return ret;
	  };
	
	  return Dict;
	}
	
	// duck typing
	
	function Interface(descriptor) {
	  assert(Obj.is(descriptor));
	
	  function Interface() {}
	
	  Interface.is = function (x) {
	    if (!Obj.is(x)) {
	      return false;
	    }
	    for (var k in descriptor) {
	      if (!descriptor[k].is(x[k])) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  Interface.of = function (x) {
	    assert(Interface.is(x));
	    return x;
	  };
	
	  return Interface;
	}
	
	// # Definizioni dei tipi più comuni
	
	// un intero
	var Int = Subtype(Num, is_integer);
	
	// un intero non negativo
	var Natural = Subtype(Int, is_not_negative);
	
	// un intero positivo
	var Positive = Subtype(Int, is_positive);
	
	// il prezzo di un oggetto
	var Amount = Subtype(Num, is_not_negative);
	
	// una data in formato Unix
	var Datetime = Int;
	
	// un identificativo univoco
	var UUID = Subtype(Str, is_uuid);
	
	// un URL assoluto
	var URL = Subtype(Str, is_url);
	
	// una email
	var Email = Subtype(Str, is_email);
	
	// una valuta supportata dalla piattaform
	var Currency = Enum('EUR GBP USD ZAR BRL'.split(' '));
	
	// una lingua supportata dalla piattaform
	var Language = Enum(['it', 'en', 'fr', 'es', 'de', 'pt']);
	
	// un paese supportato dalla piattaform
	var Country = Enum(['AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IT', 'LU', 'MC', 'NL', 'NO', 'PL', 'PT', 'SE', 'TR', 'US', 'ZA']);
	
	// un colore css
	var Color = Subtype(Str, is_color);
	
	// un locale in formato codice iso, es: it_IT, fr_fr, en_GB
	var Locale_Iso = Subtype(Str, function (x) {
	  var parts = x.split('_');
	  return Language.is(parts[0]) && Country.is(parts[1]);
	});
	
	// un valore primitivo valido in JSON
	var JSON_Value = Union([Str, Num, Bool]);
	JSON_Value.of = function (x) {
	  return JSON_Value(x);
	};
	
	// nome valido per un attributo html o per uno stile css
	var Attr_Name = Subtype(Str, function (x) {
	  return (/^[$a-z_][$0-9a-z_-]*$/i.test(x)
	  );
	});
	
	// valore valido per un attributo html o per uno stile css
	var Attr_Value = Subtype(Union([JSON_Value, List(Str), Obj]), function (x) {
	  return !(Nil.is(x) || x === false || Obj.is(x) && Obj.is_empty(x));
	});
	
	// parti di una data
	var Year = Int;
	var Month = Subtype(Natural, function (x) {
	  return x >= 1 && x <= 12;
	});
	var Day = Subtype(Natural, function (x) {
	  return x >= 1 && x <= 31;
	});
	var Hour = Subtype(Natural, function (x) {
	  return x >= 0 && x <= 23;
	});
	var Minute = Subtype(Natural, function (x) {
	  return x >= 0 && x <= 59;
	});
	
	// rappresentazione di una data come tupla delle sue parti
	
	function days_per_month(yyyy) {
	  return function (MM) {
	    return ({
	      0: 31,
	      1: yyyy % 4 === 0 ? 29 : 28, // handle leap year
	      2: 31,
	      3: 30,
	      4: 31,
	      5: 30,
	      6: 31,
	      7: 31,
	      8: 30,
	      9: 31,
	      10: 30,
	      11: 31
	    })[MM - 1];
	  };
	}
	
	var Short_Date = Subtype(Tuple([Year, Month, Day]), function (x) {
	  return x[2] <= days_per_month(x[0])(x[1]);
	});
	var Accurate_Date = Subtype(Tuple([Year, Month, Day, Hour, Minute]), function (x) {
	  return x[2] <= days_per_month(x[0])(x[1]);
	});
	
	var Str_Option = Tuple([Str, Str]);
	
	// formato markdown
	
	function Markdown(value) {
	  assert(Str.is(value));
	  this.value = value;
	  return freeze(this);
	}
	
	Markdown.is = function (x) {
	  return x instanceof Markdown;
	};
	
	Markdown.of = function (x) {
	  return new Markdown(x);
	};
	
	Markdown.prototype.toJSON = function () {
	  return this.value;
	};
	
	Markdown.prototype.toString = function () {
	  return micromd(this.value);
	};
	
	// rappresenta sia un tipo di internazionalizzazione sia un tipo di localizzazione
	
	function Locale(language, country) {
	  assert(Language.is(language));
	  assert(Country.is(country));
	  this.language = language;
	  this.country = country;
	  return freeze(this);
	}
	
	Locale.is = function (x) {
	  return x instanceof Locale;
	};
	
	Locale.of = function (iso) {
	  assert(Locale_Iso.is(iso));
	  var a = iso.split('_');
	  return new Locale(a[0], a[1]);
	};
	
	Locale.prototype.toJSON = Locale.prototype.toString = function () {
	  return this.language + '_' + this.country;
	};
	
	// il bundle di localizzazione serve per formattare numeri, date e valute
	Locale.prototype.locale_bundle = function () {
	  var bundle = window.require('io/' + this);
	  assert(Obj.is(bundle));
	  return bundle;
	};
	
	// il bundle di internazionalizzazione
	// Serve per tradurre le regole di validazione di una form, tradurre i paesi
	// e le lingue
	Locale.prototype.language_bundle = function () {
	  var bundle = window.require('io/' + this.language);
	  assert(Obj.is(bundle));
	  return bundle;
	};
	
	Locale.prototype.display_country = function (country) {
	  assert(Country.is(country));
	  var bundle = this.language_bundle();
	  assert(Obj.is(bundle));
	  return bundle.country[country];
	};
	
	Locale.prototype.display_language = function (language) {
	  assert(Language.is(language));
	  return this.language_bundle().language[language];
	};
	
	Locale.prototype.to_number_format = function (opt_digits) {
	  assert(Maybe(Natural).is(opt_digits));
	  var bundle = this.locale_bundle().number;
	  return new Number_Format(bundle.decimal_symbol, Nil.is(opt_digits) ? bundle.digits : opt_digits, bundle.grouping_symbol, bundle.infinity, bundle.negative_suffix, bundle.positive_suffix);
	};
	
	Locale.prototype.format_date = function (millis, is_accurate) {
	  var bundle = this.locale_bundle().date;
	  var pattern = is_accurate ? bundle.accurate : bundle['short'];
	  return Datetime.format(millis, pattern);
	};
	
	Locale.prototype.format_number = function (n, digits) {
	  return Num.format(n, this.to_number_format(digits));
	};
	
	Locale.prototype.format_integer = function (n) {
	  return this.format_number(n, 0);
	};
	
	Locale.prototype.parse_number = function (n) {
	  return this.to_number_format().parse_number(n);
	};
	
	// # Tool di sviluppo
	
	// log sulla console x-browser
	
	function log(s) {
	  if (typeof console !== 'undefined') {
	    console.log(s); // eslint-disable-line no-console
	  }
	}
	
	// genera un uuid (RFC-4122)
	
	function uuid() {
	  var chars = '0123456789abcdef'.split(''),
	      id = [],
	      rnd = Math.random,
	      r;
	
	  id[8] = id[13] = id[18] = id[23] = '-';
	  id[14] = '4';
	  for (var i = 0; i < 36; i++) {
	    if (!id[i]) {
	      r = 0 | rnd() * 16;
	      id[i] = chars[i === 19 ? r & 0x3 | 0x8 : r & 0xf];
	    }
	  }
	  return id.join('');
	}
	
	function prop(name) {
	  return function (x) {
	    return x[name];
	  };
	}
	
	// aggiunge i campi propri di y a x
	
	function mixin(x, y) {
	  for (var k in y) {
	    if (y.hasOwnProperty(k)) {
	      x[k] = y[k];
	    }
	  }
	  return x;
	}
	
	// mixin() senza side effects
	
	function merge(x, y) {
	  return mixin(mixin({}, x), y);
	}
	
	// copia di x passando dalla sua rappresentazione json
	
	function copy(x) {
	  return JSON.parse(JSON.stringify(x));
	}
	
	// ## Funzioni sugli Array
	
	function all(xs, p) {
	  assert(Arr.is(xs));
	  assert(Func.is(p));
	  for (var i = 0, len = xs.length; i < len; i++) {
	    if (!p(xs[i], i)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function any(xs, p) {
	  // non faccio asserts, li fa già all()
	  return !all(xs, function (x, i) {
	    return !p(x, i);
	  });
	}
	
	// utility: per ordinare una lista di oggetti per il campo name
	
	function by() {
	  var fields = arguments;
	  return function (a, b) {
	    for (var i = 0, len = fields.length; i < len; i = i + 2) {
	      var name = fields[i];
	      var is_desc = fields[i + 1];
	      if (is_desc) {
	        if (a[name] > b[name]) {
	          return -1;
	        } else if (a[name] < b[name]) {
	          return 1;
	        }
	      } else {
	        if (a[name] < b[name]) {
	          return -1;
	        } else if (a[name] > b[name]) {
	          return 1;
	        }
	      }
	    }
	    return 0;
	  };
	}
	
	/*
	function by(name, is_desc) {
	    var asc = function (a, b) {
	        return a[name] < b[name] ? -1 : a[name] === b[name] ? 0 : 1;
	    };
	    var desc = function (a, b) {
	        return a[name] > b[name] ? -1 : a[name] === b[name] ? 0 : 1;
	    };
	    return is_desc ? desc : asc;
	}
	*/
	
	// utility per ordinare le option di una select
	
	function by_description(a, b) {
	  return a[1] < b[1] ? -1 : a[1] === b[1] ? 0 : 1;
	}
	
	// converte un array in un oggetto
	//
	//     to_obj(['a', 'b']) -> {a: 0, b: 1}
	
	function to_obj(xs, f) {
	  assert(Arr.is(xs));
	
	  f = f || function (ret, x, i) {
	    ret[x] = i;
	  };
	
	  var ret = {};
	  for (var i = 0, len = xs.length; i < len; i++) {
	    f(ret, xs[i], i);
	  }
	  return ret;
	}
	
	// trasforma un oggetto in un oggetto mantenendo le stesse chiavi
	
	function map_obj(obj, f) {
	  var result = {};
	  for (var k in obj) {
	    result[k] = f(obj[k], k);
	  }
	  return result;
	}
	
	// converte un oggetto in un array
	
	function to_arr(obj, f) {
	  assert(Obj.is(obj));
	
	  f = f || function (v, k) {
	    return [k, v];
	  };
	
	  var xs = [];
	  for (var k in obj) {
	    xs.push(f(obj[k], k));
	  }
	  return xs;
	}
	
	// l'indice del primo elemento di xs che soddisfa il predicato p
	// se p è una stringa viene interpretato come id
	
	function index_of(xs, p) {
	  assert(Arr.is(xs));
	  assert(Union([Func, Str]).is(p));
	
	  var f = Func.is(p) ? p : function (x) {
	    return x.id === p;
	  };
	
	  for (var i = 0, len = xs.length; i < len; i++) {
	    if (f(xs[i])) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	// il primo elemento di xs che soddisfa il predicato p
	// altrimenti null.
	// se p è una stringa viene interpretato come id
	
	function find(xs, p) {
	  var i = index_of(xs, p);
	  return i === -1 ? null : xs[i];
	}
	
	// un nuovo array contenente gli elementi di xs tranne quello
	// che stava in posizione at
	
	function remove(xs, at) {
	  assert(at >= 0 && at <= xs.length - 1);
	  var ys = xs.slice();
	  ys.splice(at, 1);
	  return ys;
	}
	
	// un array in cui l'elemento di xs di indice from si ritrova
	// all'indice to
	//     move([1, 2, 3, 4, 5], 3, 1) => [1, 4, 2, 3, 5]
	
	function move(xs, from, to) {
	  assert(from >= 0 && from <= xs.length - 1);
	  assert(to >= 0 && to <= xs.length - 1);
	  var ys = xs.slice();
	  var el = ys.splice(from, 1)[0];
	  ys.splice(to, 0, el);
	  return ys;
	}
	
	// ## Funzioni caratteristiche
	
	function is_positive(n) {
	  return n > 0;
	}
	
	function is_not_negative(n) {
	  return n >= 0;
	}
	
	function is_integer(n) {
	  return n === parseInt(n, 10);
	}
	
	var is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	
	function is_uuid(s) {
	  return is_uuid_regexp.test(s);
	}
	
	// true se l'email è formalmente valida
	var is_email_regexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
	
	function is_email(s) {
	  return is_email_regexp.test(s);
	}
	
	// true se s contiene solo cifre
	var is_digits_regexp = /^\d*$/;
	
	function is_digits(s) {
	  return is_digits_regexp.test(s);
	}
	
	// true se il numero è pari
	
	function is_even(n) {
	  return n % 2 === 0;
	}
	
	// true se s è la rappresentazione in stringa di un numero JavaScript
	var is_numeric_regexp = /^-{0,1}\d*\.{0,1}\d+$/;
	
	function is_numeric(s) {
	  return is_numeric_regexp.test(s);
	}
	
	// true se è un url assoluto formalmente valido
	var is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	
	function is_url(s) {
	  return is_url_regexp.test(s);
	}
	
	// true se è un url https assoluto formalmente valido
	
	function is_https_url(s) {
	  return is_url(s) && starts_with(s, 'https');
	}
	
	// true se s comincia con start
	
	function starts_with(s, start) {
	  return s.indexOf(start) === 0;
	}
	
	// true se s è un colore css
	var is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;
	
	function is_color(s) {
	  return is_color_regexp.test(s);
	}
	
	// ## Funzioni sugli Obj
	
	// true se x non ha chiavi proprie
	Obj.is_empty = function (x) {
	  assert(Obj.is(x));
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      return false;
	    }
	  }
	  return true;
	};
	
	// array delle chiavi
	
	function keys(obj) {
	  assert(Obj.is(obj));
	  var ret = [];
	  for (var k in obj) {
	    ret.push(k);
	  }
	  return ret;
	}
	
	// array dei valori
	
	function values(obj) {
	  assert(Obj.is(obj));
	  var ret = [];
	  for (var k in obj) {
	    ret.push(obj[k]);
	  }
	  return ret;
	}
	
	// rende immutabile un oggetto per i browser che lo supportano
	// devo controllare che x sia un oggetto perchè Object.freeze
	// è definita solo sugli oggetti e lancerebbe un errore
	
	function freeze(x) {
	  return Obj.is(x) && Object.freeze ? Object.freeze(x) : x;
	}
	
	// converte un oggetto in una querystring;
	// non serializzo null e undefined
	//
	//     to_querystring({a: 1, b: 2}) -> a=1&b=2
	
	function to_querystring(obj) {
	  assert(Obj.is(obj));
	
	  var url = [];
	  for (var k in obj) {
	    if (obj.hasOwnProperty(k) && !Nil.is(obj[k])) {
	      url.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
	    }
	  }
	  return url.join('&');
	}
	
	// parse_querystring('a=1&b=2') -> {a: 1, b: 2}
	
	function parse_querystring(qs) {
	  assert(Str.is(qs));
	  var params = {};
	  if (qs) {
	    // se nella querystring compare ? lo elimino
	    var pairs = qs.replace(/\?/, '').split('&');
	    pairs.forEach(function (pair) {
	      var arr = pair.split('=');
	      params[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1]);
	    });
	  }
	  return params;
	}
	
	// appende una querystring ad un url esistente
	// il parametro querystring può essere una stringa o una mappa di parametri
	
	function to_url(url, querystring) {
	  assert(Str.is(url));
	  assert(Maybe(Union([Str, Obj])).is(querystring));
	
	  // mi assicuro che querystring sia una stringa
	  // e se non è vuota gestisco la presenza del ? nell'url
	  // prima di appenderla
	
	  querystring = Obj.is(querystring) ? to_querystring(querystring) : querystring || '';
	
	  if (querystring) {
	    // è già presente il ?
	    if (url.indexOf('?') !== -1) {
	      url += '&' + querystring;
	    } else {
	      // è presente un hash?
	      var hash_index = url.indexOf('#');
	      if (hash_index !== -1) {
	        var hash = url.substring(hash_index);
	        url = url.substring(0, hash_index) + '?' + querystring + hash;
	      } else {
	        url += '?' + querystring;
	      }
	    }
	  }
	
	  return url;
	}
	
	// elimina i null e gli undefined dagli array e dagli oggetti in modo ricorsivo
	// serve a rendere più piccoli i JSON serializzati
	
	function compact(x) {
	  var y = x;
	  if (Obj.is(x)) {
	    y = {};
	    for (var k in x) {
	      if (x.hasOwnProperty(k) && !Nil.is(x[k])) {
	        y[k] = compact(x[k]);
	      }
	    }
	  } else if (Arr.is(x)) {
	    y = [];
	    for (var i = 0, len = x.length; i < len; i++) {
	      if (!Nil.is(x[i])) {
	        y.push(compact(x[i]));
	      }
	    }
	  }
	  return y;
	}
	
	function fold(xs, init, f) {
	  assert(Arr.is(xs));
	  assert(Func.is(f));
	  var ret = init;
	  for (var i = 0, len = xs.length; i < len; i++) {
	    ret = f(ret, xs[i]);
	  }
	  return ret;
	}
	
	// unique(['a', 'b', 'a']) => ['a', 'b']
	
	function unique(xs) {
	  assert(Arr.is(xs));
	  var ret = [];
	  for (var i = 0, len = xs.length; i < len; i++) {
	    for (var j = i + 1; j < len; j++) {
	      if (xs[i] === xs[j]) {
	        j = ++i;
	      }
	    }
	    ret.push(xs[i]);
	  }
	  return ret;
	}
	
	//     flatten([1, 2, [3, 4]]) => [1, 2, 3, 4]
	
	function flatten(xs) {
	  var ys = [];
	  for (var i = 0, len = xs.length; i < len; i++) {
	    if (Arr.is(xs[i])) {
	      ys = ys.concat(xs[i]);
	    } else {
	      ys.push(xs[i]);
	    }
	  }
	  return ys;
	}
	
	// un nuovo array senza i primi n elementi di xs
	//     drop(2, [1, 2, 3]) => [1]
	
	function drop(n, xs) {
	  assert(Natural.is(n));
	  return Array.prototype.slice.call(xs, n);
	}
	
	// un nuovo array contenente i primi n elementi di xs
	//     take(2, [1, 2, 3]) => [1, 2]
	
	function take(n, xs) {
	  assert(Natural.is(n));
	  return Array.prototype.slice.call(xs, 0, n);
	}
	
	function trim_left(s) {
	  return s.replace(/^\s\s*/, '');
	}
	
	function trim_right(s) {
	  return s.replace(/\s\s*$/, '');
	}
	
	function pad_time(n) {
	  return pad_left(String(n), 2, "0");
	}
	
	// una mappa contenente le diverse parti di una data
	// (yyyy, MM, dd, ...)
	
	function date_parts(millis) {
	  assert(is_integer(millis));
	  var d = new Date(millis);
	  return {
	    YY: String(d.getFullYear()),
	    MM: pad_time(d.getMonth() + 1),
	    DD: pad_time(d.getDate()),
	    hh: pad_time(d.getHours()),
	    mm: pad_time(d.getMinutes())
	  };
	}
	
	// una stringa declinata al singolare o al plurale a seconda
	// dell'argomento opts.
	// Il bundle è un oggetto che contiene le tre chiavi
	//
	// - zero: usato se opts.count = 0
	// - one: usato se opts.count = 1
	// - other: usato se opts.count > 1
	//
	// oppure una stringa, nel qual caso il risultato non viene declinato.
	//
	// L'intero oggetto opts viene passato come locals al template scelto dalla
	// procedura precedente.
	//
	//     var bundle = {
	//         zero: 'nessuna casa',
	//         one: 'una casa',
	//         other: '<%= count %> case <%= color %>'
	//     };
	//
	//     pluralize(bundle, {count: 0})); => 'nessuna casa'
	//     pluralize(bundle, {count: 1})); => 'una casa'
	//     pluralize(bundle, {count: 5, color: 'rosse'})); => '5 case rosse'
	//
	//
	
	function pluralize(bundle, opts) {
	  assert(Union([Str, Obj]).is(bundle));
	  assert(Obj.is(opts));
	
	  var src = Obj.is(bundle) ? opts.count === 0 ? bundle.zero : opts.count === 1 ? bundle.one : bundle.other : bundle;
	  return template(src)(opts);
	}
	
	function truncate(s, max_length) {
	  assert(Str.is(s));
	  assert(Natural.is(max_length));
	  //var ELLIPSIS = '\u2026';
	  var ELLIPSIS = '...';
	  return s.length <= max_length ? s : s.substring(0, max_length - ELLIPSIS.length) + ELLIPSIS;
	}
	
	// range(1, 10, 2) => [1, 3, 5, 7, 9]
	
	function range(start, stop, step) {
	  assert(Int.is(start));
	  assert(Int.is(stop));
	  assert(Int.is(step));
	
	  var ret = [];
	  stop = Math.abs(stop);
	  for (var i = start; Math.abs(i) <= stop; i = i + step) {
	    ret.push(i);
	  }
	  return ret;
	}
	
	//     pad_left('foo', 2, 'x') => 'foo'
	//     pad_left('foo', 5, 'x') => 'xxfoo'
	
	function pad_left(s, min_length, c) {
	  return pad(s, min_length, c, 'left');
	}
	
	function pad_right(s, min_length, c) {
	  return pad(s, min_length, c, 'right');
	}
	
	function pad_center(s, min_length, c) {
	  return pad(s, min_length, c, 'center');
	}
	
	function pad(s, min_length, c, type) {
	  assert(Str.is(s));
	  assert(Natural.is(min_length));
	  assert(Str.is(c));
	  assert(c.length === 1);
	  assert(type in {
	    'left': 1,
	    'right': 1,
	    'center': 1
	  });
	  var length = s.length;
	  min_length = Math.max(length, min_length);
	  var pad_left = '';
	  var pad_right = '';
	  if (type === 'left') {
	    pad_left = repeat(c, min_length - length);
	  } else if (type === 'right') {
	    pad_right = repeat(c, min_length - length);
	  } else {
	    var left = parseInt(min_length / 2, 10) - parseInt(length / 2, 10);
	    pad_left = repeat(c, left);
	    pad_right = repeat(c, min_length - length - left);
	  }
	  return pad_left + s + pad_right;
	}
	
	function repeat(c, times) {
	  return Arr.of_length(times + 1).join(c);
	}
	
	function noop() {}
	
	function is_cookies_enabled() {
	  var TEST_COOKIE = 'test_cookie';
	  $.cookie(TEST_COOKIE, 'true');
	  if ($.cookie(TEST_COOKIE)) {
	    $.cookie(TEST_COOKIE, null); // delete the cookie
	    return true;
	  }
	  return false;
	}
	
	// event emitter
	var Emitter = {
	
	  on: function on(name, f) {
	    assert(Str.is(name));
	    assert(Func.is(f));
	    this.events[name] = this.events[name] || [];
	    this.events[name].push(f);
	    return this;
	  },
	
	  off: function off(name, f) {
	    assert(Maybe(Str).is(name));
	    assert(Maybe(Func).is(f));
	    var l = arguments.length;
	    if (l === 0) {
	      this.events = {};
	    } else if (l === 1) {
	      delete this.events[name];
	    } else if (this.events[name]) {
	      this.events[name] = this.events[name].filter(function (cb) {
	        return cb !== f;
	      });
	    }
	    return this;
	  },
	
	  emit: function emit(name, args) {
	    assert(Str.is(name));
	    var fs = this.events[name];
	    if (fs) {
	      for (var i = 0, len = fs.length; i < len; i++) {
	        fs[i](args);
	      }
	    }
	    return this;
	  },
	
	  once: function once(name, f) {
	    assert(Str.is(name));
	    assert(Func.is(f));
	    var self = this;
	    var on = function on(args) {
	      self.off(name, on);
	      f(args);
	    };
	    this.on(name, on);
	    return this;
	  }
	
	};
	
	// sistema di templating
	
	function template(src, opt_settings) {
	  assert(Str.is(src));
	  opt_settings = opt_settings || template.jsp;
	  assert(Obj.is(opt_settings));
	
	  var tmpl = 'var __p=[],print=function(){__p.push.apply(__p,arguments);};' + 'with(obj||{}){__p.push(\'' + src.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(opt_settings.interpolate, function (match, code) {
	    return "'," + code.replace(/\\'/g, "'") + ",'";
	  }).replace(opt_settings.evaluate || null, function (match, code) {
	    return "');" + code.replace(/\\'/g, "'").replace(/[\r\n\t]/g, ' ') + "__p.push('";
	  }).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/\t/g, '\\t') + "');}return __p.join('');";
	
	  return new Function('obj', tmpl); // eslint-disable-line no-new-func
	}
	
	template.jsp = {
	  evaluate: /<%([\s\S]+?)%>/g,
	  interpolate: /<%=([\s\S]+?)%>/g
	};
	
	template.mustache = {
	  evaluate: /{{([\s\S]+?)}}/g,
	  interpolate: /{{=([\s\S]+?)}}/g
	};
	
	var template_cache = {};
	
	template.store = function (id, t) {
	  template_cache[id] = t;
	  return t;
	};
	
	template.of = function (id) {
	  return template_cache[id];
	};
	
	// Da usare quando il sorgente del template non può contenere <, >
	
	function mustache(src) {
	  return template(src, template.mustache);
	}
	
	// # Input
	// Armamentario per gestire il recupero e la validazione dei dati di input
	
	// rappresenta una regola di validazione fallita, con il name che indica
	// quale è la regola fallita, e args che può contenere info più specifiche
	// sulla ragione del perchè è fallita e possono essere sfruttate in fase
	// di traduzione della regola in un formato leggibile da un umano
	
	function Rule(name, args) {
	  args = args || [];
	  assert(Str.is(name));
	  assert(Arr.is(args));
	  this.name = name;
	  this.args = args;
	  return freeze(this);
	}
	
	Rule.is = function (x) {
	  return x instanceof Rule;
	};
	
	Rule.of = function (x) {
	  assert(Obj.is(x));
	  return new Rule(Str.of(x.name), Arr.of(x.args));
	};
	
	(function () {
	
	  var localizers = {};
	
	  Rule.add_localizer = function (name, localizer) {
	    assert(!localizers.hasOwnProperty(name));
	    localizers[name] = localizer;
	    return Rule;
	  };
	
	  Rule.get_localizer = function (name) {
	    return localizers[name];
	  };
	})();
	
	Rule.bundle = function (locale) {
	  return locale.language_bundle().validation;
	};
	
	// traduce una regola di validazione fallita in un messaggio da mostrare all'utente.
	// L'argomento deve essere un locale e non semplicemente una lingua
	// perchè in generale la traduzione potrebbe richiedere la formattazione
	// di numeri (ad esempio il messaggio "almeno 1.000 caratteri").
	Rule.prototype.localize = function (locale) {
	  //assert(Locale.is(locale)); //fixme
	  return Rule.get_localizer(this.name)(this.args, locale);
	};
	
	Rule.add_localizer('required', function (args, locale) {
	  return Rule.bundle(locale).required;
	}).add_localizer('format', function (args, locale) {
	  return Rule.bundle(locale)[args[0]];
	}).add_localizer('max_length', function (args, locale) {
	  var max_length = args[0];
	  return pluralize(Rule.bundle(locale).max_length, {
	    arg: locale.format_integer(max_length),
	    count: max_length
	  });
	}).add_localizer('min_length', function (args, locale) {
	  var min_length = args[0];
	  return pluralize(Rule.bundle(locale).min_length, {
	    arg: locale.format_integer(min_length),
	    count: min_length
	  });
	}).add_localizer('max', function (args, locale) {
	  var max = args[0];
	  return template(Rule.bundle(locale).max)({
	    arg: locale.format_integer(max)
	  });
	}).add_localizer('min', function (args, locale) {
	  var min = args[0];
	  return template(Rule.bundle(locale).min)({
	    arg: locale.format_integer(min)
	  });
	}).add_localizer('number', function (args, locale) {
	  return Rule.bundle(locale).number;
	}).add_localizer('date', function (args, locale) {
	  return Rule.bundle(locale).date;
	}).add_localizer('integer', function (args, locale) {
	  return Rule.bundle(locale).integer;
	}).add_localizer('any', function (args, locale) {
	  return Rule.bundle(locale).any;
	}).add_localizer('min_items', function (args, locale) {
	  var min_items = args[0];
	  return pluralize(Rule.bundle(locale).min_items, {
	    count: min_items,
	    arg: min_items
	  });
	});
	
	// rappresenta il risultato di una validazione
	// nel campo x c'è il valore validato, eventualmente modificato
	// dal processo di validazione (ad esempio un parsing di un numero)
	// nel campo rule la eventuale prima regola di validazione fallita
	// altrimenti null
	
	function Validation(x, rule) {
	  assert(Maybe(Union([JSON_Value, Arr])).is(x));
	  assert(Maybe(Rule).is(rule));
	  this.x = x;
	  this.rule = rule;
	  return freeze(this);
	}
	
	Validation.is = function (x) {
	  return x instanceof Validation;
	};
	
	Validation.of = function (x) {
	  assert(Obj.is(x));
	  return new Validation(Maybe(Union([JSON_Value, Arr])).of(x.x), Maybe(Rule).of(x.rule));
	};
	
	// rappresenta il formato di un numero
	// Per validare un numero immesso come stringa, ovvero per parsarlo,
	// ho bisogno prima di sapere in che formato è stato immesso
	
	function Number_Format(decimal_symbol, digits, grouping_symbol, infinity, negative_suffix, positive_suffix) {
	  assert(Str.is(decimal_symbol));
	  assert(Natural.is(digits));
	  assert(Str.is(grouping_symbol));
	  assert(Str.is(infinity));
	  assert(Str.is(negative_suffix));
	  assert(Str.is(positive_suffix));
	  this.decimal_symbol = decimal_symbol;
	  this.digits = digits;
	  this.grouping_symbol = grouping_symbol;
	  this.infinity = infinity;
	  this.negative_suffix = negative_suffix;
	  this.positive_suffix = positive_suffix;
	  return freeze(this);
	}
	
	Number_Format.is = function (x) {
	  return x instanceof Number_Format;
	};
	
	Number_Format.of = function (x) {
	  assert(Obj.is(x));
	  return new Number_Format(Str.of(x.decimal_symbol), Natural.of(x.digits), Str.of(x.grouping_symbol), Str.of(x.infinity), Str.of(x.negative_suffix), Str.of(x.positive_suffix));
	};
	
	// se s è parsabile un numero altrimenti null
	Number_Format.prototype.parse_number = function (s) {
	  assert(Str.is(s));
	
	  var escape_regexp = function escape_regexp(s) {
	    return s.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
	  };
	
	  // elimina i simboli di raggruppamento delle migliaia
	  // e il simbolo della virgola con la virgola JavaScript
	  var make_parseable = function make_parseable(fmt, s) {
	    var grouping_symbol_re = new RegExp(escape_regexp(fmt.grouping_symbol), 'gm');
	    var decimal_symbol_re = new RegExp(escape_regexp(fmt.decimal_symbol), 'gm');
	    var without_grouping = s.replace(grouping_symbol_re, "");
	    return without_grouping.replace(decimal_symbol_re, ".");
	  };
	
	  var parseable = make_parseable(this, s);
	  return is_numeric(parseable) ? parseFloat(parseable) : parseable === this.infinity ? Infinity : parseable === this.negative_suffix + this.infinity ? -Infinity : null;
	};
	
	var Validation_Monad = (function () {
	
	  // Haskell return
	  var unit = function unit(x) {
	    return new Validation(x, null);
	  };
	
	  // Haskell >>=
	  var bind = function bind(validation, f) {
	    assert(Validation.is(validation));
	    assert(Func.is(f));
	
	    if (validation.x === null) {
	      return validation;
	    } else if (validation.rule) {
	      return validation;
	    }
	    return f(validation.x);
	  };
	
	  var required = function required(b) {
	    assert(Bool.is(b));
	    return function (x) {
	      if (Str.is(x)) {
	        x = x.trim();
	        if (x.length === 0) {
	          x = null;
	        }
	      }
	      if (b && x === null) {
	        return new Validation(x, new Rule('required'));
	      }
	      return unit(x);
	    };
	  };
	
	  var max_length = function max_length(length) {
	    assert(Natural.is(length));
	    return function (x) {
	      if (x.length > length) {
	        return new Validation(x, new Rule("max_length", [length]));
	      }
	      return unit(x);
	    };
	  };
	
	  var min_length = function min_length(length) {
	    assert(Natural.is(length));
	    return function (x) {
	      if (x.length < length) {
	        return new Validation(x, new Rule("min_length", [length]));
	      }
	      return unit(x);
	    };
	  };
	
	  var format = function format(sf) {
	    assert(Str_Format.is(sf));
	    return function (x) {
	      var p = Str_Format.formats[sf];
	      if (!p(x)) {
	        return new Validation(x, new Rule("format", [sf]));
	      }
	      return unit(x);
	    };
	  };
	
	  var any_of = function any_of(values, is_case_insensitive) {
	    assert(Arr.is(values));
	    return function (x) {
	      var lower = String(x).toLowerCase();
	      if (all(values, function (value) {
	        return is_case_insensitive ? String(value).toLowerCase() !== lower : value !== x;
	      })) {
	        return new Validation(x, new Rule("any", [values]));
	      }
	      return unit(x);
	    };
	  };
	
	  var is_num = function is_num(number_format) {
	    assert(Number_Format.is(number_format));
	    return function (x) {
	      x = number_format.parse_number(x);
	      if (x === null || !isFinite(x)) {
	        return new Validation(x, new Rule("number"));
	      }
	      return unit(x);
	    };
	  };
	
	  var max = function max(i) {
	    assert(Num.is(i));
	    return function (x) {
	      if (x > i) {
	        return new Validation(x, new Rule("max", [i]));
	      }
	      return unit(x);
	    };
	  };
	
	  var min = function min(i) {
	    assert(Num.is(i));
	    return function (x) {
	      if (x < i) {
	        return new Validation(x, new Rule("min", [i]));
	      }
	      return unit(x);
	    };
	  };
	
	  var is_int = function is_int(x) {
	    if (!is_integer(x)) {
	      return new Validation(x, new Rule("integer"));
	    }
	    return unit(x);
	  };
	
	  var bool = function bool(x) {
	    if (!Bool.is(x)) {
	      return new Validation(x, new Rule("boolean"));
	    }
	    return unit(x);
	  };
	
	  var array = function array(x) {
	    if (!Arr.is(x)) {
	      return new Validation(x, new Rule("array"));
	    }
	    return unit(x);
	  };
	
	  var min_items = function min_items(min) {
	    assert(Natural.is(min));
	    return function (x) {
	      if (x.length < min) {
	        return new Validation(x, new Rule("min_items", [min]));
	      }
	      return unit(x);
	    };
	  };
	
	  var is_ranking = function is_ranking() {
	    return function (x) {
	      var answer = {};
	      for (var i = 0; i < x.length; i++) {
	        if (!answer[x[i][1]]) {
	          answer[x[i][1]] = 1;
	        }
	      }
	      if (x.length !== keys(answer).length) {
	        return new Validation({ x: x, rule: new Rule({ name: "is_ranking" }) });
	      }
	      return unit(x);
	    };
	  };
	
	  var date = function date(required) {
	    assert(Bool.is(required));
	    return function (x) {
	      assert(List(Str).is(x));
	      if (all(x, function (y) {
	        return y === '';
	      }) && !required) {
	        return unit(null);
	      }
	      x = x.map(function (y) {
	        // converto le parti in interi
	        return parseInt(y, 10);
	      });
	      if (x.length === 5) {
	        // la data è accurata
	        if (!Accurate_Date.is(x)) {
	          // controllo che sia una data valida
	          return new Validation(x, new Rule("date"));
	        }
	        x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
	        return unit(new Date(x[0], x[1], x[2], x[3], x[4], 0).getTime());
	      } else {
	        if (!Short_Date.is(x)) {
	          // controllo che sia una data valida
	          return new Validation(x, new Rule("date"));
	        }
	        x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
	        return unit(new Date(x[0], x[1], x[2]).getTime());
	      }
	    };
	  };
	
	  var pipe = function pipe(x, actions) {
	    assert(Str.is(x) || Arr.is(x) || Bool.is(x));
	    return fold(actions, unit(x), bind);
	  };
	
	  return {
	    unit: unit,
	    bind: bind,
	    pipe: pipe,
	    required: required,
	    max_length: max_length,
	    min_length: min_length,
	    format: format,
	    any: any_of,
	    is_number: is_num,
	    is_integer: is_int,
	    max: max,
	    min: min,
	    bool: bool,
	    array: array,
	    min_items: min_items,
	    is_ranking: is_ranking,
	    date: date
	  };
	})();
	
	// # Schemas
	
	function Str_Schema(required, max_length, min_length, format, any, is_case_insensitive) {
	  assert(Maybe(Bool).is(required));
	  assert(Maybe(Natural).is(max_length));
	  assert(Maybe(Natural).is(min_length));
	  assert(Maybe(Str_Format).is(format));
	  assert(Maybe(List(Str)).is(any));
	  assert(Maybe(Bool).is(is_case_insensitive));
	  this.type = 'string';
	  this.required = required;
	  this.max_length = max_length;
	  this.min_length = min_length;
	  this.format = format;
	  this.any = any;
	  this.is_case_insensitive = is_case_insensitive;
	  return freeze(this);
	}
	
	Str_Schema.is = function (x) {
	  return x instanceof Str_Schema;
	};
	Str_Schema.of = function (x) {
	  assert(Obj.is(x));
	  return new Str_Schema(Maybe(Bool).of(x.required), Maybe(Natural).of(x.max_length), Maybe(Natural).of(x.min_length), Maybe(Str_Format).of(x.format), Maybe(List(Str)).of(x.any), Maybe(Bool).of(x.is_case_insensitive));
	};
	
	var Str_Format = Subtype(Str, function (x) {
	  return Str_Format.formats.hasOwnProperty(x);
	});
	
	Str_Format.formats = {
	  email: is_email,
	  url: is_url,
	  https_url: is_https_url,
	  digits: is_digits,
	  color: is_color,
	  uuid: is_uuid
	};
	
	Str_Schema.prototype.validate = function (s) {
	  assert(Str.is(s));
	  var actions = [];
	  actions.push(Validation_Monad.required(!!this.required));
	  if (!Nil.is(this.max_length)) {
	    actions.push(Validation_Monad.max_length(this.max_length));
	  }
	  if (!Nil.is(this.min_length)) {
	    actions.push(Validation_Monad.min_length(this.min_length));
	  }
	  if (!Nil.is(this.format)) {
	    actions.push(Validation_Monad.format(this.format));
	  }
	  if (!Nil.is(this.any)) {
	    actions.push(Validation_Monad.any(this.any, this.is_case_insensitive));
	  }
	  return Validation_Monad.pipe(s, actions);
	};
	
	function Num_Schema(required, max, min, integer, any) {
	  assert(Maybe(Bool).is(required));
	  assert(Maybe(Num).is(max));
	  assert(Maybe(Num).is(min));
	  assert(Maybe(Bool).is(integer));
	  assert(Maybe(List(Num)).is(any));
	  this.type = 'number';
	  this.required = required;
	  this.max = max;
	  this.min = min;
	  this.integer = integer;
	  this.any = any;
	  return freeze(this);
	}
	
	Num_Schema.is = function (x) {
	  return x instanceof Num_Schema;
	};
	
	Num_Schema.of = function (x) {
	  assert(Obj.is(x));
	  return new Num_Schema(Maybe(Bool).of(x.required), Maybe(Num).of(x.max), Maybe(Num).of(x.min), Maybe(Bool).of(x.integer), Maybe(List(Num)).of(x.any));
	};
	
	Num_Schema.prototype.to_computation = function (number_format) {
	  assert(Maybe(Number_Format).is(number_format));
	  var actions = [];
	  actions.push(Validation_Monad.required(!!this.required));
	  if (number_format) {
	    actions.push(Validation_Monad.is_number(number_format));
	  }
	  if (!Nil.is(this.max)) {
	    actions.push(Validation_Monad.max(this.max));
	  }
	  if (!Nil.is(this.min)) {
	    actions.push(Validation_Monad.min(this.min));
	  }
	  if (this.integer) {
	    actions.push(Validation_Monad.is_integer);
	  }
	  if (!Nil.is(this.any)) {
	    actions.push(Validation_Monad.any(this.any, false));
	  }
	  return function (x) {
	    return Validation_Monad.pipe(x, actions);
	  };
	};
	
	Num_Schema.prototype.validate_num = function (n) {
	  assert(Num.is(n));
	  return this.to_computation()(n);
	};
	
	Num_Schema.prototype.validate = function (s, locale) {
	  assert(Str.is(s));
	  assert(Locale.is(locale));
	  var number_format = locale.to_number_format();
	  return this.to_computation(number_format)(s);
	};
	
	function Bool_Schema(any) {
	  assert(Maybe(List(Bool)).is(any));
	  this.type = 'boolean';
	  this.any = any;
	  return freeze(this);
	}
	
	Bool_Schema.is = function (x) {
	  return x instanceof Bool_Schema;
	};
	
	Bool_Schema.of = function (x) {
	  assert(Obj.is(x));
	  return new Bool_Schema(Maybe(List(Bool)).of(x.any));
	};
	
	Bool_Schema.prototype.validate = function (b) {
	  assert(Bool.is(b));
	  var actions = [];
	  actions.push(Validation_Monad.bool);
	  if (!Nil.is(this.any)) {
	    actions.push(Validation_Monad.any(this.any, false));
	  }
	  return Validation_Monad.pipe(b, actions);
	};
	
	function Date_Schema(required) {
	  assert(Maybe(Bool).is(required));
	  this.type = 'date';
	  this.required = required;
	  return freeze(this);
	}
	
	Date_Schema.is = function (x) {
	  return x instanceof Date_Schema;
	};
	
	Date_Schema.of = function (x) {
	  assert(Obj.is(x));
	  return new Date_Schema(Maybe(Bool).of(x.required));
	};
	
	Date_Schema.prototype.validate = function (a) {
	  var actions = [];
	  actions.push(Validation_Monad.date(!!this.required));
	  return Validation_Monad.pipe(a, actions);
	};
	
	function Arr_Schema(min_items, is_ranking) {
	  assert(Maybe(Natural).is(min_items));
	  assert(Maybe(Bool).is(is_ranking));
	  this.type = 'array';
	  this.min_items = min_items;
	  this.is_ranking = is_ranking;
	  return freeze(this);
	}
	
	Arr_Schema.is = function (x) {
	  return x instanceof Arr_Schema;
	};
	
	Arr_Schema.of = function (x) {
	  assert(Obj.is(x));
	  return new Arr_Schema(Maybe(Natural).of(x.min_items), Maybe(Bool).of(x.is_ranking));
	};
	
	Arr_Schema.prototype.validate = function (xs) {
	  assert(Arr.is(xs));
	  var actions = [];
	  actions.push(Validation_Monad.array);
	  if (!Nil.is(this.min_items)) {
	    actions.push(Validation_Monad.min_items(this.min_items));
	  }
	  if (!Nil.is(this.is_ranking)) {
	    actions.push(Validation_Monad.is_ranking());
	  }
	  return Validation_Monad.pipe(xs, actions);
	};
	
	var Schema = Union([Str_Schema, Num_Schema, Bool_Schema, Arr_Schema]);
	
	Schema.of = function (obj) {
	  assert(Obj.is(obj));
	  var schemas = {
	    string: Str_Schema,
	    number: Num_Schema,
	    'boolean': Bool_Schema,
	    array: Arr_Schema
	  };
	  assert(Func.is(schemas[obj.type]));
	  return schemas[obj.type].of(obj);
	};
	
	// # Output
	// funzioni di formattazione
	
	Amount.format = function (locale, currency, amount) {
	  //assert(Locale.is(locale));
	  assert(Currency.is(currency));
	  assert(Amount.is(amount));
	  var bundle = locale.locale_bundle();
	  assert(bundle);
	  var symbol = bundle.currency[currency];
	  return symbol + ' ' + locale.format_number(amount);
	};
	
	Num.format = function (n, number_format) {
	  assert(Num.is(n) || !isFinite(n));
	  assert(Number_Format.is(number_format));
	
	  var add_grouping_symbol = function add_grouping_symbol(s, grouping_symbol) {
	    var re = /(\d+)(\d{3})/;
	    var symbols = parseInt(s.length / 3, 10);
	    Arr.of_length(symbols).forEach(function () {
	      s = s.replace(re, "$1" + grouping_symbol + "$2");
	    });
	    return s;
	  };
	
	  var format_abs = function format_abs(abs, fmt) {
	    var s = abs.toFixed(fmt.digits);
	    var xs = s.split(".");
	    var is_decimal = xs.length > 1;
	    var integers = xs[0];
	    var decimals = xs[1];
	    var grouping_symbol = fmt.grouping_symbol;
	    var integral_part = grouping_symbol ? add_grouping_symbol(integers, grouping_symbol) : integers;
	    var decimal_part = is_decimal ? fmt.decimal_symbol + decimals : "";
	    return integral_part + decimal_part;
	  };
	
	  var suffix = number_format[n >= 0 ? 'positive_suffix' : 'negative_suffix'];
	  var abs = Math.abs(n);
	  return suffix + (abs === Infinity ? number_format.infinity : format_abs(abs, number_format));
	};
	
	Datetime.format = function (millis, pattern) {
	  assert(Datetime.is(millis));
	  assert(Str.is(pattern));
	  return template(pattern)(date_parts(millis));
	};
	
	JSON_Value.format = function (locale, schema, value) {
	  //assert(Locale.is(locale)); fixme
	  //assert(Schema.is(schema)); fixme
	  //assert(Maybe(JSON_Value).is(value)); fixme
	
	  if (Nil.is(value)) {
	    return '';
	  }
	  if (schema.type === 'number') {
	    return schema.integer ? locale.format_integer(value) : locale.format_number(value, schema.digits);
	  }
	  return String(value);
	};
	
	// micro markdown parser
	
	var micromd = (function () {
	
	  // converte un tag in html
	  // - i p sono convertiti semplicemente in testo con gli a capo
	  // sostituiti da <br/>
	  // - le liste con le liste corrispondenti ol, ul a seconda che
	  // siano ordinate o no
	  var render_tag = function render_tag(tag) {
	    var name = tag.name;
	    var args = tag.args;
	    return name === 'p' ? args.join('<br/>') : dom[name](args.map(function (x) {
	      return dom.li(x.replace(lists[name], '')); // toglie "- " o "+ "
	    }).join(''));
	  };
	
	  // elenco trasformazioni inline
	  var inline = {
	    strong: function strong(src) {
	      return src.replace(/(\*\*)(?=\S)([^\r]*?\S[*]*)\1/g, "<strong>$2</strong>");
	    },
	    em: function em(src) {
	      return src.replace(/(\*)(?=\S)([^\r]*?\S)\1/g, "<em>$2</em>");
	    },
	    link: function link(src) {
	      return src.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?(.*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, function (wholeMatch, m1, text, m3, url) {
	        var isMailto = url.indexOf('mailto:') === 0;
	        var self = url.indexOf('self:') === 0;
	        var isJS = url.indexOf('javascript:') === 0; // eslint-disable-line no-script-url
	        var target = '_blank';
	        if (isMailto) {
	          target = '';
	        }
	        if (self) {
	          target = '_self';
	          url = url.substring(5, url.length);
	        }
	        if (isJS) {
	          target = '#';
	        }
	        // non uso attr() altrimenti farei due volte l'escape_html()
	        return '<a href="' + url + '" target="' + target + '">' + text + '</a>';
	      });
	    }
	  };
	
	  var lists = {
	    ul: /^- /,
	    ol: /^\+ /
	  };
	
	  // data una linea quel'è il tag più appropriato per
	  // farne il rendering
	  var detect_tag = function detect_tag(line) {
	    return lists.ul.exec(line) ? 'ul' : lists.ol.exec(line) ? 'ol' : 'p';
	  };
	
	  return function (md) {
	
	    assert(Str.is(md));
	
	    // uniformo gli a capo a \n
	    var uniformed = md.replace(/\r\n|\r/g, '\n');
	
	    // elimino tag molesti
	    var escaped = escape_html(uniformed);
	
	    // applico le trasformazioni inline
	    var inlined = fold(['link', 'strong', 'em'], escaped, function (ret, x) {
	      return inline[x](ret);
	    });
	
	    // divido il sorgente ottenuto in blocchi divisi dagli a capo
	    // e faccio un trim delle righe
	    var lines = inlined.split('\n').map(function (s) {
	      return s.trim();
	    });
	
	    // analizzo i blocchi per determinare i tag
	    var tags = [];
	    var old_tag;
	    lines.forEach(function (line) {
	      var new_tag = detect_tag(line);
	      if (new_tag !== old_tag) {
	        tags.push({
	          name: new_tag,
	          args: []
	        });
	      }
	      tags[tags.length - 1].args.push(line);
	      old_tag = new_tag;
	    });
	
	    // render dei tag trovati
	    return tags.map(render_tag).join('');
	  };
	})();
	
	// # html
	
	function escape_html(s) {
	  assert(Str.is(s));
	
	  return s.replace(/&(?!\w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
	}
	
	function abbr(s, max_length) {
	  assert(Str.is(s));
	  assert(Natural.is(max_length));
	  return "<span" + attr2("title", s) + ">" + escape_html(truncate(s, max_length)) + "</span>";
	}
	
	// # renderers di basso livello degli oggetti html più comuni
	// - textbox
	// - textarea
	// - gruppo di radio
	// - select
	// - data
	// - table
	
	function radio_group(options, name, attrs, value) {
	  attrs = attrs || {};
	  attrs['class'] = attrs['class'] || [];
	
	  var opt = function opt(option) {
	    assert(Str_Option.is(option));
	    return '<div class="group-input">' + dom.radio({
	      value: option[0],
	      name: name,
	      checked: option[0] === value
	    }) + '</div><div class="group-label">' + option[1] + '</div>';
	  };
	
	  return dom.div(options.map(opt).join(''), attrs);
	}
	
	function date_option(i) {
	  var s = pad_time(i);
	  return [s, s];
	}
	
	var EMPTY_OPTION = ['', '-'];
	var DAYS = [EMPTY_OPTION].concat(range(1, 31, 1).map(date_option));
	var MONTHS = [EMPTY_OPTION].concat(range(1, 12, 1).map(date_option));
	var HOURS = [EMPTY_OPTION].concat(range(0, 23, 1).map(date_option));
	var MINUTES = [EMPTY_OPTION].concat(range(0, 59, 1).map(date_option));
	
	function date(attrs, value, order) {
	  attrs = attrs || {};
	  var parts = !Nil.is(value) ? date_parts(value) : {};
	  var ui_parts = {
	    DD: dom.select_of_options(DAYS, {
	      "class": "days"
	    }, parts.DD),
	    MM: dom.select_of_options(MONTHS, {
	      "class": "months"
	    }, parts.MM),
	    YY: dom.textbox({
	      size: 4,
	      maxlength: 4,
	      "class": "years",
	      value: parts.YY
	    }),
	    hh: dom.select_of_options(HOURS, {
	      "class": "hours"
	    }, parts.hh),
	    mm: dom.select_of_options(MINUTES, {
	      "class": "minutes"
	    }, parts.mm)
	  };
	
	  return dom.div(order.map(function (part) {
	    return ui_parts[part];
	  }).join(''), attrs);
	}
	
	function table(columns, rows, attrs) {
	  assert(List(Str).is(columns));
	  //assert(List(List(Str)).is(rows));
	  assert(Maybe(Obj).is(attrs));
	  var html = '<table' + attr(attrs || {}) + '>';
	  html += table.thead(columns);
	  html += table.tbody(rows);
	  html += '</table>';
	  return html;
	}
	
	table.tbody = function (rows) {
	  var html = ['<tbody>'];
	  rows.forEach(function (row, i) {
	    html.push('<tr class="', is_even(i) ? 'odd' : 'even', ' tr_', i, '">');
	    row.forEach(function (cell, j) {
	      html.push('<td class="td_', j, '">', cell, '</td>');
	    });
	    html.push('</tr>');
	  });
	  html.push('</tbody>');
	  return html.join('');
	};
	
	table.thead = function (columns) {
	  var html = '<thead><tr>';
	  columns.forEach(function (column, j) {
	    html += '<th class="th_' + j + '">' + column + '</th>';
	  });
	  html += '</tr></thead>';
	  return html;
	};
	
	function attr2(name, value) {
	  assert(Attr_Name.is(name));
	
	  if (!Attr_Value.is(value)) {
	    return '';
	  }
	
	  var n = name.trim();
	  // trasformo value in una stringa; value potrebbe essere un numero, un array
	  // nel caso name sia 'class' oppure un oggetto se name = 'style'
	  var v = String(n === 'class' && Arr.is(value) ? value.join(' ') : n === 'style' && Obj.is(value) ? css(value) : value);
	  return ' ' + n + '="' + escape_html(v.trim()) + '"';
	}
	
	function attr(obj) {
	  assert(Obj.is(obj));
	  var ret = [];
	  for (var k in obj) {
	    ret.push(attr2(k, obj[k]));
	  }
	  return ret.sort().join(''); // li ordino in modo che sia più facile fare i test
	}
	
	function css(obj) {
	  assert(Obj.is(obj));
	  var ret = [];
	  for (var k in obj) {
	    ret.push(css2(k, obj[k]));
	  }
	  return ret.sort().join(''); // li ordino in modo che sia più facile fare i test
	}
	
	function css2(name, value) {
	  assert(Attr_Name.is(name));
	  assert(Maybe(JSON_Value).is(value));
	
	  if (Nil.is(value)) {
	    return '';
	  }
	
	  var background_image_of_url = function background_image_of_url(url) {
	    url = url.replace("(", "%28").replace(")", "%29");
	    return "url(" + url + ")";
	  };
	
	  var n = name.trim();
	  // - se lo stile è background-image devo assicurarmi che l'url
	  // contenuto in value non abbia parentesi e wrapparlo con url(...)
	  // - se value è un numero allora sono pixel e aggiungo
	  // il suffisso "px"
	  var v = String(name === 'background-image' ? background_image_of_url(value) : Num.is(value) ? value + "px" : value);
	  return n + ": " + v.trim() + ";";
	}
	
	// divide gli stili che riguardano i margini dagli altri
	// serve a costruire input per la Form
	
	function split_margins(style) {
	  function is_margin(k) {
	    return k.indexOf('margin') !== -1;
	  }
	
	  style = style || {};
	  var ret = {
	    margins: {},
	    other: {}
	  };
	  for (var k in style) {
	    if (is_margin(k)) {
	      ret.margins[k] = style[k];
	    } else {
	      ret.other[k] = style[k];
	    }
	  }
	  return ret;
	}
	
	var Message_Type = Enum('success error warning danger'.split(' '));
	
	function Message(type, id, args) {
	  assert(Message_Type.is(type));
	  assert(Str.is(id));
	  assert(Maybe(Obj).is(args));
	  this.type = type;
	  this.id = id;
	  this.args = args;
	  return freeze(this);
	}
	
	Message.is = function (x) {
	  return x instanceof Message;
	};
	
	Message.of = function (x) {
	  assert(Obj.is(x));
	  return new Message(Message_Type.of(x.type), Str.of(x.id), Maybe(Obj).of(x.args));
	};
	
	Message.prototype.translate = function (locale) {
	  var src = this.bundle(locale)[this.id];
	  return template(src)(this.args);
	};
	
	Message.to_std_message = function (type, body, closeable) {
	  return ['<div class="alert ' + type + '">', closeable ? '<a class="close" href="#">&times;</a>' : '', // aggiungo la X di chiusura, se è il caso
	  body, '</div>'].join('');
	};
	
	Message.to_html = function (message, locale) {
	  assert(Maybe(Message).is(message));
	  assert(Locale.is(locale));
	  if (!message) {
	    return '';
	  }
	  return Message.to_std_message(message.type, micromd(message.translate(locale)), false);
	};
	
	// Widget
	
	var Widget_Interface = Interface({
	  to_html: Func,
	  start: Func,
	  stop: Func
	});
	
	function Widget(to_html, start, stop) {
	  assert(Union([Str, Func]).is(to_html));
	  assert(Maybe(Func).is(start));
	  assert(Maybe(Func).is(stop));
	  this.to_html = Str.is(to_html) ? function () {
	    return to_html;
	  } : to_html;
	  this.start = start || noop;
	  this.stop = stop || noop;
	  return freeze(this);
	}
	
	Widget.concat = function (widgets, tmpl) {
	  assert(List(Widget_Interface).is(widgets));
	
	  // di default concateno i widget uno dopo l'altro
	  tmpl = tmpl || widgets.map(function (w, i) {
	    return '<%= $' + i + ' %>';
	  }).join('');
	
	  var to_html = function to_html() {
	    var locals = {};
	    widgets.forEach(function (w, i) {
	      locals['$' + i] = w.to_html();
	    });
	    return template(tmpl)(locals);
	  };
	
	  var start = function start() {
	    widgets.forEach(function (w) {
	      w.start();
	    });
	  };
	
	  var stop = function stop() {
	    widgets.forEach(function (w) {
	      w.stop();
	    });
	  };
	
	  return new Widget(to_html, start, stop);
	};
	
	// Form
	
	var Form_Cell = Union([Str, Obj]);
	
	function Form(config, data, locale) {
	
	  assert(Obj.is(config));
	  assert(Maybe(Obj).is(config.attrs));
	  assert(Obj.is(data));
	  //  assert(Locale.is(locale));
	
	  var self = this;
	  this.input_list = [];
	  this.input_map = {};
	  this.stacked = !!config.stacked;
	  this.attrs = config.attrs || {};
	  this.rows = config.rows.map(function (row) {
	    return row.map(function (cell) {
	      assert(Form_Cell.is(cell));
	      if (Str.is(cell)) {
	        return cell;
	      } else {
	        assert(Str.is(cell.type)); // un input deve avere un tipo
	        assert(Str.is(cell.id)); // un input deve avere un id
	        assert(!self.input_map[cell.id]); // controllo che gli id siano tutti diversi
	        var input_ctor = Form.get_input(cell.type);
	        assert(Func.is(input_ctor), 'unknown input ' + cell.type); // controllo che l'input sia censito
	        var input = input_ctor(cell);
	        self.input_list.push(input);
	        self.input_map[input.id] = input;
	        return input;
	      }
	    });
	  });
	  this.data = data;
	  this.locale = locale;
	  return freeze(this);
	}
	
	Form.is = function (x) {
	  return x instanceof Form;
	};
	
	// per censire i tipi di input provvedo ad un paio di metodi
	(function () {
	
	  var inputs = {};
	
	  Form.add_input = function (type, input_ctor) {
	    assert(!inputs.hasOwnProperty(type));
	    inputs[type] = input_ctor;
	    return Form;
	  };
	
	  Form.get_input = function (id) {
	    return inputs[id].of ? inputs[id].of : inputs[id];
	  };
	})();
	
	Form.prototype.to_html = function (context) {
	  function form(stacked, attrs, rows) {
	
	    assert(Nil.is(attrs['class']));
	    attrs = attrs || {};
	    attrs['class'] = 'form' + (stacked ? ' form-stacked' : ' form-inline');
	
	    var html = [];
	    for (var i = 0, rows_len = rows.length; i < rows_len; i++) {
	      var row = rows[i];
	      var cells_len = row.length;
	      html.push('<div', attr({
	        'class': ['form-group', 'form-group-' + i, 'nr-form-cells-' + cells_len]
	      }), '>');
	      for (var j = 0; j < cells_len; j++) {
	        html.push(dom.div(row[j], {
	          'class': ['form-cell', 'form-cell-' + j]
	        }));
	      }
	      html.push('</div>');
	    }
	    return dom.div(html.join(''), attrs);
	  }
	
	  var data = this.data;
	  var locale = this.locale;
	  var value;
	  var rows = this.rows.map(function (row) {
	    return row.map(function (cell) {
	      if (Str.is(cell)) {
	        return cell;
	      } else {
	        value = data[cell.id];
	        if (Nil.is(value)) {
	          // normalizzo le non risposte al valore null
	          value = null;
	        }
	        if (Obj.is(value)) {
	          value = String(value);
	        }
	        return cell.to_html(value, locale, context);
	      }
	    });
	  });
	  return form(this.stacked, this.attrs, rows);
	};
	
	// attiva gli input contenuti nella form chiamando il loro metodo start(locale) se esiste.
	Form.prototype.start = function () {
	  var locale = this.locale;
	  this.input_list.forEach(function (input) {
	    if (Func.is(input.start)) {
	      input.start(locale);
	    }
	  });
	};
	
	// mette il focus sul primo input che lo supporta
	Form.prototype.focus = function () {
	  var focused = false;
	  any(this.input_list, function (input) {
	    if (Func.is(input.focus) && !focused) {
	      input.focus();
	      return true;
	    }
	    return false;
	  });
	};
	
	// attiva gli input e mette il focus
	Form.prototype.start_and_focus = function () {
	  this.start();
	  this.focus();
	};
	
	// disattiva gli input
	Form.prototype.stop = function () {
	  this.input_list.forEach(function (input) {
	    if (Func.is(input.stop)) {
	      input.stop();
	    }
	  });
	};
	
	// una mappa id input -> valore input
	// il parametro opzionale context serve a far arrivare eventuali informazioni
	// di contesto che possono servire agli input
	Form.prototype.value = function (context) {
	  var locale = this.locale;
	  var ret = {};
	  var value;
	  var focused = false;
	  this.input_list.forEach(function (input) {
	    value = input.value(locale, context);
	    if (value.rule) {
	      // metto il focus sul primo input che è andato male
	      if (!focused && Func.is(input.focus)) {
	        input.focus();
	        focused = true;
	      }
	      ret = null;
	    } else if (ret) {
	      ret[input.id] = value.x;
	    }
	  });
	  return ret;
	};
	
	Form.wrap_input = function (id, html, style, hint) {
	  return ['<div' + attr({
	    'class': 'input-wrapper',
	    style: style
	  }) + '>', html, '<div' + attr({
	    "class": "error",
	    id: id + "_error"
	  }) + '></div>', '<div' + attr({
	    "class": "hint",
	    id: id + "_hint"
	  }) + '>', hint || '', '</div>', '</div>'].join('');
	};
	
	// Inputs
	/*
	var Textbox_Input_Schema = Union([Str_Schema, Num_Schema]);
	
	Textbox_Input_Schema.of = function(x) {
	  return Textbox_Input_Schema(Schema.of(x));
	};
	
	function Textbox_Input(id, schema, is_multiline, attrs, hint) {
	  assert(Str.is(id));
	  assert(Textbox_Input_Schema.is(schema));
	  assert(Maybe(Bool).is(is_multiline));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'textbox';
	  this.id = id;
	  this.schema = schema;
	  this.is_multiline = is_multiline;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Textbox_Input.is = function(x) {
	  return x instanceof Textbox_Input;
	};
	
	Textbox_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Textbox_Input(
	    Str.of(x.id),
	    Textbox_Input_Schema.of(x.schema),
	    Maybe(Bool).of(x.is_multiline),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	
	Textbox_Input.prototype.to_html = function(value, locale) {
	  assert(Maybe(JSON_Value).is(value));
	  assert(Locale.is(locale));
	  var id = this.id;
	  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = split_margins(attrs.style);
	  attrs.style = styles.other;
	  if (this.is_multiline) {
	    return Form.wrap_input(id, dom.textarea(value, attrs), styles.margins, this.hint);
	  }
	  attrs.value = JSON_Value.format(locale, this.schema, value);
	  return Form.wrap_input(id, dom.textbox(attrs), styles.margins, this.hint);
	};
	
	Textbox_Input.prototype.focus = function() {
	  $('#' + this.id).focus();
	};
	
	Textbox_Input.prototype.set_error = function(message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Textbox_Input.prototype.value = function(locale) {
	  assert(Locale.is(locale));
	  var value = $('#' + this.id).val();
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	Form.add_input('textbox', Textbox_Input);
	*/
	/*
	function Select_Input(id, options, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(List(Str_Option).is(options));
	  assert(Str_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'select';
	  this.id = id;
	  this.options = options;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Select_Input.is = function(x) {
	  return x instanceof Select_Input;
	};
	
	Select_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Select_Input(
	    Str.of(x.id),
	    List(Str_Option).of(x.options),
	    Str_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	
	Select_Input.prototype.to_html = function(value, locale) {
	  assert(Maybe(JSON_Value).is(value));
	  assert(Locale.is(locale));
	  var id = this.id;
	  var options = [EMPTY_OPTION].concat(this.options);
	  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = split_margins(attrs.style);
	  attrs.style = styles.other;
	  return Form.wrap_input(id, dom.select_of_options(options, attrs, value), styles.margins, this.hint);
	};
	
	Select_Input.prototype.focus = function() {
	  $('#' + this.id).focus();
	};
	
	Select_Input.prototype.set_error = function(message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Select_Input.prototype.value = function(locale) {
	  assert(Locale.is(locale));
	  var value = $('#' + this.id).val();
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	Form.add_input('select', Select_Input);
	*/
	/*
	function Date_Input(id, is_accurate, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(Maybe(Bool).is(is_accurate));
	  assert(Date_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'date';
	  this.id = id;
	  this.is_accurate = is_accurate;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	
	
	Date_Input.is = function(x) {
	  return x instanceof Date_Input;
	};
	
	Date_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Date_Input(
	    Str.of(x.id),
	    Maybe(Bool).of(x.is_accurate),
	    Date_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	
	Date_Input.prototype.to_html = function(value, locale) {
	  assert(Maybe(JSON_Value).is(value));
	  assert(Locale.is(locale));
	  var id = this.id;
	  var order = this.is_accurate ?
	    locale.locale_bundle().date.accurate_order :
	    locale.locale_bundle().date.order;
	  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = split_margins(attrs.style);
	  attrs.style = styles.other;
	  return Form.wrap_input(id, date(attrs, value, order), styles.margins, this.hint);
	};
	
	Date_Input.prototype.focus = function() {
	  $('#' + this.id).children().get(0).focus();
	};
	
	Date_Input.prototype.set_error = function(message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Date_Input.prototype.value = function(locale) {
	  assert(Locale.is(locale));
	  var id = this.id;
	  var value = [
	    $('#' + id + " .years").val(),
	    $('#' + id + " .months").val(),
	    $('#' + id + " .days").val()
	  ];
	  if (this.is_accurate) {
	    value.push(
	      $('#' + id + " .hours").val(),
	      $('#' + id + " .minutes").val()
	    );
	  }
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	Form.add_input('date', Date_Input);
	*/
	/*
	function Checkbox_Input(id, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(Bool_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'checkbox';
	  this.id = id;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Checkbox_Input.is = function(x) {
	  return x instanceof Checkbox_Input;
	};
	
	Checkbox_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Checkbox_Input(
	    Str.of(x.id),
	    Bool_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	
	Checkbox_Input.prototype.to_html = function(value, locale) {
	  assert(Maybe(JSON_Value).is(value));
	  assert(Locale.is(locale));
	  var id = this.id;
	  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
	  attrs.id = id;
	  attrs.checked = value;
	  var styles = split_margins(attrs.style);
	  attrs.style = styles.other;
	  return Form.wrap_input(id, dom.checkbox(attrs), styles.margins, this.hint);
	};
	
	Checkbox_Input.prototype.focus = function() {
	  $('#' + this.id).focus();
	};
	
	Checkbox_Input.prototype.set_error = function(message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Checkbox_Input.prototype.value = function(locale) {
	  assert(Locale.is(locale));
	  var id = this.id;
	  var checked = $('#' + id).is(':checked');
	  var validation = this.schema.validate(checked, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	Form.add_input('checkbox', Checkbox_Input);
	
	function Radio_Input(id, options, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(List(Str_Option).is(options));
	  assert(Str_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'radio';
	  this.id = id;
	  this.options = options;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Radio_Input.is = function(x) {
	  return x instanceof Radio_Input;
	};
	
	Radio_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Radio_Input(
	    Str.of(x.id),
	    List(Str_Option).of(x.options),
	    Str_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	
	Radio_Input.prototype.to_html = function(value, locale) {
	  assert(Maybe(JSON_Value).is(value));
	  assert(Locale.is(locale));
	  var id = this.id;
	  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = split_margins(attrs.style);
	  attrs.style = styles.other;
	  return Form.wrap_input(id, radio_group(this.options, id, attrs, value), styles.margins, this.hint);
	};
	
	Radio_Input.prototype.focus = function() {
	  $('#' + this.id + ' input[type=radio]').get(0).focus();
	};
	
	Radio_Input.prototype.set_error = function(message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Radio_Input.prototype.value = function(locale) {
	  assert(Locale.is(locale));
	  var id = this.id;
	  var value = $('#' + id + ' input[type=radio]:checked').val() || "";
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	Form.add_input('radio', Radio_Input);
	*/
	
	function load_css(href) {
	  var doc = document,
	      head = doc.head || doc.getElementsByTagName("head")[0],
	      link = doc.createElement('link');
	
	  link.type = 'text/css';
	  link.rel = 'stylesheet';
	  link.href = href;
	  head.appendChild(link);
	}
	
	var dom = {};
	
	function build_tag_factory(tag_name, can_have_content) {
	  if (can_have_content) {
	    return function (content, attrs) {
	      return '<' + tag_name + attr(attrs || {}) + '>' + (content || '') + '</' + tag_name + '>';
	    };
	  } else {
	    return function (attrs) {
	      return '<' + tag_name + attr(attrs || {}) + '/>';
	    };
	  }
	}
	
	// build empty tags
	'input'.split(' ').map(function (tagname) {
	  dom[tagname] = build_tag_factory(tagname, false);
	});
	// build rest of tags
	'a button div h2 h3 label li ol option select small table textarea ul'.split(' ').map(function (tagname) {
	  dom[tagname] = build_tag_factory(tagname, true);
	});
	
	// inputs
	
	function build_input_factory(type) {
	  return function (attrs) {
	    attrs = attrs || {};
	    attrs.type = attrs.type || type; // altrimenti non riesco a costruire una input type="password"
	    return dom.input(attrs);
	  };
	}
	
	dom.textbox = build_input_factory('text');
	dom.password = build_input_factory('password');
	dom.checkbox = build_input_factory('checkbox');
	dom.radio = build_input_factory('radio');
	
	dom.select_of_options = function (options, attrs, selected_option_value) {
	  var option_of_tuple = function option_of_tuple(tuple) {
	    return dom.option(tuple[1], {
	      value: tuple[0],
	      selected: selected_option_value === tuple[0]
	    });
	  };
	  return dom.select(options.map(option_of_tuple).join(''), attrs);
	};
	
	dom.link_button = function (content, attrs) {
	  attrs = attrs || {};
	  attrs.href = attrs.href ? attrs.href : '#';
	  return dom.a(content, attrs);
	};
	
	// Server api
	
	var Http_Method = Enum(['get', 'post']);
	var Http_Data_Type = Enum(['json']);
	var Http_Params = Dict(Str, Func);
	
	function Http(async, url, method, data_type, url_params, form_params) {
	  assert(Bool.is(async));
	  assert(Str.is(url));
	  assert(Http_Method.is(method));
	  assert(Http_Data_Type.is(data_type));
	  assert(Maybe(Http_Params).is(url_params));
	  assert(Maybe(Http_Params).is(form_params));
	
	  this.async = async;
	  this.url = url;
	  this.method = method;
	  this.data_type = data_type;
	  this.url_params = url_params;
	  this.form_params = form_params;
	  return freeze(this);
	}
	
	Http.is = function (x) {
	  return x instanceof Http;
	};
	
	Http.of = function (x) {
	  assert(Obj.is(x));
	  return new Http(Bool.of(x.async), Str.of(x.url), Http_Method.of(x.method), Http_Data_Type.of(x.data_type || 'json'), // default json
	  Maybe(Http_Params).of(x.url_params), Maybe(Http_Params).of(x.form_params));
	};
	
	Http.parse_response = function (response) {
	  try {
	    return response ? JSON.parse(response) : null;
	  } catch (e) {
	    return null;
	  }
	};
	
	Http.checked_error = function (xhr, text_status, thrown_error) {
	  var json = Http.parse_response(xhr.responseText);
	  if (json && !Nil.is(json.error)) {
	    return Err.of({
	      name: json.error,
	      response_error: json
	    });
	  }
	  return Http.unexpected_error(xhr, text_status, thrown_error);
	};
	
	Http.unexpected_error = function (xhr, text_status, thrown_error) {
	  if (text_status === "timeout") {
	    xhr.abort();
	    return Err.of({
	      name: "timeout",
	      message: "timeout"
	    });
	  }
	  return Err.of({
	    name: thrown_error
	  });
	};
	
	Http.to_error = function (args, xhr, text_status, thrown_error) {
	  var err = text_status === "error" && xhr ? Http.checked_error(xhr, text_status, thrown_error) : Http.unexpected_error(xhr, text_status, thrown_error);
	  err.request = this;
	  err.args = args;
	  err.xhr = xhr;
	  return err;
	};
	
	Http.prototype.to_func = function () {
	  var self = this;
	  return function (args, callback) {
	    assert(Obj.is(args));
	    assert(Maybe(Func).is(callback));
	
	    var url_args = {};
	    var form_args = {};
	    var param;
	    var arg;
	
	    for (param in self.url_params) {
	      arg = args[param];
	      // controllo il tipo dei parametri
	      assert(self.url_params[param].is(arg));
	      // converto gli argomenti in stringa
	      /*
	          arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
	          // i parametri nell'url vanno encondati
	          url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
	      */
	      if (arg) {
	        arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
	        // i parametri nell'url vanno encondati
	        url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
	      } else {
	        url_args[encodeURIComponent(param)] = "";
	      }
	    }
	    for (param in self.form_params) {
	      arg = args[param];
	      // controllo il tipo delle form
	      assert(self.form_params[param].is(arg));
	      // converto gli argomenti in stringa
	      arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
	      form_args[param] = arg;
	    }
	
	    // fix IE bug: se method = "post" e non c'è nessun parametro nella form, IE manda una chiamata in GET
	    if (self.method === 'post' && Obj.is_empty(form_args)) {
	      form_args["__noemptybody__"] = "";
	    }
	
	    // converto la configurazione dell'api in una configurazione del metodo ajax() di jQuery
	    var url = template(self.url)(url_args);
	    var config = {
	      async: self.async,
	      cache: false,
	      type: self.method,
	      dataType: self.data_type,
	      url: url,
	      data: form_args
	    };
	
	    var request = $.ajax(config);
	    if (callback) {
	      request.then(function (response) {
	        callback(null, response);
	      }, function (xhr, text_status, thrown_error) {
	        callback(Http.to_error(args, xhr, text_status, thrown_error));
	      });
	      return null;
	    } else {
	      return request.then(function (response) {
	        return response;
	      }, function (xhr, text_status, thrown_error) {
	        return Http.to_error(args, xhr, text_status, thrown_error);
	      }).promise();
	    }
	  };
	};
	
	function http(config) {
	  return Http.of(config).to_func();
	}
	
	//
	// single page application
	//
	
	function Unexpected_Error_State(err) {
	  assert(err instanceof Error);
	  this.name = 'unexpected_error';
	  this.err = err;
	  return freeze(this);
	}
	
	Unexpected_Error_State.prototype.to_widget = function (app, callback) {
	  var html = ['<div id="unexpected_error" class="alert error">', '<h1>Unexpected error :-(</h1>', '<pre>', JSON.stringify(this.err, null, 4), '</pre>', '</div>'].join('');
	  callback(new Widget(html));
	};
	
	function Disabled_Cookies_State() {
	  this.name = 'disabled_cookies';
	  return freeze(this);
	}
	
	Disabled_Cookies_State.prototype.to_widget = function (app, callback) {
	  var html = ['<div id="disabled_cookies" class="alert error">', '<h1>Cookies not enabled</h1>', '<p>This web application requires enabled cookies.\nPlease make sure cookies are enabled in your browser and try again.</pre>', '</div>'].join('');
	  callback(new Widget(html));
	};
	
	var SPA = {
	  protect_method: function protect_method(f) {
	    return function (args, callback) {
	      $('body').addClass('wait');
	      f(args, function (err, result) {
	        $('body').removeClass('wait');
	        callback(err, result);
	      });
	    };
	  },
	  extend: function extend(ctor, options) {
	
	    assert(Func.is(ctor));
	    assert(Maybe(Obj).is(options));
	
	    options = options || {};
	    options.view_id = options.view_id || 'view';
	    options.scroll_selector = options.scroll_selector || 'html, body';
	    options.on_start = options.on_start || noop;
	    options.on_state_load = options.on_state_load || noop;
	
	    // to_html()
	    ctor.prototype.to_html = ctor.prototype.to_html || function () {
	      var html = '<div id="' + options.view_id + '"></div>';
	      if ($('#shield').length === 0) {
	        html += '<div id="shield"></div>';
	      }
	      if ($('#ajax').length === 0) {
	        html += '<div id="ajax"><div></div></div>';
	      }
	      return html;
	    };
	
	    // start()
	    assert(Nil.is(ctor.prototype.start));
	    ctor.prototype.start = function () {
	      options.on_start.call(this);
	      if (options.cookies && !is_cookies_enabled()) {
	        this.io(new Disabled_Cookies_State());
	      } else {
	        this.io(this.state);
	      }
	    };
	
	    // stop()
	    assert(Nil.is(ctor.prototype.stop));
	    ctor.prototype.stop = function () {
	      if (this.widget) {
	        this.widget.stop();
	      }
	    };
	
	    // render_to($el)
	    assert(Nil.is(ctor.prototype.render_to));
	    ctor.prototype.render_to = function ($el) {
	      $(this.to_html()).appendTo($el);
	      this.start();
	      return this;
	    };
	
	    // io()
	    assert(Nil.is(ctor.prototype.io));
	    ctor.prototype.io = function (state) {
	
	      assert(Obj.is(state));
	      assert(Func.is(state.to_widget));
	
	      var app = this;
	
	      function mountWidget(widget) {
	        app.widget = widget;
	        $('#' + options.view_id).html(widget.to_html());
	        widget.start();
	      }
	
	      this.stop();
	      this.state = state;
	      state.to_widget(this, function (widget) {
	
	        if (widget instanceof Widget) {
	          mountWidget(widget);
	        } else {}
	        //mountComponent(widget);
	
	        // a volte non mi interessa far scrollare la pagina in cima
	        // ad esempio se viene fatto un update frequente in una parte della pagina
	        // che so essere molto in fondo e non voglio che l'utente venga
	        // disorientato da un continuo scrolling della pagina
	        if (!state.do_not_scroll) {
	          $(options.scroll_selector).animate({
	            scrollTop: 0
	          }, 'fast');
	        }
	
	        options.on_state_load.call(app);
	      });
	    };
	
	    // se c'è baco non posso fare altro che mostrare lo stack trace
	    assert(Nil.is(ctor.prototype.go_unexpected_err));
	    ctor.prototype.go_unexpected_err = function (err) {
	      this.io(new Unexpected_Error_State(err));
	    };
	
	    return ctor;
	  }
	
	};
	
	module.exports = {
	
	  assert: assert,
	
	  Nil: Nil,
	
	  Str: Str,
	  //String: Str,
	  Num: Num,
	  //Number: Num,
	  Int: Int,
	  Bool: Bool,
	  //Boolean: Bool,
	  Func: Func,
	  //Function: Func,
	  Obj: Obj,
	  //Object: Obj,
	  Arr: Arr,
	  //Array: Arr,
	  Err: Err,
	  //Error: Err,
	  Enum: Enum,
	  //enums: Enum,
	  Subtype: Subtype,
	  //subtype: Subtype,
	  Union: Union,
	  //union: Union,
	  Maybe: Maybe,
	  //maybe: Maybe,
	  List: List,
	  //list: List,
	  Tuple: Tuple,
	  //tuple: Tuple,
	  Dict: Dict,
	  //dict: Dict,
	  Interface: Interface,
	
	  // common types
	  Amount: Amount,
	  Color: Color,
	  Country: Country,
	  Currency: Currency,
	  Datetime: Datetime,
	  Email: Email,
	  JSON_Value: JSON_Value,
	  Language: Language,
	  Locale_Iso: Locale_Iso,
	  Locale: Locale,
	  Natural: Natural,
	  Positive: Positive,
	  URL: URL,
	  UUID: UUID,
	  Markdown: Markdown,
	  Str_Option: Str_Option,
	
	  // tool di sviluppo
	  uuid: uuid,
	  mixin: mixin,
	  merge: merge,
	  copy: copy,
	  log: log,
	  all: all,
	  any: any,
	  keys: keys,
	  values: values,
	  freeze: freeze,
	  prop: prop,
	  by: by,
	  by_description: by_description,
	  noop: noop,
	  map_obj: map_obj,
	  find: find,
	  remove: remove,
	  move: move,
	  compact: compact,
	  Emitter: Emitter,
	  template: template,
	  mustache: mustache,
	  to_obj: to_obj,
	  to_arr: to_arr,
	  http: http,
	  fold: fold,
	  drop: drop,
	  take: take,
	  trim_left: trim_left,
	  trim_right: trim_right,
	  pad_left: pad_left,
	  pad_right: pad_right,
	  pad_center: pad_center,
	  repeat: repeat,
	  to_querystring: to_querystring,
	  parse_querystring: parse_querystring,
	  truncate: truncate,
	  index_of: index_of,
	  unique: unique,
	  flatten: flatten,
	  range: range,
	  to_url: to_url,
	  pluralize: pluralize,
	  starts_with: starts_with,
	  is_integer: is_integer,
	  is_uuid: is_uuid,
	  is_email: is_email,
	  is_digits: is_digits,
	  is_url: is_url,
	  is_https_url: is_https_url,
	  is_color: is_color,
	  is_positive: is_positive,
	  is_not_negative: is_not_negative,
	  is_cookies_enabled: is_cookies_enabled,
	  is_even: is_even,
	
	  // input
	  Str_Format: Str_Format,
	  Str_Schema: Str_Schema,
	  Num_Schema: Num_Schema,
	  Bool_Schema: Bool_Schema,
	  Arr_Schema: Arr_Schema,
	  Date_Schema: Date_Schema,
	  Schema: Schema,
	  Validation: Validation,
	  Rule: Rule,
	  Validation_Monad: Validation_Monad,
	  // html
	  dom: dom,
	  table: table,
	  escape_html: escape_html,
	  abbr: abbr,
	  Widget: Widget,
	  Widget_Interface: Widget_Interface,
	  Form: Form,
	  //Textbox_Input: Textbox_Input,
	  EMPTY_OPTION: EMPTY_OPTION,
	  radio_group: radio_group,
	  micromd: micromd,
	  attr2: attr2,
	  attr: attr,
	  css: css,
	  split_margins: split_margins,
	  Message: Message,
	  load_css: load_css,
	
	  SPA: SPA,
	  Number_Format: Number_Format,
	  date: date
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var CLICK = 'click';
	
	// Rappresenta una finestra modale generica
	// Si possono aprire più modali contemporaneamente
	// e si può specificare se l'utente può chiuderla o meno
	
	function Modal(width, body, is_closable) {
	
	  _jsdk2['default'].assert(_jsdk2['default'].Natural.is(width));
	  _jsdk2['default'].assert(_jsdk2['default'].Str.is(body));
	  _jsdk2['default'].assert(_jsdk2['default'].Bool.is(is_closable));
	  this.width = width;
	  this.body = body;
	  this.is_closable = is_closable;
	  return _jsdk2['default'].freeze(this);
	}
	
	Modal.overlay = function (attrs) {
	  attrs = attrs ? _jsdk2['default'].copy(attrs) : {};
	  attrs['class'] = attrs['class'] || [];
	  attrs['class'].push('overlay');
	  return '<div' + _jsdk2['default'].attr(attrs) + '></div>';
	};
	
	Modal.header = function (s) {
	  return '<div class="modal-header">' + s + "</div>";
	};
	
	Modal.section = function (s) {
	  return '<div class="modal-section">' + s + "</div>";
	};
	
	Modal.footer = function (s) {
	  return '<div class="modal-footer">' + s + "</div>";
	};
	
	Modal.close_button = function () {
	  return '<div class="modal-close"></div>';
	};
	
	Modal.prototype.to_html = function () {
	  return ['<div id="modal-container">', Modal.overlay(), '<div class="modal">', '<div', _jsdk2['default'].attr({
	    'class': 'modal-body',
	    style: {
	      'max-width': this.width
	    }
	  }), '>', this.is_closable ? Modal.close_button() : "", this.body, '</div>', '</div>', '</div>'].join('');
	};
	
	Modal.prototype.to_widget = function () {
	  var self = this;
	  var start = function start() {
	    $('#modal-container').on(CLICK, '.modal-close', function () {
	      stop();
	    });
	    // scroll top
	    $('html, body').animate({
	      scrollTop: 0
	    }, 'fast');
	  };
	  var stop = function stop() {
	    $('#modal-container').off().remove();
	  };
	  return new _jsdk2['default'].Widget(self.to_html(), start, stop);
	};
	
	// Rappresenta l'interfaccia di una finestra di dialogo in cui
	// la modale è divisa in tre parti
	// - l'header opzionale
	// - la sezione centrale obbligatoria
	// - il footer opzionale
	
	function Dialog(width, body, footer, header) {
	  _jsdk2['default'].assert(_jsdk2['default'].Natural.is(width));
	  _jsdk2['default'].assert(_jsdk2['default'].Str.is(body));
	  _jsdk2['default'].assert(_jsdk2['default'].Maybe(_jsdk2['default'].Str).is(body));
	  _jsdk2['default'].assert(_jsdk2['default'].Maybe(_jsdk2['default'].Str).is(body));
	  this.width = width;
	  this.body = body;
	  this.footer = footer;
	  this.header = header;
	  return _jsdk2['default'].freeze(this);
	}
	
	Dialog.prototype.to_widget = function () {
	  var content = [this.header ? Modal.header(this.header) : '', Modal.section(this.body), this.footer ? Modal.footer(this.footer) : ''].join('');
	  var modal = new Modal(this.width, content, false);
	  return modal.to_widget();
	};
	
	// Rappresenta l'interfaccia di una finestra di alert
	// Il locale serve per mostrare il bottone di chisura localizzato
	
	function Alert(locale, width, body, opt_header) {
	  _jsdk2['default'].assert(_jsdk2['default'].Locale.is(locale));
	  _jsdk2['default'].assert(_jsdk2['default'].Natural.is(width));
	  _jsdk2['default'].assert(_jsdk2['default'].Str.is(body));
	  _jsdk2['default'].assert(_jsdk2['default'].Maybe(_jsdk2['default'].Str).is(opt_header));
	  this.locale = locale;
	  this.width = width;
	  this.body = body;
	  this.header = opt_header;
	  return _jsdk2['default'].freeze(this);
	}
	
	Alert.prototype.to_widget = function (options) {
	  options = options || {};
	  var locale = this.locale;
	  var close = locale.language_bundle().button.close;
	  var footer = [_jsdk2['default'].dom.button(close, {
	    id: 'do_close_alert'
	  })].join('');
	  var dialog = new Dialog(this.width, this.body, footer, this.header);
	  var widget = dialog.to_widget();
	  var start = function start() {
	    widget.start();
	    $('#modal-container').on(CLICK, '#do_close_alert', function () {
	      stop();
	    });
	    if (options.start) {
	      options.start(dialog);
	    }
	  };
	  var stop = function stop() {
	    widget.stop();
	    if (options.stop) {
	      options.stop(dialog);
	    }
	  };
	  return new _jsdk2['default'].Widget(widget.to_html(), start, stop);
	};
	
	Alert.go = function (locale, width, body, opt_header, options) {
	  var a = new Alert(locale, width, body, opt_header, options);
	  var w = a.to_widget(options);
	  $('body').append(w.to_html());
	  w.start();
	  return w;
	};
	
	function Confirm(locale, width, body, opt_header) {
	  //jsdk.assert(jsdk.Locale.is(locale));
	  _jsdk2['default'].assert(_jsdk2['default'].Natural.is(width));
	  _jsdk2['default'].assert(_jsdk2['default'].Str.is(body));
	  _jsdk2['default'].assert(_jsdk2['default'].Maybe(_jsdk2['default'].Str).is(opt_header));
	  this.locale = locale;
	  this.width = width;
	  this.body = body;
	  this.header = opt_header;
	  return _jsdk2['default'].freeze(this);
	}
	
	// Rappresenta l'interfaccia di una finestra di richiesta comferma
	// Il locale serve per mostrare i bottoni localizzati
	Confirm.prototype.to_widget = function (callback) {
	  _jsdk2['default'].assert(_jsdk2['default'].Func.is(callback));
	  var locale = this.locale;
	  var bundle = locale.language_bundle().bool;
	  var yes = bundle.TRUE;
	  var no = bundle.FALSE;
	  var footer = [_jsdk2['default'].dom.button(yes, {
	    id: 'do_yes'
	  }), _jsdk2['default'].dom.button(no, {
	    id: 'do_no',
	    'class': ['primary']
	  })].join('');
	  var dialog = new Dialog(this.width, this.body, footer, this.header);
	  var widget = dialog.to_widget();
	  var start = function start() {
	    widget.start();
	    $('#modal-container').on(CLICK, '#do_yes', function () {
	      stop();
	      callback(true);
	    }).on(CLICK, '#do_no', function () {
	      stop();
	      callback(false);
	    });
	  };
	  var stop = function stop() {
	    widget.stop();
	  };
	  return new _jsdk2['default'].Widget(widget.to_html(), start, stop);
	};
	
	Confirm.go = function (callback, locale, width, body, opt_header) {
	  var c = new Confirm(locale, width, body, opt_header);
	  var w = c.to_widget(callback);
	  $('body').append(w.to_html());
	  w.start();
	};
	
	function Prompt(locale, width, form, opt_header, opt_focus) {
	  _jsdk2['default'].assert(_jsdk2['default'].Locale.is(locale));
	  _jsdk2['default'].assert(_jsdk2['default'].Natural.is(width));
	  _jsdk2['default'].assert(_jsdk2['default'].Form.is(form));
	  _jsdk2['default'].assert(_jsdk2['default'].Maybe(_jsdk2['default'].Str).is(opt_header));
	  this.locale = locale;
	  this.width = width;
	  this.form = form;
	  this.header = opt_header;
	  this.focus = opt_focus;
	  return _jsdk2['default'].freeze(this);
	}
	
	Prompt.prototype.to_widget = function (callback) {
	  var self = this;
	  var locale = this.locale;
	  var bundle = locale.language_bundle().button;
	  var ok = bundle.ok;
	  var close = bundle.close;
	  var footer = [_jsdk2['default'].dom.button(ok, {
	    id: 'do_prompt_ok',
	    'class': ['primary']
	  }), _jsdk2['default'].dom.button(close, {
	    id: 'do_prompt_close'
	  })].join('');
	  var form = this.form;
	  var dialog = new Dialog(this.width, form.to_html(), footer, this.header);
	  var widget = dialog.to_widget();
	  var start = function start() {
	    widget.start();
	    if (self.focus) {
	      form.start_and_focus();
	    } else {
	      form.start();
	    }
	    $('#do_prompt_ok').on(CLICK, function () {
	      var value = form.value();
	      if (value) {
	        if (callback(value)) {
	          stop();
	        }
	      }
	    });
	    $('#do_prompt_close').on(CLICK, function () {
	      if (callback(null)) {
	        stop();
	      }
	    });
	    /*$('#modal-container').on(CLICK, '#do_prompt_ok', function() {
	        var value = form.value();
	        if (value) {
	          if (callback(value)) {
	            stop();
	          }
	        }
	      })
	      .on(CLICK, '#do_prompt_close', function() {
	        if (callback(null)) {
	          stop();
	        }
	      });*/
	  };
	  var stop = function stop() {
	    form.stop();
	    widget.stop();
	    $('#modal-container').off().remove();
	  };
	  return new _jsdk2['default'].Widget(widget.to_html(), start, stop);
	};
	
	Prompt.go = function (callback, locale, width, config, data, opt_header, opt_focus) {
	  var p = new Prompt(locale, width, config, data, opt_header, opt_focus);
	  var w = p.to_widget(callback);
	  $('body').append(w.to_html());
	  w.start();
	};
	
	exports.Modal = Modal;
	exports.Dialog = Dialog;
	exports.Alert = Alert;
	exports.Confirm = Confirm;
	exports.Prompt = Prompt;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = ReactDOM;

/***/ },
/* 5 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/*! @preserve
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014-2015 Giulio Canti
	 *
	 */
	
	'use strict';
	
	// overrideable by the user
	exports.stringify = function stringify(x) {
	  try { // handle "Converting circular structure to JSON" error
	    return JSON.stringify(x, null, 2);
	  }
	  catch (e) {
	    return String(x);
	  }
	};
	
	function isNil(x) {
	  return x === null || x === void 0;
	}
	
	function isBoolean(x) {
	  return x === true || x === false;
	}
	
	function isString(x) {
	  return typeof x === 'string';
	}
	
	function isNumber(x) {
	  return typeof x === 'number' && isFinite(x) && !isNaN(x);
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	function isArray(x) {
	  return x instanceof Array;
	}
	
	function isObject(x) {
	  return !isNil(x) && typeof x === 'object' && !isArray(x);
	}
	
	function isType(x) {
	  return isFunction(x) && isObject(x.meta);
	}
	
	function isStruct(x) {
	  return isType(x) && ( x.meta.kind === 'struct' );
	}
	
	function isMaybe(x) {
	  return isType(x) && ( x.meta.kind === 'maybe' );
	}
	
	function isUnion(x) {
	  return isType(x) && ( x.meta.kind === 'union' );
	}
	
	function isTypeName(name) {
	  return isNil(name) || isString(name);
	}
	
	// returns true if x is an instance of type
	function is(x, type) {
	  if (isType(type)) {
	    return type.is(x);
	  }
	  return x instanceof type; // type should be a class constructor
	}
	
	// return true if the type constructor behaves like the identity function (exceptions are the structs)
	function isIdentity(type) {
	  if (isType(type)) {
	    return type.meta.identity;
	  }
	  return true; // ES6 classes are identity for tcomb
	}
	
	// creates an instance of a type, handling the optional new operator
	function create(type, value, path) {
	  if (isType(type)) {
	    // for structs the new operator is allowed
	    return isStruct(type) ? new type(value, path) : type(value, path);
	  }
	
	  if (false) {
	    // here type should be a class constructor and value some instance, just check membership and return the value
	    path = path || [getFunctionName(type)];
	    assert(value instanceof type, function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	  }
	
	  return value;
	}
	
	function getFunctionName(f) {
	  return f.displayName || f.name || '<function' + f.length + '>';
	}
	
	function getTypeName(constructor) {
	  if (isType(constructor)) {
	    return constructor.displayName;
	  }
	  return getFunctionName(constructor);
	}
	
	// overrideable by the user
	exports.fail = function fail(message) {
	  throw new TypeError('[tcomb] ' + message);
	};
	
	function assert(guard, message) {
	  if (guard !== true) {
	    if (isFunction(message)) { // handle lazy messages
	      message = message();
	    }
	    else if (isNil(message)) { // use a default message
	      message = 'Assert failed (turn on "Pause on exceptions" in your Source panel)';
	    }
	    exports.fail(message);
	  }
	}
	
	// safe mixin, cannot override props unless specified
	function mixin(target, source, overwrite) {
	  if (isNil(source)) { return target; }
	  for (var k in source) {
	    if (source.hasOwnProperty(k)) {
	      if (overwrite !== true) {
	        if (false) {
	          assert(!target.hasOwnProperty(k), function () { return 'Invalid call to mixin(target, source, [overwrite]): cannot overwrite property "' + k + '" of target object'; });
	        }
	      }
	      target[k] = source[k];
	    }
	  }
	  return target;
	}
	
	function forbidNewOperator(x, type) {
	  assert(!(x instanceof type), function () { return 'Cannot use the new operator to instantiate the type ' + getTypeName(type); });
	}
	
	function getShallowCopy(x) {
	  if (isArray(x)) {
	    return x.concat();
	  }
	  if (isObject(x)) {
	    return mixin({}, x);
	  }
	  return x;
	}
	
	// immutability helper
	function update(instance, spec) {
	
	  if (false) {
	    assert(isObject(spec), function () { return 'Invalid argument spec ' + exports.stringify(spec) + ' supplied to function update(instance, spec): expected an object containing commands'; });
	  }
	
	  var value = getShallowCopy(instance);
	  var isChanged = false;
	  for (var k in spec) {
	    if (spec.hasOwnProperty(k)) {
	      if (update.commands.hasOwnProperty(k)) {
	        return update.commands[k](spec[k], value);
	      }
	      else {
	        var newValue = update(value[k], spec[k]);
	        isChanged = isChanged || ( newValue !== value[k] );
	        value[k] = newValue;
	      }
	    }
	  }
	  return isChanged ? value : instance;
	}
	
	// built-in commands
	
	function $apply(f, value) {
	  if (false) {
	    assert(isFunction(f), 'Invalid argument f supplied to immutability helper { $apply: f } (expected a function)');
	  }
	  return f(value);
	}
	
	function $push(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper { $push: elements } (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $push (expected an array)');
	  }
	  return arr.concat(elements);
	}
	
	function $remove(keys, obj) {
	  if (false) {
	    assert(isArray(keys), 'Invalid argument keys supplied to immutability helper { $remove: keys } (expected an array)');
	    assert(isObject(obj), 'Invalid value supplied to immutability helper $remove (expected an object)');
	  }
	  for (var i = 0, len = keys.length; i < len; i++ ) {
	    delete obj[keys[i]];
	  }
	  return obj;
	}
	
	function $set(value) {
	  return value;
	}
	
	function $splice(splices, arr) {
	  if (false) {
	    assert(list(Arr).is(splices), 'Invalid argument splices supplied to immutability helper { $splice: splices } (expected an array of arrays)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $splice (expected an array)');
	  }
	  return splices.reduce(function (acc, splice) {
	    acc.splice.apply(acc, splice);
	    return acc;
	  }, arr);
	}
	
	function $swap(config, arr) {
	  if (false) {
	    assert(isObject(config), 'Invalid argument config supplied to immutability helper { $swap: config } (expected an object)');
	    assert(isNumber(config.from), 'Invalid argument config.from supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isNumber(config.to), 'Invalid argument config.to supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $swap (expected an array)');
	  }
	  var element = arr[config.to];
	  arr[config.to] = arr[config.from];
	  arr[config.from] = element;
	  return arr;
	}
	
	function $unshift(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper {$unshift: elements} (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $unshift (expected an array)');
	  }
	  return elements.concat(arr);
	}
	
	function $merge(obj, value) {
	  return mixin(mixin({}, value), obj, true);
	}
	
	update.commands = {
	  $apply: $apply,
	  $push: $push,
	  $remove: $remove,
	  $set: $set,
	  $splice: $splice,
	  $swap: $swap,
	  $unshift: $unshift,
	  $merge: $merge
	};
	
	function irreducible(name, predicate) {
	
	  if (false) {
	    assert(isString(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to irreducible(name, predicate) (expected a string)'; });
	    assert(isFunction(predicate), 'Invalid argument predicate ' + exports.stringify(predicate) + ' supplied to irreducible(name, predicate) (expected a function)');
	  }
	
	  function Irreducible(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Irreducible);
	      path = path || [name];
	      assert(predicate(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Irreducible.meta = {
	    kind: 'irreducible',
	    name: name,
	    identity: true
	  };
	
	  Irreducible.displayName = name;
	
	  Irreducible.is = predicate;
	
	  return Irreducible;
	}
	
	var Any = irreducible('Any', function () {
	  return true;
	});
	
	var Nil = irreducible('Nil', isNil);
	
	var Str = irreducible('String', isString);
	
	var Num = irreducible('Number', isNumber);
	
	var Bool = irreducible('Boolean', isBoolean);
	
	var Arr = irreducible('Array', isArray);
	
	var Obj = irreducible('Object', isObject);
	
	var Func = irreducible('Function', isFunction);
	
	var Err = irreducible('Error', function (x) {
	  return x instanceof Error;
	});
	
	var Re = irreducible('RegExp', function (x) {
	  return x instanceof RegExp;
	});
	
	var Dat = irreducible('Date', function (x) {
	  return x instanceof Date;
	});
	
	function struct(props, name) {
	
	  if (false) {
	    assert(dict(Str, Func).is(props), function () { return 'Invalid argument props ' + exports.stringify(props) + ' supplied to struct(props, [name]) combinator (expected a dictionary String -> Type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to struct(props, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || struct.getDefaultName(props);
	
	  function Struct(value, path) {
	
	    if (Struct.is(value)) { // implements idempotency
	      return value;
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an object)'; });
	    }
	
	    if (!(this instanceof Struct)) { // `new` is optional
	      return new Struct(value);
	    }
	
	    for (var k in props) {
	      if (props.hasOwnProperty(k)) {
	        var expected = props[k];
	        var actual = value[k];
	        this[k] = create(expected, actual, (  false ? path.concat(k + ': ' + getTypeName(expected)) : null ));
	      }
	    }
	
	    if (false) {
	      Object.freeze(this);
	    }
	
	  }
	
	  Struct.meta = {
	    kind: 'struct',
	    props: props,
	    name: name,
	    identity: false
	  };
	
	  Struct.displayName = displayName;
	
	  Struct.is = function (x) {
	    return x instanceof Struct;
	  };
	
	  Struct.update = function (instance, spec) {
	    return new Struct(exports.update(instance, spec));
	  };
	
	  Struct.extend = function (structs, name) {
	    var props = {};
	    var prototype = {};
	    [Struct].concat(structs).forEach(function (struct, i) {
	      if (isObject(struct)) {
	        mixin(props, struct);
	      }
	      else {
	        if (false) {
	          assert(isStruct(struct), function () { return 'Invalid argument structs[' + i + '] ' + exports.stringify(struct) + ' supplied to ' + displayName + '.extend(structs, name)'; });
	        }
	        mixin(props, struct.meta.props);
	        mixin(prototype, struct.prototype);
	      }
	    });
	    var ret = struct(props, name);
	    mixin(ret.prototype, prototype);
	    return ret;
	  };
	
	  return Struct;
	}
	
	struct.getDefaultName = function (props) {
	  return '{' + Object.keys(props).map(function (prop) {
	    return prop + ': ' + getTypeName(props[prop]);
	  }).join(', ') + '}';
	};
	
	function union(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + exports.stringify(types) + ' supplied to union(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to union(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || union.getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Union(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    var type = Union.dispatch(value);
	    if (!type && Union.is(value)) {
	      return value;
	    }
	
	    if (false) {
	      forbidNewOperator(this, Union);
	      path = path || [displayName];
	      assert(isType(type), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (no constructor returned by dispatch)'; });
	      path[path.length - 1] += '(' + getTypeName(type) + ')';
	    }
	
	    return create(type, value, path);
	  }
	
	  Union.meta = {
	    kind: 'union',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Union.displayName = displayName;
	
	  Union.is = function (x) {
	    return types.some(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Union.dispatch = function (x) { // default dispatch implementation
	    for (var i = 0, len = types.length; i < len; i++ ) {
	      var type = types[i];
	      if (isUnion(type)) { // handle union of unions
	        var t = type.dispatch(x);
	        if (!isNil(t)) {
	          return t;
	        }
	      }
	      else if (is(x, type)) {
	        return type;
	      }
	    }
	  };
	
	  Union.update = function (instance, spec) {
	    return Union(exports.update(instance, spec));
	  };
	
	  return Union;
	}
	
	union.getDefaultName = function (types) {
	  return types.map(getTypeName).join(' | ');
	};
	
	function intersection(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + exports.stringify(types) + ' supplied to intersection(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to intersection(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || intersection.getDefaultName(types);
	
	  function Intersection(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Intersection);
	      path = path || [displayName];
	      assert(Intersection.is(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Intersection.meta = {
	    kind: 'intersection',
	    types: types,
	    name: name,
	    identity: true
	  };
	
	  Intersection.displayName = displayName;
	
	  Intersection.is = function (x) {
	    return types.every(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Intersection.update = function (instance, spec) {
	    return Intersection(exports.update(instance, spec));
	  };
	
	  return Intersection;
	}
	
	intersection.getDefaultName = function (types) {
	  return types.map(getTypeName).join(' & ');
	};
	
	function maybe(type, name) {
	
	  if (isMaybe(type) || type === Any || type === Nil) { // makes the combinator idempotent and handle Any, Nil
	    return type;
	  }
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + exports.stringify(type) + ' supplied to maybe(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to maybe(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || maybe.getDefaultName(type);
	
	  function Maybe(value, path) {
	    if (false) {
	      forbidNewOperator(this, Maybe);
	    }
	    return isNil(value) ? null : create(type, value, path);
	  }
	
	  Maybe.meta = {
	    kind: 'maybe',
	    type: type,
	    name: name,
	    identity: isIdentity(type)
	  };
	
	  Maybe.displayName = displayName;
	
	  Maybe.is = function (x) {
	    return isNil(x) || is(x, type);
	  };
	
	  return Maybe;
	}
	
	maybe.getDefaultName = function (type) {
	  return '?' + getTypeName(type);
	};
	
	function enums(map, name) {
	
	  if (false) {
	    assert(isObject(map), function () { return 'Invalid argument map ' + exports.stringify(map) + ' supplied to enums(map, [name]) combinator (expected a dictionary of String -> String | Number)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to enums(map, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || enums.getDefaultName(map);
	
	  function Enums(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Enums);
	      path = path || [displayName];
	      assert(Enums.is(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected one of ' + exports.stringify(Object.keys(map)) + ')'; });
	    }
	
	    return value;
	  }
	
	  Enums.meta = {
	    kind: 'enums',
	    map: map,
	    name: name,
	    identity: true
	  };
	
	  Enums.displayName = displayName;
	
	  Enums.is = function (x) {
	    return map.hasOwnProperty(x);
	  };
	
	  return Enums;
	}
	
	enums.getDefaultName = function (map) {
	  return Object.keys(map).map(function (k) { return exports.stringify(k); }).join(' | ');
	};
	
	enums.of = function (keys, name) {
	  keys = isString(keys) ? keys.split(' ') : keys;
	  var value = {};
	  keys.forEach(function (k) {
	    value[k] = k;
	  });
	  return enums(value, name);
	};
	
	function tuple(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction), function () { return 'Invalid argument types ' + exports.stringify(types) + ' supplied to tuple(types, [name]) combinator (expected an array of types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to tuple(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || tuple.getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Tuple(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value) && value.length === types.length, function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of length ' + types.length + ')'; });
	    }
	
	    var idempotent = true;
	    var ret = [];
	    for (var i = 0, len = types.length; i < len; i++) {
	      var expected = types[i];
	      var actual = value[i];
	      var instance = create(expected, actual, (  false ? path.concat(i + ': ' + getTypeName(expected)) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Tuple.meta = {
	    kind: 'tuple',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Tuple.displayName = displayName;
	
	  Tuple.is = function (x) {
	    return isArray(x) &&
	      x.length === types.length &&
	      types.every(function (type, i) {
	        return is(x[i], type);
	      });
	  };
	
	  Tuple.update = function (instance, spec) {
	    return Tuple(exports.update(instance, spec));
	  };
	
	  return Tuple;
	}
	
	tuple.getDefaultName = function (types) {
	  return '[' + types.map(getTypeName).join(', ') + ']';
	};
	
	function refinement(type, predicate, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + exports.stringify(type) + ' supplied to refinement(type, predicate, [name]) combinator (expected a type)'; });
	    assert(isFunction(predicate), function () { return 'Invalid argument predicate supplied to refinement(type, predicate, [name]) combinator (expected a function)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to refinement(type, predicate, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || refinement.getDefaultName(type, predicate);
	  var identity = isIdentity(type);
	
	  function Refinement(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Refinement);
	      path = path || [displayName];
	    }
	
	    var x = create(type, value, path);
	
	    if (false) {
	      assert(predicate(x), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return x;
	  }
	
	  Refinement.meta = {
	    kind: 'subtype',
	    type: type,
	    predicate: predicate,
	    name: name,
	    identity: identity
	  };
	
	  Refinement.displayName = displayName;
	
	  Refinement.is = function (x) {
	    return is(x, type) && predicate(x);
	  };
	
	  Refinement.update = function (instance, spec) {
	    return Refinement(exports.update(instance, spec));
	  };
	
	  return Refinement;
	}
	
	refinement.getDefaultName = function (type, predicate) {
	  return '{' + getTypeName(type) + ' | ' + getFunctionName(predicate) + '}';
	};
	
	function list(type, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + exports.stringify(type) + ' supplied to list(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to list(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || list.getDefaultName(type);
	  var typeNameCache = getTypeName(type);
	  var identity = isIdentity(type); // the list is identity iif type is identity
	
	  function List(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of ' + typeNameCache + ')'; });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = []; // make a temporary copy, will be discarded if idempotent remains true
	    for (var i = 0, len = value.length; i < len; i++ ) {
	      var actual = value[i];
	      var instance = create(type, actual, (  false ? path.concat(i + ': ' + typeNameCache) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  List.meta = {
	    kind: 'list',
	    type: type,
	    name: name,
	    identity: identity
	  };
	
	  List.displayName = displayName;
	
	  List.is = function (x) {
	    return isArray(x) && x.every(function (e) {
	      return is(e, type);
	    });
	  };
	
	  List.update = function (instance, spec) {
	    return List(exports.update(instance, spec));
	  };
	
	  return List;
	}
	
	list.getDefaultName = function (type) {
	  return 'Array<' + getTypeName(type) + '>';
	};
	
	function dict(domain, codomain, name) {
	
	  if (false) {
	    assert(isFunction(domain), function () { return 'Invalid argument domain ' + exports.stringify(domain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + exports.stringify(codomain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to dict(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || dict.getDefaultName(domain, codomain);
	  var domainNameCache = getTypeName(domain);
	  var codomainNameCache = getTypeName(codomain);
	  var identity = isIdentity(domain) && isIdentity(codomain);
	
	  function Dict(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = {}; // make a temporary copy, will be discarded if idempotent remains true
	    for (var k in value) {
	      if (value.hasOwnProperty(k)) {
	        k = create(domain, k, (  false ? path.concat(domainNameCache) : null ));
	        var actual = value[k];
	        var instance = create(codomain, actual, (  false ? path.concat(k + ': ' + codomainNameCache) : null ));
	        idempotent = idempotent && ( actual === instance );
	        ret[k] = instance;
	      }
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Dict.meta = {
	    kind: 'dict',
	    domain: domain,
	    codomain: codomain,
	    name: name,
	    identity: identity
	  };
	
	  Dict.displayName = displayName;
	
	  Dict.is = function (x) {
	    if (!isObject(x)) {
	      return false;
	    }
	    for (var k in x) {
	      if (x.hasOwnProperty(k)) {
	        if (!is(k, domain) || !is(x[k], codomain)) {
	          return false;
	        }
	      }
	    }
	    return true;
	  };
	
	  Dict.update = function (instance, spec) {
	    return Dict(exports.update(instance, spec));
	  };
	
	  return Dict;
	}
	
	dict.getDefaultName = function (domain, codomain) {
	  return '{[key: ' + getTypeName(domain) + ']: ' + getTypeName(codomain) + '}';
	};
	
	function isInstrumented(f) {
	  return isFunction(f) && isObject(f.instrumentation);
	}
	
	function func(domain, codomain, name) {
	
	  domain = isArray(domain) ? domain : [domain]; // handle handy syntax for unary functions
	
	  if (false) {
	    assert(list(Func).is(domain), function () { return 'Invalid argument domain ' + exports.stringify(domain) + ' supplied to func(domain, codomain, [name]) combinator (expected an array of types)'; });
	    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + exports.stringify(codomain) + ' supplied to func(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to func(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || func.getDefaultName(domain, codomain);
	
	  function FuncType(value, curried) {
	
	    if (!isInstrumented(value)) { // automatically instrument the function
	      return FuncType.of(value, curried);
	    }
	
	    if (false) {
	      assert(FuncType.is(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + displayName; });
	    }
	
	    return value;
	  }
	
	  FuncType.meta = {
	    kind: 'func',
	    domain: domain,
	    codomain: codomain,
	    name: name
	  };
	
	  FuncType.displayName = displayName;
	
	  FuncType.is = function (x) {
	    return isInstrumented(x) &&
	      x.instrumentation.domain.length === domain.length &&
	      x.instrumentation.domain.every(function (type, i) {
	        return type === domain[i];
	      }) &&
	      x.instrumentation.codomain === codomain;
	  };
	
	  FuncType.of = function (f, curried) {
	
	    if (false) {
	      assert(isFunction(f), function () { return 'Invalid argument f supplied to func.of ' + displayName + ' (expected a function)'; });
	      assert(isNil(curried) || isBoolean(curried), function () { return 'Invalid argument curried ' + exports.stringify(curried) + ' supplied to func.of ' + displayName + ' (expected a boolean)'; });
	    }
	
	    if (FuncType.is(f)) { // makes FuncType.of idempotent
	      return f;
	    }
	
	    function fn() {
	      var args = Array.prototype.slice.call(arguments);
	      var len = curried ?
	        args.length :
	        domain.length;
	      var argsType = tuple(domain.slice(0, len));
	
	      args = argsType(args); // type check arguments
	
	      if (len === domain.length) {
	        return create(codomain, f.apply(this, args));
	      }
	      else {
	        var g = Function.prototype.bind.apply(f, [this].concat(args));
	        var newdomain = func(domain.slice(len), codomain);
	        return newdomain.of(g, curried);
	      }
	    }
	
	    fn.instrumentation = {
	      domain: domain,
	      codomain: codomain,
	      f: f
	    };
	
	    fn.displayName = getFunctionName(f);
	
	    return fn;
	
	  };
	
	  return FuncType;
	
	}
	
	func.getDefaultName = function (domain, codomain) {
	  return '(' + domain.map(getTypeName).join(', ') + ') => ' + getTypeName(codomain);
	};
	
	function match(x) {
	  var type, guard, f, count;
	  for (var i = 1, len = arguments.length; i < len; ) {
	    type = arguments[i];
	    guard = arguments[i + 1];
	    f = arguments[i + 2];
	
	    if (isFunction(f) && !isType(f)) {
	      i = i + 3;
	    }
	    else {
	      f = guard;
	      guard = Any.is;
	      i = i + 2;
	    }
	
	    if (false) {
	      count = (count || 0) + 1;
	      assert(isType(type), function () { return 'Invalid type in clause #' + count; });
	      assert(isFunction(guard), function () { return 'Invalid guard in clause #' + count; });
	      assert(isFunction(f), function () { return 'Invalid block in clause #' + count; });
	    }
	
	    if (type.is(x) && guard(x)) {
	      return f(x);
	    }
	  }
	  exports.fail('Match error');
	}
	
	mixin(exports, {
	  is: is,
	  isType: isType,
	  getTypeName: getTypeName,
	  mixin: mixin,
	  update: update,
	  assert: assert,
	  Any: Any,
	  Nil: Nil,
	  Str: Str, // deprecated
	  String: Str,
	  Num: Num, // deprecated
	  Number: Num,
	  Bool: Bool, // deprecated
	  Boolean: Bool,
	  Arr: Arr, // deprecated
	  Array: Arr,
	  Obj: Obj, // deprecated
	  Object: Obj,
	  Func: Func, // deprecated
	  Function: Func,
	  Err: Err, // deprecated
	  Error: Err,
	  Re: Re, // deprecated
	  RegExp: Re,
	  Dat: Dat, // deprecated
	  Date: Dat,
	  irreducible: irreducible,
	  struct: struct,
	  enums: enums,
	  union: union,
	  maybe: maybe,
	  tuple: tuple,
	  subtype: refinement, // deprecated
	  refinement: refinement,
	  list: list,
	  dict: dict,
	  func: func,
	  intersection: intersection,
	  match: match
	});


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(8),
	    createAssigner = __webpack_require__(35);
	
	/**
	 * Recursively merges own enumerable properties of the source object(s), that
	 * don't resolve to `undefined` into the destination object. Subsequent sources
	 * overwrite property assignments of previous sources. If `customizer` is
	 * provided it's invoked to produce the merged values of the destination and
	 * source properties. If `customizer` returns `undefined` merging is handled
	 * by the method instead. The `customizer` is bound to `thisArg` and invoked
	 * with five arguments: (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 *
	 * // using a customizer callback
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.merge(object, other, function(a, b) {
	 *   if (_.isArray(a)) {
	 *     return a.concat(b);
	 *   }
	 * });
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var merge = createAssigner(baseMerge);
	
	module.exports = merge;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(9),
	    baseMergeDeep = __webpack_require__(10),
	    isArray = __webpack_require__(18),
	    isArrayLike = __webpack_require__(13),
	    isObject = __webpack_require__(22),
	    isObjectLike = __webpack_require__(17),
	    isTypedArray = __webpack_require__(30),
	    keys = __webpack_require__(33);
	
	/**
	 * The base implementation of `_.merge` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {Object} Returns `object`.
	 */
	function baseMerge(object, source, customizer, stackA, stackB) {
	  if (!isObject(object)) {
	    return object;
	  }
	  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	      props = isSrcArr ? undefined : keys(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObjectLike(srcValue)) {
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	    }
	    else {
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	      }
	      if ((result !== undefined || (isSrcArr && !(key in object))) &&
	          (isCommon || (result === result ? (result !== value) : (value === value)))) {
	        object[key] = result;
	      }
	    }
	  });
	  return object;
	}
	
	module.exports = baseMerge;


/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(11),
	    isArguments = __webpack_require__(12),
	    isArray = __webpack_require__(18),
	    isArrayLike = __webpack_require__(13),
	    isPlainObject = __webpack_require__(23),
	    isTypedArray = __webpack_require__(30),
	    toPlainObject = __webpack_require__(31);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	  var length = stackA.length,
	      srcValue = source[key];
	
	  while (length--) {
	    if (stackA[length] == srcValue) {
	      object[key] = stackB[length];
	      return;
	    }
	  }
	  var value = object[key],
	      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	      isCommon = result === undefined;
	
	  if (isCommon) {
	    result = srcValue;
	    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	      result = isArray(value)
	        ? value
	        : (isArrayLike(value) ? arrayCopy(value) : []);
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      result = isArguments(value)
	        ? toPlainObject(value)
	        : (isPlainObject(value) ? value : {});
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate
	  // it with its merged value.
	  stackA.push(srcValue);
	  stackB.push(result);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	  } else if (result === result ? (result !== value) : (value === value)) {
	    object[key] = result;
	  }
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 11 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(13),
	    isObjectLike = __webpack_require__(17);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(14),
	    isLength = __webpack_require__(16);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(15);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    isLength = __webpack_require__(16),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(20);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(21),
	    isObjectLike = __webpack_require__(17);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(24),
	    isArguments = __webpack_require__(12),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(25),
	    keysIn = __webpack_require__(28);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(26);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(27);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(12),
	    isArray = __webpack_require__(18),
	    isIndex = __webpack_require__(29),
	    isLength = __webpack_require__(16),
	    isObject = __webpack_require__(22);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 29 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(16),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(32),
	    keysIn = __webpack_require__(28);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return baseCopy(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    isArrayLike = __webpack_require__(13),
	    isObject = __webpack_require__(22),
	    shimKeys = __webpack_require__(34);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(12),
	    isArray = __webpack_require__(18),
	    isIndex = __webpack_require__(29),
	    isLength = __webpack_require__(16),
	    keysIn = __webpack_require__(28);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(36),
	    isIterateeCall = __webpack_require__(38),
	    restParam = __webpack_require__(39);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(37);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(13),
	    isIndex = __webpack_require__(29),
	    isObject = __webpack_require__(22);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _lodashStringEscape = __webpack_require__(41);
	
	var _lodashStringEscape2 = _interopRequireDefault(_lodashStringEscape);
	
	// converte un tag in html
	// - i p sono convertiti semplicemente in testo con gli a capo
	// sostituiti da <br/>
	// - le liste con le liste corrispondenti ol, ul a seconda che
	// siano ordinate o no
	
	function renderTag(tag) {
	  var name = tag.name;
	  var args = tag.args;
	
	  if (name === 'p') {
	    return args.join('<br/>');
	  }
	  var lis = args.map(function (x) {
	    return '<li>' + x.replace(lists[name], '') + '</li>'; // toglie "- " o "+ "
	  }).join('');
	  return '<' + name + '>' + lis + '</' + name + '>';
	}
	
	// elenco trasformazioni inline
	var inline = {
	  strong: function strong(src) {
	    return src.replace(/(\*\*)(?=\S)([^\r]*?\S[*]*)\1/g, "<strong>$2</strong>");
	  },
	  em: function em(src) {
	    return src.replace(/(\*)(?=\S)([^\r]*?\S)\1/g, "<em>$2</em>");
	  },
	  link: function link(src) {
	    return src.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?(.*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, function (wholeMatch, m1, text, m3, url) {
	      var isMailto = url.indexOf('mailto:') === 0;
	      var self = url.indexOf('self:') === 0;
	      var isJS = url.indexOf('javascript:') === 0; // eslint-disable-line no-script-url
	      var target = undefined;
	      if (self) {
	        target = '_self';
	        url = url.substring(5, url.length);
	      } else if (isJS) {
	        target = '#';
	      } else if (!isMailto) {
	        target = '_blank';
	      }
	      var targetAttr = '';
	      if (!_tcomb2['default'].Nil.is(target)) {
	        targetAttr = ' target="' + target + '"';
	      }
	      // non uso attr() altrimenti farei due volte l'escape_html()
	      return '<a href="' + url + '"' + targetAttr + '>' + text + '</a>';
	    });
	  }
	};
	
	var lists = {
	  ul: /^- /,
	  ol: /^\+ /
	};
	
	// data una linea quel'è il tag più appropriato per
	// farne il rendering
	
	function detectTag(line) {
	  return lists.ul.exec(line) ? 'ul' : lists.ol.exec(line) ? 'ol' : 'p';
	}
	
	var transformations = ['link', 'strong', 'em'];
	
	exports['default'] = function (md) {
	  md = _tcomb2['default'].String(md);
	
	  var ret = function (md) {
	
	    // uniformo gli a capo a \n
	    var uniformed = md.replace(/\r\n|\r/g, '\n');
	
	    // elimino tag molesti
	    var escaped = (0, _lodashStringEscape2['default'])(uniformed);
	
	    // applico le trasformazioni inline
	    var inlined = transformations.reduce(function (ret, x) {
	      return inline[x](ret);
	    }, escaped);
	
	    // divido il sorgente ottenuto in blocchi divisi dagli a capo
	    // e faccio un trim delle righe
	    var lines = inlined.split('\n').map(function (s) {
	      return s.trim();
	    });
	
	    // analizzo i blocchi per determinare i tag
	    var tags = [];
	    var oldTag = undefined;
	    lines.forEach(function (line) {
	      var newTag = detectTag(line);
	      if (newTag !== oldTag) {
	        tags.push({
	          name: newTag,
	          args: []
	        });
	      }
	      tags[tags.length - 1].args.push(line);
	      oldTag = newTag;
	    });
	
	    // render dei tag trovati
	    return tags.map(renderTag).join('');
	  }.call(this, md);
	
	  return _tcomb2['default'].String(ret);
	};

	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(42),
	    escapeHtmlChar = __webpack_require__(43);
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"'`]/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/**
	 * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	 * their corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional characters
	 * use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value.
	 * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * Backticks are escaped because in Internet Explorer < 9, they can break out
	 * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	 * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	 * for more details.
	 *
	 * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	 * to reduce XSS vectors.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	  string = baseToString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = escape;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 43 */
/***/ function(module, exports) {

	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '`': '&#96;'
	};
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeHtmlChar(chr) {
	  return htmlEscapes[chr];
	}
	
	module.exports = escapeHtmlChar;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	
	var UUID = _tcomb2['default'].refinement(_tcomb2['default'].String, function (s) {
	  return is_uuid_regexp.test(s);
	});
	
	exports['default'] = UUID;
	module.exports = exports['default'];

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = to_url;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _querystring = __webpack_require__(46);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var QueryString = _tcomb2['default'].union([_tcomb2['default'].String, _tcomb2['default'].Object], 'QueryString');
	
	function to_url(url, qs) {
	  url = _tcomb2['default'].String(url);
	  qs = _tcomb2['default'].maybe(QueryString)(qs);
	
	  var ret = function (url, qs) {
	
	    qs = _tcomb2['default'].Obj.is(qs) ? _querystring2['default'].stringify(qs) : qs || '';
	
	    if (qs) {
	      // è già presente il ?
	      if (url.indexOf('?') !== -1) {
	        url += '&' + qs;
	      } else {
	        // è presente un hash?
	        var hashIndex = url.indexOf('#');
	        if (hashIndex !== -1) {
	          var hash = url.substring(hashIndex);
	          url = url.substring(0, hashIndex) + '?' + qs + hash;
	        } else {
	          url += '?' + qs;
	        }
	      }
	    }
	
	    return url;
	  }.call(this, url, qs);
	
	  return _tcomb2['default'].String(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(47);
	exports.encode = exports.stringify = __webpack_require__(48);


/***/ },
/* 47 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = get_bundle;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function get_bundle(locale) {
	  var ret = function (locale) {
	    return window.require('web/io/' + locale.language);
	  }.call(this, locale);
	
	  return _tcomb2['default'].Object(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = buildHeightNotifier;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _querystring = __webpack_require__(46);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _isModal = __webpack_require__(51);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _isPostMessageSupported = __webpack_require__(52);
	
	var _isPostMessageSupported2 = _interopRequireDefault(_isPostMessageSupported);
	
	var _lodashUtilityNoop = __webpack_require__(53);
	
	var _lodashUtilityNoop2 = _interopRequireDefault(_lodashUtilityNoop);
	
	// comunica con il container quando l'applicazione è ospitata in una modale
	// e se il container supporta l'api postMessage()
	
	function buildHeightNotifier(app) {
	
	  var do_post = (0, _isPostMessageSupported2['default'])() && (0, _isModal2['default'])();
	
	  if (!do_post) {
	    return _lodashUtilityNoop2['default'];
	  }
	
	  var height = undefined;
	
	  return function () {
	
	    // controllo se c'è una modale aperta
	    var modalContainer = document.getElementById('modal-container');
	
	    var do_scroll = document.getElementById('modal-container') && modalContainer.getAttribute("scroll") !== "sent";
	
	    if (document.getElementById('modal-container')) {
	      modalContainer.setAttribute("scroll", "sent");
	    }
	
	    var new_height = document.body.clientHeight;
	    if (new_height !== height) {
	      var message = _querystring2['default'].stringify({
	        current_module: app.route.name,
	        height: new_height,
	        do_scroll: do_scroll
	      });
	      window.top.postMessage(message, '*');
	      height = new_height;
	    }
	  };
	}

	module.exports = exports['default'];

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isModal;
	
	function isModal() {
	  return window !== window.top;
	}

	module.exports = exports["default"];

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = isPostMessageSupported;
	
	function isPostMessageSupported() {
	  return typeof window.top.postMessage !== 'undefined';
	}

	module.exports = exports['default'];

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Anonymous = __webpack_require__(78);
	
	var _Anonymous2 = _interopRequireDefault(_Anonymous);
	
	var _Registered = __webpack_require__(79);
	
	var _Registered2 = _interopRequireDefault(_Registered);
	
	var _Verified = __webpack_require__(111);
	
	var _Verified2 = _interopRequireDefault(_Verified);
	
	var _get_bundle = __webpack_require__(49);
	
	var _get_bundle2 = _interopRequireDefault(_get_bundle);
	
	var _Field = __webpack_require__(115);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _lodashCollectionFind = __webpack_require__(116);
	
	var _lodashCollectionFind2 = _interopRequireDefault(_lodashCollectionFind);
	
	var User = _tcomb2['default'].union([_Anonymous2['default'], _Registered2['default'], _Verified2['default']], 'User');
	
	User.dispatch = function (obj) {
	  switch (obj.profile) {
	    case 'anonymous':
	      return _Anonymous2['default'];
	    case 'registered':
	      return _Registered2['default'];
	    case 'verified':
	      return _Verified2['default'];
	  }
	  return obj.constructor;
	};
	
	User.to_fields = function (user, locale) {
	  var bundle = (0, _get_bundle2['default'])(locale).user;
	  var ret = {};
	
	  var _loop = function (field) {
	    if (user.hasOwnProperty(field)) {
	      switch (field) {
	        case 'gender':
	          ret[field] = (0, _lodashCollectionFind2['default'])(bundle.gender_options, function (option) {
	            return option[0] === user[field];
	          })[1];
	          break;
	        case 'district':
	          var districts = window.require('district/' + user.country);
	          ret[field] = (0, _lodashCollectionFind2['default'])(districts, function (option) {
	            return option[0] === user[field];
	          })[1];
	          break;
	        case 'birth_date':
	          ret[field] = locale.format_date(user[field]);
	          break;
	        case 'country':
	          ret[field] = locale.display_country(user[field]);
	          break;
	        default:
	          ret[field] = user[field];
	      }
	    }
	  };
	
	  for (var field in _Field2['default'].meta.map) {
	    _loop(field);
	  }
	  return ret;
	};
	
	User.of = function (user) {
	  if (['registered', 'verified'].indexOf(user.profile) !== -1) {
	    user.com_locale = _Locale2['default'].of(user.com_locale);
	  }
	  return User(user);
	};
	
	exports['default'] = User;
	module.exports = exports['default'];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Locale_Iso = __webpack_require__(58);
	
	var _Locale_Iso2 = _interopRequireDefault(_Locale_Iso);
	
	var _Language = __webpack_require__(59);
	
	var _Language2 = _interopRequireDefault(_Language);
	
	var _Country = __webpack_require__(60);
	
	var _Country2 = _interopRequireDefault(_Country);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _utilFormatNumber = __webpack_require__(75);
	
	var _utilFormatNumber2 = _interopRequireDefault(_utilFormatNumber);
	
	var _Number_Format = __webpack_require__(76);
	
	var _Number_Format2 = _interopRequireDefault(_Number_Format);
	
	var Locale = _tcomb2['default'].struct({
	  language: _Language2['default'],
	  country: _Country2['default']
	}, 'Locale');
	
	Locale.of = function (iso) {
	  iso = (0, _Locale_Iso2['default'])(iso);
	
	  var _iso$split = iso.split('_');
	
	  var _iso$split2 = _slicedToArray(_iso$split, 2);
	
	  var language = _iso$split2[0];
	  var country = _iso$split2[1];
	
	  return Locale({ language: language, country: country });
	};
	
	Locale.prototype.toJSON = Locale.prototype.toString = function () {
	  return this.language + '_' + this.country;
	};
	
	// il bundle di localizzazione serve per formattare numeri, date e valute
	Locale.prototype.locale_bundle = function () {
	  var ret = function () {
	    return window.require('io/' + this);
	  }.call(this);
	
	  return _tcomb2['default'].Object(ret);
	};
	
	// il bundle di internazionalizzazione
	// Serve per tradurre le regole di validazione di una form, tradurre i paesi
	// e le lingue
	Locale.prototype.language_bundle = function () {
	  var ret = function () {
	    return window.require('io/' + this.language);
	  }.call(this);
	
	  return _tcomb2['default'].Object(ret);
	};
	
	Locale.prototype.display_country = function (country) {
	  country = (0, _Country2['default'])(country);
	
	  var ret = function (country) {
	    return this.language_bundle().country[country];
	  }.call(this, country);
	
	  return _tcomb2['default'].String(ret);
	};
	
	Locale.prototype.display_language = function (language) {
	  language = (0, _Language2['default'])(language);
	
	  var ret = function (language) {
	    return this.language_bundle().language[language];
	  }.call(this, language);
	
	  return _tcomb2['default'].String(ret);
	};
	
	Locale.prototype.to_number_format = function (opt_digits) {
	  opt_digits = _tcomb2['default'].maybe(_Natural2['default'])(opt_digits);
	
	  var bundle = this.locale_bundle().number;
	  return new _Number_Format2['default']({
	    decimal_symbol: bundle.decimal_symbol,
	    digits: _tcomb2['default'].Nil.is(opt_digits) ? bundle.digits : opt_digits,
	    grouping_symbol: bundle.grouping_symbol,
	    infinity: bundle.infinity,
	    negative_suffix: bundle.negative_suffix,
	    positive_suffix: bundle.positive_suffix
	  });
	};
	
	Locale.prototype.format_date = function (millis, is_accurate) {
	  is_accurate = _tcomb2['default'].maybe(_tcomb2['default'].Boolean)(is_accurate);
	
	  var bundle = this.locale_bundle().date;
	  var pattern = is_accurate ? bundle.accurate : bundle['short'];
	  return _Datetime2['default'].format(millis, pattern);
	};
	
	Locale.prototype.format_number = function (n, digits) {
	  n = _tcomb2['default'].Number(n);
	  digits = _tcomb2['default'].maybe(_Natural2['default'])(digits);
	
	  return (0, _utilFormatNumber2['default'])(n, this.to_number_format(digits));
	};
	
	Locale.prototype.format_integer = function (n) {
	  n = _tcomb2['default'].Number(n);
	
	  return this.format_number(n, 0);
	};
	
	Locale.prototype.parse_number = function (n) {
	  n = _tcomb2['default'].Number(n);
	
	  return this.to_number_format().parse_number(n);
	};
	
	Locale.prototype.getTcombFormDateOrder = function () {
	  return this.locale_bundle().date.order.map(function (part) {
	    if (part === 'DD') {
	      return 'D';
	    }
	    if (part === 'MM') {
	      return 'M';
	    }
	    return part;
	  });
	};
	
	module.exports = Locale;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Int = __webpack_require__(57);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var Natural = _tcomb2['default'].refinement(_Int2['default'], function (n) {
	  return n >= 0;
	});
	
	exports['default'] = Natural;
	module.exports = exports['default'];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function is_integer(n) {
	  return n === parseInt(n, 10);
	}
	
	var Int = _tcomb2['default'].subtype(_tcomb2['default'].Num, is_integer);
	
	module.exports = Int;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Language = __webpack_require__(59);
	
	var _Language2 = _interopRequireDefault(_Language);
	
	var _Country = __webpack_require__(60);
	
	var _Country2 = _interopRequireDefault(_Country);
	
	var Locale_Iso = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	  var parts = x.split('_');
	  return _Language2['default'].is(parts[0]) && _Country2['default'].is(parts[1]);
	});
	
	module.exports = Locale_Iso;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Language = _tcomb2['default'].enums.of(['it', 'en', 'fr', 'es', 'de', 'pt']);
	
	module.exports = Language;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Country = _tcomb2['default'].enums.of(['AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IT', 'LU', 'MC', 'NL', 'NO', 'PL', 'PT', 'SE', 'TR', 'US', 'ZA']);
	
	module.exports = Country;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Int = __webpack_require__(57);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _simpleFormatDate = __webpack_require__(62);
	
	var _simpleFormatDate2 = _interopRequireDefault(_simpleFormatDate);
	
	var Datetime = _tcomb2['default'].refinement(_Int2['default'], function () {
	  return true;
	}, 'Datetime');
	
	Datetime.format = function (millis, template) {
	  millis = Datetime(millis);
	  template = _tcomb2['default'].String(template);
	
	  return (0, _simpleFormatDate2['default'])(new Date(millis), { template: template });
	};
	
	exports['default'] = Datetime;
	module.exports = exports['default'];

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var template = __webpack_require__(63);
	
	var templates = {};
	
	function padLeft(x, len) {
	  var s = x + '';
	  var times = len - s.length;
	  for (var i = 0 ; i < times ; i++ ) {
	    s = '0' + s;
	  }
	  return s;
	}
	
	function splitDate(date) {
	  var YY = date.getFullYear();
	  var M = date.getMonth() + 1;
	  var D = date.getDate();
	  var h = date.getHours();
	  var m = date.getMinutes();
	  return {
	    Y: String(YY).substr(-2),   // short year (15 for 2015)
	    YY: YY,                     // numeric long year
	    M: M,                       // numeric month (9 for September)
	    MM: padLeft(M, 2),          // padded month ('09' for September)
	    D: D,                       // numeric day
	    DD: padLeft(D, 2),          // padded day
	    h: h,                       // numeric hours
	    hh: padLeft(h, 2),          // padded hours
	    m: m,                       // numeric minutes
	    mm: padLeft(m, 2)           // padded minutes
	  };
	}
	
	function shallowCopy(a, b) {
	  if (b) {
	    for (var k in b) {
	      if (b.hasOwnProperty(k)) {
	        a[k] = b[k];
	      }
	    }
	  }
	  return a;
	}
	
	function getOptions(options) {
	  var defaults = {
	    template: '<%= MM %>/<%= DD %>/<%= YY %>'
	  };
	  return shallowCopy(defaults, options);
	}
	
	function formatDate(d, options) {
	  options = getOptions(options);
	  var formatter = options.template;
	  if (typeof formatter === 'string') {
	    // compile the template just once
	    formatter = ( templates[formatter] = templates[formatter] || template(formatter) );
	  }
	  return formatter(splitDate(d));
	}
	
	module.exports = formatDate;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var assignOwnDefaults = __webpack_require__(64),
	    assignWith = __webpack_require__(65),
	    attempt = __webpack_require__(66),
	    baseAssign = __webpack_require__(68),
	    baseToString = __webpack_require__(42),
	    baseValues = __webpack_require__(69),
	    escapeStringChar = __webpack_require__(70),
	    isError = __webpack_require__(67),
	    isIterateeCall = __webpack_require__(38),
	    keys = __webpack_require__(33),
	    reInterpolate = __webpack_require__(71),
	    templateSettings = __webpack_require__(72);
	
	/** Used to match empty string literals in compiled template source. */
	var reEmptyStringLeading = /\b__p \+= '';/g,
	    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	/** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	/** Used to ensure capturing order of template delimiters. */
	var reNoMatch = /($^)/;
	
	/** Used to match unescaped characters in compiled string literals. */
	var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	/**
	 * Creates a compiled template function that can interpolate data properties
	 * in "interpolate" delimiters, HTML-escape interpolated data properties in
	 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	 * properties may be accessed as free variables in the template. If a setting
	 * object is provided it takes precedence over `_.templateSettings` values.
	 *
	 * **Note:** In the development build `_.template` utilizes
	 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	 * for easier debugging.
	 *
	 * For more information on precompiling templates see
	 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	 *
	 * For more information on Chrome extension sandboxes see
	 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The template string.
	 * @param {Object} [options] The options object.
	 * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	 * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	 * @param {Object} [options.imports] An object to import into the template as free variables.
	 * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	 * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	 * @param {string} [options.variable] The data object variable name.
	 * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	 * @returns {Function} Returns the compiled template function.
	 * @example
	 *
	 * // using the "interpolate" delimiter to create a compiled template
	 * var compiled = _.template('hello <%= user %>!');
	 * compiled({ 'user': 'fred' });
	 * // => 'hello fred!'
	 *
	 * // using the HTML "escape" delimiter to escape data property values
	 * var compiled = _.template('<b><%- value %></b>');
	 * compiled({ 'value': '<script>' });
	 * // => '<b>&lt;script&gt;</b>'
	 *
	 * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // using the internal `print` function in "evaluate" delimiters
	 * var compiled = _.template('<% print("hello " + user); %>!');
	 * compiled({ 'user': 'barney' });
	 * // => 'hello barney!'
	 *
	 * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	 * var compiled = _.template('hello ${ user }!');
	 * compiled({ 'user': 'pebbles' });
	 * // => 'hello pebbles!'
	 *
	 * // using custom template delimiters
	 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	 * var compiled = _.template('hello {{ user }}!');
	 * compiled({ 'user': 'mustache' });
	 * // => 'hello mustache!'
	 *
	 * // using backslashes to treat delimiters as plain text
	 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	 * compiled({ 'value': 'ignored' });
	 * // => '<%- value %>'
	 *
	 * // using the `imports` option to import `jQuery` as `jq`
	 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // using the `sourceURL` option to specify a custom sourceURL for the template
	 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	 * compiled(data);
	 * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	 *
	 * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	 * compiled.source;
	 * // => function(data) {
	 * //   var __t, __p = '';
	 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	 * //   return __p;
	 * // }
	 *
	 * // using the `source` property to inline compiled templates for meaningful
	 * // line numbers in error messages and a stack trace
	 * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	 *   var JST = {\
	 *     "main": ' + _.template(mainText).source + '\
	 *   };\
	 * ');
	 */
	function template(string, options, otherOptions) {
	  // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	  var settings = templateSettings.imports._.templateSettings || templateSettings;
	
	  if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	    options = otherOptions = undefined;
	  }
	  string = baseToString(string);
	  options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	  var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	      importsKeys = keys(imports),
	      importsValues = baseValues(imports, importsKeys);
	
	  var isEscaping,
	      isEvaluating,
	      index = 0,
	      interpolate = options.interpolate || reNoMatch,
	      source = "__p += '";
	
	  // Compile the regexp to match each delimiter.
	  var reDelimiters = RegExp(
	    (options.escape || reNoMatch).source + '|' +
	    interpolate.source + '|' +
	    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	    (options.evaluate || reNoMatch).source + '|$'
	  , 'g');
	
	  // Use a sourceURL for easier debugging.
	  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';
	
	  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	    interpolateValue || (interpolateValue = esTemplateValue);
	
	    // Escape characters that can't be included in string literals.
	    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	    // Replace delimiters with snippets.
	    if (escapeValue) {
	      isEscaping = true;
	      source += "' +\n__e(" + escapeValue + ") +\n'";
	    }
	    if (evaluateValue) {
	      isEvaluating = true;
	      source += "';\n" + evaluateValue + ";\n__p += '";
	    }
	    if (interpolateValue) {
	      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	    }
	    index = offset + match.length;
	
	    // The JS engine embedded in Adobe products requires returning the `match`
	    // string in order to produce the correct `offset` value.
	    return match;
	  });
	
	  source += "';\n";
	
	  // If `variable` is not specified wrap a with-statement around the generated
	  // code to add the data object to the top of the scope chain.
	  var variable = options.variable;
	  if (!variable) {
	    source = 'with (obj) {\n' + source + '\n}\n';
	  }
	  // Cleanup code by stripping empty strings.
	  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	    .replace(reEmptyStringMiddle, '$1')
	    .replace(reEmptyStringTrailing, '$1;');
	
	  // Frame code as the function body.
	  source = 'function(' + (variable || 'obj') + ') {\n' +
	    (variable
	      ? ''
	      : 'obj || (obj = {});\n'
	    ) +
	    "var __t, __p = ''" +
	    (isEscaping
	       ? ', __e = _.escape'
	       : ''
	    ) +
	    (isEvaluating
	      ? ', __j = Array.prototype.join;\n' +
	        "function print() { __p += __j.call(arguments, '') }\n"
	      : ';\n'
	    ) +
	    source +
	    'return __p\n}';
	
	  var result = attempt(function() {
	    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	  });
	
	  // Provide the compiled function's source by its `toString` method or
	  // the `source` property as a convenience for inlining compiled templates.
	  result.source = source;
	  if (isError(result)) {
	    throw result;
	  }
	  return result;
	}
	
	module.exports = template;


/***/ },
/* 64 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.template` to customize its `_.assign` use.
	 *
	 * **Note:** This function is like `assignDefaults` except that it ignores
	 * inherited property values when checking if a property is `undefined`.
	 *
	 * @private
	 * @param {*} objectValue The destination object property value.
	 * @param {*} sourceValue The source object property value.
	 * @param {string} key The key associated with the object and source values.
	 * @param {Object} object The destination object.
	 * @returns {*} Returns the value to assign to the destination object.
	 */
	function assignOwnDefaults(objectValue, sourceValue, key, object) {
	  return (objectValue === undefined || !hasOwnProperty.call(object, key))
	    ? sourceValue
	    : objectValue;
	}
	
	module.exports = assignOwnDefaults;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(33);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var isError = __webpack_require__(67),
	    restParam = __webpack_require__(39);
	
	/**
	 * Attempts to invoke `func`, returning either the result or the caught error
	 * object. Any additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Function} func The function to attempt.
	 * @returns {*} Returns the `func` result or error object.
	 * @example
	 *
	 * // avoid throwing errors for invalid selectors
	 * var elements = _.attempt(function(selector) {
	 *   return document.querySelectorAll(selector);
	 * }, '>_>');
	 *
	 * if (_.isError(elements)) {
	 *   elements = [];
	 * }
	 */
	var attempt = restParam(function(func, args) {
	  try {
	    return func.apply(undefined, args);
	  } catch(e) {
	    return isError(e) ? e : new Error(e);
	  }
	});
	
	module.exports = attempt;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var errorTag = '[object Error]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	}
	
	module.exports = isError;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(32),
	    keys = __webpack_require__(33);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  var index = -1,
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = object[props[index]];
	  }
	  return result;
	}
	
	module.exports = baseValues;


/***/ },
/* 70 */
/***/ function(module, exports) {

	/** Used to escape characters for inclusion in compiled string literals. */
	var stringEscapes = {
	  '\\': '\\',
	  "'": "'",
	  '\n': 'n',
	  '\r': 'r',
	  '\u2028': 'u2028',
	  '\u2029': 'u2029'
	};
	
	/**
	 * Used by `_.template` to escape characters for inclusion in compiled string literals.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeStringChar(chr) {
	  return '\\' + stringEscapes[chr];
	}
	
	module.exports = escapeStringChar;


/***/ },
/* 71 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	module.exports = reInterpolate;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(41),
	    reEscape = __webpack_require__(73),
	    reEvaluate = __webpack_require__(74),
	    reInterpolate = __webpack_require__(71);
	
	/**
	 * By default, the template delimiters used by lodash are like those in
	 * embedded Ruby (ERB). Change the following template settings to use
	 * alternative delimiters.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var templateSettings = {
	
	  /**
	   * Used to detect `data` property values to be HTML-escaped.
	   *
	   * @memberOf _.templateSettings
	   * @type RegExp
	   */
	  'escape': reEscape,
	
	  /**
	   * Used to detect code to be evaluated.
	   *
	   * @memberOf _.templateSettings
	   * @type RegExp
	   */
	  'evaluate': reEvaluate,
	
	  /**
	   * Used to detect `data` property values to inject.
	   *
	   * @memberOf _.templateSettings
	   * @type RegExp
	   */
	  'interpolate': reInterpolate,
	
	  /**
	   * Used to reference the data object in the template text.
	   *
	   * @memberOf _.templateSettings
	   * @type string
	   */
	  'variable': '',
	
	  /**
	   * Used to import variables into the compiled template.
	   *
	   * @memberOf _.templateSettings
	   * @type Object
	   */
	  'imports': {
	
	    /**
	     * A reference to the `lodash` function.
	     *
	     * @memberOf _.templateSettings.imports
	     * @type Function
	     */
	    '_': { 'escape': escape }
	  }
	};
	
	module.exports = templateSettings;


/***/ },
/* 73 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reEscape = /<%-([\s\S]+?)%>/g;
	
	module.exports = reEscape;


/***/ },
/* 74 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reEvaluate = /<%([\s\S]+?)%>/g;
	
	module.exports = reEvaluate;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = formatNumber;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _domainNumber_Format = __webpack_require__(76);
	
	var _domainNumber_Format2 = _interopRequireDefault(_domainNumber_Format);
	
	var _simpleFormatNumber = __webpack_require__(77);
	
	var _simpleFormatNumber2 = _interopRequireDefault(_simpleFormatNumber);
	
	function formatNumber(n, numberFormat) {
	  n = _tcomb2['default'].Number(n);
	  numberFormat = (0, _domainNumber_Format2['default'])(numberFormat);
	
	  var ret = function (n, numberFormat) {
	    return (0, _simpleFormatNumber2['default'])(n, {
	      fractionDigits: numberFormat.digits,
	      symbols: {
	        decimal: numberFormat.decimal_symbol,
	        grouping: numberFormat.grouping_symbol
	      }
	    });
	  }.call(this, n, numberFormat);
	
	  return _tcomb2['default'].String(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var Number_Format = _tcomb2['default'].struct({
	  decimal_symbol: _tcomb2['default'].Str,
	  digits: _Natural2['default'],
	  grouping_symbol: _tcomb2['default'].Str,
	  infinity: _tcomb2['default'].Str,
	  negative_suffix: _tcomb2['default'].Str,
	  positive_suffix: _tcomb2['default'].Str
	}, 'Number_Format');
	
	// true se s è la rappresentazione in stringa di un numero JavaScript
	var is_numeric_regexp = /^-{0,1}\d*\.{0,1}\d+$/;
	
	var is_numeric = function is_numeric(s) {
	  return is_numeric_regexp.test(s);
	};
	// se s è parsabile un numero altrimenti null
	Number_Format.prototype.parse_number = function (s) {
	  s = _tcomb2['default'].String(s);
	
	  var escape_regexp = function escape_regexp(s) {
	    return s.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
	  };
	
	  // elimina i simboli di raggruppamento delle migliaia
	  // e il simbolo della virgola con la virgola JavaScript
	  var make_parseable = function make_parseable(fmt, s) {
	    var grouping_symbol_re = new RegExp(escape_regexp(fmt.grouping_symbol), 'gm');
	    var decimal_symbol_re = new RegExp(escape_regexp(fmt.decimal_symbol), 'gm');
	    var without_grouping = s.replace(grouping_symbol_re, "");
	    return without_grouping.replace(decimal_symbol_re, ".");
	  };
	
	  var parseable = make_parseable(this, s);
	  return is_numeric(parseable) ? parseFloat(parseable) : parseable === this.infinity ? Infinity : parseable === this.negative_suffix + this.infinity ? -Infinity : null;
	};
	
	exports['default'] = Number_Format;
	module.exports = exports['default'];

/***/ },
/* 77 */
/***/ function(module, exports) {

	function shallowCopy(a, b) {
	  if (b) {
	    for (var k in b) {
	      if (b.hasOwnProperty(k)) {
	        a[k] = b[k];
	      }
	    }
	  }
	  return a;
	}
	
	function getOptions(options) {
	  var defaults = {
	    fractionDigits: 2,
	    useGrouping: true // turn off when you want to display a number in a textbox
	  };
	  var symbols = { // US formats as default
	    grouping: ',',
	    decimal: '.'
	  };
	  options = shallowCopy(defaults, options);
	  options.symbols = shallowCopy(symbols, options.symbols);
	  return options;
	}
	
	var insertGroupingRegexp = /(\d+)(\d{3})/;
	
	function insertGrouping(s, grouping) {
	  var times = Math.floor(s.length / 3);
	  for (var i = 0; i < times; i++) {
	    s = s.replace(insertGroupingRegexp, '$1' + grouping + '$2');
	  }
	  return s;
	}
	
	function formatNumber(n, options) {
	  options = getOptions(options);
	  var parts = n.toFixed(options.fractionDigits).split('.');
	  var integerPart = parts[0];
	  var decimalPart = parts[1];
	  if (options.useGrouping) {
	    integerPart = insertGrouping(integerPart, options.symbols.grouping);
	  }
	  return integerPart + (options.fractionDigits > 0 ? options.symbols.decimal + decimalPart : '');
	}
	
	module.exports = formatNumber;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Anonymous = _tcomb2['default'].struct({}, 'Anonymous');
	
	module.exports = Anonymous;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Email = __webpack_require__(80);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Registered = _tcomb2['default'].struct({
	  email: _Email2['default'],
	  com_locale: _Locale2['default'],
	  rcs_privacy_needed: _tcomb2['default'].Bool
	}, 'Registered');
	
	module.exports = Registered;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var emailRegexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
	
	var Email = _tcombForm2['default'].refinement(_tcombForm2['default'].String, function (s) {
	  return emailRegexp.test(s);
	});
	
	module.exports = Email;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/*! @preserve
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014-2015 Giulio Canti
	 *
	 */
	var t = __webpack_require__(82);
	var templates = __webpack_require__(88);
	var i18n = __webpack_require__(110);
	
	t.form.Form.templates = templates;
	t.form.Form.i18n = i18n;
	
	module.exports = t;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombValidation = __webpack_require__(83);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _components = __webpack_require__(84);
	
	var components = _interopRequireWildcard(_components);
	
	_tcombValidation2['default'].form = components;
	_tcombValidation2['default'].form.File = _tcombValidation2['default'].irreducible('File', function (x) {
	  return x instanceof File;
	});
	
	module.exports = _tcombValidation2['default'];

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var t = __webpack_require__(6);
	var stringify = t.stringify;
	
	var ValidationError = t.struct({
	  message: t.Str,
	  actual: t.Any,
	  expected: t.Any,
	  path: t.list(t.union([t.Str, t.Num]))
	}, 'ValidationError');
	
	function getDefaultValidationErrorMessage(actual, expected, path) {
	  var expectedName = t.getTypeName(expected);
	  var to = path.length ? '/' + path.join('/') + ': ' + expectedName : expectedName;
	  return 'Invalid value ' + stringify(actual) + ' supplied to ' + to;
	}
	
	function getValidationErrorMessage(actual, expected, path, context) {
	  if (t.Function.is(expected.getValidationErrorMessage)) {
	    return expected.getValidationErrorMessage(actual, path, context);
	  }
	  else {
	    return getDefaultValidationErrorMessage(actual, expected, path);
	  }
	}
	
	ValidationError.of = function (actual, expected, path, context) {
	  return new ValidationError({
	    message: getValidationErrorMessage(actual, expected, path, context),
	    actual: actual,
	    expected: expected,
	    path: path
	  });
	};
	
	var ValidationResult = t.struct({
	  errors: t.list(ValidationError),
	  value: t.Any
	}, 'ValidationResult');
	
	ValidationResult.prototype.isValid = function () {
	  return !(this.errors.length);
	};
	
	ValidationResult.prototype.firstError = function () {
	  return this.isValid() ? null : this.errors[0];
	};
	
	ValidationResult.prototype.toString = function () {
	  if (this.isValid()) {
	    return '[ValidationResult, true, ' + stringify(this.value) + ']';
	  }
	  else {
	    return '[ValidationResult, false, (' + this.errors.map(function (err) {
	      return err.message;
	    }).join(', ') + ')]';
	  }
	};
	
	function validate(x, type, options) {
	  options = options || {};
	  var path = t.Array.is(options) ? options : options.path || [];
	  return new ValidationResult(recurse(x, type, path, options.context));
	}
	
	function recurse(x, type, path, context) {
	  if (t.isType(type)) {
	    return validators[type.meta.kind](x, type, path, context);
	  }
	  else {
	    return validators.es6classes(x, type, path, context);
	  }
	}
	
	var validators = validate.validators = {};
	
	validators.es6classes = function validateES6Classes(x, type, path, context) {
	  return {
	    value: x,
	    errors: x instanceof type ? [] : [ValidationError.of(x, type, path, context)]
	  };
	};
	
	// irreducibles and enums
	validators.irreducible =
	validators.enums = function validateIrreducible(x, type, path, context) {
	  return {
	    value: x,
	    errors: type.is(x) ? [] : [ValidationError.of(x, type, path, context)]
	  };
	};
	
	validators.list = function validateList(x, type, path, context) {
	
	  // x should be an array
	  if (!t.Arr.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `type.meta.type`
	  for (var i = 0, len = x.length; i < len; i++ ) {
	    var item = recurse(x[i], type.meta.type, path.concat(i), context);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.subtype = function validateSubtype(x, type, path, context) {
	
	  // x should be a valid inner type
	  var ret = recurse(x, type.meta.type, path, context);
	  if (ret.errors.length) {
	    return ret;
	  }
	
	  // x should satisfy the predicate
	  if (!type.meta.predicate(ret.value)) {
	    ret.errors = [ValidationError.of(x, type, path, context)];
	  }
	
	  return ret;
	
	};
	
	validators.maybe = function validateMaybe(x, type, path, context) {
	  return t.Nil.is(x) ?
	    {value: null, errors: []} :
	    recurse(x, type.meta.type, path, context);
	};
	
	validators.struct = function validateStruct(x, type, path, context) {
	
	  // x should be an object
	  if (!t.Obj.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  // [optimization]
	  if (type.is(x)) {
	    return {value: x, errors: []};
	  }
	
	  var ret = {value: {}, errors: []};
	  var props = type.meta.props;
	  // every item should be of type `props[name]`
	  for (var name in props) {
	    if (props.hasOwnProperty(name)) {
	      var prop = recurse(x[name], props[name], path.concat(name), context);
	      ret.value[name] = prop.value;
	      ret.errors = ret.errors.concat(prop.errors);
	    }
	  }
	  if (!ret.errors.length) {
	    ret.value = new type(ret.value);
	  }
	  return ret;
	};
	
	validators.tuple = function validateTuple(x, type, path, context) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  // x should be an array of at most `len` items
	  if (!t.Arr.is(x) || x.length > len) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `types[i]`
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x[i], types[i], path.concat(i), context);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.dict = function validateDict(x, type, path, context) {
	
	  // x should be an object
	  if (!t.Obj.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  var ret = {value: {}, errors: []};
	  // every key should be of type `domain`
	  // every value should be of type `codomain`
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      var subpath = path.concat(k);
	      var key = recurse(k, type.meta.domain, subpath, context);
	      var item = recurse(x[k], type.meta.codomain, subpath, context);
	      ret.value[k] = item.value;
	      ret.errors = ret.errors.concat(key.errors, item.errors);
	    }
	  }
	  return ret;
	};
	
	validators.union = function validateUnion(x, type, path, context) {
	  var ctor = type.dispatch(x);
	  return t.Func.is(ctor) ?
	    recurse(x, ctor, path.concat(type.meta.types.indexOf(ctor)), context) :
	    {value: x, errors: [ValidationError.of(x, type, path, context)]};
	};
	
	validators.intersection = function validateIntersection(x, type, path, context) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  var ret = {value: x, errors: []};
	  // x should be of type `types[i]` for all i
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x, types[i], path, context);
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	t.mixin(t, {
	  ValidationError: ValidationError,
	  ValidationResult: ValidationResult,
	  validate: validate
	});
	
	module.exports = t;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.getComponent = getComponent;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombValidation = __webpack_require__(83);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _uvdomReact = __webpack_require__(85);
	
	var _util = __webpack_require__(87);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Nil = _tcombValidation2['default'].Nil;
	var assert = _tcombValidation2['default'].assert;
	var SOURCE = 'tcomb-form';
	var noobj = Object.freeze({});
	var noarr = Object.freeze([]);
	var noop = function noop() {};
	
	function getComponent(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var type = _x,
	        options = _x2;
	    name = undefined;
	    _again = false;
	
	    if (options.factory) {
	      return options.factory;
	    }
	    var name = _tcombValidation2['default'].getTypeName(type);
	    switch (type.meta.kind) {
	      case 'irreducible':
	        return type === _tcombValidation2['default'].Bool ? Checkbox : type === _tcombValidation2['default'].Dat ? Datetime : Textbox;
	      case 'struct':
	        return Struct;
	      case 'list':
	        return List;
	      case 'enums':
	        return Select;
	      case 'maybe':
	      case 'subtype':
	        _x = type.meta.type;
	        _x2 = options;
	        _again = true;
	        continue _function;
	
	      default:
	        _tcombValidation2['default'].fail('[' + SOURCE + '] unsupported type ' + name);
	    }
	  }
	}
	
	function sortByText(a, b) {
	  return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
	}
	
	function getComparator(order) {
	  return ({
	    asc: sortByText,
	    desc: function desc(a, b) {
	      return -sortByText(a, b);
	    }
	  })[order];
	}
	
	var decorators = {
	
	  template: function template(name) {
	    return function (Component) {
	      Component.prototype.getTemplate = function getTemplate() {
	        return this.props.options.template || this.props.ctx.templates[name];
	      };
	    };
	  },
	
	  attrs: function attrs(Component) {
	    Component.prototype.getAttrs = function getAttrs() {
	      var attrs = _tcombValidation2['default'].mixin({}, this.props.options.attrs);
	      attrs.id = this.getId();
	      attrs.name = this.getName();
	      if (attrs.className) {
	        var _attrs$className;
	
	        attrs.className = (_attrs$className = {}, _attrs$className[_classnames2['default'](attrs.className)] = true, _attrs$className);
	      }
	      return attrs;
	    };
	  },
	
	  templates: function templates(Component) {
	    Component.prototype.getTemplates = function getTemplates() {
	      return _util.merge(this.props.ctx.templates, this.props.options.templates);
	    };
	  }
	
	};
	
	exports.decorators = decorators;
	
	var Component = (function (_React$Component) {
	  _inherits(Component, _React$Component);
	
	  _createClass(Component, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function Component(props) {
	    _classCallCheck(this, Component);
	
	    _React$Component.call(this, props);
	    this.typeInfo = _util.getTypeInfo(props.type);
	    this.state = {
	      hasError: false,
	      value: this.getTransformer().format(props.value)
	    };
	  }
	
	  Component.prototype.getTransformer = function getTransformer() {
	    return this.props.options.transformer || this.constructor.transformer;
	  };
	
	  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var should = nextState.value !== this.state.value || nextState.hasError !== this.state.hasError || nextProps.options !== this.props.options || nextProps.type !== this.props.type;
	    // console.log(nextState.value !== this.state.value,
	    //   nextState.hasError !== this.state.hasError,
	    //   nextProps.options !== this.props.options,
	    //   nextProps.type !== this.props.type,
	    //   should);
	    return should;
	  };
	
	  Component.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.type !== this.props.type) {
	      this.typeInfo = _util.getTypeInfo(props.type);
	    }
	    this.setState({ value: this.getTransformer().format(props.value) });
	  };
	
	  Component.prototype.onChange = function onChange(value) {
	    var _this = this;
	
	    this.setState({ value: value }, function () {
	      _this.props.onChange(value, _this.props.ctx.path);
	    });
	  };
	
	  Component.prototype.getValidationOptions = function getValidationOptions() {
	    return {
	      path: this.props.ctx.path,
	      context: _tcombValidation2['default'].mixin(_tcombValidation2['default'].mixin({}, this.props.context || this.props.ctx.context), { options: this.props.options })
	    };
	  };
	
	  Component.prototype.isValueNully = function isValueNully() {
	    return Nil.is(this.getTransformer().parse(this.state.value));
	  };
	
	  Component.prototype.removeErrors = function removeErrors() {
	    this.setState({ hasError: false });
	  };
	
	  Component.prototype.validate = function validate() {
	    var value = this.getTransformer().parse(this.state.value);
	    var result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	    this.setState({ hasError: !result.isValid() });
	    return result;
	  };
	
	  Component.prototype.getAuto = function getAuto() {
	    return this.props.options.auto || this.props.ctx.auto;
	  };
	
	  Component.prototype.getI18n = function getI18n() {
	    return this.props.options.i18n || this.props.ctx.i18n;
	  };
	
	  Component.prototype.getDefaultLabel = function getDefaultLabel() {
	    var ctx = this.props.ctx;
	    if (ctx.label) {
	      return ctx.label + (this.typeInfo.isMaybe ? this.getI18n().optional : this.getI18n().required);
	    }
	  };
	
	  Component.prototype.getLabel = function getLabel() {
	    var ctx = this.props.ctx;
	    var legend = this.props.options.legend;
	    var label = this.props.options.label;
	    label = label || legend;
	    if (Nil.is(label) && ctx.auto === 'labels') {
	      label = this.getDefaultLabel();
	    }
	    return label;
	  };
	
	  Component.prototype.getError = function getError() {
	    var error = this.props.options.error || this.typeInfo.getValidationErrorMessage;
	    if (_tcombValidation2['default'].Func.is(error)) {
	      var validationOptions = this.getValidationOptions();
	      var value = this.getTransformer().parse(this.state.value);
	      return error(value, validationOptions.path, validationOptions.context);
	    }
	    return error;
	  };
	
	  Component.prototype.hasError = function hasError() {
	    return this.props.options.hasError || this.state.hasError;
	  };
	
	  Component.prototype.getConfig = function getConfig() {
	    return _util.merge(this.props.ctx.config, this.props.options.config);
	  };
	
	  Component.prototype.getId = function getId() {
	    var attrs = this.props.options.attrs || noobj;
	    if (attrs.id) {
	      return attrs.id;
	    }
	    if (!this.uid) {
	      this.uid = this.props.ctx.uidGenerator.next();
	    }
	    return this.uid;
	  };
	
	  Component.prototype.getName = function getName() {
	    return this.props.options.name || this.props.ctx.name || this.getId();
	  };
	
	  Component.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var value = this.state.value;
	    return {
	      typeInfo: this.typeInfo,
	      path: this.props.ctx.path,
	      error: this.getError(),
	      hasError: this.hasError(),
	      label: this.getLabel(),
	      onChange: this.onChange.bind(this),
	      config: this.getConfig(),
	      value: value,
	      disabled: options.disabled,
	      help: options.help
	    };
	  };
	
	  Component.prototype.render = function render() {
	    var locals = this.getLocals();
	    // getTemplate is the only required implementation when extending Component
	    assert(_tcombValidation2['default'].Func.is(this.getTemplate), '[' + SOURCE + '] missing getTemplate method of component ' + this.constructor.name);
	    var template = this.getTemplate();
	    return _uvdomReact.compile(template(locals));
	  };
	
	  return Component;
	})(_react2['default'].Component);
	
	exports.Component = Component;
	
	function toNull(value) {
	  return _tcombValidation2['default'].Str.is(value) && value.trim() === '' || Nil.is(value) ? null : value;
	}
	
	function parseNumber(value) {
	  var n = parseFloat(value);
	  var isNumeric = value - n + 1 >= 0;
	  return isNumeric ? n : toNull(value);
	}
	
	var Textbox = (function (_Component) {
	  _inherits(Textbox, _Component);
	
	  function Textbox() {
	    _classCallCheck(this, _Textbox);
	
	    _Component.apply(this, arguments);
	  }
	
	  Textbox.prototype.getTransformer = function getTransformer() {
	    var options = this.props.options;
	    return options.transformer ? options.transformer : this.typeInfo.innerType === _tcombValidation2['default'].Num ? Textbox.numberTransformer : Textbox.transformer;
	  };
	
	  Textbox.prototype.getPlaceholder = function getPlaceholder() {
	    var attrs = this.props.options.attrs || noobj;
	    var placeholder = attrs.placeholder;
	    if (Nil.is(placeholder) && this.getAuto() === 'placeholders') {
	      placeholder = this.getDefaultLabel();
	    }
	    return placeholder;
	  };
	
	  Textbox.prototype.getLocals = function getLocals() {
	    var locals = _Component.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.attrs.placeholder = this.getPlaceholder();
	    locals.type = this.props.options.type || 'text';
	    return locals;
	  };
	
	  _createClass(Textbox, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: toNull
	    },
	    enumerable: true
	  }, {
	    key: 'numberTransformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : String(value);
	      },
	      parse: parseNumber
	    },
	    enumerable: true
	  }]);
	
	  var _Textbox = Textbox;
	  Textbox = decorators.template('textbox')(Textbox) || Textbox;
	  Textbox = decorators.attrs(Textbox) || Textbox;
	  return Textbox;
	})(Component);
	
	exports.Textbox = Textbox;
	
	var Checkbox = (function (_Component2) {
	  _inherits(Checkbox, _Component2);
	
	  function Checkbox() {
	    _classCallCheck(this, _Checkbox);
	
	    _Component2.apply(this, arguments);
	  }
	
	  Checkbox.prototype.getLocals = function getLocals() {
	    var locals = _Component2.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    // checkboxes must always have a label
	    locals.label = locals.label || this.getDefaultLabel();
	    return locals;
	  };
	
	  _createClass(Checkbox, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? false : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Checkbox = Checkbox;
	  Checkbox = decorators.template('checkbox')(Checkbox) || Checkbox;
	  Checkbox = decorators.attrs(Checkbox) || Checkbox;
	  return Checkbox;
	})(Component);
	
	exports.Checkbox = Checkbox;
	
	var Select = (function (_Component3) {
	  _inherits(Select, _Component3);
	
	  function Select() {
	    _classCallCheck(this, _Select);
	
	    _Component3.apply(this, arguments);
	  }
	
	  Select.prototype.getTransformer = function getTransformer() {
	    var options = this.props.options;
	    if (options.transformer) {
	      return options.transformer;
	    }
	    if (this.isMultiple()) {
	      return Select.multipleTransformer;
	    }
	    return Select.transformer(this.getNullOption());
	  };
	
	  Select.prototype.getNullOption = function getNullOption() {
	    return this.props.options.nullOption || { value: '', text: '-' };
	  };
	
	  Select.prototype.isMultiple = function isMultiple() {
	    return this.typeInfo.innerType.meta.kind === 'list';
	  };
	
	  Select.prototype.getEnum = function getEnum() {
	    return this.isMultiple() ? _util.getTypeInfo(this.typeInfo.innerType.meta.type).innerType : this.typeInfo.innerType;
	  };
	
	  Select.prototype.getOptions = function getOptions() {
	    var options = this.props.options;
	    var items = options.options ? options.options.slice() : _util.getOptionsOfEnum(this.getEnum());
	    if (options.order) {
	      items.sort(getComparator(options.order));
	    }
	    var nullOption = this.getNullOption();
	    if (!this.isMultiple() && options.nullOption !== false) {
	      items.unshift(nullOption);
	    }
	    return items;
	  };
	
	  Select.prototype.getLocals = function getLocals() {
	    var locals = _Component3.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.options = this.getOptions();
	    locals.isMultiple = this.isMultiple();
	    return locals;
	  };
	
	  _createClass(Select, null, [{
	    key: 'transformer',
	    value: function value(nullOption) {
	      return {
	        format: function format(value) {
	          return Nil.is(value) && nullOption ? nullOption.value : value;
	        },
	        parse: function parse(value) {
	          return nullOption && nullOption.value === value ? null : value;
	        }
	      };
	    },
	    enumerable: true
	  }, {
	    key: 'multipleTransformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noarr : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Select = Select;
	  Select = decorators.template('select')(Select) || Select;
	  Select = decorators.attrs(Select) || Select;
	  return Select;
	})(Component);
	
	exports.Select = Select;
	
	var Radio = (function (_Component4) {
	  _inherits(Radio, _Component4);
	
	  function Radio() {
	    _classCallCheck(this, _Radio);
	
	    _Component4.apply(this, arguments);
	  }
	
	  Radio.prototype.getOptions = function getOptions() {
	    var options = this.props.options;
	    var items = options.options ? options.options.slice() : _util.getOptionsOfEnum(this.typeInfo.innerType);
	    if (options.order) {
	      items.sort(getComparator(options.order));
	    }
	    return items;
	  };
	
	  Radio.prototype.getLocals = function getLocals() {
	    var locals = _Component4.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.options = this.getOptions();
	    return locals;
	  };
	
	  _createClass(Radio, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Radio = Radio;
	  Radio = decorators.template('radio')(Radio) || Radio;
	  Radio = decorators.attrs(Radio) || Radio;
	  return Radio;
	})(Component);
	
	exports.Radio = Radio;
	
	var Datetime = (function (_Component5) {
	  _inherits(Datetime, _Component5);
	
	  function Datetime() {
	    _classCallCheck(this, _Datetime);
	
	    _Component5.apply(this, arguments);
	  }
	
	  Datetime.prototype.getOrder = function getOrder() {
	    return this.props.options.order || ['M', 'D', 'YY'];
	  };
	
	  Datetime.prototype.getLocals = function getLocals() {
	    var locals = _Component5.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.order = this.getOrder();
	    return locals;
	  };
	
	  _createClass(Datetime, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return _tcombValidation2['default'].Arr.is(value) ? value : _tcombValidation2['default'].Dat.is(value) ? [value.getFullYear(), value.getMonth(), value.getDate()].map(String) : [null, null, null];
	      },
	      parse: function parse(value) {
	        value = value.map(parseNumber);
	        return value.every(_tcombValidation2['default'].Num.is) ? new Date(value[0], value[1], value[2]) : value.every(Nil.is) ? null : value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Datetime = Datetime;
	  Datetime = decorators.template('date')(Datetime) || Datetime;
	  Datetime = decorators.attrs(Datetime) || Datetime;
	  return Datetime;
	})(Component);
	
	exports.Datetime = Datetime;
	
	var Struct = (function (_Component6) {
	  _inherits(Struct, _Component6);
	
	  function Struct() {
	    _classCallCheck(this, _Struct);
	
	    _Component6.apply(this, arguments);
	  }
	
	  Struct.prototype.isValueNully = function isValueNully() {
	    var _this2 = this;
	
	    return Object.keys(this.refs).every(function (ref) {
	      return _this2.refs[ref].isValueNully();
	    });
	  };
	
	  Struct.prototype.removeErrors = function removeErrors() {
	    var _this3 = this;
	
	    this.setState({ hasError: false });
	    Object.keys(this.refs).forEach(function (ref) {
	      return _this3.refs[ref].removeErrors();
	    });
	  };
	
	  Struct.prototype.validate = function validate() {
	    var value = {};
	    var errors = [];
	    var hasError = false;
	    var result = undefined;
	
	    if (this.typeInfo.isMaybe && this.isValueNully()) {
	      this.removeErrors();
	      return new _tcombValidation2['default'].ValidationResult({ errors: [], value: null });
	    }
	
	    for (var ref in this.refs) {
	      if (this.refs.hasOwnProperty(ref)) {
	        result = this.refs[ref].validate();
	        errors = errors.concat(result.errors);
	        value[ref] = result.value;
	      }
	    }
	
	    if (errors.length === 0) {
	      var InnerType = this.typeInfo.innerType;
	      value = new InnerType(value);
	      if (this.typeInfo.isSubtype && errors.length === 0) {
	        result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	        hasError = !result.isValid();
	        errors = errors.concat(result.errors);
	      }
	    }
	
	    this.setState({ hasError: hasError });
	    return new _tcombValidation2['default'].ValidationResult({ errors: errors, value: value });
	  };
	
	  Struct.prototype.onChange = function onChange(fieldName, fieldValue, path, kind) {
	    var _this4 = this;
	
	    var value = _tcombValidation2['default'].mixin({}, this.state.value);
	    value[fieldName] = fieldValue;
	    this.setState({ value: value }, function () {
	      _this4.props.onChange(value, path, kind);
	    });
	  };
	
	  Struct.prototype.getTemplate = function getTemplate() {
	    return this.props.options.template || this.getTemplates().struct;
	  };
	
	  Struct.prototype.getTypeProps = function getTypeProps() {
	    return this.typeInfo.innerType.meta.props;
	  };
	
	  Struct.prototype.getOrder = function getOrder() {
	    return this.props.options.order || Object.keys(this.getTypeProps());
	  };
	
	  Struct.prototype.getInputs = function getInputs() {
	    var _props = this.props;
	    var options = _props.options;
	    var ctx = _props.ctx;
	
	    var props = this.getTypeProps();
	    var auto = this.getAuto();
	    var i18n = this.getI18n();
	    var config = this.getConfig();
	    var templates = this.getTemplates();
	    var value = this.state.value;
	    var inputs = {};
	
	    for (var prop in props) {
	      if (props.hasOwnProperty(prop)) {
	        var propType = props[prop];
	        var propOptions = options.fields && options.fields[prop] ? options.fields[prop] : noobj;
	        inputs[prop] = _react2['default'].createElement(getComponent(propType, propOptions), {
	          key: prop,
	          ref: prop,
	          type: propType,
	          options: propOptions,
	          value: value[prop],
	          onChange: this.onChange.bind(this, prop),
	          ctx: {
	            context: ctx.context,
	            uidGenerator: ctx.uidGenerator,
	            auto: auto,
	            config: config,
	            name: ctx.name ? ctx.name + '[' + prop + ']' : prop,
	            label: _util.humanize(prop),
	            i18n: i18n,
	            templates: templates,
	            path: ctx.path.concat(prop)
	          }
	        });
	      }
	    }
	    return inputs;
	  };
	
	  Struct.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var locals = _Component6.prototype.getLocals.call(this);
	    locals.order = this.getOrder();
	    locals.inputs = this.getInputs();
	    locals.className = options.className;
	    return locals;
	  };
	
	  _createClass(Struct, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noobj : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Struct = Struct;
	  Struct = decorators.templates(Struct) || Struct;
	  return Struct;
	})(Component);
	
	exports.Struct = Struct;
	
	function toSameLength(value, keys, uidGenerator) {
	  if (value.length === keys.length) {
	    return keys;
	  }
	  var ret = [];
	  for (var i = 0, len = value.length; i < len; i++) {
	    ret[i] = keys[i] || uidGenerator.next();
	  }
	  return ret;
	}
	
	var List = (function (_Component7) {
	  _inherits(List, _Component7);
	
	  _createClass(List, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noarr : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function List(props) {
	    _classCallCheck(this, _List);
	
	    _Component7.call(this, props);
	    this.state.keys = this.state.value.map(function () {
	      return props.ctx.uidGenerator.next();
	    });
	  }
	
	  List.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.type !== this.props.type) {
	      this.typeInfo = _util.getTypeInfo(props.type);
	    }
	    var value = this.getTransformer().format(props.value);
	    this.setState({
	      value: value,
	      keys: toSameLength(value, this.state.keys, props.ctx.uidGenerator)
	    });
	  };
	
	  List.prototype.isValueNully = function isValueNully() {
	    return this.state.value.length === 0;
	  };
	
	  List.prototype.removeErrors = function removeErrors() {
	    var _this5 = this;
	
	    this.setState({ hasError: false });
	    Object.keys(this.refs).forEach(function (ref) {
	      return _this5.refs[ref].removeErrors();
	    });
	  };
	
	  List.prototype.validate = function validate() {
	    var value = [];
	    var errors = [];
	    var hasError = false;
	    var result = undefined;
	
	    if (this.typeInfo.isMaybe && this.isValueNully()) {
	      this.removeErrors();
	      return new _tcombValidation2['default'].ValidationResult({ errors: [], value: null });
	    }
	
	    for (var i = 0, len = this.state.value.length; i < len; i++) {
	      result = this.refs[i].validate();
	      errors = errors.concat(result.errors);
	      value.push(result.value);
	    }
	
	    // handle subtype
	    if (this.typeInfo.isSubtype && errors.length === 0) {
	      result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	      hasError = !result.isValid();
	      errors = errors.concat(result.errors);
	    }
	
	    this.setState({ hasError: hasError });
	    return new _tcombValidation2['default'].ValidationResult({ errors: errors, value: value });
	  };
	
	  List.prototype.onChange = function onChange(value, keys, path, kind) {
	    var _this6 = this;
	
	    keys = toSameLength(value, keys, this.props.ctx.uidGenerator);
	    this.setState({ value: value, keys: keys }, function () {
	      _this6.props.onChange(value, path, kind);
	    });
	  };
	
	  List.prototype.addItem = function addItem(evt) {
	    evt.preventDefault();
	    var value = this.state.value.concat(undefined);
	    var keys = this.state.keys.concat(this.props.ctx.uidGenerator.next());
	    this.onChange(value, keys, this.props.ctx.path.concat(value.length - 1), 'add');
	  };
	
	  List.prototype.onItemChange = function onItemChange(itemIndex, itemValue, path, kind) {
	    var value = this.state.value.slice();
	    value[itemIndex] = itemValue;
	    this.onChange(value, this.state.keys, path, kind);
	  };
	
	  List.prototype.removeItem = function removeItem(i, evt) {
	    evt.preventDefault();
	    var value = this.state.value.slice();
	    value.splice(i, 1);
	    var keys = this.state.keys.slice();
	    keys.splice(i, 1);
	    this.onChange(value, keys, this.props.ctx.path.concat(i), 'remove');
	  };
	
	  List.prototype.moveUpItem = function moveUpItem(i, evt) {
	    evt.preventDefault();
	    if (i > 0) {
	      this.onChange(_util.move(this.state.value.slice(), i, i - 1), _util.move(this.state.keys.slice(), i, i - 1), this.props.ctx.path.concat(i), 'moveUp');
	    }
	  };
	
	  List.prototype.moveDownItem = function moveDownItem(i, evt) {
	    evt.preventDefault();
	    if (i < this.state.value.length - 1) {
	      this.onChange(_util.move(this.state.value.slice(), i, i + 1), _util.move(this.state.keys.slice(), i, i + 1), this.props.ctx.path.concat(i), 'moveDown');
	    }
	  };
	
	  List.prototype.getTemplate = function getTemplate() {
	    return this.props.options.template || this.getTemplates().list;
	  };
	
	  List.prototype.getItems = function getItems() {
	    var _this7 = this;
	
	    var _props2 = this.props;
	    var options = _props2.options;
	    var ctx = _props2.ctx;
	
	    var auto = this.getAuto();
	    var i18n = this.getI18n();
	    var config = this.getConfig();
	    var templates = this.getTemplates();
	    var value = this.state.value;
	    var type = this.typeInfo.innerType.meta.type;
	    var Component = getComponent(type, options.item || noobj);
	    return value.map(function (value, i) {
	      var buttons = [];
	      if (!options.disableRemove) {
	        buttons.push({ label: i18n.remove, click: _this7.removeItem.bind(_this7, i) });
	      }
	      if (!options.disableOrder) {
	        buttons.push({ label: i18n.up, click: _this7.moveUpItem.bind(_this7, i) });
	      }
	      if (!options.disableOrder) {
	        buttons.push({ label: i18n.down, click: _this7.moveDownItem.bind(_this7, i) });
	      }
	      return {
	        input: _react2['default'].createElement(Component, {
	          ref: i,
	          type: type,
	          options: options.item || noobj,
	          value: value,
	          onChange: _this7.onItemChange.bind(_this7, i),
	          ctx: {
	            context: ctx.context,
	            uidGenerator: ctx.uidGenerator,
	            auto: auto,
	            config: config,
	            i18n: i18n,
	            name: ctx.name ? ctx.name + '[' + i + ']' : String(i),
	            templates: templates,
	            path: ctx.path.concat(i)
	          }
	        }),
	        key: _this7.state.keys[i],
	        buttons: buttons
	      };
	    });
	  };
	
	  List.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var i18n = this.getI18n();
	    var locals = _Component7.prototype.getLocals.call(this);
	    locals.add = options.disableAdd ? null : {
	      label: i18n.add,
	      click: this.addItem.bind(this)
	    };
	    locals.items = this.getItems();
	    locals.className = options.className;
	    return locals;
	  };
	
	  var _List = List;
	  List = decorators.templates(List) || List;
	  return List;
	})(Component);
	
	exports.List = List;
	
	var Form = (function (_React$Component2) {
	  _inherits(Form, _React$Component2);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    _React$Component2.apply(this, arguments);
	  }
	
	  Form.prototype.validate = function validate() {
	    return this.refs.input.validate();
	  };
	
	  Form.prototype.getValue = function getValue(raw) {
	    var result = this.validate();
	    return raw === true ? result : result.isValid() ? result.value : null;
	  };
	
	  Form.prototype.getComponent = function getComponent(path) {
	    path = _tcombValidation2['default'].Str.is(path) ? path.split('.') : path;
	    return path.reduce(function (input, name) {
	      return input.refs[name];
	    }, this.refs.input);
	  };
	
	  Form.prototype.render = function render() {
	
	    var type = this.props.type;
	    var options = this.props.options || noobj;
	    var i18n = Form.i18n;
	    var templates = Form.templates;
	
	    assert(_tcombValidation2['default'].isType(type), '[' + SOURCE + '] missing required prop type');
	    assert(_tcombValidation2['default'].Obj.is(options), '[' + SOURCE + '] prop options must be an object');
	    assert(_tcombValidation2['default'].Obj.is(templates), '[' + SOURCE + '] missing templates config');
	    assert(_tcombValidation2['default'].Obj.is(i18n), '[' + SOURCE + '] missing i18n config');
	
	    // this is in the render method because I need this._reactInternalInstance
	    this.uidGenerator = this.uidGenerator || new _util.UIDGenerator(this._reactInternalInstance ? this._reactInternalInstance._rootNodeID : '');
	
	    var Component = getComponent(type, options);
	    return _react2['default'].createElement(Component, {
	      ref: 'input',
	      type: type,
	      options: options,
	      value: this.props.value,
	      onChange: this.props.onChange || noop,
	      ctx: this.props.ctx || {
	        context: this.props.context,
	        uidGenerator: this.uidGenerator,
	        auto: 'labels',
	        templates: templates,
	        i18n: i18n,
	        path: []
	      }
	    });
	  };
	
	  return Form;
	})(_react2['default'].Component);
	
	exports.Form = Form;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(3);
	var cx = __webpack_require__(86);
	
	// compile: x -> ReactElement
	function compile(x) {
	
	  // with host elements, compile behaves like the identity
	  if (React.isValidElement(x)) {
	    return x;
	  }
	
	  if (Array.isArray(x)) {
	    return x.map(compile);
	  }
	
	  if (typeof x === 'object' && x !== null) {
	
	    // attrs
	    var attrs = mixin({}, x.attrs);
	    if (attrs.className) {
	      attrs.className = cx(attrs.className) || null; // avoid class=""
	    }
	    if (x.key != null) { attrs.key = x.key; }
	    if (x.ref != null) { attrs.ref = x.ref; }
	
	    // events
	    if (x.events) {
	      for (var name in x.events) {
	        attrs[camelizeEvent(name)] = x.events[name];
	      }
	    }
	
	    // children
	    var children = compile(x.children);
	
	    // build ReactElement
	    return React.createElement.apply(React, [x.tag, attrs].concat(children));
	  }
	
	  return x;
	}
	
	//
	// helpers
	//
	
	// transforms an event name to a React event name
	// click -> onClick
	// blur -> onBlur
	function camelizeEvent(name) {
	  return 'on' + name.charAt(0).toUpperCase() + name.substring(1);
	}
	
	function mixin(x, y) {
	  if (!y) { return x; }
	  for (var k in y) {
	    if (y.hasOwnProperty(k)) {
	      x[k] = y[k];
	    }
	  }
	  return x;
	}
	
	module.exports = {
	  compile: compile
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes += ' ' + arg;
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getOptionsOfEnum = getOptionsOfEnum;
	exports.getTypeInfo = getTypeInfo;
	exports.humanize = humanize;
	exports.merge = merge;
	exports.move = move;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _tcombValidation = __webpack_require__(83);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	function getOptionsOfEnum(type) {
	  var enums = type.meta.map;
	  return Object.keys(enums).map(function (value) {
	    return {
	      value: value,
	      text: enums[value]
	    };
	  });
	}
	
	function getTypeInfo(type) {
	
	  var innerType = type;
	  var isMaybe = false;
	  var isSubtype = false;
	  var kind = undefined;
	  var innerGetValidationErrorMessage = undefined;
	
	  while (innerType) {
	    kind = innerType.meta.kind;
	    if (_tcombValidation2['default'].Func.is(innerType.getValidationErrorMessage)) {
	      innerGetValidationErrorMessage = innerType.getValidationErrorMessage;
	    }
	    if (kind === 'maybe') {
	      isMaybe = true;
	      innerType = innerType.meta.type;
	      continue;
	    }
	    if (kind === 'subtype') {
	      isSubtype = true;
	      innerType = innerType.meta.type;
	      continue;
	    }
	    break;
	  }
	
	  var getValidationErrorMessage = innerGetValidationErrorMessage ? function (value, path, context) {
	    var result = _tcombValidation2['default'].validate(value, type, { path: path, context: context });
	    if (!result.isValid()) {
	      for (var i = 0, len = result.errors.length; i < len; i++) {
	        if (_tcombValidation2['default'].Func.is(result.errors[i].expected.getValidationErrorMessage)) {
	          return result.errors[i].message;
	        }
	      }
	      return innerGetValidationErrorMessage(value, path, context);
	    }
	  } : undefined;
	
	  return {
	    type: type,
	    isMaybe: isMaybe,
	    isSubtype: isSubtype,
	    innerType: innerType,
	    getValidationErrorMessage: getValidationErrorMessage
	  };
	}
	
	// thanks to https://github.com/epeli/underscore.string
	
	function underscored(s) {
	  return s.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
	}
	
	function capitalize(s) {
	  return s.charAt(0).toUpperCase() + s.slice(1);
	}
	
	function humanize(s) {
	  return capitalize(underscored(s).replace(/_id$/, '').replace(/_/g, ' '));
	}
	
	function merge(a, b) {
	  return _tcombValidation.mixin(_tcombValidation.mixin({}, a), b, true);
	}
	
	function move(arr, fromIndex, toIndex) {
	  var element = arr.splice(fromIndex, 1)[0];
	  arr.splice(toIndex, 0, element);
	  return arr;
	}
	
	var UIDGenerator = (function () {
	  function UIDGenerator(seed) {
	    _classCallCheck(this, UIDGenerator);
	
	    this.seed = seed;
	    this.counter = 0;
	  }
	
	  UIDGenerator.prototype.next = function next() {
	    var id = this.seed + this.counter++;
	    return id;
	  };
	
	  return UIDGenerator;
	})();
	
	exports.UIDGenerator = UIDGenerator;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.textbox = textbox;
	exports.checkbox = checkbox;
	exports.select = select;
	exports.radio = radio;
	exports.date = date;
	exports.struct = struct;
	exports.list = list;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombValidation = __webpack_require__(83);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _uvdomBootstrap = __webpack_require__(89);
	
	var _uvdomBootstrap2 = _interopRequireDefault(_uvdomBootstrap);
	
	var Any = _tcombValidation2['default'].Any;
	var maybe = _tcombValidation2['default'].maybe;
	var noobj = {};
	
	var Positive = _tcombValidation2['default'].subtype(_tcombValidation2['default'].Num, function (n) {
	  return n % 1 === 0 && n >= 0;
	}, 'Positive');
	
	var Cols = _tcombValidation2['default'].tuple([Positive, Positive], 'Cols');
	
	var Breakpoints = _tcombValidation2['default'].struct({
	  xs: maybe(Cols),
	  sm: maybe(Cols),
	  md: maybe(Cols),
	  lg: maybe(Cols)
	}, 'Breakpoints');
	
	Breakpoints.prototype.getBreakpoints = function (index) {
	  var breakpoints = {};
	  for (var size in this) {
	    if (this.hasOwnProperty(size) && !_tcombValidation2['default'].Nil.is(this[size])) {
	      breakpoints[size] = this[size][index];
	    }
	  }
	  return breakpoints;
	};
	
	Breakpoints.prototype.getLabelClassName = function () {
	  return _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(0));
	};
	
	Breakpoints.prototype.getInputClassName = function () {
	  return _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(1));
	};
	
	Breakpoints.prototype.getOffsetClassName = function () {
	  return _tcombValidation2['default'].mixin(_uvdomBootstrap2['default'].getOffsets(this.getBreakpoints(1)), _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(1)));
	};
	
	var Size = _tcombValidation2['default'].enums.of('xs sm md lg', 'Size');
	
	var TextboxConfig = _tcombValidation2['default'].struct({
	  addonBefore: Any,
	  addonAfter: Any,
	  horizontal: maybe(Breakpoints),
	  size: maybe(Size),
	  buttonBefore: Any,
	  buttonAfter: Any
	}, 'TextboxConfig');
	
	var CheckboxConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'CheckboxConfig');
	
	var SelectConfig = _tcombValidation2['default'].struct({
	  addonBefore: Any,
	  addonAfter: Any,
	  horizontal: maybe(Breakpoints),
	  size: maybe(Size)
	}, 'SelectConfig');
	
	var RadioConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'RadioConfig');
	
	var DateConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'DateConfig');
	
	var StructConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'StructConfig');
	
	var ListConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'ListConfig');
	
	function getLabel(_ref) {
	  var label = _ref.label;
	  var breakpoints = _ref.breakpoints;
	  var htmlFor = _ref.htmlFor;
	  var id = _ref.id;
	  var align = _ref.align;
	
	  if (!label) {
	    return;
	  }
	
	  var className = breakpoints ? breakpoints.getLabelClassName() : null;
	
	  return _uvdomBootstrap2['default'].getLabel({
	    align: align,
	    className: className,
	    htmlFor: htmlFor,
	    id: id,
	    label: label
	  });
	}
	
	function getHelp(_ref2) {
	  var help = _ref2.help;
	  var attrs = _ref2.attrs;
	
	  if (!help) {
	    return;
	  }
	  return _uvdomBootstrap2['default'].getHelpBlock({
	    help: help,
	    id: attrs.id + '-tip'
	  });
	}
	
	function getError(_ref3) {
	  var hasError = _ref3.hasError;
	  var error = _ref3.error;
	
	  if (!hasError || !error) {
	    return;
	  }
	  return _uvdomBootstrap2['default'].getErrorBlock({
	    error: error,
	    hasError: hasError
	  });
	}
	
	function getHiddenTextbox(_ref4) {
	  var value = _ref4.value;
	  var name = _ref4.name;
	
	  return {
	    tag: 'input',
	    attrs: {
	      type: 'hidden',
	      value: value,
	      name: name
	    }
	  };
	}
	
	function getInputGroupButton(button) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'input-group-btn': true
	      }
	    },
	    children: button
	  };
	}
	
	function textbox(locals) {
	
	  var config = new TextboxConfig(locals.config || noobj);
	
	  if (locals.type === 'hidden') {
	    return getHiddenTextbox(locals);
	  }
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	  var control = undefined;
	
	  if (locals.type === 'static') {
	    control = _uvdomBootstrap2['default'].getStatic(locals.value);
	  } else {
	
	    var tag = 'textarea';
	    if (locals.type !== 'textarea') {
	      tag = 'input';
	      attrs.type = locals.type;
	    }
	
	    attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	    attrs.className['form-control'] = true;
	
	    attrs.disabled = locals.disabled;
	    if (locals.type !== 'file') {
	      attrs.value = locals.value;
	    }
	    attrs.onChange = locals.type === 'file' ? function (evt) {
	      return locals.onChange(evt.target.files[0]);
	    } : function (evt) {
	      return locals.onChange(evt.target.value);
	    };
	
	    if (locals.help) {
	      attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	    }
	
	    control = {
	      tag: tag,
	      attrs: attrs
	    };
	    if (config.addonBefore || config.addonAfter || config.buttonBefore || config.buttonAfter) {
	      control = _uvdomBootstrap2['default'].getInputGroup([config.buttonBefore ? getInputGroupButton(config.buttonBefore) : null, config.addonBefore ? _uvdomBootstrap2['default'].getAddon(config.addonBefore) : null, control, config.addonAfter ? _uvdomBootstrap2['default'].getAddon(config.addonAfter) : null, config.buttonAfter ? getInputGroupButton(config.buttonAfter) : null]);
	    }
	  }
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    htmlFor: attrs.id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function checkbox(locals) {
	
	  var config = new CheckboxConfig(locals.config || noobj);
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	  attrs.type = 'checkbox';
	  attrs.disabled = locals.disabled;
	  attrs.checked = locals.value;
	  attrs.onChange = function (evt) {
	    return locals.onChange(evt.target.checked);
	  };
	
	  if (locals.help) {
	    attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	  }
	
	  var control = _uvdomBootstrap2['default'].getCheckbox(attrs, locals.label);
	
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [control, error, help];
	
	  if (config.horizontal) {
	    children = {
	      tag: 'div',
	      attrs: {
	        className: config.horizontal.getOffsetClassName()
	      },
	      children: children
	    };
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function select(locals) {
	
	  var config = new SelectConfig(locals.config || noobj);
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	
	  attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	  attrs.className['form-control'] = true;
	
	  attrs.multiple = locals.isMultiple;
	  attrs.disabled = locals.disabled;
	  attrs.value = locals.value;
	  attrs.onChange = function (evt) {
	    var value = locals.isMultiple ? Array.prototype.slice.call(evt.target.options).filter(function (option) {
	      return option.selected;
	    }).map(function (option) {
	      return option.value;
	    }) : evt.target.value;
	    locals.onChange(value);
	  };
	
	  if (locals.help) {
	    attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	  }
	
	  var options = locals.options.map(function (x) {
	    return x.label ? _uvdomBootstrap2['default'].getOptGroup(x) : _uvdomBootstrap2['default'].getOption(x);
	  });
	
	  var control = {
	    tag: 'select',
	    attrs: attrs,
	    children: options
	  };
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    htmlFor: attrs.id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function radio(locals) {
	
	  var config = new RadioConfig(locals.config || noobj);
	
	  var id = locals.attrs.id;
	  var onChange = function onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var controls = locals.options.map(function (option, i) {
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	    attrs.type = 'radio';
	    attrs.checked = option.value === locals.value;
	    attrs.disabled = locals.disabled;
	    attrs.value = option.value;
	    attrs.autoFocus = attrs.autoFocus && i === 0;
	    attrs.id = id + '_' + i;
	    attrs['aria-describedby'] = attrs['aria-describedby'] || (locals.label ? id : null);
	    attrs.onChange = onChange;
	
	    return _uvdomBootstrap2['default'].getRadio(attrs, option.text, option.value);
	  });
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    id: id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, controls, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [controls, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function range(n) {
	  var result = [];
	  for (var i = 1; i <= n; i++) {
	    result.push(i);
	  }
	  return result;
	}
	
	function padLeft(x, len) {
	  var str = String(x);
	  var times = len - str.length;
	  for (var i = 0; i < times; i++) {
	    str = '0' + str;
	  }
	  return str;
	}
	
	function toOption(value, text) {
	  return {
	    tag: 'option',
	    attrs: { value: value + '' },
	    children: text
	  };
	}
	
	var nullOption = [toOption('', '-')];
	
	var days = nullOption.concat(range(31).map(function (i) {
	  return toOption(i, padLeft(i, 2));
	}));
	
	var months = nullOption.concat(range(12).map(function (i) {
	  return toOption(i - 1, padLeft(i, 2));
	}));
	
	function date(locals) {
	
	  var config = new DateConfig(locals.config || noobj);
	  var value = locals.value.slice();
	
	  function onDayChange(evt) {
	    value[2] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  }
	
	  function onMonthChange(evt) {
	    value[1] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  }
	
	  function onYearChange(evt) {
	    value[0] = evt.target.value.trim() === '' ? null : evt.target.value.trim();
	    locals.onChange(value);
	  }
	
	  var parts = {
	
	    D: {
	      tag: 'li',
	      key: 'D',
	      children: {
	        tag: 'select',
	        attrs: {
	          disabled: locals.disabled,
	          className: {
	            'form-control': true
	          },
	          value: value[2]
	        },
	        events: {
	          change: onDayChange
	        },
	        children: days
	      }
	    },
	
	    M: {
	      tag: 'li',
	      key: 'M',
	      children: {
	        tag: 'select',
	        attrs: {
	          disabled: locals.disabled,
	          className: {
	            'form-control': true
	          },
	          value: value[1]
	        },
	        events: {
	          change: onMonthChange
	        },
	        children: months
	      }
	    },
	
	    YY: {
	      tag: 'li',
	      key: 'YY',
	      children: {
	        tag: 'input',
	        attrs: {
	          disabled: locals.disabled,
	          type: 'text',
	          size: 5,
	          className: {
	            'form-control': true
	          },
	          value: value[0]
	        },
	        events: {
	          change: onYearChange
	        }
	      }
	    }
	
	  };
	
	  var control = {
	    tag: 'ul',
	    attrs: {
	      className: {
	        'nav nav-pills': true
	      }
	    },
	    children: locals.order.map(function (id) {
	      return parts[id];
	    })
	  };
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function struct(locals) {
	
	  var config = new StructConfig(locals.config || noobj);
	  var children = [];
	
	  if (locals.help) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      children: locals.help
	    }));
	  }
	
	  if (locals.error && locals.hasError) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      type: 'danger',
	      children: locals.error
	    }));
	  }
	
	  children = children.concat(locals.order.map(function (name) {
	    return locals.inputs[name];
	  }));
	
	  var className = {};
	  if (locals.className) {
	    className[locals.className] = true;
	  }
	
	  return _uvdomBootstrap2['default'].getFieldset({
	    className: className,
	    disabled: locals.disabled,
	    legend: locals.label,
	    children: children
	  });
	}
	
	function list(locals) {
	
	  var config = new ListConfig(locals.config || noobj);
	  var children = [];
	
	  if (locals.help) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      children: locals.help
	    }));
	  }
	
	  if (locals.error && locals.hasError) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      type: 'danger',
	      children: locals.error
	    }));
	  }
	
	  children = children.concat(locals.items.map(function (item) {
	    if (item.buttons.length === 0) {
	      return _uvdomBootstrap2['default'].getRow({
	        key: item.key,
	        children: [_uvdomBootstrap2['default'].getCol({
	          breakpoints: { xs: 12 },
	          children: item.input
	        })]
	      });
	    }
	    return _uvdomBootstrap2['default'].getRow({
	      key: item.key,
	      children: [_uvdomBootstrap2['default'].getCol({
	        breakpoints: { sm: 8, xs: 6 },
	        children: item.input
	      }), _uvdomBootstrap2['default'].getCol({
	        breakpoints: { sm: 4, xs: 6 },
	        children: _uvdomBootstrap2['default'].getButtonGroup(item.buttons.map(function (button, i) {
	          return _uvdomBootstrap2['default'].getButton({
	            click: button.click,
	            key: i,
	            label: button.label
	          });
	        }))
	      })]
	    });
	  }));
	
	  if (locals.add) {
	    children.push({
	      tag: 'div',
	      attrs: { className: 'row' },
	      children: {
	        tag: 'div',
	        attrs: { className: 'col-lg-12' },
	        children: {
	          tag: 'div',
	          attrs: { style: { marginBottom: '15px' } },
	          children: _uvdomBootstrap2['default'].getButton(locals.add)
	        }
	      }
	    });
	  }
	
	  var className = {};
	  if (locals.className) {
	    className[locals.className] = true;
	  }
	
	  return _uvdomBootstrap2['default'].getFieldset({
	    className: className,
	    disabled: locals.disabled,
	    legend: locals.label,
	    children: children
	  });
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  getAddon: __webpack_require__(90),
	  getAlert: __webpack_require__(91),
	  getBreakpoints: __webpack_require__(92),
	  getButton: __webpack_require__(93),
	  getButtonGroup: __webpack_require__(94),
	  getCheckbox: __webpack_require__(95),
	  getCol: __webpack_require__(96),
	  getErrorBlock: __webpack_require__(97),
	  getFieldset: __webpack_require__(98),
	  getFormGroup: __webpack_require__(99),
	  getHelpBlock: __webpack_require__(100),
	  getInputGroup: __webpack_require__(101),
	  getLabel: __webpack_require__(102),
	  getOffsets: __webpack_require__(104),
	  getOptGroup: __webpack_require__(105),
	  getOption: __webpack_require__(106),
	  getRadio: __webpack_require__(107),
	  getRow: __webpack_require__(108),
	  getStatic: __webpack_require__(109)
	};

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	function getAddon(addon) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'input-group-addon': true
	      }
	    },
	    children: addon
	  };
	}
	
	module.exports = getAddon;

/***/ },
/* 91 */
/***/ function(module, exports) {

	'use strict';
	
	function getAlert(opts) {
	
	  var type = opts.type || 'info';
	  var className = {
	    'alert': true
	  };
	  className['alert-' + type] = true;
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getAlert;

/***/ },
/* 92 */
/***/ function(module, exports) {

	'use strict';
	
	function getBreakpoints(breakpoints) {
	  var className = {};
	  for (var size in breakpoints) {
	    if (breakpoints.hasOwnProperty(size)) {
	      className['col-' + size + '-' + breakpoints[size]] = true;
	    }
	  }
	  return className;
	}
	
	module.exports = getBreakpoints;

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    type: 'primary',
	    block: true,
	    active: true,
	    size: 'lg',
	    disabled: true,
	    autoFocus: true,
	    events: {
	      ...
	    }
	  }
	
	*/
	
	function getButton(opts) {
	
	  var type = opts.type || 'default';
	
	  var className = {
	    'btn': true,
	    'btn-block': opts.block,
	    'active': opts.active
	  };
	  className['btn-' + type] = true;
	  if (opts.size) {
	    className['btn-' + opts.size] = true;
	  }
	
	  var events = opts.events || {
	    click: opts.click
	  };
	
	  return {
	    tag: 'button',
	    attrs: {
	      type: 'button',
	      disabled: opts.disabled,
	      className: className,
	      autoFocus: opts.autoFocus
	    },
	    events: events,
	    children: opts.label,
	    key: opts.key
	  }
	}
	
	module.exports = getButton;


/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	function getButtonGroup(buttons) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'btn-group': true
	      }
	    },
	    children: buttons
	  };
	};
	
	module.exports = getButtonGroup;
	


/***/ },
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	function getCheckbox(attrs, label) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'checkbox': true,
	        'disabled': attrs.disabled
	      }
	    },
	    children: {
	      tag: 'label',
	      attrs: {
	        htmlFor: attrs.id
	      },
	      children: [
	        {
	          tag: 'input',
	          attrs: attrs
	        },
	        ' ',
	        label
	      ]
	    }
	  };
	}
	
	module.exports = getCheckbox;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getBreakpoints = __webpack_require__(92);
	
	function getCol(opts) {
	
	  var className = opts.breakpoints ? getBreakpoints(opts.breakpoints) : null;
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getCol;

/***/ },
/* 97 */
/***/ function(module, exports) {

	'use strict';
	
	function getErrorBlock(opts) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'help-block': true,
	        'error-block': opts.hasError
	      }
	    },
	    children: opts.error
	  };
	}
	
	module.exports = getErrorBlock;
	


/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	
	function getFieldset(opts) {
	
	  var children = opts.children.slice();
	
	  if (opts.legend) {
	    children.unshift({
	      tag: 'legend',
	      children: opts.legend
	    });
	  }
	
	  return {
	    tag: 'fieldset',
	    attrs: {
	      className: opts.className,
	      disabled: opts.disabled
	    },
	    children: children
	  };
	};
	
	module.exports = getFieldset;
	


/***/ },
/* 99 */
/***/ function(module, exports) {

	'use strict';
	
	function getFormGroup(opts) {
	
	  var className = {
	    'form-group': true,
	    'has-error': opts.hasError
	  };
	  if (opts.className) {
	    className[opts.className] = true;
	  }
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getFormGroup;

/***/ },
/* 100 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    help: 'my help',
	    hasError: true,
	    id: 'password-tip'
	  }
	
	*/
	
	function getHelpBlock(opts) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'help-block': true,
	        'error-block': opts.hasError
	      },
	      // aria support
	      id: opts.id,
	      role: 'tooltip'
	    },
	    children: opts.help
	  };
	}
	
	module.exports = getHelpBlock;
	


/***/ },
/* 101 */
/***/ function(module, exports) {

	'use strict';
	
	function getInputGroup(children) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'input-group': true
	      }
	    },
	    children: children
	  };
	}
	
	module.exports = getInputGroup;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var mixin = __webpack_require__(103);
	
	/*
	
	  Example:
	
	  {
	    label: 'my label',
	    htmlFor: 'inputId',
	    id: 'myid',
	    align: 'right',
	    className: {}
	  }
	
	*/
	
	function getLabel(opts) {
	
	  var className = mixin({
	    'control-label': true
	  }, opts.className);
	
	  if (opts.align) {
	    className['text-' + opts.align] = true;
	  }
	
	  return {
	    tag: 'label',
	    attrs: {
	      htmlFor: opts.htmlFor,
	      id: opts.id,
	      className: className
	    },
	    children: opts.label
	  };
	}
	
	module.exports = getLabel;
	


/***/ },
/* 103 */
/***/ function(module, exports) {

	'use strict';
	
	function mixin(a, b) {
	  if (!b) { return a; }
	  for (var k in b) {
	    if (b.hasOwnProperty(k)) {
	      a[k] = b[k];
	    }
	  }
	  return a;
	}
	
	module.exports = mixin;

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	function getOffsets(breakpoints) {
	  var className = {};
	  for (var size in breakpoints) {
	    if (breakpoints.hasOwnProperty(size)) {
	      className['col-' + size + '-offset-' + (12 - breakpoints[size])] = true;
	    }
	  }
	  return className;
	}
	
	module.exports = getOffsets;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getOption = __webpack_require__(106);
	
	/*
	
	  Example:
	
	  {
	    label: 'group1',
	    options: [
	      {value: 'value1', text: 'description1'},
	      {value: 'value3', text: 'description3'}
	    ]
	  }
	
	*/
	
	function getOptGroup(opts) {
	  return {
	    tag: 'optgroup',
	    attrs: {
	      disabled: opts.disabled,
	      label: opts.label
	    },
	    children: opts.options.map(getOption),
	    key: opts.label
	  };
	}
	
	module.exports = getOptGroup;
	


/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    value: '1',
	    text: 'option 1'
	  }
	
	*/
	
	function getOption(opts) {
	  return {
	    tag: 'option',
	    attrs: {
	      disabled: opts.disabled,
	      value: opts.value
	    },
	    children: opts.text,
	    key: opts.value
	  };
	}
	
	module.exports = getOption;
	


/***/ },
/* 107 */
/***/ function(module, exports) {

	'use strict';
	
	function getRadio(attrs, text, key) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'radio': true,
	        'disabled': attrs.disabled
	      }
	    },
	    children: {
	      tag: 'label',
	      attrs: {
	        htmlFor: attrs.id,
	      },
	      children: [
	        {
	          tag: 'input',
	          attrs: attrs
	        },
	        ' ',
	        text
	      ]
	    },
	    key: key
	  };
	}
	
	module.exports = getRadio;

/***/ },
/* 108 */
/***/ function(module, exports) {

	'use strict';
	
	function getRow(opts) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'row': true
	      }
	    },
	    children: opts.children,
	    key: opts.key
	  };
	}
	
	module.exports = getRow;

/***/ },
/* 109 */
/***/ function(module, exports) {

	'use strict';
	
	function getStatic(value) {
	  return {
	    tag: 'p',
	    attrs: {
	      className: {
	        'form-control-static': true
	      }
	    },
	    children: value
	  };
	}
	
	module.exports = getStatic;

/***/ },
/* 110 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  optional: ' (optional)',
	  required: '',
	  add: 'Add',
	  remove: 'Remove',
	  up: 'Up',
	  down: 'Down'
	};
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Mobile = __webpack_require__(112);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Gender = __webpack_require__(113);
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _Email = __webpack_require__(80);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var Verified = _tcomb2['default'].struct({
	  email: _Email2['default'],
	  mobile: _Mobile2['default'],
	  mobile_country: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  name: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  surname: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  birth_date: _Datetime2['default'],
	  gender: _Gender2['default'],
	  country: _Register_Country2['default'],
	  district: _tcomb2['default'].Str,
	  zip: _tcomb2['default'].Str,
	  com_locale: _Locale2['default'],
	  rcs_privacy_needed: _tcomb2['default'].Bool
	}, 'Verified');
	
	module.exports = Verified;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	//const digitsRegExp = /^\d*$/;
	
	var Mobile = _tcomb2['default'].String; // t.refinement(t.String, (s) => digitsRegExp.test(s), 'Mobile');
	
	exports['default'] = Mobile;
	module.exports = exports['default'];

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Gender = _tcomb2['default'].enums.of(['M', 'F']);
	
	module.exports = Gender;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Register_Country = _tcomb2['default'].enums.of(['AT', 'BR', 'CA', 'CH', 'DE', 'ES', 'FR', 'GB', 'IT', 'US', 'ZA']);
	
	module.exports = Register_Country;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Field = _tcomb2['default'].enums.of('email birth_date zip district mobile gender country', 'Field');
	
	module.exports = Field;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(117),
	    createFind = __webpack_require__(120);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(118),
	    createBaseEach = __webpack_require__(119);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(25),
	    keys = __webpack_require__(33);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(14),
	    isLength = __webpack_require__(16),
	    toObject = __webpack_require__(27);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(121),
	    baseFind = __webpack_require__(141),
	    baseFindIndex = __webpack_require__(142),
	    isArray = __webpack_require__(18);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(122),
	    baseMatchesProperty = __webpack_require__(133),
	    bindCallback = __webpack_require__(36),
	    identity = __webpack_require__(37),
	    property = __webpack_require__(139);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(123),
	    getMatchData = __webpack_require__(130),
	    toObject = __webpack_require__(27);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(124),
	    toObject = __webpack_require__(27);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(125),
	    isObject = __webpack_require__(22),
	    isObjectLike = __webpack_require__(17);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(126),
	    equalByTag = __webpack_require__(128),
	    equalObjects = __webpack_require__(129),
	    isArray = __webpack_require__(18),
	    isTypedArray = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(127);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 128 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(33);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(131),
	    pairs = __webpack_require__(132);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(33),
	    toObject = __webpack_require__(27);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(134),
	    baseIsEqual = __webpack_require__(124),
	    baseSlice = __webpack_require__(135),
	    isArray = __webpack_require__(18),
	    isKey = __webpack_require__(136),
	    isStrictComparable = __webpack_require__(131),
	    last = __webpack_require__(137),
	    toObject = __webpack_require__(27),
	    toPath = __webpack_require__(138);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(27);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(18),
	    toObject = __webpack_require__(27);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(42),
	    isArray = __webpack_require__(18);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(15),
	    basePropertyDeep = __webpack_require__(140),
	    isKey = __webpack_require__(136);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(134),
	    toPath = __webpack_require__(138);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashArrayUnique = __webpack_require__(144);
	
	var _lodashArrayUnique2 = _interopRequireDefault(_lodashArrayUnique);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Shipping = __webpack_require__(154);
	
	var _Shipping2 = _interopRequireDefault(_Shipping);
	
	var _Runtime = __webpack_require__(157);
	
	var _Runtime2 = _interopRequireDefault(_Runtime);
	
	var _Sponsor = __webpack_require__(159);
	
	var _Sponsor2 = _interopRequireDefault(_Sponsor);
	
	var _Color = __webpack_require__(161);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _get_bundle = __webpack_require__(49);
	
	var _get_bundle2 = _interopRequireDefault(_get_bundle);
	
	var _Custom_Payment = __webpack_require__(162);
	
	var _Custom_Payment2 = _interopRequireDefault(_Custom_Payment);
	
	var _Payment_Type = __webpack_require__(163);
	
	var _Payment_Type2 = _interopRequireDefault(_Payment_Type);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var _Currency = __webpack_require__(156);
	
	var _Currency2 = _interopRequireDefault(_Currency);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Authorization = __webpack_require__(164);
	
	var _Authorization2 = _interopRequireDefault(_Authorization);
	
	var _componentsStdShipping = __webpack_require__(165);
	
	var _componentsStdShipping2 = _interopRequireDefault(_componentsStdShipping);
	
	var _componentsCouponShipping = __webpack_require__(169);
	
	var _componentsCouponShipping2 = _interopRequireDefault(_componentsCouponShipping);
	
	var _componentsProductShippings = __webpack_require__(170);
	
	var _componentsProductShippings2 = _interopRequireDefault(_componentsProductShippings);
	
	var Product = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  locale: _Locale2['default'],
	  name: _tcomb2['default'].Str,
	  description: _tcomb2['default'].Str, //ex markdown
	  image: _URL2['default'],
	  currency: _Currency2['default'],
	  list_price: _Amount2['default'],
	  color: _tcomb2['default'].maybe(_Color2['default']),
	  end_date: _Datetime2['default'],
	  nr_items: _Natural2['default'],
	  max_items: _Natural2['default'],
	  min_price: _Amount2['default'],
	  details: _tcomb2['default'].Str, //ex markdown
	  shippings: _tcomb2['default'].list(_Shipping2['default']),
	  is_coupon: _tcomb2['default'].Bool,
	  is_invoiced: _tcomb2['default'].Bool,
	  is_min_price_hidden: _tcomb2['default'].Bool,
	  payments: _tcomb2['default'].list(_Payment_Type2['default']),
	  custom_payments: _tcomb2['default'].maybe(_tcomb2['default'].list(_Custom_Payment2['default'])),
	  runtime: _tcomb2['default'].maybe(_Runtime2['default']),
	  privacy: _tcomb2['default'].maybe(_tcomb2['default'].Str), // ex markdown
	  sponsor: _tcomb2['default'].maybe(_Sponsor2['default']),
	  start_price: _Amount2['default'],
	  pending_purchase_message: _tcomb2['default'].maybe(_tcomb2['default'].Str), //ex markdown
	  gift_card_not_supported: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  bonus_not_supported: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  button_label: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  authorization: _tcomb2['default'].maybe(_Authorization2['default']),
	  min_buy_price: _tcomb2['default'].maybe(_Amount2['default'])
	}, 'Product');
	
	Product.of = function (p) {
	  p.locale = _Locale2['default'].of(p.locale);
	  return new Product(p);
	};
	
	Product.prototype.shipping_countries = function () {
	  return (0, _lodashArrayUnique2['default'])(this.shippings.map(function (shipping) {
	    return shipping.country;
	  }));
	};
	
	// Un prodotto è scaduto quando non è passata la sua end_date
	Product.prototype.is_expired = function () {
	  return new Date().getTime() > this.end_date;
	};
	
	// Un prodotto è disponibile se non è scaduto e
	// se non sono stati venduti tutti gli item
	Product.prototype.is_available = function () {
	  return !this.runtime.is_sold_out && !this.is_expired();
	};
	
	// utility per formattare i prezzi del prodotto
	Product.prototype.format_amount = function (locale, amount) {
	  return _Amount2['default'].format(locale, this.currency, amount);
	};
	
	Product.prototype.replace_runtime = function (runtime) {
	  return Product.update(this, { runtime: { $set: runtime } });
	};
	
	Product.prototype.display_shippings = function (locale) {
	  var product = this;
	  if (this.is_coupon) {
	    return _react2['default'].createElement(_componentsCouponShipping2['default'], {
	      locale: locale,
	      currency: product.currency
	    }); //product.display_shipping(locale, Coupon_Shipping.of_locale(locale), true);
	  } else {
	      return _react2['default'].createElement(_componentsProductShippings2['default'], { locale: locale, product: product }); // this.get_html_shippings_groupped(locale);
	    }
	};
	
	Product.prototype.display_shipping = function (locale, shipping, omit_country) {
	  return _react2['default'].createElement(_componentsStdShipping2['default'], {
	    locale: locale,
	    currency: this.currency,
	    shipping: shipping,
	    omit_country: omit_country });
	};
	
	Product.prototype.total = function (locale, order) {
	  var total = this.runtime.price;
	  var current_shipping = order && order.domicile ? order.domicile.shipping : null;
	  if (current_shipping) {
	    total += current_shipping.cost;
	  } else if (!this.is_coupon && this.shippings.length === 1) {
	    total += this.shippings[0].cost;
	  }
	  return this.format_amount(locale, total);
	};
	
	Product.prototype.getBuyButtonLabel = function (locale) {
	  return this.button_label ? this.button_label : (0, _get_bundle2['default'])(locale).product.console.go_buy[0];
	};
	
	Product.prototype.hasPrivacy = function () {
	  return this.privacy !== null;
	};
	
	module.exports = Product;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(145);


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(121),
	    baseUniq = __webpack_require__(146),
	    isIterateeCall = __webpack_require__(38),
	    sortedUniq = __webpack_require__(153);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurence of each element
	 * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	 * for sorted arrays. If an iteratee function is provided it's invoked for
	 * each element in the array to generate the criterion by which uniqueness
	 * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index, array).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}
	
	module.exports = uniq;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(147),
	    cacheIndexOf = __webpack_require__(149),
	    createCache = __webpack_require__(150);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(148);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(151),
	    getNative = __webpack_require__(19);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(152),
	    getNative = __webpack_require__(19);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = sortedUniq;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Country = __webpack_require__(60);
	
	var _Country2 = _interopRequireDefault(_Country);
	
	var Shipping = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  description: _tcomb2['default'].Str, //ex markdown
	  cost: _Amount2['default'],
	  country: _Country2['default']
	}, 'Shipping');
	
	module.exports = Shipping;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Currency = __webpack_require__(156);
	
	var _Currency2 = _interopRequireDefault(_Currency);
	
	var Amount = _tcomb2['default'].refinement(_tcomb2['default'].Num, function (n) {
	  return n >= 0;
	});
	
	Amount.format = function (locale, currency, amount) {
	  locale = (0, _Locale2['default'])(locale);
	  currency = (0, _Currency2['default'])(currency);
	  amount = Amount(amount);
	
	  var ret = function (locale, currency, amount) {
	    var bundle = locale.locale_bundle();
	    _tcomb2['default'].assert(_tcomb2['default'].Object.is(bundle));
	    var symbol = bundle.currency[currency];
	    return symbol + ' ' + locale.format_number(amount);
	  }.call(this, locale, currency, amount);
	
	  return _tcomb2['default'].String(ret);
	};
	
	exports['default'] = Amount;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Currency = _tcomb2['default'].enums.of('EUR CAD GBP USD ZAR BRL'.split(' '));
	
	module.exports = Currency;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Deal = __webpack_require__(158);
	
	var _Deal2 = _interopRequireDefault(_Deal);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Int = __webpack_require__(57);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var Registered_State = _tcomb2['default'].enums.of(['virgin', 'sinner']);
	
	var Runtime = _tcomb2['default'].struct({
	  price: _tcomb2['default'].maybe(_Amount2['default']),
	  delta: _tcomb2['default'].maybe(_Int2['default']),
	  bonus: _tcomb2['default'].maybe(_Amount2['default']),
	  is_sold_out: _tcomb2['default'].Bool,
	  is_max_items_overflow: _tcomb2['default'].Bool,
	  payments_overflow: _tcomb2['default'].maybe(_UUID2['default']),
	  status: _tcomb2['default'].maybe(Registered_State),
	  best: _tcomb2['default'].maybe(_Deal2['default']),
	  lasts: _tcomb2['default'].list(_Deal2['default'])
	}, 'Runtime');
	
	module.exports = Runtime;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Currency = __webpack_require__(156);
	
	var _Currency2 = _interopRequireDefault(_Currency);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Int = __webpack_require__(57);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var Deal = _tcomb2['default'].struct({
	  currency: _Currency2['default'],
	  price: _Amount2['default'],
	  delta: _Int2['default'],
	  tick: _Datetime2['default']
	}, 'Deal');
	
	module.exports = Deal;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var _Color = __webpack_require__(161);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var Background_Position = _tcomb2['default'].enums.of(['left top', 'left center', 'left bottom', 'right top', 'right center', 'right bottom', 'center top', 'center center', 'center bottom'], 'Background_Position');
	
	var Repeat = _tcomb2['default'].enums.of(['repeat', 'repeat-x', 'repeat-y', 'no-repeat'], 'Repeat');
	
	var Attachment = _tcomb2['default'].enums.of(['scroll', 'fixed'], 'Attachment');
	
	var Sponsor_Background = _tcomb2['default'].struct({
	  color: _tcomb2['default'].maybe(_Color2['default']),
	  image: _tcomb2['default'].maybe(_URL2['default']),
	  position: _tcomb2['default'].maybe(Background_Position),
	  repeat: _tcomb2['default'].maybe(Repeat),
	  attachment: _tcomb2['default'].maybe(Attachment)
	}, 'Sponsor_Background');
	
	var Sponsor = _tcomb2['default'].struct({
	  name: _tcomb2['default'].String,
	  logo: _tcomb2['default'].maybe(_URL2['default']),
	  tutorial: _tcomb2['default'].maybe(_URL2['default']),
	  description: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  tagline: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  privacy: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  color: _Color2['default'],
	  bg_color: _Color2['default'],
	  image: _tcomb2['default'].maybe(_URL2['default']),
	  background: _tcomb2['default'].maybe(Sponsor_Background),
	  welcome_name: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  welcome_logo: _tcomb2['default'].maybe(_URL2['default']),
	  welcome_image: _tcomb2['default'].maybe(_URL2['default']),
	  welcome_tutorial: _tcomb2['default'].maybe(_URL2['default']),
	  welcome_description: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  welcome_color: _tcomb2['default'].maybe(_Color2['default']),
	  welcome_bg_color: _tcomb2['default'].maybe(_Color2['default'])
	}, 'Sponsor');
	
	exports['default'] = Sponsor;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	
	var URL = _tcomb2['default'].refinement(_tcomb2['default'].String, function (url) {
	  return is_url_regexp.test(url);
	});
	
	exports['default'] = URL;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;
	
	var is_color = function is_color(s) {
	  return is_color_regexp.test(s);
	};
	
	var Color = _tcomb2['default'].subtype(_tcomb2['default'].Str, is_color);
	
	module.exports = Color;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Payment_Type = __webpack_require__(163);
	
	var _Payment_Type2 = _interopRequireDefault(_Payment_Type);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Custom_Payment = _tcomb2['default'].struct({
	  type: _Payment_Type2['default'],
	  description: _tcomb2['default'].Str,
	  purchase_description: _tcomb2['default'].Str,
	  image: _URL2['default']
	}, 'Custom_Payment');
	
	module.exports = Custom_Payment;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Payment_Type = _tcomb2['default'].enums.of('wepayyou paypal paypal_it paypal_cc qui_pago mysi skrill skrill_cc magento chebanca stripe stripe_sca satispay falkensteiner two_checkout custom'.split(' '));
	
	module.exports = Payment_Type;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	// authorization necessaria per rispondere al reducer
	var Authorization = _tcomb2['default'].enums.of(['anonymous', 'registered', 'verified'], 'Authorization');
	
	module.exports = Authorization;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainCurrency = __webpack_require__(156);
	
	var _domainCurrency2 = _interopRequireDefault(_domainCurrency);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainShipping = __webpack_require__(154);
	
	var _domainShipping2 = _interopRequireDefault(_domainShipping);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var StdShipping = (function (_React$Component) {
	  _inherits(StdShipping, _React$Component);
	
	  function StdShipping() {
	    _classCallCheck(this, _StdShipping);
	
	    _get(Object.getPrototypeOf(_StdShipping.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StdShipping, [{
	    key: 'getCountry',
	    value: function getCountry() {
	      if (!this.props.shipping.country || this.props.omit_country) {
	        return null;
	      }
	
	      var countryLabel = (0, _domainGet_bundle2['default'])(this.props.locale).order.shippings.country;
	      return _react2['default'].createElement(
	        'span',
	        null,
	        countryLabel,
	        ' ',
	        _react2['default'].createElement(
	          'strong',
	          null,
	          this.props.locale.display_country(this.props.shipping.country)
	        )
	      );
	    }
	  }, {
	    key: 'getCost',
	    value: function getCost() {
	      return _domainAmount2['default'].format(this.props.locale, this.props.currency, this.props.shipping.cost);
	    }
	  }, {
	    key: 'getDescription',
	    value: function getDescription() {
	      return this.props.shipping.description;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          this.getCountry()
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            this.getCost()
	          ),
	          '   ',
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            this.getDescription()
	          )
	        )
	      );
	    }
	  }]);
	
	  var _StdShipping = StdShipping;
	  StdShipping = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    currency: _domainCurrency2['default'],
	    shipping: _domainShipping2['default'],
	    omit_country: _tcombReact.t.Bool
	  })(StdShipping) || StdShipping;
	  return StdShipping;
	})(_react2['default'].Component);
	
	exports['default'] = StdShipping;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var _micromd = __webpack_require__(40);
	
	var _micromd2 = _interopRequireDefault(_micromd);
	
	var MarkdownComponent = (function (_React$Component) {
	  _inherits(MarkdownComponent, _React$Component);
	
	  function MarkdownComponent() {
	    _classCallCheck(this, _MarkdownComponent);
	
	    _get(Object.getPrototypeOf(_MarkdownComponent.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MarkdownComponent, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.children) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        _HTMLComponent2['default'],
	        null,
	        (0, _micromd2['default'])(this.props.children)
	      );
	    }
	  }]);
	
	  var _MarkdownComponent = MarkdownComponent;
	  MarkdownComponent = (0, _tcombReact.props)({
	    children: _tcombReact.t.Str
	  })(MarkdownComponent) || MarkdownComponent;
	  return MarkdownComponent;
	})(_react2['default'].Component);
	
	exports['default'] = MarkdownComponent;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var HTMLComponent = (function (_React$Component) {
	  _inherits(HTMLComponent, _React$Component);
	
	  function HTMLComponent() {
	    _classCallCheck(this, _HTMLComponent);
	
	    _get(Object.getPrototypeOf(_HTMLComponent.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HTMLComponent, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: this.props.children } });
	    }
	  }]);
	
	  var _HTMLComponent = HTMLComponent;
	  HTMLComponent = (0, _tcombReact.props)({
	    children: _tcombReact.t.Str
	  })(HTMLComponent) || HTMLComponent;
	  return HTMLComponent;
	})(_react2['default'].Component);
	
	exports['default'] = HTMLComponent;
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(3);
	var t = __webpack_require__(83);
	
	//
	// helpers
	//
	
	// use t.stringify if defined, otherwise fallback to a verbose but possibly slow implementation
	var stringify = t.stringify || function stringify(x) {
	  try { // handle "Converting circular structure to JSON" error
	    return JSON.stringify(x);
	  }
	  catch (e) {
	    return String(x);
	  }
	};
	
	// returns true id type is a struct
	function isStruct(type) {
	  return ( type.meta.kind === 'struct' );
	}
	
	// returns true id type is a subtype
	function isSubtype(type) {
	  return ( type.meta.kind === 'subtype' );
	}
	
	//
	// main function
	//
	
	function getPropTypes(type, options) {
	
	  //
	  // let's type check the input...
	  //
	
	  // getPropTypes can also accept a dictionary prop -> type
	  if (t.Obj.is(type)) {
	    type = t.struct(type);
	  }
	
	  // here type should be a struct or a subtype of a struct
	  if (false) {
	    t.assert(
	      t.isType(type) && ( isStruct(type) || ( isSubtype(type) && isStruct(type.meta.type) ) ),
	      '[tcomb-react] Invalid argument type supplied to propTypes(), must be a struct, a subtype of a struct or a dictionary prop -> type'
	    );
	  }
	
	  var propTypes = {};
	  var subtype = isSubtype(type);
	  var innerStruct = subtype ? type.meta.type : type;
	  var props = innerStruct.meta.props;
	
	  Object.keys(props).forEach(function (k) {
	
	    var propType = props[k];
	    var propTypeName = t.getTypeName(propType);
	    var checkPropType = function () {};
	
	    if (false) {
	
	      // React custom prop validators
	      // see http://facebook.github.io/react/docs/reusable-components.html
	      checkPropType = function (values, prop, displayName) {
	
	        var value = values[prop];
	        var validationResult = t.validate(value, props[prop]);
	
	        if (!validationResult.isValid()) {
	
	          var message = [
	            'Invalid prop ' + stringify(prop) + ' supplied to ' + displayName + ', should be a ' + propTypeName + '.\n',
	            'Detected errors (' + validationResult.errors.length + '):\n'
	          ].concat(validationResult.errors.map(function (e, i) {
	            return ' ' + (i + 1) + '. ' + e.message;
	          })).join('\n') + '\n\n';
	
	          // add a readable entry in the call stack
	          // when "Pause on exceptions" and "Pause on Caught Exceptions"
	          // are enabled in Chrome DevTools
	          checkPropType.displayName = message;
	
	          t.fail(message);
	        }
	      };
	    }
	
	    // attach the original tcomb definition, so other components can read it
	    // via `propTypes.whatever.tcomb`
	    checkPropType.tcomb = propType;
	
	    propTypes[k] = checkPropType;
	  });
	
	  if (false) {
	
	    options = options || {};
	
	    // allows to opt-out additional props check
	    if (options.strict !== false) {
	      propTypes.__strict__ = function (values, prop, displayName) {
	        var extra = [];
	        for (var k in values) {
	          // __strict__ and __subtype__ keys are excluded in order to support the React context feature
	          if (k !== '__strict__' && k !== '__subtype__' && values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
	            extra.push(k);
	          }
	        }
	        if (extra.length > 0) {
	          t.fail('Invalid additional prop(s):\n\n' + stringify(extra) + '\n\nsupplied to ' + displayName + '.');
	        }
	      };
	    }
	
	    if (subtype) {
	      propTypes.__subtype__ = function (values, prop, displayName) {
	        if (!type.meta.predicate(values)) {
	          t.fail('Invalid props:\n\n' + stringify(values) + '\n\nsupplied to ' + displayName + ', should be a ' + t.getTypeName(type) + ' subtype.');
	        }
	      };
	    }
	  }
	
	  return propTypes;
	}
	
	//
	// ES7 decorator
	//
	
	function es7PropsDecorator(type, options) {
	  return function (Component) {
	    Component.propTypes = getPropTypes(type, options);
	  };
	}
	
	var ReactElement = t.irreducible('ReactElement', React.isValidElement);
	var ReactNode = t.irreducible('ReactNode', function (x) {
	  return t.Str.is(x) || t.Num.is(x) || ReactElement.is(x) || t.list(ReactNode).is(x);
	});
	
	t.ReactElement = ReactElement;
	t.ReactNode = ReactNode;
	
	module.exports = {
	  t: t,
	  propTypes: getPropTypes,
	  props: es7PropsDecorator,
	  ReactElement: ReactElement, // deprecated
	  ReactNode: ReactNode  // deprecated
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainCurrency = __webpack_require__(156);
	
	var _domainCurrency2 = _interopRequireDefault(_domainCurrency);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var CouponShipping = (function (_React$Component) {
	  _inherits(CouponShipping, _React$Component);
	
	  function CouponShipping() {
	    _classCallCheck(this, _CouponShipping);
	
	    _get(Object.getPrototypeOf(_CouponShipping.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CouponShipping, [{
	    key: 'getCost',
	    value: function getCost() {
	      return _domainAmount2['default'].format(this.props.locale, this.props.currency, 0);
	    }
	  }, {
	    key: 'getDescription',
	    value: function getDescription() {
	      return (0, _domainGet_bundle2['default'])(this.props.locale).order.coupon.shipping.description;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'span',
	        null,
	        _react2['default'].createElement(
	          _MarkdownComponent2['default'],
	          null,
	          this.getDescription()
	        )
	      );
	    }
	  }]);
	
	  var _CouponShipping = CouponShipping;
	  CouponShipping = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    currency: _domainCurrency2['default']
	  })(CouponShipping) || CouponShipping;
	  return CouponShipping;
	})(_react2['default'].Component);
	
	exports['default'] = CouponShipping;
	module.exports = exports['default'];
	/*this.getCost()*/

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _CouponShipping = __webpack_require__(169);
	
	var _CouponShipping2 = _interopRequireDefault(_CouponShipping);
	
	var _micromd = __webpack_require__(40);
	
	var _micromd2 = _interopRequireDefault(_micromd);
	
	var _tcombReact = __webpack_require__(168);
	
	var ProductShippings = (function (_React$Component) {
	  _inherits(ProductShippings, _React$Component);
	
	  function ProductShippings() {
	    _classCallCheck(this, _ProductShippings);
	
	    _get(Object.getPrototypeOf(_ProductShippings.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProductShippings, [{
	    key: 'getCouponShipping',
	    value: function getCouponShipping() {
	      return _react2['default'].createElement(_CouponShipping2['default'], {
	        locale: this.props.locale,
	        currency: this.props.product.currency });
	    }
	  }, {
	    key: 'getHtmlShippingsGroupped',
	    value: function getHtmlShippingsGroupped() {
	      var _this = this;
	
	      var shippings_groupped = {};
	      var html = "";
	      var locale = this.props.locale;
	      this.props.product.shippings.map(function (shipping) {
	        var k = shipping.cost + "_" + shipping.description;
	
	        if (shippings_groupped[k]) {
	          shippings_groupped[k].shippings.push({
	            id: shipping.id,
	            country: shipping.country
	          });
	        } else {
	          shippings_groupped[k] = {
	            cost: shipping.cost,
	            description: shipping.description,
	            shippings: [{
	              id: shipping.id,
	              country: shipping.country
	            }]
	          };
	        }
	      });
	
	      var getShippingDisplayCountry = function getShippingDisplayCountry(shipping) {
	        return _this.props.locale.display_country(shipping.country);
	      };
	      for (var shipping_groupped in shippings_groupped) {
	        var obj = shippings_groupped[shipping_groupped];
	        var country = '';
	        var cost = _domainAmount2['default'].format(locale, this.props.product.currency, obj.cost) + '<br/>';
	        var description = (0, _micromd2['default'])(obj.description);
	        country = (0, _domainGet_bundle2['default'])(locale).order.shippings.country + ': ' + obj.shippings.map(getShippingDisplayCountry).join(", ") + '<br/>';
	        html += country + description + '<br/><hr>';
	      }
	      return _react2['default'].createElement(
	        _HTMLComponent2['default'],
	        null,
	        html
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.product.is_coupon) {
	        return this.getCouponShipping();
	      }
	      return this.getHtmlShippingsGroupped(this.props.locale);
	    }
	  }]);
	
	  var _ProductShippings = ProductShippings;
	  ProductShippings = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _tcomb2['default'].Obj
	  })(ProductShippings) || ProductShippings;
	  return ProductShippings;
	})(_react2['default'].Component);
	
	exports['default'] = ProductShippings;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Sponsor = __webpack_require__(159);
	
	var _Sponsor2 = _interopRequireDefault(_Sponsor);
	
	var _Reducer = __webpack_require__(172);
	
	var _Reducer2 = _interopRequireDefault(_Reducer);
	
	var _Adv_Box = __webpack_require__(234);
	
	var _Adv_Box2 = _interopRequireDefault(_Adv_Box);
	
	var _Color = __webpack_require__(161);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var _Partners = __webpack_require__(235);
	
	var _Partners2 = _interopRequireDefault(_Partners);
	
	var _Widget = __webpack_require__(238);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var Lattice = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  locale: _Locale2['default'],
	  sponsor: _Sponsor2['default'],
	  reducers: _tcomb2['default'].list(_Reducer2['default']),
	  share_url: _tcomb2['default'].maybe(_URL2['default']),
	  share_caption: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  theme_btn_color: _tcomb2['default'].maybe(_Color2['default']),
	  theme_bg_color: _tcomb2['default'].maybe(_Color2['default']),
	  has_third_parties_privacy: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  adv_boxes: _tcomb2['default'].maybe(_tcomb2['default'].list(_Adv_Box2['default'])),
	  partners: _tcomb2['default'].maybe(_Partners2['default']),
	  theme_btn_font_color: _tcomb2['default'].maybe(_Color2['default']),
	  theme_bg_font_color: _tcomb2['default'].maybe(_Color2['default']),
	  is_white_label: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  widget: _tcomb2['default'].maybe(_Widget2['default']),
	  is_hidden: _tcomb2['default'].maybe(_tcomb2['default'].Bool)
	}, 'Lattice');
	
	Lattice.of = function (lattice) {
	  lattice.locale = _Locale2['default'].of(lattice.locale);
	  return new Lattice(lattice);
	};
	module.exports = Lattice;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _micromd = __webpack_require__(40);
	
	var _micromd2 = _interopRequireDefault(_micromd);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Component = __webpack_require__(173);
	
	var _get_bundle = __webpack_require__(49);
	
	var _get_bundle2 = _interopRequireDefault(_get_bundle);
	
	var _Feedback = __webpack_require__(229);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _Behaviour = __webpack_require__(231);
	
	var _Behaviour2 = _interopRequireDefault(_Behaviour);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Authorization = __webpack_require__(164);
	
	var _Authorization2 = _interopRequireDefault(_Authorization);
	
	var _componentsConfirm = __webpack_require__(232);
	
	var _componentsConfirm2 = _interopRequireDefault(_componentsConfirm);
	
	// FIXME cosa ci fa qui?
	
	var _componentsAlert = __webpack_require__(233);
	
	var _componentsAlert2 = _interopRequireDefault(_componentsAlert);
	
	// FIXME cosa ci fa qui?
	
	var _template = __webpack_require__(189);
	
	_template.template.store('reducer_content', (0, _template.template)('\n<div id="reducer_content" class="box light">\n  <%= reducer %>\n  <div class="large-text-center">\n    <% if (is_skippable) { %>\n    <button id="do_skip" class="big"><%= do_skip %></button>\n    <% } %>\n    <button id="do_reduce" <%= styleBtnColor %> class="big" ><%= do_reduce %></button>\n    <%= required_privacy_form %>\n    <div class="disclaimer">\n      <small><%= standard_privacy_disclaimer %></small>\n    </div>\n    <% if (privacy_type !== "none") { %>\n      <div id="privacy" class="<%= is_privacy_open ? "" : "large-hide " %>large-text-left"><%= privacy %></div>\n    <% } %>\n  </div>\n</div>\n'));
	
	var Privacy_Type = _tcomb2['default'].enums.of(['none', 'standard', 'required'], 'Privacy_Type');
	
	var Reducer = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  style: _tcomb2['default'].Object, //Reducer_Style,
	  components: _tcomb2['default'].list(_Component.Component),
	  privacy_type: Privacy_Type,
	  privacy: _tcomb2['default'].maybe(_tcomb2['default'].String), //ex markdown
	  is_privacy_open: _tcomb2['default'].Boolean,
	  is_skippable: _tcomb2['default'].maybe(_tcomb2['default'].Boolean),
	  timeout: _Natural2['default'],
	  authorization: _tcomb2['default'].maybe(_Authorization2['default'])
	}, 'Reducer');
	
	var likes = [];
	
	Reducer.add_like = function (id) {
	  id = (0, _UUID2['default'])(id);
	
	  likes.push(id);
	};
	
	Reducer.remove_like = function (id) {
	  id = (0, _UUID2['default'])(id);
	
	  if (!id) {
	    likes = [];
	  } else {
	    likes = likes.filter(function (like) {
	      return like !== id;
	    });
	  }
	};
	
	Reducer.prototype.has_like = function (id) {
	  id = (0, _UUID2['default'])(id);
	
	  return likes.some(function (like) {
	    return like === id;
	  });
	};
	
	var gpluses = [];
	
	Reducer.add_gplus = function (id) {
	  id = (0, _UUID2['default'])(id);
	
	  gpluses.push(id);
	};
	
	Reducer.remove_gplus = function (id) {
	  id = (0, _UUID2['default'])(id);
	
	  if (!id) {
	    gpluses = [];
	  } else {
	    gpluses = gpluses.filter(function (gplus) {
	      return gplus !== id;
	    });
	  }
	};
	
	Reducer.has_gplus = function (id) {
	  id = (0, _UUID2['default'])(id);
	
	  return gpluses.some(function (gplus) {
	    return gplus === id;
	  });
	};
	
	Reducer.prototype.get_privacy = function (default_privacy) {
	  switch (this.privacy_type) {
	    case 'none':
	      return '';
	    case 'standard':
	    case 'required':
	      return this.privacy || default_privacy || '';
	  }
	};
	
	Reducer.prototype.getReducerForm = function (locale, like_url, gplus_url) {
	  var config = {
	    stacked: true,
	    attrs: {
	      id: this.id,
	      style: this.style
	    },
	    rows: this.components.map(function (component) {
	      component = (0, _Component.Component)(component);
	
	      return [component.to_form({
	        like_url: like_url,
	        gplus_url: gplus_url
	      })];
	    })
	  };
	  return new _jsdk2['default'].Form(config, {}, locale);
	};
	
	function getReducerPrivacyForm(locale, privacy_required) {
	  var config = {
	    attrs: {
	      id: 'privacy_form'
	    },
	    rows: [[{
	      type: 'checkbox',
	      id: 'is_privacy_checked',
	      schema: {
	        type: 'boolean',
	        any: [true]
	      }
	    }, '<div class="large-text-left">' + (0, _micromd2['default'])(privacy_required) + '</div>']]
	  };
	  return new _jsdk2['default'].Form(config, {}, locale);
	}
	
	Reducer.prototype.isPrivacyRequired = function () {
	  return this.privacy_type === 'required';
	};
	
	Reducer.prototype.to_widget = function (sandbox) {
	  var locale = sandbox.locale;
	  var like_url = sandbox.like_url;
	  var gplus_url = sandbox.gplus_url;
	  var context = sandbox.context;
	  var default_privacy = sandbox.default_privacy;
	
	  var bundle = (0, _get_bundle2['default'])(locale).reducer;
	  var form = this.getReducerForm(locale, like_url, gplus_url);
	  var privacyForm = this.isPrivacyRequired() ? getReducerPrivacyForm(locale, bundle.privacy_required) : null;
	  var timeout = this.timeout;
	
	  var html = _template.template.of('reducer_content')({
	    reducer: form.to_html(context),
	    is_skippable: this.is_skippable,
	    privacy_type: this.privacy_type,
	    privacy: String(this.get_privacy(default_privacy)),
	    is_privacy_open: this.is_privacy_open,
	    do_skip: bundle.do_skip,
	    do_reduce: bundle.do_reduce,
	    required_privacy_form: privacyForm ? privacyForm.to_html() : '', // se è required
	    standard_privacy_disclaimer: this.privacy_type === 'standard' ? (0, _micromd2['default'])(bundle.privacy) : '', // se è standard
	    styleBtnColor: sandbox.styleBtnColor
	  });
	
	  var timeoutID = null;
	
	  function start() {
	
	    form.start();
	
	    if (privacyForm) {
	      privacyForm.start();
	    }
	
	    $('#reducer_content').on('click', 'a[href=go_privacy]', function (evt) {
	      evt.preventDefault();
	      $('#privacy').toggle();
	    }).on('click', '#do_reduce', function () {
	      // gestione timeout del bottone riduci
	      if (!$('#do_reduce').hasClass('disabled')) {
	        var value = form.value(context);
	        if (value) {
	          if (privacyForm) {
	            var privacy_value = privacyForm.value();
	            if (privacy_value) {
	              sandbox.do_reduce(value);
	            }
	          } else {
	            sandbox.do_reduce(value);
	          }
	        }
	      }
	    }).on('click', '#do_skip', function () {
	      var cbk = function cbk(b) {
	        if (b) {
	          sandbox.do_skip();
	        } else {
	          _reactDom2['default'].unmountComponentAtNode(document.getElementById('modal-container'));
	        }
	      };
	      _reactDom2['default'].render(_react2['default'].createElement(
	        _componentsConfirm2['default'],
	        { callback: cbk, locale: locale, width: '600', title: bundle.do_skip },
	        _react2['default'].createElement(
	          _componentsAlert2['default'],
	          { type: 'warning' },
	          bundle.confirm_skip
	        )
	      ), document.getElementById('modal-container'));
	    });
	
	    // gestione timeout del bottone riduci
	    if (timeout) {
	      $('#do_reduce').addClass('disabled');
	      timeoutID = setTimeout(function () {
	        $('#do_reduce').removeClass('disabled');
	      }, timeout * 1000);
	    }
	  }
	
	  function stop() {
	
	    form.stop();
	
	    if (privacyForm) {
	      privacyForm.stop();
	    }
	
	    $('#reducer_content').off();
	
	    // gestione timeout del bottone riduci
	    if (timeoutID) {
	      clearTimeout(timeoutID);
	    }
	  }
	
	  return new _jsdk2['default'].Widget(html, start, stop);
	};
	
	Reducer.prototype.getReducerBehaviour = function (lattice_id, form_value) {
	  lattice_id = (0, _UUID2['default'])(lattice_id);
	  form_value = _tcomb2['default'].Object(form_value);
	
	  var feedbacks = [];
	
	  function getFeedback(_ref) {
	    var _ref2 = _slicedToArray(_ref, 2);
	
	    var id = _ref2[0];
	    var value = _ref2[1];
	
	    return new _Feedback2['default']({ id: id, value: value });
	  }
	
	  for (var k in form_value) {
	    var answer = form_value[k];
	    if (_tcomb2['default'].Array.is(answer)) {
	      feedbacks = feedbacks.concat(answer.map(getFeedback));
	    } else {
	      feedbacks.push(new _Feedback2['default']({ id: k, value: answer }));
	    }
	  }
	
	  return new _Behaviour2['default']({
	    lattice_id: lattice_id,
	    reducer_id: this.id,
	    value: feedbacks
	  });
	};
	
	Reducer.prototype.getSkipBehaviour = function (lattice_id) {
	  lattice_id = (0, _UUID2['default'])(lattice_id);
	
	  return new _Behaviour2['default']({
	    lattice_id: lattice_id,
	    reducer_id: this.id,
	    value: null
	  });
	};
	
	exports['default'] = Reducer;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _HText_Component = __webpack_require__(174);
	
	var _HText_Component2 = _interopRequireDefault(_HText_Component);
	
	var _Movie_Component = __webpack_require__(186);
	
	var _Movie_Component2 = _interopRequireDefault(_Movie_Component);
	
	var _HTML_Component = __webpack_require__(190);
	
	var _HTML_Component2 = _interopRequireDefault(_HTML_Component);
	
	var _Textbox_Component = __webpack_require__(192);
	
	var _Textbox_Component2 = _interopRequireDefault(_Textbox_Component);
	
	var _Select_Component = __webpack_require__(201);
	
	var _Select_Component2 = _interopRequireDefault(_Select_Component);
	
	var _Date_Component = __webpack_require__(212);
	
	var _Date_Component2 = _interopRequireDefault(_Date_Component);
	
	var _Like_Component = __webpack_require__(215);
	
	var _Like_Component2 = _interopRequireDefault(_Like_Component);
	
	var _Gplus_Component = __webpack_require__(216);
	
	var _Gplus_Component2 = _interopRequireDefault(_Gplus_Component);
	
	var _Checkboxes_Component = __webpack_require__(217);
	
	var _Checkboxes_Component2 = _interopRequireDefault(_Checkboxes_Component);
	
	var _Routing_Checkboxes_Component = __webpack_require__(223);
	
	var _Routing_Checkboxes_Component2 = _interopRequireDefault(_Routing_Checkboxes_Component);
	
	var _Field_Component = __webpack_require__(225);
	
	var _Field_Component2 = _interopRequireDefault(_Field_Component);
	
	var _Matrix_Component = __webpack_require__(228);
	
	var _Matrix_Component2 = _interopRequireDefault(_Matrix_Component);
	
	var Component = _tcomb2['default'].union([_HText_Component2['default'], _Movie_Component2['default'], _Textbox_Component2['default'], _Select_Component2['default'], _Date_Component2['default'], _Like_Component2['default'], _Gplus_Component2['default'], _Checkboxes_Component2['default'], _Routing_Checkboxes_Component2['default'], _Field_Component2['default'], _Matrix_Component2['default'], _HTML_Component2['default']], 'Component');
	
	exports.Component = Component;
	Component.map = {
	  htext: _HText_Component2['default'],
	  movie: _Movie_Component2['default'],
	  textbox: _Textbox_Component2['default'],
	  select: _Select_Component2['default'],
	  date: _Date_Component2['default'],
	  like: _Like_Component2['default'],
	  checkboxes: _Checkboxes_Component2['default'],
	  routing_checkboxes: _Routing_Checkboxes_Component2['default'],
	  field: _Field_Component2['default'],
	  matrix: _Matrix_Component2['default'],
	  gplus: _Gplus_Component2['default'],
	  html: _HTML_Component2['default']
	};
	
	Component.dispatch = function (obj) {
	  return Component.map[obj.type];
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Text = __webpack_require__(175);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Image = __webpack_require__(178);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _styleHText_Component_Style = __webpack_require__(179);
	
	var _styleHText_Component_Style2 = _interopRequireDefault(_styleHText_Component_Style);
	
	var _lodashLangCloneDeep = __webpack_require__(180);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var _micromd = __webpack_require__(40);
	
	var _micromd2 = _interopRequireDefault(_micromd);
	
	var text_representation = function text_representation(text) {
	
	  var tag = 'div';
	  var content = (0, _micromd2['default'])(String(text.value)); // rendering del markdown contenuto in .value
	
	  // come stile la dimensione del testo è una gestione a parte
	  // e viene indicato con il parametro size invece che font-size
	  // per distinguerlo dalla proprietà css
	  //
	  // se size è un numerico viene interpretato come font-size in pixel
	  // e il line-height viene impostato automaticamente
	  //
	  // se invece size è una stringa viene interpretata in modo semantico
	  // e tradotta con questi tag:
	  // - small: small
	  // - normal: div
	  // - medium: h3
	  // - large: h2
	
	  var style = (0, _lodashLangCloneDeep2['default'])(text.style);
	
	  if (style.size) {
	
	    var size = style.size;
	    delete style.size;
	
	    if (_tcomb2['default'].Number.is(size)) {
	      style['font-size'] = size;
	      style['line-height'] = parseInt(size * 1.5, 10);
	    } else {
	      switch (size) {
	        case 'small':
	          tag = 'small';
	          break;
	        case 'medium':
	          tag = 'h3';
	          break;
	        case 'large':
	          tag = 'h2';
	          break;
	      }
	    }
	  }
	
	  return {
	    tag: tag,
	    attrs: {
	      style: style
	    },
	    content: content
	  };
	};
	
	var HText_Component = _tcomb2['default'].struct({
	  text: _tcomb2['default'].maybe(_Text2['default']),
	  image: _tcomb2['default'].maybe(_Image2['default']),
	  style: _styleHText_Component_Style2['default']
	}, 'HText_Component');
	
	HText_Component.prototype.to_form = function () {
	  var html;
	  var image = '';
	  var text = '';
	  if (this.image) {
	    image += !_tcomb2['default'].Nil.is(this.image.link) ? '<a href="' + this.image.link + '" target="_blank">' : '';
	    image += '<img' + _jsdk2['default'].attr({
	      src: this.image.src
	    }) + '/>';
	    image += !_tcomb2['default'].Nil.is(this.image.link) ? '</a>' : '';
	  }
	  if (this.text) {
	    var repr = text_representation(this.text);
	    text = _jsdk2['default'].dom[repr.tag](repr.content, repr.attrs);
	  }
	  if (this.image && this.text) {
	    if (this.text.position === 'right') {
	      html = '<div class="large-45 small-100">' + image + '</div><div class="large-45 large-pull-right small-100">' + text + '</div>';
	    } else {
	      html = '<div class="large-45 large-pull-right small-100">' + image + '</div><div class="large-45 large-pull-left small-100">' + text + '</div>';
	    }
	  } else {
	    html = image + text;
	  }
	  var style = this.style;
	  if (style.height) {
	    style = _tcomb2['default'].mixin({
	      overflow: 'auto'
	    }, style);
	  }
	  return '<div' + _jsdk2['default'].attr({
	    style: style
	  }) + '>' + html + '</div>';
	};
	
	exports['default'] = HText_Component;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _styleText_Style = __webpack_require__(176);
	
	var _styleText_Style2 = _interopRequireDefault(_styleText_Style);
	
	var Position = _tcomb2['default'].enums.of(['left', 'right'], 'Position'); //FIXME  PORTARE FUORI
	
	var Valign = _tcomb2['default'].enums.of(['top', 'middle', 'bottom'], 'Valign'); //FIXME  PORTARE FUORI
	
	var Text = _tcomb2['default'].struct({
	  style: _styleText_Style2['default'],
	  value: _tcomb2['default'].Str, //ex.markdown
	  position: _tcomb2['default'].maybe(Position),
	  valign: _tcomb2['default'].maybe(Valign)
	}, 'Text');
	
	exports['default'] = Text;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Style_Distance = __webpack_require__(177);
	
	var _Style_Distance2 = _interopRequireDefault(_Style_Distance);
	
	var _Color = __webpack_require__(161);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	// Stili delle componenti
	var Text_Align = _tcomb2['default'].enums.of('left right center justify'.split(' '));
	var Font_family = _tcomb2['default'].enums.of(['Georgia', 'Tahoma', 'Courier New', 'Verdana']);
	var Text_Style_Size = _tcomb2['default'].enums.of(['small', 'medium', 'large']);
	
	var Text_Style = _tcomb2['default'].struct({
	  size: _tcomb2['default'].maybe(Text_Style_Size),
	  'text-align': _tcomb2['default'].maybe(Text_Align),
	  color: _tcomb2['default'].maybe(_Color2['default']),
	  'background-color': _tcomb2['default'].maybe(_Color2['default']),
	  padding: _tcomb2['default'].maybe(_Style_Distance2['default']),
	  'font-family': _tcomb2['default'].maybe(Font_family)
	}, 'Text_Style');
	
	module.exports = Text_Style;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Int = __webpack_require__(57);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var re_is_style_percentage = /(-)?\d+%/;
	var Style_Percentage = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	  return re_is_style_percentage.test(x);
	});
	
	var Style_Distance = _tcomb2['default'].union([_Int2['default'], Style_Percentage]);
	
	module.exports = Style_Distance;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Image = _tcomb2['default'].struct({
	  src: _URL2['default'],
	  link: _tcomb2['default'].maybe(_URL2['default'])
	}, 'Image');
	
	module.exports = Image;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Style_Distance = __webpack_require__(177);
	
	var _Style_Distance2 = _interopRequireDefault(_Style_Distance);
	
	var HText_Component_Style = _tcomb2['default'].struct({
	  'margin-bottom': _tcomb2['default'].maybe(_Style_Distance2['default']),
	  height: _tcomb2['default'].maybe(_Style_Distance2['default'])
	}, 'HText_Component_Style');
	
	module.exports = HText_Component_Style;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(181),
	    bindCallback = __webpack_require__(36);
	
	/**
	 * Creates a deep clone of `value`. If `customizer` is provided it's invoked
	 * to produce the cloned values. If `customizer` returns `undefined` cloning
	 * is handled by the method instead. The `customizer` is bound to `thisArg`
	 * and invoked with up to three argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var deep = _.cloneDeep(users);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.cloneDeep(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 20
	 */
	function cloneDeep(value, customizer, thisArg) {
	  return typeof customizer == 'function'
	    ? baseClone(value, true, bindCallback(customizer, thisArg, 3))
	    : baseClone(value, true);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(11),
	    arrayEach = __webpack_require__(9),
	    baseAssign = __webpack_require__(68),
	    baseForOwn = __webpack_require__(118),
	    initCloneArray = __webpack_require__(182),
	    initCloneByTag = __webpack_require__(183),
	    initCloneObject = __webpack_require__(185),
	    isArray = __webpack_require__(18),
	    isObject = __webpack_require__(22);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[stringTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[mapTag] = cloneableTags[setTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.clone` without support for argument juggling
	 * and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The object `value` belongs to.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates clones with source counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return arrayCopy(value, result);
	    }
	  } else {
	    var tag = objToString.call(value),
	        isFunc = tag == funcTag;
	
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return baseAssign(result, value);
	      }
	    } else {
	      return cloneableTags[tag]
	        ? initCloneByTag(value, tag, isDeep)
	        : (object ? value : {});
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == value) {
	      return stackB[length];
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate it with its clone.
	  stackA.push(value);
	  stackB.push(result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 182 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add array properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var bufferClone = __webpack_require__(184);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return bufferClone(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      var buffer = object.buffer;
	      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      var result = new Ctor(object.source, reFlags.exec(object));
	      result.lastIndex = object.lastIndex;
	  }
	  return result;
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 184 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Native method references. */
	var ArrayBuffer = global.ArrayBuffer,
	    Uint8Array = global.Uint8Array;
	
	/**
	 * Creates a clone of the given array buffer.
	 *
	 * @private
	 * @param {ArrayBuffer} buffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function bufferClone(buffer) {
	  var result = new ArrayBuffer(buffer.byteLength),
	      view = new Uint8Array(result);
	
	  view.set(new Uint8Array(buffer));
	  return result;
	}
	
	module.exports = bufferClone;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  var Ctor = object.constructor;
	  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	    Ctor = Object;
	  }
	  return new Ctor;
	}
	
	module.exports = initCloneObject;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashStringEscape = __webpack_require__(41);
	
	var _lodashStringEscape2 = _interopRequireDefault(_lodashStringEscape);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _styleMovie_Component_Style = __webpack_require__(187);
	
	var _styleMovie_Component_Style2 = _interopRequireDefault(_styleMovie_Component_Style);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _template = __webpack_require__(189);
	
	// Rappresenta una componente video (solo YouTube per ora)
	var Movie_Component = _tcomb2['default'].struct({
	  style: _styleMovie_Component_Style2['default'],
	  src: _tcomb2['default'].Str,
	  width: _tcomb2['default'].maybe(_Natural2['default']),
	  height: _tcomb2['default'].maybe(_Natural2['default'])
	}, 'Movie_Component');
	
	Movie_Component.prototype.to_form = function () {
	  var tmpl = (0, _template.template)(['<div<%= attrs %>>', '<object width="<%= width %>" height="<%= height %>" data="<%= src %>">', '</object>', '</div>'].join(''));
	  return tmpl({
	    attrs: _jsdk2['default'].attr({
	      style: this.style
	    }),
	    src: (0, _lodashStringEscape2['default'])('https://www.youtube.com/embed/' + this.src + '?rel=0'),
	    width: '100%', //this.width,
	    height: '300' //this.height
	  });
	};
	
	exports['default'] = Movie_Component;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var Movie_Component_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = Movie_Component_Style;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Style_Distance = __webpack_require__(177);
	
	var _Style_Distance2 = _interopRequireDefault(_Style_Distance);
	
	var Margin_Bottom_Style = _tcomb2['default'].struct({
	  'margin-bottom': _tcomb2['default'].maybe(_Style_Distance2['default'])
	}, 'Margin_Bottom_Style');
	
	module.exports = Margin_Bottom_Style;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.template = template;
	exports.mustache = mustache;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function template(src, opt_settings) {
	  src = _tcomb2['default'].String(src);
	  opt_settings = _tcomb2['default'].maybe(_tcomb2['default'].Object)(opt_settings);
	
	  opt_settings = opt_settings || template.jsp;
	
	  var tmpl = 'var __p=[],print=function(){__p.push.apply(__p,arguments);};' + 'with(obj||{}){__p.push(\'' + src.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(opt_settings.interpolate, function (match, code) {
	    return "'," + code.replace(/\\'/g, "'") + ",'";
	  }).replace(opt_settings.evaluate || null, function (match, code) {
	    return "');" + code.replace(/\\'/g, "'").replace(/[\r\n\t]/g, ' ') + "__p.push('";
	  }).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/\t/g, '\\t') + "');}return __p.join('');";
	
	  return new Function('obj', tmpl); // eslint-disable-line no-new-func
	}
	
	template.jsp = {
	  evaluate: /<%([\s\S]+?)%>/g,
	  interpolate: /<%=([\s\S]+?)%>/g
	};
	
	template.mustache = {
	  evaluate: /{{([\s\S]+?)}}/g,
	  interpolate: /{{=([\s\S]+?)}}/g
	};
	
	var template_cache = {};
	
	template.store = function (id, t) {
	  template_cache[id] = t;
	  return t;
	};
	
	template.of = function (id) {
	  return template_cache[id];
	};
	
	// Da usare quando il sorgente del template non può contenere <, >
	
	function mustache(src) {
	  return template(src, template.mustache);
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _styleHTML_Component_Style = __webpack_require__(191);
	
	var _styleHTML_Component_Style2 = _interopRequireDefault(_styleHTML_Component_Style);
	
	var _template = __webpack_require__(189);
	
	// Rappresenta una componente html
	var HTML_Component = _tcomb2['default'].struct({
	  value: _tcomb2['default'].Str,
	  style: _styleHTML_Component_Style2['default']
	}, 'HTML_Component');
	
	HTML_Component.prototype.to_form = function () {
	  var tmpl = (0, _template.template)(['<div<%= attrs %>>', '<%= value %>', '</div>'].join(''));
	
	  return tmpl({
	    attrs: _jsdk2['default'].attr({
	      style: this.style
	    }),
	    value: this.value
	  });
	};
	
	exports['default'] = HTML_Component;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var HTML_Component_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = HTML_Component_Style;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _styleMargin_Bottom_Style = __webpack_require__(188);
	
	var _styleMargin_Bottom_Style2 = _interopRequireDefault(_styleMargin_Bottom_Style);
	
	var _Str_Schema = __webpack_require__(193);
	
	var _Str_Schema2 = _interopRequireDefault(_Str_Schema);
	
	var _Num_Schema = __webpack_require__(200);
	
	var _Num_Schema2 = _interopRequireDefault(_Num_Schema);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Textbox_Component_Style = _styleMargin_Bottom_Style2['default'];
	
	var Textbox_Component_Schema = _tcomb2['default'].union([_Str_Schema2['default'], _Num_Schema2['default']]);
	
	Textbox_Component_Schema.dispatch = function (obj) {
	  return obj.type === 'string' ? _Str_Schema2['default'] : _Num_Schema2['default'];
	};
	
	var Textbox_Component = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  name: _tcomb2['default'].Str,
	  style: Textbox_Component_Style,
	  schema: Textbox_Component_Schema,
	  is_multiline: _tcomb2['default'].maybe(_tcomb2['default'].Bool)
	}, 'Textbox_Component');
	
	Textbox_Component.prototype.to_form = function () {
	  return {
	    type: 'textbox',
	    id: this.id,
	    attrs: {
	      style: this.style
	    },
	    schema: this.schema,
	    is_multiline: this.is_multiline
	  };
	};
	
	exports['default'] = Textbox_Component;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Str_Format = __webpack_require__(194);
	
	var _Str_Format2 = _interopRequireDefault(_Str_Format);
	
	var _Validation_Monad = __webpack_require__(195);
	
	var _Validation_Monad2 = _interopRequireDefault(_Validation_Monad);
	
	var Str_Schema = _tcomb2['default'].struct({
	  required: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  max_length: _tcomb2['default'].maybe(_Natural2['default']),
	  min_length: _tcomb2['default'].maybe(_Natural2['default']),
	  format: _tcomb2['default'].maybe(_Str_Format2['default']),
	  any: _tcomb2['default'].maybe(_tcomb2['default'].list(_tcomb2['default'].Str)),
	  is_case_insensitive: _tcomb2['default'].maybe(_tcomb2['default'].Bool)
	}, 'Str_Schema');
	
	Str_Schema.prototype.validate = function (s) {
	  _tcomb2['default'].assert(_tcomb2['default'].Str.is(s));
	  var actions = [];
	  actions.push(_Validation_Monad2['default'].required(!!this.required));
	  if (!_tcomb2['default'].Nil.is(this.max_length)) {
	    actions.push(_Validation_Monad2['default'].max_length(this.max_length));
	  }
	  if (!_tcomb2['default'].Nil.is(this.min_length)) {
	    actions.push(_Validation_Monad2['default'].min_length(this.min_length));
	  }
	  if (!_tcomb2['default'].Nil.is(this.format)) {
	    actions.push(_Validation_Monad2['default'].format(this.format));
	  }
	  if (!_tcomb2['default'].Nil.is(this.any)) {
	    actions.push(_Validation_Monad2['default'].any(this.any, this.is_case_insensitive));
	  }
	  return _Validation_Monad2['default'].pipe(s, actions);
	};
	
	module.exports = Str_Schema;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	
	function is_uuid(s) {
	  return is_uuid_regexp.test(s);
	}
	
	// true se l'email è formalmente valida
	var is_email_regexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
	
	function is_email(s) {
	  return is_email_regexp.test(s);
	}
	
	// true se s contiene solo cifre
	var is_digits_regexp = /^\d*$/;
	
	function is_digits(s) {
	  return is_digits_regexp.test(s);
	}
	
	// true se è un url assoluto formalmente valido
	var is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	
	function is_url(s) {
	  return is_url_regexp.test(s);
	}
	
	// true se è un url https assoluto formalmente valido
	
	function is_https_url(s) {
	  return is_url(s) && starts_with(s, 'https');
	}
	
	// true se s comincia con start
	
	function starts_with(s, start) {
	  return s.indexOf(start) === 0;
	}
	
	// true se s è un colore css
	var is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;
	
	function is_color(s) {
	  return is_color_regexp.test(s);
	}
	
	var Str_Format = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	  return Str_Format.formats.hasOwnProperty(x);
	});
	
	Str_Format.formats = {
	  email: is_email,
	  url: is_url,
	  https_url: is_https_url,
	  digits: is_digits,
	  color: is_color,
	  uuid: is_uuid
	};
	
	exports['default'] = Str_Format;
	module.exports = exports['default'];

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Validation = __webpack_require__(196);
	
	var _Validation2 = _interopRequireDefault(_Validation);
	
	var _Rule = __webpack_require__(197);
	
	var _Rule2 = _interopRequireDefault(_Rule);
	
	var _Int = __webpack_require__(57);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Str_Format = __webpack_require__(194);
	
	var _Str_Format2 = _interopRequireDefault(_Str_Format);
	
	var _lodash = __webpack_require__(198);
	
	// Haskell return
	var unit = function unit(x) {
	  return new _Validation2['default']({ x: x,
	    rule: null
	  });
	};
	
	// Haskell >>=
	var bind = function bind(validation, f) {
	  _tcomb2['default'].assert(_Validation2['default'].is(validation));
	  _tcomb2['default'].assert(_tcomb2['default'].Func.is(f));
	
	  if (validation.x === null) {
	    return validation;
	  } else if (validation.rule) {
	    return validation;
	  }
	  return f(validation.x);
	};
	
	var required = function required(b) {
	  _tcomb2['default'].assert(_tcomb2['default'].Bool.is(b));
	  return function (x) {
	    if (_tcomb2['default'].Str.is(x)) {
	      x = x.trim();
	      if (x.length === 0) {
	        x = null;
	      }
	    }
	    if (b && x === null) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: 'required' }) });
	    }
	    return unit(x);
	  };
	};
	
	var max_length = function max_length(length) {
	  _tcomb2['default'].assert(_Natural2['default'].is(length));
	  return function (x) {
	    if (x.length > length) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "max_length", args: [length] }) });
	    }
	    return unit(x);
	  };
	};
	
	var min_length = function min_length(length) {
	  _tcomb2['default'].assert(_Natural2['default'].is(length));
	  return function (x) {
	    if (x.length < length) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "min_length", args: [length] }) });
	    }
	    return unit(x);
	  };
	};
	
	var format = function format(sf) {
	  _tcomb2['default'].assert(_Str_Format2['default'].is(sf));
	  return function (x) {
	    var p = _Str_Format2['default'].formats[sf];
	    if (!p(x)) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "format", args: [sf] }) });
	    }
	    return unit(x);
	  };
	};
	
	var any_of = function any_of(values, is_case_insensitive) {
	  _tcomb2['default'].assert(_tcomb2['default'].Arr.is(values));
	  return function (x) {
	    var lower = String(x).toLowerCase();
	    if (values.every(function (value) {
	      return is_case_insensitive ? String(value).toLowerCase() !== lower : value !== x;
	    })) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "any", args: [values] }) });
	    }
	    return unit(x);
	  };
	};
	
	var is_num = function is_num(number_format) {
	  //t.assert(Number_Format.is(number_format));
	  return function (x) {
	    x = number_format.parse_number(x);
	    if (x === null || !isFinite(x)) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "number" }) });
	    }
	    return unit(x);
	  };
	};
	
	var max = function max(i) {
	  _tcomb2['default'].assert(_tcomb2['default'].Num.is(i));
	  return function (x) {
	    if (x > i) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "max", args: [i] }) });
	    }
	    return unit(x);
	  };
	};
	
	var min = function min(i) {
	  _tcomb2['default'].assert(_tcomb2['default'].Num.is(i));
	  return function (x) {
	    if (x < i) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "min", args: [i] }) });
	    }
	    return unit(x);
	  };
	};
	
	function is_integer(n) {
	  return n === parseInt(n, 10);
	}
	
	var is_int = function is_int(x) {
	  if (!is_integer(x)) {
	    return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "integer" }) });
	  }
	  return unit(x);
	};
	
	var bool = function bool(x) {
	  if (!_tcomb2['default'].Bool.is(x)) {
	    return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "boolean" }) });
	  }
	  return unit(x);
	};
	
	var array = function array(x) {
	  if (!_tcomb2['default'].Arr.is(x)) {
	    return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "array" }) });
	  }
	  return unit(x);
	};
	
	var min_items = function min_items(min) {
	  //t.assert(Natural.is(min));
	  return function (x) {
	    if (x.length < min) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "min_items", args: [min] }) });
	    }
	    return unit(x);
	  };
	};
	
	var is_ranking = function is_ranking() {
	  return function (x) {
	    var answer = {};
	    for (var i = 0; i < x.length; i++) {
	      if (!answer[x[i][1]]) {
	        answer[x[i][1]] = 1;
	      }
	    }
	    if (x.length !== (0, _lodash.keys)(answer).length) {
	      return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "is_ranking" }) });
	    }
	    return unit(x);
	  };
	};
	
	function days_per_month(yyyy) {
	  return function (MM) {
	    return ({
	      0: 31,
	      1: yyyy % 4 === 0 ? 29 : 28, // handle leap year
	      2: 31,
	      3: 30,
	      4: 31,
	      5: 30,
	      6: 31,
	      7: 31,
	      8: 30,
	      9: 31,
	      10: 30,
	      11: 31
	    })[MM - 1];
	  };
	}
	
	// parti di una data
	var Year = _Int2['default'];
	var Month = _tcomb2['default'].subtype(_Natural2['default'], function (x) {
	  return x >= 1 && x <= 12;
	});
	var Day = _tcomb2['default'].subtype(_Natural2['default'], function (x) {
	  return x >= 1 && x <= 31;
	});
	var Hour = _tcomb2['default'].subtype(_Natural2['default'], function (x) {
	  return x >= 0 && x <= 23;
	});
	var Minute = _tcomb2['default'].subtype(_Natural2['default'], function (x) {
	  return x >= 0 && x <= 59;
	});
	var Short_Date = _tcomb2['default'].subtype(_tcomb2['default'].tuple([Year, Month, Day]), function (x) {
	  return x[2] <= days_per_month(x[0])(x[1]);
	});
	var Accurate_Date = _tcomb2['default'].subtype(_tcomb2['default'].tuple([Year, Month, Day, Hour, Minute]), function (x) {
	  return x[2] <= days_per_month(x[0])(x[1]);
	});
	
	var date = function date(required) {
	  _tcomb2['default'].assert(_tcomb2['default'].Bool.is(required));
	  return function (x) {
	    _tcomb2['default'].assert(_tcomb2['default'].list(_tcomb2['default'].Str).is(x));
	    if (x.every(function (y) {
	      return y === '';
	    }) && !required) {
	      return unit(null);
	    }
	    x = x.map(function (y) {
	      // converto le parti in interi
	      return parseInt(y, 10);
	    });
	    if (x.length === 5) {
	      // la data è accurata
	      if (!Accurate_Date.is(x)) {
	        // controllo che sia una data valida
	        return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "date" }) });
	      }
	      x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
	      return unit(new Date(x[0], x[1], x[2], x[3], x[4], 0).getTime());
	    } else {
	      if (!Short_Date.is(x)) {
	        // controllo che sia una data valida
	        return new _Validation2['default']({ x: x, rule: new _Rule2['default']({ name: "date" }) });
	      }
	      x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
	      return unit(new Date(x[0], x[1], x[2]).getTime());
	    }
	  };
	};
	
	var pipe = function pipe(x, actions) {
	  x = _tcomb2['default'].union([_tcomb2['default'].String, _tcomb2['default'].Array, _tcomb2['default'].Boolean])(x);
	
	  return actions.reduce(bind, unit(x));
	};
	
	module.exports = {
	  unit: unit,
	  bind: bind,
	  pipe: pipe,
	  required: required,
	  max_length: max_length,
	  min_length: min_length,
	  format: format,
	  any: any_of,
	  is_number: is_num,
	  is_integer: is_int,
	  max: max,
	  min: min,
	  bool: bool,
	  array: array,
	  min_items: min_items,
	  is_ranking: is_ranking,
	  date: date
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Rule = __webpack_require__(197);
	
	var _Rule2 = _interopRequireDefault(_Rule);
	
	var Validation = _tcomb2['default'].struct({
	  x: _tcomb2['default'].Any, //t.union[JSON_Value, t.Arr]), //fixme
	  rule: _tcomb2['default'].maybe(_Rule2['default'])
	}, 'Validation');
	
	module.exports = Validation;
	
	/*

	function Validation(x, rule) {
	  assert(Maybe(Union([JSON_Value, Arr])).is(x));
	  assert(Maybe(Rule).is(rule));
	  this.x = x;
	  this.rule = rule;
	  return freeze(this);
	}

	Validation.is = function(x) {
	  return x instanceof Validation;
	};

	Validation.of = function(x) {
	  assert(Obj.is(x));
	  return new Validation(
	    Maybe(Union([JSON_Value, Arr])).of(x.x),
	    Maybe(Rule).of(x.rule)
	  );
	};

	*/

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var Rule = _tcomb2['default'].struct({
	  name: _tcomb2['default'].Str,
	  args: _tcomb2['default'].maybe(_tcomb2['default'].Arr)
	}, 'Rule');
	
	(function () {
	
	  var localizers = {};
	
	  Rule.add_localizer = function (name, localizer) {
	    _tcomb2['default'].assert(!localizers.hasOwnProperty(name));
	    localizers[name] = localizer;
	    return Rule;
	  };
	
	  Rule.get_localizer = function (name) {
	    return localizers[name];
	  };
	})();
	
	function pluralize(bundle, opts) {
	  _tcomb2['default'].assert(_tcomb2['default'].union([_tcomb2['default'].Str, _tcomb2['default'].Obj]).is(bundle));
	  _tcomb2['default'].assert(_tcomb2['default'].Obj.is(opts));
	
	  var src = _tcomb2['default'].Obj.is(bundle) ? opts.count === 0 ? bundle.zero : opts.count === 1 ? bundle.one : bundle.other : bundle;
	  return (0, _lodashStringTemplate2['default'])(src)(opts);
	}
	
	Rule.add_localizer('required', function (args, locale) {
	  return Rule.bundle(locale).required;
	}).add_localizer('format', function (args, locale) {
	  return Rule.bundle(locale)[args[0]];
	}).add_localizer('max_length', function (args, locale) {
	  var max_length = args[0];
	  return pluralize(Rule.bundle(locale).max_length, {
	    arg: locale.format_integer(max_length),
	    count: max_length
	  });
	}).add_localizer('min_length', function (args, locale) {
	  var min_length = args[0];
	  return pluralize(Rule.bundle(locale).min_length, {
	    arg: locale.format_integer(min_length),
	    count: min_length
	  });
	}).add_localizer('max', function (args, locale) {
	  var max = args[0];
	  return (0, _lodashStringTemplate2['default'])(Rule.bundle(locale).max)({
	    arg: locale.format_integer(max)
	  });
	}).add_localizer('min', function (args, locale) {
	  var min = args[0];
	  return (0, _lodashStringTemplate2['default'])(Rule.bundle(locale).min)({
	    arg: locale.format_integer(min)
	  });
	}).add_localizer('number', function (args, locale) {
	  return Rule.bundle(locale).number;
	}).add_localizer('date', function (args, locale) {
	  return Rule.bundle(locale).date;
	}).add_localizer('integer', function (args, locale) {
	  return Rule.bundle(locale).integer;
	}).add_localizer('any', function (args, locale) {
	  return Rule.bundle(locale).any;
	}).add_localizer('min_items', function (args, locale) {
	  var min_items = args[0];
	  return pluralize(Rule.bundle(locale).min_items, {
	    count: min_items,
	    arg: min_items
	  });
	}).add_localizer('mobile_number_not_allowed', function (args, locale) {
	  var prefix = args[0];
	  return (0, _lodashStringTemplate2['default'])(Rule.bundle(locale).mobile_number_not_allowed)({
	    arg: prefix
	  });
	}).add_localizer('duplicated_routing_option', function (args, locale) {
	  return Rule.bundle(locale).duplicated_routing_option;
	}).add_localizer('priority_is_integer', function (args, locale) {
	  return Rule.bundle(locale).priority_is_integer;
	}).add_localizer('duplicated_option', function (args, locale) {
	  return Rule.bundle(locale).duplicated_option;
	}).add_localizer('is_ranking', function (args, locale) {
	  return Rule.bundle(locale).is_ranking;
	});
	
	Rule.prototype.localize = function (locale) {
	  //assert(Locale.is(locale)); //fixme
	  return Rule.get_localizer(this.name)(this.args, locale);
	};
	
	Rule.bundle = function (locale) {
	  return locale.language_bundle().validation;
	};
	
	exports['default'] = Rule;
	
	/*
	function Rule(name, args) {
	  args = args || [];
	  assert(Str.is(name));
	  assert(Arr.is(args));
	  this.name = name;
	  this.args = args;
	  return freeze(this);
	}

	Rule.is = function(x) {
	  return x instanceof Rule;
	};

	Rule.of = function(x) {
	  assert(Obj.is(x));
	  return new Rule(
	    Str.of(x.name),
	    Arr.of(x.args)
	  );
	};
	*/
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199)(module), (function() { return this; }())))

/***/ },
/* 199 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Validation_Monad = __webpack_require__(195);
	
	var _Validation_Monad2 = _interopRequireDefault(_Validation_Monad);
	
	var Num_Schema = _tcomb2['default'].struct({
	  required: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  max: _tcomb2['default'].maybe(_tcomb2['default'].Num),
	  min: _tcomb2['default'].maybe(_tcomb2['default'].Num),
	  integer: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  any: _tcomb2['default'].maybe(_tcomb2['default'].list(_tcomb2['default'].Num))
	}, 'Num_Schema');
	
	Num_Schema.prototype.to_computation = function (number_format) {
	  //t.assert(t.maybe(Number_Format).is(number_format));
	  var actions = [];
	  actions.push(_Validation_Monad2['default'].required(!!this.required));
	  if (number_format) {
	    actions.push(_Validation_Monad2['default'].is_number(number_format));
	  }
	  if (!_tcomb2['default'].Nil.is(this.max)) {
	    actions.push(_Validation_Monad2['default'].max(this.max));
	  }
	  if (!_tcomb2['default'].Nil.is(this.min)) {
	    actions.push(_Validation_Monad2['default'].min(this.min));
	  }
	  if (this.integer) {
	    actions.push(_Validation_Monad2['default'].is_integer);
	  }
	  if (!_tcomb2['default'].Nil.is(this.any)) {
	    actions.push(_Validation_Monad2['default'].any(this.any, false));
	  }
	  return function (x) {
	    return _Validation_Monad2['default'].pipe(x, actions);
	  };
	};
	
	Num_Schema.prototype.validate_num = function (n) {
	  _tcomb2['default'].assert(_tcomb2['default'].Num.is(n));
	  return this.to_computation()(n);
	};
	
	Num_Schema.prototype.validate = function (s, locale) {
	  _tcomb2['default'].assert(_tcomb2['default'].Str.is(s));
	  //t.assert(Locale.is(locale));
	  var number_format = locale.to_number_format();
	  return this.to_computation(number_format)(s);
	};
	
	module.exports = Num_Schema;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Component_Option = __webpack_require__(202);
	
	var _Component_Option2 = _interopRequireDefault(_Component_Option);
	
	var _Select_Render_As = __webpack_require__(203);
	
	var _Select_Render_As2 = _interopRequireDefault(_Select_Render_As);
	
	var _Select_Other = __webpack_require__(204);
	
	var _Select_Other2 = _interopRequireDefault(_Select_Other);
	
	var _Str_Schema = __webpack_require__(193);
	
	var _Str_Schema2 = _interopRequireDefault(_Str_Schema);
	
	var _styleSelect_Component_Style = __webpack_require__(205);
	
	var _styleSelect_Component_Style2 = _interopRequireDefault(_styleSelect_Component_Style);
	
	var _lodashCollectionShuffle = __webpack_require__(206);
	
	var _lodashCollectionShuffle2 = _interopRequireDefault(_lodashCollectionShuffle);
	
	var Ord = _tcomb2['default'].enums.of(['asc', 'desc', 'random']);
	
	var Select_Component = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  name: _tcomb2['default'].String,
	  style: _styleSelect_Component_Style2['default'],
	  options: _tcomb2['default'].list(_Component_Option2['default']),
	  schema: _Str_Schema2['default'],
	  render_as: _Select_Render_As2['default'],
	  order: _tcomb2['default'].maybe(Ord),
	  other: _tcomb2['default'].maybe(_Select_Other2['default']),
	  other_label: _tcomb2['default'].maybe(_tcomb2['default'].String)
	}, 'Select_Component');
	
	Select_Component.prototype.to_form = function () {
	  // converto le options dal formato del bo a quello che
	  // capisce il web e poi le ordino come ha scelto l'operatore
	
	  var options = this.options.map(function (option) {
	    return [option.k, option.v];
	  });
	
	  if (this.order) {
	    if (this.order === 'random') {
	      options = (0, _lodashCollectionShuffle2['default'])(options);
	    } else {
	      options = options.sort(_jsdk2['default'].by(1, this.order === 'desc'));
	    }
	  }
	
	  return {
	    type: 'reducer/select',
	    id: this.id,
	    options: _jsdk2['default'].copy(options),
	    style: this.style,
	    schema: this.schema,
	    render_as: this.render_as,
	    other: this.other,
	    other_label: this.other_label
	  };
	};
	
	module.exports = Select_Component;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Component_Option = _tcomb2['default'].struct({
	  k: _UUID2['default'],
	  v: _tcomb2['default'].Str,
	  is_exclusive: _tcomb2['default'].maybe(_tcomb2['default'].Bool)
	}, 'Component_Option');
	
	module.exports = Component_Option;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Select_Render_As = _tcomb2['default'].enums.of(['radio', 'select', 'textbox']);
	
	module.exports = Select_Render_As;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Str_Schema = __webpack_require__(193);
	
	var _Str_Schema2 = _interopRequireDefault(_Str_Schema);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Select_Other = _tcomb2['default'].struct({
	  textbox_id: _UUID2['default'],
	  schema: _Str_Schema2['default']
	}, 'Select_Other');
	
	exports['default'] = Select_Other;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var Select_Component_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = Select_Component_Style;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var sample = __webpack_require__(207);
	
	/** Used as references for `-Infinity` and `Infinity`. */
	var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  return sample(collection, POSITIVE_INFINITY);
	}
	
	module.exports = shuffle;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(208),
	    isIterateeCall = __webpack_require__(38),
	    toArray = __webpack_require__(209),
	    toIterable = __webpack_require__(211);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Gets a random element or `n` random elements from a collection.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to sample.
	 * @param {number} [n] The number of elements to sample.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {*} Returns the random sample(s).
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 *
	 * _.sample([1, 2, 3, 4], 2);
	 * // => [3, 1]
	 */
	function sample(collection, n, guard) {
	  if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	    collection = toIterable(collection);
	    var length = collection.length;
	    return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	  }
	  var index = -1,
	      result = toArray(collection),
	      length = result.length,
	      lastIndex = length - 1;
	
	  n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	  while (++index < n) {
	    var rand = baseRandom(index, lastIndex),
	        value = result[rand];
	
	    result[rand] = result[index];
	    result[index] = value;
	  }
	  result.length = n;
	  return result;
	}
	
	module.exports = sample;


/***/ },
/* 208 */
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for argument juggling
	 * and returning floating-point numbers.
	 *
	 * @private
	 * @param {number} min The minimum possible value.
	 * @param {number} max The maximum possible value.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(min, max) {
	  return min + nativeFloor(nativeRandom() * (max - min + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(11),
	    getLength = __webpack_require__(14),
	    isLength = __webpack_require__(16),
	    values = __webpack_require__(210);
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * (function() {
	 *   return _.toArray(arguments).slice(1);
	 * }(1, 2, 3));
	 * // => [2, 3]
	 */
	function toArray(value) {
	  var length = value ? getLength(value) : 0;
	  if (!isLength(length)) {
	    return values(value);
	  }
	  if (!length) {
	    return [];
	  }
	  return arrayCopy(value);
	}
	
	module.exports = toArray;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(69),
	    keys = __webpack_require__(33);
	
	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(13),
	    isObject = __webpack_require__(22),
	    values = __webpack_require__(210);
	
	/**
	 * Converts `value` to an array-like object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array|Object} Returns the array-like object.
	 */
	function toIterable(value) {
	  if (value == null) {
	    return [];
	  }
	  if (!isArrayLike(value)) {
	    return values(value);
	  }
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toIterable;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _styleDate_Component_Style = __webpack_require__(213);
	
	var _styleDate_Component_Style2 = _interopRequireDefault(_styleDate_Component_Style);
	
	var _Date_Schema = __webpack_require__(214);
	
	var _Date_Schema2 = _interopRequireDefault(_Date_Schema);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Date_Component = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  name: _tcomb2['default'].Str,
	  style: _styleDate_Component_Style2['default'],
	  schema: _Date_Schema2['default']
	}, 'Date_Component');
	
	Date_Component.prototype.to_form = function () {
	  return {
	    type: 'date',
	    id: this.id,
	    attrs: {
	      style: this.style
	    },
	    schema: this.schema
	  };
	};
	
	exports['default'] = Date_Component;
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var Date_Component_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = Date_Component_Style;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Validation_Monad = __webpack_require__(195);
	
	var _Validation_Monad2 = _interopRequireDefault(_Validation_Monad);
	
	var Date_Schema = _tcomb2['default'].struct({
	  required: _tcomb2['default'].maybe(_tcomb2['default'].Bool)
	}, 'Date_Schema');
	
	/*
	function Date_Schema(required) {
	  assert(Maybe(Bool).is(required));
	  this.type = 'date';
	  this.required = required;
	  return freeze(this);
	}
	
	Date_Schema.is = function(x) {
	  return x instanceof Date_Schema;
	};
	
	Date_Schema.of = function(x) {
	  assert(Obj.is(x));
	  return new Date_Schema(
	    Maybe(Bool).of(x.required)
	  );
	};
	*/
	
	Date_Schema.prototype.validate = function (a) {
	  var actions = [];
	  actions.push(_Validation_Monad2['default'].date(!!this.required));
	  return _Validation_Monad2['default'].pipe(a, actions);
	};
	
	exports['default'] = Date_Schema;
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Like_Component = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  url: _URL2['default']
	}, 'Like_Component');
	
	Like_Component.prototype.to_form = function (opts) {
	  _tcomb2['default'].assert(_tcomb2['default'].Str.is(opts.like_url));
	  return {
	    type: 'reducer/like',
	    id: this.id,
	    url: this.url,
	    like_url: opts.like_url
	  };
	};
	
	exports['default'] = Like_Component;
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Gplus_Component = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  url: _URL2['default']
	}, 'Gplus_Component');
	
	Gplus_Component.prototype.to_form = function (opts) {
	  _tcomb2['default'].assert(_tcomb2['default'].Str.is(opts.gplus_url));
	  return {
	    type: 'reducer/gplus',
	    id: this.id,
	    url: this.url,
	    gplus_url: opts.gplus_url
	  };
	};
	
	exports['default'] = Gplus_Component;
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Arr_Schema = __webpack_require__(218);
	
	var _Arr_Schema2 = _interopRequireDefault(_Arr_Schema);
	
	var _Component_Option = __webpack_require__(202);
	
	var _Component_Option2 = _interopRequireDefault(_Component_Option);
	
	var _styleCheckboxes_Style = __webpack_require__(219);
	
	var _styleCheckboxes_Style2 = _interopRequireDefault(_styleCheckboxes_Style);
	
	var _Checkboxes_Other = __webpack_require__(220);
	
	var _Checkboxes_Other2 = _interopRequireDefault(_Checkboxes_Other);
	
	var _getUUID = __webpack_require__(221);
	
	var _getUUID2 = _interopRequireDefault(_getUUID);
	
	var _lodashObjectAssign = __webpack_require__(222);
	
	var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);
	
	var _lodashCollectionShuffle = __webpack_require__(206);
	
	var _lodashCollectionShuffle2 = _interopRequireDefault(_lodashCollectionShuffle);
	
	var Ord = _tcomb2['default'].enums.of(['asc', 'desc', 'random']);
	
	var Checkboxes_Component = _tcomb2['default'].struct({
	  name: _tcomb2['default'].Str,
	  style: _styleCheckboxes_Style2['default'],
	  options: _tcomb2['default'].list(_Component_Option2['default']),
	  schema: _Arr_Schema2['default'],
	  other: _tcomb2['default'].maybe(_Checkboxes_Other2['default']),
	  order: _tcomb2['default'].maybe(Ord),
	  other_label: _tcomb2['default'].maybe(_tcomb2['default'].String)
	}, 'Checkboxes_Component');
	
	Checkboxes_Component.prototype.to_form = function () {
	  var _this = this;
	
	  function getOption(option) {
	    return [option.k, option.v, option.is_exclusive];
	  }
	
	  var getOptionsOrdered = function getOptionsOrdered() {
	    var options = _this.options.map(getOption);
	
	    if (_this.order !== null) {
	      if (_this.order === 'random') {
	        return (0, _lodashCollectionShuffle2['default'])(options);
	      } else {
	        return options.sort(_jsdk2['default'].by(1, _this.order === 'desc'));
	      }
	    } else {
	      return options;
	    }
	  };
	
	  return (0, _lodashObjectAssign2['default'])({}, this, {
	    id: (0, _getUUID2['default'])(), // id temporaneo utile alla Form
	    type: 'reducer/checkboxes',
	    options: getOptionsOrdered(),
	    other_label: this.other_label
	  });
	};
	
	exports['default'] = Checkboxes_Component;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Natural = __webpack_require__(56);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Validation_Monad = __webpack_require__(195);
	
	var _Validation_Monad2 = _interopRequireDefault(_Validation_Monad);
	
	var Arr_Schema = _tcomb2['default'].struct({
	  min_items: _tcomb2['default'].maybe(_Natural2['default']),
	  is_ranking: _tcomb2['default'].maybe(_tcomb2['default'].Bool)
	}, 'Arr_Schema');
	
	Arr_Schema.prototype.validate = function (xs) {
	  _tcomb2['default'].assert(_tcomb2['default'].Arr.is(xs));
	  var actions = [];
	  actions.push(_Validation_Monad2['default'].array);
	  if (!_tcomb2['default'].Nil.is(this.min_items)) {
	    actions.push(_Validation_Monad2['default'].min_items(this.min_items));
	  }
	  if (!_tcomb2['default'].Nil.is(this.is_ranking) && this.is_ranking) {
	    actions.push(_Validation_Monad2['default'].is_ranking());
	  }
	  return _Validation_Monad2['default'].pipe(xs, actions);
	};
	
	module.exports = Arr_Schema;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var Checkboxes_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = Checkboxes_Style;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Str_Schema = __webpack_require__(193);
	
	var _Str_Schema2 = _interopRequireDefault(_Str_Schema);
	
	var Checkboxes_Other = _tcomb2['default'].struct({
	  option_id: _UUID2['default'],
	  textbox_id: _UUID2['default'],
	  schema: _Str_Schema2['default']
	}, 'Checkboxes_Other');
	
	exports['default'] = Checkboxes_Other;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getUUID;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function getUUID() {
	  var ret = function () {
	    var chars = '0123456789abcdef'.split(''),
	        id = [],
	        rnd = Math.random;
	    var r = undefined;
	
	    id[8] = id[13] = id[18] = id[23] = '-';
	    id[14] = '4';
	    for (var i = 0; i < 36; i++) {
	      if (!id[i]) {
	        r = 0 | rnd() * 16;
	        id[i] = chars[i === 19 ? r & 0x3 | 0x8 : r & 0xf];
	      }
	    }
	    return id.join('');
	  }.call(this);
	
	  return _tcomb2['default'].String(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(65),
	    baseAssign = __webpack_require__(68),
	    createAssigner = __webpack_require__(35);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it's invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Arr_Schema = __webpack_require__(218);
	
	var _Arr_Schema2 = _interopRequireDefault(_Arr_Schema);
	
	var _Component_Routing_Option = __webpack_require__(224);
	
	var _Component_Routing_Option2 = _interopRequireDefault(_Component_Routing_Option);
	
	var _styleCheckboxes_Style = __webpack_require__(219);
	
	var _styleCheckboxes_Style2 = _interopRequireDefault(_styleCheckboxes_Style);
	
	var _Checkboxes_Other = __webpack_require__(220);
	
	var _Checkboxes_Other2 = _interopRequireDefault(_Checkboxes_Other);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _lodashObjectAssign = __webpack_require__(222);
	
	var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);
	
	var _lodashCollectionShuffle = __webpack_require__(206);
	
	var _lodashCollectionShuffle2 = _interopRequireDefault(_lodashCollectionShuffle);
	
	var Ord = _tcomb2['default'].enums.of(['asc', 'desc', 'random']);
	
	var Routing_Checkboxes_Component = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  name: _tcomb2['default'].Str,
	  style: _styleCheckboxes_Style2['default'],
	  options: _tcomb2['default'].list(_Component_Routing_Option2['default']),
	  schema: _Arr_Schema2['default'],
	  other: _tcomb2['default'].maybe(_Checkboxes_Other2['default']),
	  order: _tcomb2['default'].maybe(Ord),
	  other_label: _tcomb2['default'].maybe(_tcomb2['default'].String)
	}, 'Routing_Checkboxes_Component');
	
	Routing_Checkboxes_Component.prototype.to_form = function () {
	  var _this = this;
	
	  function getOption(option) {
	    return [option.k, option.v, option.is_exclusive, option.priority];
	  }
	
	  var getOptionsOrdered = function getOptionsOrdered() {
	    var options = _this.options.map(getOption);
	
	    if (_this.order !== null) {
	      if (_this.order === 'random') {
	        return (0, _lodashCollectionShuffle2['default'])(options);
	      } else {
	        return options.sort(_jsdk2['default'].by(1, _this.order === 'desc'));
	      }
	    } else {
	      return options;
	    }
	  };
	
	  return (0, _lodashObjectAssign2['default'])({}, this, {
	    id: this.id,
	    type: 'reducer/routing_checkboxes',
	    options: getOptionsOrdered(),
	    other_label: this.other_label
	  });
	};
	
	exports['default'] = Routing_Checkboxes_Component;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Component_Routing_Option = _tcomb2['default'].struct({
	  k: _UUID2['default'],
	  v: _tcomb2['default'].Str,
	  is_exclusive: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  priority: _tcomb2['default'].Number
	}, 'Component_Routing_Option');
	
	module.exports = Component_Routing_Option;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _getUUID = __webpack_require__(221);
	
	var _getUUID2 = _interopRequireDefault(_getUUID);
	
	var _lodashObjectAssign = __webpack_require__(222);
	
	var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);
	
	var _styleField_Style = __webpack_require__(226);
	
	var _styleField_Style2 = _interopRequireDefault(_styleField_Style);
	
	var _Field_Target = __webpack_require__(227);
	
	var _Field_Target2 = _interopRequireDefault(_Field_Target);
	
	var Field_Component = _tcomb2['default'].struct({
	  style: _tcomb2['default'].maybe(_styleField_Style2['default']),
	  targets: _tcomb2['default'].list(_Field_Target2['default']),
	  owner: _tcomb2['default'].Str
	}, 'Field_Component');
	
	Field_Component.prototype.to_form = function () {
	  return (0, _lodashObjectAssign2['default'])({}, this, {
	    id: (0, _getUUID2['default'])(), // id temporaneo utile alla Form
	    type: 'reducer/field'
	  });
	};
	
	exports['default'] = Field_Component;
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var Field_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = Field_Style;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Field = __webpack_require__(115);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Field_Target = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  //field: t.list(Field)
	  field: _Field2['default']
	}, 'Field_Target');
	
	module.exports = Field_Target;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Component_Option = __webpack_require__(202);
	
	var _Component_Option2 = _interopRequireDefault(_Component_Option);
	
	var _styleMargin_Bottom_Style = __webpack_require__(188);
	
	var _styleMargin_Bottom_Style2 = _interopRequireDefault(_styleMargin_Bottom_Style);
	
	var _Arr_Schema = __webpack_require__(218);
	
	var _Arr_Schema2 = _interopRequireDefault(_Arr_Schema);
	
	var _getUUID = __webpack_require__(221);
	
	var _getUUID2 = _interopRequireDefault(_getUUID);
	
	var _lodashCollectionShuffle = __webpack_require__(206);
	
	var _lodashCollectionShuffle2 = _interopRequireDefault(_lodashCollectionShuffle);
	
	var Ord = _tcomb2['default'].enums.of(['asc', 'desc', 'random']);
	
	var Matrix_Component = _tcomb2['default'].struct({
	  name: _tcomb2['default'].Str,
	  style: _styleMargin_Bottom_Style2['default'],
	  questions: _tcomb2['default'].list(_Component_Option2['default']),
	  options: _tcomb2['default'].list(_Component_Option2['default']),
	  schema: _Arr_Schema2['default'],
	  order: _tcomb2['default'].maybe(Ord)
	}, 'Matrix_Component');
	
	Matrix_Component.prototype.to_form = function () {
	  var _this = this;
	
	  function getQuestion(question) {
	    return [question.k, question.v];
	  }
	
	  var getQuestionsOrdered = function getQuestionsOrdered() {
	    var questions = _this.questions.map(getQuestion);
	
	    if (_this.order !== null) {
	      if (_this.order === 'random') {
	        return (0, _lodashCollectionShuffle2['default'])(questions);
	      } else {
	        return questions.sort(_jsdk2['default'].by(1, _this.order === 'desc'));
	      }
	    } else {
	      return questions;
	    }
	  };
	
	  return {
	    type: 'reducer/matrix',
	    id: (0, _getUUID2['default'])(), // id temporaneo utile alla Form
	    style: this.style,
	    questions: getQuestionsOrdered(),
	    options: this.options.map(function (option) {
	      return [option.k, option.v];
	    }),
	    schema: this.schema
	  };
	};
	
	exports['default'] = Matrix_Component;
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _JSON_Value = __webpack_require__(230);
	
	var _JSON_Value2 = _interopRequireDefault(_JSON_Value);
	
	var Feedback = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  value: _tcomb2['default'].maybe(_JSON_Value2['default'])
	}, 'Feedback');
	
	module.exports = Feedback;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	// FIXME
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var JSON_Value = _tcomb2['default'].union([_tcomb2['default'].Str, _tcomb2['default'].Num, _tcomb2['default'].Bool]);
	
	JSON_Value.format = function (locale, schema, value) {
	  //t.assert(Locale.is(locale));
	  //assert(Schema.is(schema)); fixme
	  //assert(Maybe(JSON_Value).is(value)); fixme
	
	  if (_tcomb2['default'].Nil.is(value)) {
	    return '';
	  }
	  if (schema.type === 'number') {
	    return schema.integer ? locale.format_integer(value) : locale.format_number(value, schema.digits);
	  }
	  return String(value);
	};
	
	exports['default'] = JSON_Value;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Feedback = __webpack_require__(229);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var Behaviour = _tcomb2['default'].struct({
	  lattice_id: _UUID2['default'],
	  reducer_id: _UUID2['default'],
	  value: _tcomb2['default'].maybe(_tcomb2['default'].list(_Feedback2['default']))
	}, 'Behaviour');
	
	module.exports = Behaviour;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _tcombReact = __webpack_require__(168);
	
	var Confirm = (function (_React$Component) {
	  _inherits(Confirm, _React$Component);
	
	  function Confirm() {
	    var _this = this;
	
	    _classCallCheck(this, _Confirm);
	
	    _get(Object.getPrototypeOf(_Confirm.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doYes = function (evt) {
	      evt.preventDefault();
	      _this.props.callback(true);
	    };
	
	    this.doNo = function (evt) {
	      evt.preventDefault();
	      _this.props.callback(false);
	    };
	  }
	
	  _createClass(Confirm, [{
	    key: 'scrollTop',
	    value: function scrollTop() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollTop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var style = {
	        maxWidth: this.props.width
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { className: 'overlay' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'web-modal' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-body', style: style },
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-header' },
	              _react2['default'].createElement(
	                'h1',
	                null,
	                this.props.title
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-section' },
	              this.props.children
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2['default'].createElement(
	                'button',
	                { onClick: this.doYes },
	                this.props.locale.language_bundle().bool.TRUE
	              ),
	              _react2['default'].createElement(
	                'button',
	                { className: 'primary', onClick: this.doNo },
	                this.props.locale.language_bundle().bool.FALSE
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Confirm = Confirm;
	  Confirm = (0, _tcombReact.props)({
	    title: _tcombReact.t.Str,
	    locale: _domainLocale2['default'],
	    callback: _tcombReact.t.Func,
	    width: _tcombReact.t.Str,
	    children: _tcombReact.t.ReactElement
	  })(Confirm) || Confirm;
	  return Confirm;
	})(_react2['default'].Component);
	
	exports['default'] = Confirm;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(168);
	
	var Alert = (function (_React$Component) {
	  _inherits(Alert, _React$Component);
	
	  function Alert() {
	    _classCallCheck(this, _Alert);
	
	    _get(Object.getPrototypeOf(_Alert.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Alert, [{
	    key: 'getContainerClasses',
	    value: function getContainerClasses() {
	      var type = this.props.type;
	      return (0, _classnames2['default'])({
	        'alert': true,
	        'success': type === 'success',
	        'error': type === 'error',
	        'warning': type === 'warning',
	        'danger': type === 'danger',
	        'info': type === 'info'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: this.getContainerClasses() },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Alert = Alert;
	  Alert = (0, _tcombReact.props)({
	    children: _tcombReact.t.Any,
	    type: _tcombReact.t.maybe(_tcombReact.t.Str)
	  })(Alert) || Alert;
	  return Alert;
	})(_react2['default'].Component);
	
	exports['default'] = Alert;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Adv_Box = _tcomb2['default'].struct({
	  title: _tcomb2['default'].Str,
	  image: _URL2['default'],
	  link: _URL2['default']
	}, 'Adv_Box');
	
	module.exports = Adv_Box;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Align = __webpack_require__(236);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	var _Partner_Logo = __webpack_require__(237);
	
	var _Partner_Logo2 = _interopRequireDefault(_Partner_Logo);
	
	var Partners = _tcomb2['default'].struct({
	  logos: _tcomb2['default'].list(_Partner_Logo2['default']),
	  align: _tcomb2['default'].maybe(_Align2['default'])
	}, 'Partners');
	
	module.exports = Partners;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Align = _tcomb2['default'].enums.of(['left', 'center', 'right']);
	
	module.exports = Align;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Partner_Logo = _tcomb2['default'].struct({
	  image: _URL2['default'],
	  link: _URL2['default']
	}, 'Partner_Logo');
	
	module.exports = Partner_Logo;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Widget = _tcomb2['default'].struct({
	  header_image: _tcomb2['default'].maybe(_URL2['default']),
	  footer_image: _tcomb2['default'].maybe(_URL2['default'])
	}, 'Widget');
	
	module.exports = Widget;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var TripGoal = _tcomb2['default'].enums.of(['BuildOrderRoute', 'ReducerRoute'], 'TripGoal');
	
	module.exports = TripGoal;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Behaviour_Needed = __webpack_require__(241);
	
	var _Behaviour_Needed2 = _interopRequireDefault(_Behaviour_Needed);
	
	var _Behaviour_Ok = __webpack_require__(242);
	
	var _Behaviour_Ok2 = _interopRequireDefault(_Behaviour_Ok);
	
	var _Behaviour_Ko = __webpack_require__(243);
	
	var _Behaviour_Ko2 = _interopRequireDefault(_Behaviour_Ko);
	
	var _Captcha = __webpack_require__(244);
	
	var _Captcha2 = _interopRequireDefault(_Captcha);
	
	var Behaviour_Response = _tcomb2['default'].union([_Behaviour_Needed2['default'], _Behaviour_Ok2['default'], _Behaviour_Ko2['default'], _Captcha2['default']]);
	
	Behaviour_Response.dispatch = function (x) {
	  switch (x.type) {
	    case 'needed':
	      return _Behaviour_Needed2['default'];
	    case 'ok':
	      return _Behaviour_Ok2['default'];
	    case 'ko':
	      return _Behaviour_Ko2['default'];
	    case 'captcha':
	      return _Captcha2['default'];
	  }
	  return x.constructor;
	};
	
	module.exports = Behaviour_Response;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Behaviour_Needed = _tcomb2['default'].struct({
	  lattice_id: _UUID2['default'],
	  reducer_id: _UUID2['default']
	}, 'Behaviour_Needed');
	
	module.exports = Behaviour_Needed;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Runtime = __webpack_require__(157);
	
	var _Runtime2 = _interopRequireDefault(_Runtime);
	
	var Behaviour_Ok = _tcomb2['default'].struct({
	  is_good_fellow: _tcomb2['default'].Bool,
	  runtime: _Runtime2['default'],
	  lead_url: _tcomb2['default'].maybe(_tcomb2['default'].Str)
	}, 'Behaviour_Ok');
	
	module.exports = Behaviour_Ok;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Behaviour_Ko = _tcomb2['default'].struct({
	  type: _tcomb2['default'].Str
	}, 'Behaviour_Ko');
	
	module.exports = Behaviour_Ko;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var Captcha = _tcomb2['default'].struct({
	  type: _tcomb2['default'].Str,
	  lattice_id: _UUID2['default'],
	  reducer_id: _UUID2['default']
	}, 'Captcha');
	
	module.exports = Captcha;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = load_districts;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var _loadScript = __webpack_require__(246);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var districts = {};
	
	function load_districts(lib_url, country, callback) {
	  lib_url = _tcomb2['default'].String(lib_url);
	  callback = _tcomb2['default'].Function(callback);
	
	  _tcomb2['default'].assert(_tcomb2['default'].maybe(_Register_Country2['default']).is(country));
	
	  if (!country) {
	    return callback(null);
	  }
	
	  if (districts[country]) {
	    return callback(districts[country]);
	  }
	
	  var scriptURL = lib_url + 'district/' + country + '.js';
	  (0, _loadScript2['default'])(scriptURL, function () {
	    districts[country] = window.require('district/' + country);
	    callback(districts[country]);
	  });
	}

	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getMadaiURL;
	
	function getMadaiURL() {
	  return 'https://madai.com';
	  //return 'http://shop.madai.com/consumer/';
	}

	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = target;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(51);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _toUrl = __webpack_require__(45);
	
	var _toUrl2 = _interopRequireDefault(_toUrl);
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	function target(app, purchase_id) {
	  var url = location.href;
	  var purl = _cookiesJs2['default'].get('purl');
	
	  /*if (isModal() && purl) {
	    if (Cookies.get('purl_only') === "1") {
	      url = purl;
	    } else {
	      var params = {
	        // se c'è il product_id devo aprire l'applicativo product
	        product_id: app.product ? app.product.id : null,
	        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	        user: !app.product ? true : null
	      };
	      url = toUrl(purl, params);
	    }
	  }*/
	
	  var params = {
	    // se c'è il product_id devo aprire l'applicativo product
	    product_id: app.product ? app.product.id : null,
	    // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	    user: !app.product ? true : null
	  };
	
	  if (purl) {
	    url = (0, _toUrl2['default'])(purl, params);
	  }
	
	  // fix paypal redirect
	  /*if (url.indexOf('#') !== -1) {
	    url = url.substring(0, url.indexOf('#'));
	  }*/
	  var url_replaced = url;
	  //redirect sulla thankyou page, la pagina di ritorno non è mai in modale, e se parto dallo user vado sulla prodotto
	  var lattice_id = app.lattice ? app.lattice.id : null;
	  var lattice_params = lattice_id ? "lattice=" + lattice_id : null;
	  if ((0, _isModal2['default'])()) {
	    var value =  true ? 'promo' : 'test';
	
	    url_replaced = "https://" + value + ".madai.com/wa/ui/thankyou/" + purchase_id + '?' + lattice_params;
	  } else if (url.indexOf("/campaign") !== -1) {
	    if (url.indexOf("?") == -1) {
	      if (lattice_id != null) {
	        url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id + '?' + lattice_params);
	      } else {
	        url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id);
	      }
	    } else {
	      if (lattice_id != null) {
	        url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	      } else {
	        url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id);
	      }
	    }
	  } else if (url.indexOf("/product") !== -1) {
	    if (url.indexOf("?") == -1) {
	      if (lattice_id != null) {
	        url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	      } else {
	        url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id);
	      }
	    } else {
	      if (lattice_id != null) {
	        url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	      } else {
	        url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id);
	      }
	    }
	  } else if (url.indexOf("/user") !== -1) {
	    if (url.indexOf("?") == -1) {
	      if (lattice_id != null) {
	        url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id + '?' + lattice_params);
	      } else {
	        url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id);
	      }
	    } else {
	      if (lattice_id != null) {
	        url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	      } else {
	        url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id);
	      }
	    }
	  }
	  return url_replaced;
	}

	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Cookies.js - 1.2.2
	 * https://github.com/ScottHamper/Cookies
	 *
	 * This is free and unencumbered software released into the public domain.
	 */
	(function (global, undefined) {
	    'use strict';
	
	    var factory = function (window) {
	        if (typeof window.document !== 'object') {
	            throw new Error('Cookies.js requires a `window` with a `document` object');
	        }
	
	        var Cookies = function (key, value, options) {
	            return arguments.length === 1 ?
	                Cookies.get(key) : Cookies.set(key, value, options);
	        };
	
	        // Allows for setter injection in unit tests
	        Cookies._document = window.document;
	
	        // Used to ensure cookie keys do not collide with
	        // built-in `Object` properties
	        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
	        
	        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');
	
	        Cookies.defaults = {
	            path: '/',
	            secure: false
	        };
	
	        Cookies.get = function (key) {
	            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
	                Cookies._renewCache();
	            }
	            
	            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];
	
	            return value === undefined ? undefined : decodeURIComponent(value);
	        };
	
	        Cookies.set = function (key, value, options) {
	            options = Cookies._getExtendedOptions(options);
	            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);
	
	            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);
	
	            return Cookies;
	        };
	
	        Cookies.expire = function (key, options) {
	            return Cookies.set(key, undefined, options);
	        };
	
	        Cookies._getExtendedOptions = function (options) {
	            return {
	                path: options && options.path || Cookies.defaults.path,
	                domain: options && options.domain || Cookies.defaults.domain,
	                expires: options && options.expires || Cookies.defaults.expires,
	                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
	            };
	        };
	
	        Cookies._isValidDate = function (date) {
	            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
	        };
	
	        Cookies._getExpiresDate = function (expires, now) {
	            now = now || new Date();
	
	            if (typeof expires === 'number') {
	                expires = expires === Infinity ?
	                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
	            } else if (typeof expires === 'string') {
	                expires = new Date(expires);
	            }
	
	            if (expires && !Cookies._isValidDate(expires)) {
	                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
	            }
	
	            return expires;
	        };
	
	        Cookies._generateCookieString = function (key, value, options) {
	            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
	            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
	            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
	            options = options || {};
	
	            var cookieString = key + '=' + value;
	            cookieString += options.path ? ';path=' + options.path : '';
	            cookieString += options.domain ? ';domain=' + options.domain : '';
	            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
	            cookieString += options.secure ? ';secure' : '';
	
	            return cookieString;
	        };
	
	        Cookies._getCacheFromString = function (documentCookie) {
	            var cookieCache = {};
	            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];
	
	            for (var i = 0; i < cookiesArray.length; i++) {
	                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);
	
	                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
	                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
	                }
	            }
	
	            return cookieCache;
	        };
	
	        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
	            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
	            var separatorIndex = cookieString.indexOf('=');
	
	            // IE omits the "=" when the cookie value is an empty string
	            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
	
	            var key = cookieString.substr(0, separatorIndex);
	            var decodedKey;
	            try {
	                decodedKey = decodeURIComponent(key);
	            } catch (e) {
	                if (console && typeof console.error === 'function') {
	                    console.error('Could not decode cookie with key "' + key + '"', e);
	                }
	            }
	            
	            return {
	                key: decodedKey,
	                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
	            };
	        };
	
	        Cookies._renewCache = function () {
	            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
	            Cookies._cachedDocumentCookie = Cookies._document.cookie;
	        };
	
	        Cookies._areEnabled = function () {
	            var testKey = 'cookies.js';
	            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
	            Cookies.expire(testKey);
	            return areEnabled;
	        };
	
	        Cookies.enabled = Cookies._areEnabled();
	
	        return Cookies;
	    };
	
	    var cookiesExport = typeof global.document === 'object' ? factory(global) : factory;
	
	    // AMD support
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return cookiesExport; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    // CommonJS/Node.js support
	    } else if (typeof exports === 'object') {
	        // Support Node.js specific `module.exports` (which can be a function)
	        if (typeof module === 'object' && typeof module.exports === 'object') {
	            exports = module.exports = cookiesExport;
	        }
	        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
	        exports.Cookies = cookiesExport;
	    } else {
	        global.Cookies = cookiesExport;
	    }
	})(typeof window === 'undefined' ? this : window);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = social_target;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(51);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _toUrl = __webpack_require__(45);
	
	var _toUrl2 = _interopRequireDefault(_toUrl);
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	function social_target(app) {
	  var url = location.href;
	  var purl = _cookiesJs2['default'].get('purl');
	
	  if ((0, _isModal2['default'])() && purl) {
	    if (_cookiesJs2['default'].get('purl_only') === "1") {
	      url = purl;
	    } else {
	      var params = {
	        // se c'è il product_id devo aprire l'applicativo product
	        product_id: app.product ? app.product.id : null,
	        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	        user: !app.product ? true : null
	      };
	      url = (0, _toUrl2['default'])(purl, params);
	    }
	  }
	
	  // fix paypal redirect
	  if (url.indexOf('#') !== -1) {
	    url = url.substring(0, url.indexOf('#'));
	  }
	
	  return url;
	}

	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = setPurlCookies;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(51);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _parseQuerystring = __webpack_require__(252);
	
	var _parseQuerystring2 = _interopRequireDefault(_parseQuerystring);
	
	function setPurlCookies() {
	  var params = (0, _parseQuerystring2['default'])(location.search);
	  var purl = params.purl;
	  var purl_only = params.purl_only;
	
	  if ((0, _isModal2['default'])() && purl) {
	    _cookiesJs2['default'].set('purl', purl, {
	      path: '/'
	    });
	    _cookiesJs2['default'].set('purl_only', purl_only === "1" ? "1" : "0", {
	      path: '/'
	    });
	  }
	}

	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = parseQuerystring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _querystring = __webpack_require__(46);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var adaptQueryString = function adaptQueryString() {
	  return location.search ? location.search.substring(1, location.search.length) : null;
	};
	
	function parseQuerystring() {
	  return _querystring2['default'].parse(adaptQueryString());
	}

	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = setSessionIdCookies;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _getUUID = __webpack_require__(221);
	
	var _getUUID2 = _interopRequireDefault(_getUUID);
	
	function setSessionIdCookies() {
	  if (!_cookiesJs2['default'].get('session-id')) {
	    _cookiesJs2['default'].set('session-id', (0, _getUUID2['default'])(), {
	      path: '/'
	    });
	  }
	}

	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _lodashCollectionEvery = __webpack_require__(255);
	
	var _lodashCollectionEvery2 = _interopRequireDefault(_lodashCollectionEvery);
	
	var _lodashCollectionSortBy = __webpack_require__(258);
	
	var _lodashCollectionSortBy2 = _interopRequireDefault(_lodashCollectionSortBy);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	// # Tabella dei paesi
	// Contiene i valori per l'area, la valuta e il bonus per ogni paese
	// più alcune funzioni utili di formattazione
	var countries = {
	  data: {
	    AT: {
	      area: '43',
	      currency: 'EUR',
	      bonus: 0
	    },
	    BR: {
	      area: '55',
	      currency: 'BRL',
	      bonus: 0
	    },
	    FR: {
	      area: '33',
	      currency: 'EUR',
	      bonus: 0
	    },
	    DE: {
	      area: '49',
	      currency: 'EUR',
	      bonus: 0
	    },
	    GB: {
	      area: '44',
	      currency: 'GBP',
	      bonus: 0
	    },
	    IT: {
	      area: '39',
	      currency: 'EUR',
	      bonus: 0
	    },
	    ES: {
	      area: '34',
	      currency: 'EUR',
	      bonus: 0
	    },
	    US: {
	      area: '1',
	      currency: 'USD',
	      bonus: 0
	    },
	    CA: {
	      area: '1',
	      currency: 'CAD',
	      bonus: 0
	    },
	    ZA: {
	      area: '27',
	      currency: 'ZAR',
	      bonus: 0
	    },
	    CH: {
	      area: '41',
	      currency: 'CHF',
	      bonus: 0
	    }
	  },
	
	  currency: function currency(country) {
	    return countries.data[country].currency;
	  },
	
	  area: function area(country) {
	    return countries.data[country].area;
	  },
	
	  bonus: function bonus(country) {
	    return countries.data[country].bonus;
	  },
	
	  format_area: function format_area(locale, country) {
	    return locale.display_country(country) + ' (+' + countries.area(country) + ') ';
	  },
	
	  format_mobile: function format_mobile(country, mobile) {
	    return '(+' + countries.area(country) + ') ' + mobile;
	  },
	
	  to_options: function to_options(locale) {
	    return (0, _lodashCollectionSortBy2['default'])(Object.keys(countries.data).map(function (k) {
	      return [k, locale.display_country(k)];
	    }), '1');
	  }
	};
	
	// mi assicuro che ogni country abbia i suoi dati
	_tcomb2['default'].assert((0, _lodashCollectionEvery2['default'])(_Register_Country2['default'].meta.map, function (country) {
	  return countries.data.hasOwnProperty(country);
	}));
	
	module.exports = countries;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(256),
	    baseCallback = __webpack_require__(121),
	    baseEvery = __webpack_require__(257),
	    isArray = __webpack_require__(18),
	    isIterateeCall = __webpack_require__(38);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * The predicate is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias all
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': false },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.every(users, 'active', false);
	 * // => true
	 *
	 * // using the `_.property` callback shorthand
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	    predicate = undefined;
	  }
	  if (typeof predicate != 'function' || thisArg !== undefined) {
	    predicate = baseCallback(predicate, thisArg, 3);
	  }
	  return func(collection, predicate);
	}
	
	module.exports = every;


/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(117);
	
	/**
	 * The base implementation of `_.every` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(121),
	    baseMap = __webpack_require__(259),
	    baseSortBy = __webpack_require__(260),
	    compareAscending = __webpack_require__(261),
	    isIterateeCall = __webpack_require__(38);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection through `iteratee`. This method performs
	 * a stable sort, that is, it preserves the original sort order of equal elements.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return Math.sin(n);
	 * });
	 * // => [3, 1, 2]
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return this.sin(n);
	 * }, Math);
	 * // => [3, 1, 2]
	 *
	 * var users = [
	 *   { 'user': 'fred' },
	 *   { 'user': 'pebbles' },
	 *   { 'user': 'barney' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.sortBy(users, 'user'), 'user');
	 * // => ['barney', 'fred', 'pebbles']
	 */
	function sortBy(collection, iteratee, thisArg) {
	  if (collection == null) {
	    return [];
	  }
	  if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	    iteratee = undefined;
	  }
	  var index = -1;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	
	  var result = baseMap(collection, function(value, key, collection) {
	    return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	  });
	  return baseSortBy(result, compareAscending);
	}
	
	module.exports = sortBy;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(117),
	    isArrayLike = __webpack_require__(13);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define
	 * the sort order of `array` and replaces criteria objects with their
	 * corresponding values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(262);
	
	/**
	 * Used by `_.sortBy` to compare transformed elements of a collection and stable
	 * sort them in ascending order.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareAscending(object, other) {
	  return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	}
	
	module.exports = compareAscending;


/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `compareAscending` which compares values and
	 * sorts them in ascending order without guaranteeing a stable sort.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function baseCompareAscending(value, other) {
	  if (value !== other) {
	    var valIsNull = value === null,
	        valIsUndef = value === undefined,
	        valIsReflexive = value === value;
	
	    var othIsNull = other === null,
	        othIsUndef = other === undefined,
	        othIsReflexive = other === other;
	
	    if ((value > other && !othIsNull) || !valIsReflexive ||
	        (valIsNull && !othIsUndef && othIsReflexive) ||
	        (valIsUndef && othIsReflexive)) {
	      return 1;
	    }
	    if ((value < other && !valIsNull) || !othIsReflexive ||
	        (othIsNull && !valIsUndef && valIsReflexive) ||
	        (othIsUndef && valIsReflexive)) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = baseCompareAscending;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = cancel_target;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(51);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _toUrl = __webpack_require__(45);
	
	var _toUrl2 = _interopRequireDefault(_toUrl);
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	function cancel_target(app) {
	  var url = location.href;
	  var purl = _cookiesJs2['default'].get('purl');
	
	  if ((0, _isModal2['default'])() && purl) {
	    if (_cookiesJs2['default'].get('purl_only') === "1") {
	      url = purl;
	    } else {
	      var params = {
	        // se c'è il product_id devo aprire l'applicativo product
	        product_id: app.product ? app.product.id : null,
	        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	        user: !app.product ? true : null
	      };
	      url = (0, _toUrl2['default'])(purl, params);
	    }
	  }
	
	  // fix paypal redirect
	  if (url.indexOf('#') !== -1) {
	    url = url.substring(0, url.indexOf('#'));
	  }
	
	  return url;
	}

	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countries = __webpack_require__(254);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _get_bundle = __webpack_require__(49);
	
	var _get_bundle2 = _interopRequireDefault(_get_bundle);
	
	var _componentsSharePurchase = __webpack_require__(265);
	
	var _componentsSharePurchase2 = _interopRequireDefault(_componentsSharePurchase);
	
	var _template = __webpack_require__(189);
	
	var Share_Purchase = {
	  current: null,
	  create: function create(share_purchase_url, locale, purchase, do_share) {
	    var formatted_currency = locale.locale_bundle().currency[purchase.currency];
	    var format_currency = function format_currency(n) {
	      return formatted_currency + ' ' + locale.format_number(n, 2);
	    };
	    var bonus = format_currency(_countries2['default'].data[locale.country].bonus);
	    var discount = format_currency(purchase.discount);
	    var bundle = (0, _get_bundle2['default'])(locale).share_purchase;
	    var _share_purchase_url = share_purchase_url + '?productId=' + purchase.productId;
	    Share_Purchase.current = {
	      bonus: bonus,
	      html: function html() {
	        return _react2['default'].createElement(_componentsSharePurchase2['default'], { share_purchase_url: _share_purchase_url, bundle: bundle });
	      },
	      data: function data() {
	        return {
	          locale: String(locale),
	          language: locale.language,
	          target: 'http://madai.com',
	          name: purchase.product,
	          caption: 'madai',
	          picture: purchase.image,
	          description: (0, _template.template)(bundle.description)({
	            product: purchase.product,
	            discount: discount
	          })
	        };
	      },
	      do_share: do_share
	    };
	  }
	};
	
	exports['default'] = Share_Purchase;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var SharePurchase = (function (_React$Component) {
	  _inherits(SharePurchase, _React$Component);
	
	  function SharePurchase() {
	    _classCallCheck(this, _SharePurchase);
	
	    _get(Object.getPrototypeOf(_SharePurchase.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SharePurchase, [{
	    key: 'render',
	    value: function render() {
	      var style = {
	        'width': '100%',
	        'height': '62px'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { className: 'alert info' },
	        _react2['default'].createElement(
	          'strong',
	          null,
	          this.props.bundle.title
	        ),
	        _react2['default'].createElement('iframe', { scrolling: 'no', frameBorder: '0', src: this.props.share_purchase_url, style: style })
	      );
	    }
	  }]);
	
	  var _SharePurchase = SharePurchase;
	  SharePurchase = (0, _tcombReact.props)({
	    bundle: _tcombReact.t.Obj,
	    share_purchase_url: _tcombReact.t.Str
	  })(SharePurchase) || SharePurchase;
	  return SharePurchase;
	})(_react2['default'].Component);
	
	exports['default'] = SharePurchase;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Domicile = __webpack_require__(267);
	
	var _Domicile2 = _interopRequireDefault(_Domicile);
	
	var _Coupon = __webpack_require__(268);
	
	var _Coupon2 = _interopRequireDefault(_Coupon);
	
	var _Invoice = __webpack_require__(269);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Order = _tcomb2['default'].struct({
	  locale: _Locale2['default'],
	  domicile: _tcomb2['default'].maybe(_Domicile2['default']),
	  coupon: _tcomb2['default'].maybe(_Coupon2['default']),
	  invoice: _tcomb2['default'].maybe(_Invoice2['default'])
	}, 'Order');
	
	module.exports = Order;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Mobile = __webpack_require__(112);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Shipping = __webpack_require__(154);
	
	var _Shipping2 = _interopRequireDefault(_Shipping);
	
	var _Email = __webpack_require__(80);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Domicile = _tcomb2['default'].struct({
	  name: _tcomb2['default'].Str,
	  surname: _tcomb2['default'].Str,
	  address: _tcomb2['default'].Str,
	  co: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  town: _tcomb2['default'].Str,
	  district: _tcomb2['default'].Str,
	  zip: _tcomb2['default'].Str,
	  email: _Email2['default'],
	  mobile: _Mobile2['default'],
	  alt_email: _tcomb2['default'].maybe(_Email2['default']),
	  alt_mobile: _tcomb2['default'].maybe(_Mobile2['default']),
	  shipping: _tcomb2['default'].maybe(_Shipping2['default']),
	  mobile_country: _tcomb2['default'].maybe(_Register_Country2['default'])
	}, 'Domicile');
	
	module.exports = Domicile;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Email = __webpack_require__(80);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Mobile = __webpack_require__(112);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var Coupon = _tcomb2['default'].struct({
	  name: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  surname: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  email: _tcomb2['default'].maybe(_Email2['default']),
	  mobile: _tcomb2['default'].maybe(_Mobile2['default']),
	  mobile_country: _tcomb2['default'].maybe(_Register_Country2['default'])
	}, 'Coupon');
	
	module.exports = Coupon;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Invoice = _tcomb2['default'].struct({
	  name: _tcomb2['default'].Str,
	  vat: _tcomb2['default'].Str,
	  address: _tcomb2['default'].Str,
	  town: _tcomb2['default'].Str,
	  district: _tcomb2['default'].Str,
	  zip: _tcomb2['default'].Str
	}, 'Invoice');
	
	module.exports = Invoice;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = attach_server;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _User = __webpack_require__(54);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Anonymous = __webpack_require__(78);
	
	var _Anonymous2 = _interopRequireDefault(_Anonymous);
	
	var _Registered = __webpack_require__(79);
	
	var _Registered2 = _interopRequireDefault(_Registered);
	
	var _Verified = __webpack_require__(111);
	
	var _Verified2 = _interopRequireDefault(_Verified);
	
	var _Product = __webpack_require__(143);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Lattice = __webpack_require__(171);
	
	var _Lattice2 = _interopRequireDefault(_Lattice);
	
	var _Reducer = __webpack_require__(172);
	
	var _Reducer2 = _interopRequireDefault(_Reducer);
	
	var _Logged_User = __webpack_require__(271);
	
	var _Logged_User2 = _interopRequireDefault(_Logged_User);
	
	var _Password = __webpack_require__(272);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	var _Locale = __webpack_require__(55);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Short_Purchase = __webpack_require__(273);
	
	var _Short_Purchase2 = _interopRequireDefault(_Short_Purchase);
	
	var _Gender = __webpack_require__(113);
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var _Pin = __webpack_require__(275);
	
	var _Pin2 = _interopRequireDefault(_Pin);
	
	var _Mobile = __webpack_require__(112);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Purchase = __webpack_require__(276);
	
	var _Purchase2 = _interopRequireDefault(_Purchase);
	
	var _Order = __webpack_require__(266);
	
	var _Order2 = _interopRequireDefault(_Order);
	
	var _Behaviour = __webpack_require__(231);
	
	var _Behaviour2 = _interopRequireDefault(_Behaviour);
	
	var _Behaviour_Response = __webpack_require__(240);
	
	var _Behaviour_Response2 = _interopRequireDefault(_Behaviour_Response);
	
	var _Email = __webpack_require__(80);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _lodashObjectValues = __webpack_require__(210);
	
	var _lodashObjectValues2 = _interopRequireDefault(_lodashObjectValues);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	// Dato un server che contiene le api di comunicazione grezze
	// aggiunge agli oggetti di dominio delle api chiare e comode da usare
	
	function attach_server(server) {
	  server = _tcomb2['default'].Object(server);
	
	  // Restituisce l'utente corrente
	  _User2['default'].load = function (callback) {
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_user({}, function (err, user) {
	      if (err) {
	        callback(err);
	      } else {
	        callback(null, _User2['default'].of(user));
	      }
	    });
	  };
	
	  function do_change_password(old_password, new_password, callback) {
	    old_password = (0, _Password2['default'])(old_password);
	    new_password = (0, _Password2['default'])(new_password);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_change_password({
	      oldPassword: old_password,
	      newPassword: new_password
	    }, function (err) {
	      callback(err);
	    });
	  }
	
	  function do_logout(callback) {
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_logout({}, function (err, user) {
	      if (err) {
	        callback(err);
	      } else {
	        var anonymous = (0, _Anonymous2['default'])(user);
	        callback(null, anonymous);
	      }
	    });
	  }
	
	  function do_accept_rcs_privacy(callback) {
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_accept_rcs_privacy({}, function (err, user) {
	      if (err) {
	        callback(err);
	      } else {
	        user.com_locale = _Locale2['default'].of(user.com_locale);
	        user = (0, _Logged_User2['default'])((0, _User2['default'])(user));
	        callback(null, user);
	      }
	    });
	  }
	
	  // Registra un nuovo utente
	  _Anonymous2['default'].prototype.do_register = function (email, locale, privacy_rcs, privacy_other, privacy_tracking, callback) {
	    email = (0, _Email2['default'])(email);
	    locale = (0, _Locale2['default'])(locale);
	    privacy_rcs = _tcomb2['default'].maybe(_tcomb2['default'].String)(privacy_rcs);
	    privacy_other = _tcomb2['default'].maybe(_tcomb2['default'].String)(privacy_other);
	    privacy_tracking = _tcomb2['default'].maybe(_tcomb2['default'].String)(privacy_tracking);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_register({
	      emailAddress: email,
	      com_locale: String(locale),
	      privacy_rcs: privacy_rcs,
	      privacy_other: privacy_other,
	      privacy_tracking: privacy_tracking
	    }, callback);
	  };
	
	  // Reset password di un utente che se l'è dimenticata
	  _Anonymous2['default'].prototype.do_resend_password = function (email, callback) {
	    email = (0, _Email2['default'])(email);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_resend_password({
	      emailAddress: email
	    }, callback);
	  };
	
	  // Login
	  _Anonymous2['default'].prototype.do_login = function (email, password, callback) {
	    email = (0, _Email2['default'])(email);
	    password = (0, _Password2['default'])(password);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_login({
	      emailAddress: email,
	      password: password
	    }, function (err, user) {
	      if (err) {
	        callback(err, null);
	      } else {
	        user.com_locale = _Locale2['default'].of(user.com_locale);
	        user = (0, _Logged_User2['default'])((0, _User2['default'])(user));
	        callback(null, user);
	      }
	    });
	  };
	
	  // Resituisce l'url da raggiungere per poter effettuare la login con facebook
	  _Anonymous2['default'].prototype.load_facebook = function (target, locale, callback) {
	    target = _tcomb2['default'].String(target);
	    locale = (0, _Locale2['default'])(locale);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_facebook({
	      target: target,
	      com_locale: String(locale)
	    }, function (err, obj) {
	      obj = _tcomb2['default'].maybe(_tcomb2['default'].Object)(obj);
	
	      if (err) {
	        callback(err);
	      } else {
	        _tcomb2['default'].assert(_tcomb2['default'].String.is(obj.loginUri));
	        callback(null, obj.loginUri);
	      }
	    });
	  };
	
	  // Resituisce l'url da raggiungere per poter effettuare la login con google
	  _Anonymous2['default'].prototype.load_google = function (target, locale, callback) {
	    target = _tcomb2['default'].String(target);
	    locale = (0, _Locale2['default'])(locale);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_google({
	      target: target,
	      com_locale: String(locale)
	    }, function (err, obj) {
	      obj = _tcomb2['default'].maybe(_tcomb2['default'].Object)(obj);
	
	      if (err) {
	        callback(err);
	      } else {
	        _tcomb2['default'].assert(_tcomb2['default'].String.is(obj.loginUri));
	        callback(null, obj.loginUri);
	      }
	    });
	  };
	
	  // Resituisce l'url da raggiungere per poter effettuare la login con google
	  _Anonymous2['default'].prototype.load_microsoft = function (target, locale, callback) {
	    target = _tcomb2['default'].String(target);
	    locale = (0, _Locale2['default'])(locale);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_microsoft({
	      target: target,
	      com_locale: String(locale)
	    }, function (err, obj) {
	      obj = _tcomb2['default'].Object(obj);
	
	      if (err) {
	        callback(err);
	      } else {
	        _tcomb2['default'].assert(_tcomb2['default'].String.is(obj.loginUri));
	        callback(null, obj.loginUri);
	      }
	    });
	  };
	
	  // Resituisce l'url da raggiungere per poter effettuare la login con google
	  _Anonymous2['default'].prototype.load_twitter = function (target, locale, lattice_id, callback) {
	    target = _tcomb2['default'].String(target);
	    locale = (0, _Locale2['default'])(locale);
	    lattice_id = _tcomb2['default'].maybe(_UUID2['default'])(lattice_id);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_twitter({
	      target: target,
	      com_locale: String(locale),
	      lattice_id: lattice_id
	    }, function (err, obj) {
	      obj = _tcomb2['default'].maybe(_tcomb2['default'].Object)(obj);
	
	      if (err) {
	        callback(err);
	      } else {
	        _tcomb2['default'].assert(_tcomb2['default'].String.is(obj.loginUri));
	        callback(null, obj.loginUri);
	      }
	    });
	  };
	
	  // Cambiamento password per l'utente vver
	  _Registered2['default'].prototype.do_change_password = do_change_password;
	  // Logut per l'utente Registered
	  _Registered2['default'].prototype.do_logout = do_logout;
	  // do_accept_rcs_privacy per l'utente Registered
	  _Registered2['default'].prototype.do_accept_rcs_privacy = do_accept_rcs_privacy;
	
	  // # Processo di verifica
	
	  // Richiesta pin
	  _Registered2['default'].prototype.do_request_pin = function (country, mobile, callback) {
	    country = (0, _Register_Country2['default'])(country);
	    mobile = (0, _Mobile2['default'])(mobile);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_request_pin({
	      mobileCountry: country,
	      mobileNumber: mobile
	    }, callback);
	  };
	
	  // Inserimento pin
	  _Registered2['default'].prototype.do_insert_pin = function (pin, callback) {
	    pin = (0, _Pin2['default'])(pin);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_insert_pin({
	      pin: pin
	    }, callback);
	  };
	
	  // Conclusione del processo di verifica
	  _Registered2['default'].prototype.do_verify = function (gender, birth_date, country, district, zip, callback) {
	    gender = (0, _Gender2['default'])(gender);
	    birth_date = (0, _Datetime2['default'])(birth_date);
	    country = (0, _Register_Country2['default'])(country);
	    district = _tcomb2['default'].String(district);
	    zip = _tcomb2['default'].String(zip);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_verify({
	      gender: gender,
	      birth_date: birth_date,
	      country: country,
	      district: district,
	      zip: zip
	    }, function (err, user) {
	      if (err) {
	        callback(err, null);
	      } else {
	        user.com_locale = _Locale2['default'].of(user.com_locale);
	        var verified = new _Verified2['default'](user);
	        callback(null, verified);
	      }
	    });
	  };
	
	  // Cambiamento password per l'utente Verified
	  _Verified2['default'].prototype.do_change_password = do_change_password;
	  // Logut per l'utente Verified
	  _Verified2['default'].prototype.do_logout = do_logout;
	  // do_accept_rcs_privacy per l'utente Verified
	  _Verified2['default'].prototype.do_accept_rcs_privacy = do_accept_rcs_privacy;
	
	  // Carica le info sommarie degli acquisti di un utente
	
	  function load_purchases(callback) {
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_purchases({}, function (err, purchases) {
	      purchases = _tcomb2['default'].maybe(_tcomb2['default'].Object)(purchases);
	
	      if (err) {
	        callback(err, null);
	      } else {
	        purchases = (0, _lodashObjectValues2['default'])(purchases).map(_Short_Purchase2['default']);
	        callback(null, purchases);
	      }
	    });
	  }
	
	  _Registered2['default'].prototype.load_purchases = load_purchases;
	  _Verified2['default'].prototype.load_purchases = load_purchases;
	
	  _Verified2['default'].prototype.share_purchase = function (product_id, callback) {
	    product_id = _tcomb2['default'].String(product_id);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_share_purchase({
	      product_id: product_id
	    }, callback);
	  };
	
	  // Carica le info complete di un acquisto di un utente
	
	  function load_purchase(purchase_id, target, cancel_target, callback) {
	    purchase_id = (0, _UUID2['default'])(purchase_id);
	    target = _tcomb2['default'].String(target);
	    cancel_target = _tcomb2['default'].String(cancel_target);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_purchase({
	      purchase_id: purchase_id,
	      target: target,
	      cancel_target: cancel_target
	    }, function (err, purchase) {
	      if (err) {
	        callback(err, null);
	      } else {
	        callback(null, (0, _Purchase2['default'])(purchase));
	      }
	    });
	  }
	
	  _Registered2['default'].prototype.load_purchase = load_purchase;
	  _Verified2['default'].prototype.load_purchase = load_purchase;
	
	  _Verified2['default'].prototype.do_update_account = function (name, surname, gender, birth_date, country, district, zip, com_locale, callback) {
	    name = _tcomb2['default'].maybe(_tcomb2['default'].String)(name);
	    surname = _tcomb2['default'].maybe(_tcomb2['default'].String)(surname);
	    gender = (0, _Gender2['default'])(gender);
	    birth_date = (0, _Datetime2['default'])(birth_date);
	    country = (0, _Register_Country2['default'])(country);
	    district = _tcomb2['default'].String(district);
	    zip = _tcomb2['default'].String(zip);
	    com_locale = (0, _Locale2['default'])(com_locale);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_update_account({
	      name: name || '',
	      surname: surname || '',
	      gender: gender,
	      birth_date: birth_date,
	      country: country,
	      district: district,
	      zip: zip,
	      com_locale: String(com_locale)
	    }, function (err, user) {
	      user = _tcomb2['default'].maybe(_tcomb2['default'].Object)(user);
	
	      if (err) {
	        callback(err, null);
	      } else {
	        user.com_locale = _Locale2['default'].of(user.com_locale);
	        var verified = new _Verified2['default'](user);
	        callback(null, verified);
	      }
	    });
	  };
	
	  // L'utente acquista il prodotto
	
	  function do_approve_order(product, order, callback) {
	    product = (0, _Product2['default'])(product);
	    order = (0, _Order2['default'])(order);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_approve_order({
	      product_id: product.id,
	      price: product.runtime.price,
	      order: order
	    }, function (err, result) {
	      result = _tcomb2['default'].maybe(_tcomb2['default'].Object)(result);
	
	      if (err) {
	        callback(err);
	      } else {
	        _tcomb2['default'].assert(_UUID2['default'].is(result.purchase_id));
	        _tcomb2['default'].assert(_tcomb2['default'].Object.is(result.runtime));
	        callback(null, {
	          purchase_id: result.purchase_id,
	          product: product.replace_runtime(result.runtime)
	        });
	      }
	    });
	  }
	
	  _Registered2['default'].prototype.do_approve_order = do_approve_order;
	  _Verified2['default'].prototype.do_approve_order = do_approve_order;
	
	  // L'utente invia il codice sconto di madai
	
	  function do_send_gift_card_code(purchase_id, target, cancel_target, gift_card_code, callback) {
	    purchase_id = (0, _UUID2['default'])(purchase_id);
	    target = _tcomb2['default'].String(target);
	    cancel_target = _tcomb2['default'].String(cancel_target);
	    gift_card_code = _tcomb2['default'].String(gift_card_code);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_send_gift_card_code({
	      purchase_id: purchase_id,
	      target: target,
	      cancel_target: cancel_target,
	      gift_card_code: gift_card_code
	    }, function (err, result) {
	      result = _tcomb2['default'].maybe(_tcomb2['default'].Object)(result);
	
	      if (err) {
	        callback(err);
	      } else {
	        callback(null, {
	          purchase_id: result.id
	        });
	      }
	    });
	  }
	
	  _Registered2['default'].prototype.do_send_gift_card_code = do_send_gift_card_code;
	  _Verified2['default'].prototype.do_send_gift_card_code = do_send_gift_card_code;
	
	  // Carica il runtime di un prodotto per l'utente corrente
	  _Product2['default'].prototype.load_runtime = function (callback) {
	    callback = _tcomb2['default'].Function(callback);
	
	    var product = this;
	    server.load_runtime({
	      product_id: product.id
	    }, function (err, runtime) {
	      if (err) {
	        callback(err);
	      } else {
	        callback(null, product.replace_runtime(runtime));
	      }
	    });
	  };
	
	  // Carica un reticolo by id
	  _Lattice2['default'].load = function (lattice_id, callback) {
	    lattice_id = (0, _UUID2['default'])(lattice_id);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.load_lattice({
	      lattice_id: lattice_id
	    }, function (err, lattice) {
	      if (err) {
	        callback(err);
	      } else {
	        callback(null, _Lattice2['default'].of(lattice));
	      }
	    });
	  };
	
	  // Segnala al server il completamento di un reducer
	  _Reducer2['default'].do_reduce = function (product_id, behaviour, callback) {
	    product_id = (0, _UUID2['default'])(product_id);
	    behaviour = _tcomb2['default'].maybe(_Behaviour2['default'])(behaviour);
	    callback = _tcomb2['default'].Function(callback);
	
	    server.do_reduce({
	      product_id: product_id,
	      behaviour: behaviour
	    }, function (err, result) {
	      if (err) {
	        callback(err);
	      } else {
	        callback(null, (0, _Behaviour_Response2['default'])(result));
	      }
	    });
	  };
	}

	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Registered = __webpack_require__(79);
	
	var _Registered2 = _interopRequireDefault(_Registered);
	
	var _Verified = __webpack_require__(111);
	
	var _Verified2 = _interopRequireDefault(_Verified);
	
	var Logged_User = _tcomb2['default'].union([_Registered2['default'], _Verified2['default']]);
	
	module.exports = Logged_User;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Password = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	  return x.length >= 6;
	});
	
	module.exports = Password;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Purchase_State = __webpack_require__(274);
	
	var _Purchase_State2 = _interopRequireDefault(_Purchase_State);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _Currency = __webpack_require__(156);
	
	var _Currency2 = _interopRequireDefault(_Currency);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var Short_Purchase = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  status: _Purchase_State2['default'],
	  tick: _Datetime2['default'],
	  product: _tcomb2['default'].Str,
	  currency: _Currency2['default'],
	  amount: _Amount2['default']
	}, 'Short_Purchase');
	
	module.exports = Short_Purchase;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Purchase_State = _tcomb2['default'].enums.of('CANCELED PAID PENDING PROCESSING SHIPPED'.split(' '));
	
	module.exports = Purchase_State;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Pin = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	
	  return x.length === 4; // && t.is_digits(x);
	});
	
	module.exports = Pin;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _Purchase_State = __webpack_require__(274);
	
	var _Purchase_State2 = _interopRequireDefault(_Purchase_State);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _Currency = __webpack_require__(156);
	
	var _Currency2 = _interopRequireDefault(_Currency);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Domicile = __webpack_require__(267);
	
	var _Domicile2 = _interopRequireDefault(_Domicile);
	
	var _Coupon = __webpack_require__(268);
	
	var _Coupon2 = _interopRequireDefault(_Coupon);
	
	var _Invoice = __webpack_require__(269);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _Purchase_Payment = __webpack_require__(277);
	
	var _Purchase_Payment2 = _interopRequireDefault(_Purchase_Payment);
	
	var _Custom_Payment = __webpack_require__(162);
	
	var _Custom_Payment2 = _interopRequireDefault(_Custom_Payment);
	
	var Purchase = _tcomb2['default'].struct({
	  id: _UUID2['default'],
	  productId: _tcomb2['default'].maybe(_UUID2['default']),
	  status: _Purchase_State2['default'],
	  tick: _Datetime2['default'],
	  product: _tcomb2['default'].Str,
	  currency: _Currency2['default'],
	  amount: _Amount2['default'],
	  domicile: _tcomb2['default'].maybe(_Domicile2['default']),
	  coupon: _tcomb2['default'].maybe(_Coupon2['default']),
	  invoice: _tcomb2['default'].maybe(_Invoice2['default']),
	  payment: _tcomb2['default'].maybe(_Purchase_Payment2['default']),
	  discount: _Amount2['default'],
	  image: _tcomb2['default'].Str,
	  custom_payments: _tcomb2['default'].maybe(_tcomb2['default'].list(_Custom_Payment2['default'])),
	  pending_purchase_message: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  gift_card_not_supported: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  gift_card_code: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  payment_amount: _tcomb2['default'].maybe(_Amount2['default'])
	}, 'Purchase');
	
	module.exports = Purchase;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Purchase_Payment_Gateways = __webpack_require__(278);
	
	var _Purchase_Payment_Gateways2 = _interopRequireDefault(_Purchase_Payment_Gateways);
	
	var _Purchase_Payment_URL = __webpack_require__(280);
	
	var _Purchase_Payment_URL2 = _interopRequireDefault(_Purchase_Payment_URL);
	
	var Purchase_Payment = _tcomb2['default'].union([_Purchase_Payment_Gateways2['default'], _Purchase_Payment_URL2['default']], 'Purchase_Payment');
	
	Purchase_Payment.dispatch = function (x) {
	  switch (x.type) {
	    case 'gateways':
	      return _Purchase_Payment_Gateways2['default'];
	    case 'url':
	      return _Purchase_Payment_URL2['default'];
	  }
	  return x.constructor;
	};
	
	module.exports = Purchase_Payment;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Gateway = __webpack_require__(279);
	
	var _Gateway2 = _interopRequireDefault(_Gateway);
	
	var Purchase_Payment_Gateways = _tcomb2['default'].struct({
	  gateways: _tcomb2['default'].list(_Gateway2['default'])
	}, 'Purchase_Payment_Gateways');
	
	module.exports = Purchase_Payment_Gateways;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Payment_Type = __webpack_require__(163);
	
	var _Payment_Type2 = _interopRequireDefault(_Payment_Type);
	
	var Gateway = _tcomb2['default'].struct({
	  type: _Payment_Type2['default'],
	  html: _tcomb2['default'].Str
	}, 'Gateway');
	
	module.exports = Gateway;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var Purchase_Payment_URL = _tcomb2['default'].struct({
	  url: _URL2['default']
	}, 'Purchase_Payment_URL');
	
	exports['default'] = Purchase_Payment_URL;
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Server;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Register_Country = __webpack_require__(114);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var _Locale_Iso = __webpack_require__(58);
	
	var _Locale_Iso2 = _interopRequireDefault(_Locale_Iso);
	
	var _Pin = __webpack_require__(275);
	
	var _Pin2 = _interopRequireDefault(_Pin);
	
	var _Gender = __webpack_require__(113);
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _Order = __webpack_require__(266);
	
	var _Order2 = _interopRequireDefault(_Order);
	
	var _Behaviour = __webpack_require__(231);
	
	var _Behaviour2 = _interopRequireDefault(_Behaviour);
	
	var _http = __webpack_require__(282);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _Email = __webpack_require__(80);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _UUID = __webpack_require__(44);
	
	var _UUID2 = _interopRequireDefault(_UUID);
	
	var _URL = __webpack_require__(160);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var _Datetime = __webpack_require__(61);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _Amount = __webpack_require__(155);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	// FIXME usare ../../endpoint.js invece che http()
	
	function Server(rest_base, async) {
	  rest_base = _tcomb2['default'].String(rest_base);
	  async = _tcomb2['default'].maybe(_tcomb2['default'].Boolean)(async);
	
	  async = _tcomb2['default'].Nil.is(async) ? true : async;
	
	  this.load_user = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user',
	    method: 'get'
	  });
	
	  this.do_login = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/login',
	    method: 'post',
	    form_params: {
	      emailAddress: _Email2['default'],
	      password: _tcomb2['default'].String
	    }
	  });
	
	  this.load_facebook = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/login/facebook',
	    method: 'post',
	    form_params: {
	      target: _URL2['default'],
	      com_locale: _Locale_Iso2['default']
	    }
	  });
	
	  this.load_google = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/login/google',
	    method: 'post',
	    form_params: {
	      target: _URL2['default'],
	      com_locale: _Locale_Iso2['default']
	    }
	  });
	
	  this.load_twitter = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/login/twitter',
	    method: 'post',
	    form_params: {
	      target: _URL2['default'],
	      com_locale: _Locale_Iso2['default'],
	      lattice_id: _tcomb2['default'].maybe(_UUID2['default'])
	    }
	  });
	
	  this.load_microsoft = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/login/microsoft',
	    method: 'post',
	    form_params: {
	      target: _URL2['default'],
	      com_locale: _Locale_Iso2['default']
	    }
	  });
	
	  this.do_resend_password = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/password/reset',
	    method: 'post',
	    form_params: {
	      emailAddress: _Email2['default']
	    }
	  });
	
	  this.do_request_pin = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/mobile',
	    method: 'post',
	    form_params: {
	      mobileCountry: _Register_Country2['default'],
	      mobileNumber: _tcomb2['default'].String
	    }
	  });
	
	  this.do_insert_pin = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/mobile/pin',
	    method: 'post',
	    form_params: {
	      pin: _Pin2['default']
	    }
	  });
	
	  this.do_verify = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/verify',
	    method: 'post',
	    form_params: {
	      gender: _Gender2['default'],
	      birth_date: _Datetime2['default'],
	      country: _Register_Country2['default'],
	      district: _tcomb2['default'].String,
	      zip: _tcomb2['default'].String
	    }
	  });
	
	  this.load_purchases = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/orders',
	    method: 'get'
	  });
	
	  this.load_purchase = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'order/<%= purchase_id %>?target=<%= target %>&cancel_target=<%= cancel_target %>',
	    method: 'get',
	    url_params: {
	      purchase_id: _UUID2['default'],
	      target: _URL2['default'],
	      cancel_target: _URL2['default']
	    }
	  });
	
	  this.do_send_gift_card_code = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'order/<%= purchase_id %>/giftcard',
	    method: 'post',
	    url_params: {
	      purchase_id: _UUID2['default']
	    },
	    form_params: {
	      gift_card_code: _tcomb2['default'].String,
	      target: _URL2['default'],
	      cancel_target: _URL2['default']
	    }
	  });
	
	  this.do_register = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/account',
	    method: 'post',
	    form_params: {
	      emailAddress: _Email2['default'],
	      com_locale: _Locale_Iso2['default'],
	      privacy_rcs: _tcomb2['default'].maybe(_tcomb2['default'].String),
	      privacy_other: _tcomb2['default'].maybe(_tcomb2['default'].String),
	      privacy_tracking: _tcomb2['default'].maybe(_tcomb2['default'].String)
	    }
	  });
	
	  this.do_logout = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/logout',
	    method: 'post'
	  });
	
	  this.do_change_password = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/password',
	    method: 'post',
	    form_params: {
	      oldPassword: _tcomb2['default'].String,
	      newPassword: _tcomb2['default'].String
	    }
	  });
	
	  this.do_update_account = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user',
	    method: 'post',
	    form_params: {
	      name: _tcomb2['default'].String,
	      surname: _tcomb2['default'].String,
	      gender: _Gender2['default'],
	      birth_date: _Datetime2['default'],
	      country: _Register_Country2['default'],
	      district: _tcomb2['default'].String,
	      zip: _tcomb2['default'].String,
	      com_locale: _Locale_Iso2['default']
	    }
	  });
	
	  this.do_approve_order = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'product/<%= product_id %>/buy',
	    method: 'post',
	    url_params: {
	      product_id: _UUID2['default']
	    },
	    form_params: {
	      price: _Amount2['default'],
	      order: _Order2['default']
	    }
	  });
	
	  this.load_runtime = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'product/<%= product_id %>/runtime.json',
	    method: 'get',
	    url_params: {
	      product_id: _UUID2['default']
	    }
	  });
	
	  this.load_lattice = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'lattice/<%= lattice_id %>',
	    method: 'get',
	    url_params: {
	      lattice_id: _UUID2['default']
	    }
	  });
	
	  this.do_reduce = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'product/<%= product_id %>/behaviour',
	    method: 'post',
	    url_params: {
	      product_id: _UUID2['default']
	    },
	    form_params: {
	      behaviour: _tcomb2['default'].maybe(_Behaviour2['default'])
	    }
	  });
	
	  this.do_share_purchase = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/bonus/share',
	    method: 'post',
	    form_params: {
	      product_id: _tcomb2['default'].maybe(_UUID2['default'])
	    }
	  });
	
	  this.do_accept_rcs_privacy = (0, _http2['default'])({
	    async: async,
	    url: rest_base + 'user/account/privacy_rcs',
	    method: 'post'
	  });
	}

	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = http;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _template = __webpack_require__(189);
	
	var _lodashLangIsEmpty = __webpack_require__(283);
	
	var _lodashLangIsEmpty2 = _interopRequireDefault(_lodashLangIsEmpty);
	
	var Http_Method = _tcomb2['default'].enums.of(['get', 'post'], 'Http_Method');
	var Http_Data_Type = _tcomb2['default'].enums.of(['json'], 'Http_Data_Type');
	var Http_Params = _tcomb2['default'].dict(_tcomb2['default'].String, _tcomb2['default'].Function, 'Http_Params');
	
	var Http = _tcomb2['default'].struct({
	  async: _tcomb2['default'].Boolean,
	  url: _tcomb2['default'].String,
	  method: Http_Method,
	  data_type: _tcomb2['default'].maybe(Http_Data_Type),
	  url_params: _tcomb2['default'].maybe(Http_Params),
	  form_params: _tcomb2['default'].maybe(Http_Params)
	}, 'Http');
	
	Http.parse_response = function (response) {
	  try {
	    return response ? JSON.parse(response) : null;
	  } catch (e) {
	    return null;
	  }
	};
	
	Http.checked_error = function (xhr, text_status, thrown_error) {
	  var json = Http.parse_response(xhr.responseText);
	  if (json && !_tcomb2['default'].Nil.is(json.error)) {
	    var error = new Error(json.error);
	    error.name = json.error;
	    error.response_error = json;
	    return error;
	  }
	  return Http.unexpected_error(xhr, text_status, thrown_error);
	};
	
	Http.unexpected_error = function (xhr, text_status, thrown_error) {
	  if (text_status === 'timeout') {
	    xhr.abort();
	    var timeoutError = new Error('timeout');
	    timeoutError.name = 'timeout';
	    return timeoutError;
	  }
	  var error = new Error(thrown_error);
	  error.name = thrown_error;
	  return error;
	};
	
	Http.to_error = function (args, xhr, text_status, thrown_error) {
	  var err = text_status === "error" && xhr ? Http.checked_error(xhr, text_status, thrown_error) : Http.unexpected_error(xhr, text_status, thrown_error);
	  err.request = this;
	  err.args = args;
	  err.xhr = xhr;
	  return err;
	};
	
	Http.prototype.to_func = function () {
	  var self = this;
	  return function (args, callback) {
	    args = _tcomb2['default'].Object(args);
	    callback = _tcomb2['default'].Function(callback);
	
	    var url_args = {};
	    var form_args = {};
	    var param;
	    var arg;
	
	    for (param in self.url_params) {
	      arg = args[param];
	      // controllo il tipo dei parametri
	      _tcomb2['default'].assert(self.url_params[param].is(arg));
	      // converto gli argomenti in stringa
	      /*
	          arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
	          // i parametri nell'url vanno encondati
	          url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
	      */
	      if (arg) {
	        arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
	        // i parametri nell'url vanno encondati
	        url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
	      } else {
	        url_args[encodeURIComponent(param)] = "";
	      }
	    }
	    for (param in self.form_params) {
	      arg = args[param];
	      // controllo il tipo delle form
	      _tcomb2['default'].assert(self.form_params[param].is(arg));
	      // converto gli argomenti in stringa
	      arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
	      form_args[param] = arg;
	    }
	
	    // fix IE bug: se method = "post" e non c'è nessun parametro nella form, IE manda una chiamata in GET
	    if (self.method === 'post' && (0, _lodashLangIsEmpty2['default'])(form_args)) {
	      form_args["__noemptybody__"] = "";
	    }
	
	    // converto la configurazione dell'api in una configurazione del metodo ajax() di jQuery
	    var url = (0, _template.template)(self.url)(url_args);
	    var config = {
	      async: self.async,
	      cache: false,
	      type: self.method,
	      dataType: self.data_type || 'json',
	      url: url,
	      data: form_args
	    };
	
	    var request = $.ajax(config);
	    if (callback) {
	      request.then(function (response) {
	        callback(null, response);
	      }, function (xhr, text_status, thrown_error) {
	        callback(Http.to_error(args, xhr, text_status, thrown_error));
	      });
	      return null;
	    } else {
	      return request.then(function (response) {
	        return response;
	      }, function (xhr, text_status, thrown_error) {
	        return Http.to_error(args, xhr, text_status, thrown_error);
	      }).promise();
	    }
	  };
	};
	
	function http(config) {
	  return new Http(config).to_func();
	}

	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(12),
	    isArray = __webpack_require__(18),
	    isArrayLike = __webpack_require__(13),
	    isFunction = __webpack_require__(21),
	    isObjectLike = __webpack_require__(17),
	    isString = __webpack_require__(284),
	    keys = __webpack_require__(33);
	
	/**
	 * Checks if `value` is empty. A value is considered empty unless it's an
	 * `arguments` object, array, string, or jQuery-like collection with a length
	 * greater than `0` or an object with own enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Array|Object|string} value The value to inspect.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	      (isObjectLike(value) && isFunction(value.splice)))) {
	    return !value.length;
	  }
	  return !keys(value).length;
	}
	
	module.exports = isEmpty;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* global ga */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Google_Analytics;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function Google_Analytics() {}
	
	Google_Analytics.prototype.track_pageview = function (name) {
	  name = _tcomb2['default'].String(name);
	
	  if (typeof ga !== 'undefined') {
	    ga('send', 'pageview', name);
	  }
	};
	
	Google_Analytics.prototype.track_event = function (category, action, label) {
	  category = _tcomb2['default'].String(category);
	  action = _tcomb2['default'].String(action);
	  label = _tcomb2['default'].String(label);
	
	  if (typeof ga !== 'undefined') {
	    ga('send', 'event', category, action, label, 0);
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = setBackground;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function setBackground(sponsor) {
	
	  var do_show_background = sponsor && sponsor.background && (sponsor.background.color || sponsor.background.image);
	
	  if (do_show_background) {
	    for (var k in sponsor.background) {
	      if (k === 'image' && !_tcomb2['default'].Nil.is(sponsor.background[k])) {
	        document.getElementsByTagName('html')[0].style['background-' + k] = 'url(' + sponsor.background[k] + ')';
	      } else {
	        document.getElementsByTagName('html')[0].style['background-' + k] = sponsor.background[k];
	      }
	    }
	  } else {
	    document.getElementsByTagName('html')[0].style['background-color'] = null;
	    document.getElementsByTagName('html')[0].style['background-image'] = null;
	  }
	}

	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = doShare;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domainToUrl = __webpack_require__(45);
	
	var _domainToUrl2 = _interopRequireDefault(_domainToUrl);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	function doShare(app) {
	  return function doShare(type) {
	    var bundle = (0, _domainGet_bundle2['default'])(app.locale).social;
	    var product = app.product;
	    var target = (0, _domainToUrl2['default'])(app.social_url, {
	      lattice: app.lattice && app.is_corp ? app.lattice.id : null
	    });
	    // appendo un timestamp per indurre facebook a rifare il parsing
	    // delle info del prodotto e invalidare la loro cache
	    var fb_target = (0, _domainToUrl2['default'])(target, {
	      _: new Date().getTime()
	    });
	    var fb_caption = null;
	    var gplus_target = target;
	    var url = '';
	
	    // personalizzazione dello share
	    if (app.lattice) {
	      if (app.lattice.share_url) {
	        target = fb_target = app.lattice.share_url;
	      }
	      if (app.lattice.share_caption) {
	        fb_caption = app.lattice.share_caption;
	      }
	    }
	
	    switch (type) {
	      case 'email':
	        url = (0, _domainToUrl2['default'])('mailto:', {
	          subject: bundle.email.subject,
	          body: (0, _lodashStringTemplate2['default'])(bundle.email.body)({
	            name: product.name,
	            description: bundle.claim,
	            target: target
	          })
	        });
	        break;
	      //app_id: '242802885747781',
	      case 'facebook':
	        url = (0, _domainToUrl2['default'])('https://www.facebook.com/dialog/feed', {
	          app_id: '911642192190441',
	          link: fb_target,
	          name: product.name,
	          description: bundle.claim,
	          picture: product.image,
	          redirect_uri: 'http://www.facebook.com',
	          caption: fb_caption
	        });
	        break;
	      case 'gplus':
	        url = (0, _domainToUrl2['default'])('https://plus.google.com/share', {
	          url: gplus_target
	        });
	        break;
	      case 'linkedin':
	        url = (0, _domainToUrl2['default'])('http://www.linkedin.com/shareArticle', {
	          mini: 'true',
	          url: target,
	          title: product.name,
	          summary: bundle.claim
	        });
	        break;
	      case 'twitter':
	        url = (0, _domainToUrl2['default'])('https://twitter.com/intent/tweet', {
	          source: 'tweetbutton',
	          text: product.name + ' ' + bundle.claim,
	          url: target,
	          via: 'madainews',
	          type: 'share',
	          twttr_referrer: 'http://madai.com'
	        });
	        break;
	    }
	
	    window.open(url);
	
	    app.emit('go_share', [type]);
	  };
	}

	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = createCallback;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	// given the successHandler and the errorHandler returns a node like callback:
	// `err` as first argument, `result` as second argument
	
	function createCallback(successHandler, errorHandler) {
	  successHandler = _tcomb2['default'].Function(successHandler);
	  errorHandler = _tcomb2['default'].Function(errorHandler);
	
	  var ret = function (successHandler, errorHandler) {
	    return function (err, result) {
	      if (err) {
	        errorHandler(err);
	      } else {
	        successHandler(result);
	      }
	    };
	  }.call(this, successHandler, errorHandler);
	
	  return _tcomb2['default'].Function(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Message = __webpack_require__(290);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _tcombReact = __webpack_require__(168);
	
	var ConsoleMessage = (function (_React$Component) {
	  _inherits(ConsoleMessage, _React$Component);
	
	  function ConsoleMessage() {
	    _classCallCheck(this, _ConsoleMessage);
	
	    _get(Object.getPrototypeOf(_ConsoleMessage.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ConsoleMessage, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _Message2['default'],
	        { bgColor: '#fff', fontColor: '#333' },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _ConsoleMessage = ConsoleMessage;
	  ConsoleMessage = (0, _tcombReact.props)({
	    children: _tcombReact.t.Any
	  })(ConsoleMessage) || ConsoleMessage;
	  return ConsoleMessage;
	})(_react2['default'].Component);
	
	exports['default'] = ConsoleMessage;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var Message = (function (_React$Component) {
	  _inherits(Message, _React$Component);
	
	  function Message() {
	    _classCallCheck(this, _Message);
	
	    _get(Object.getPrototypeOf(_Message.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Message, [{
	    key: 'getStyle',
	    value: function getStyle() {
	      if (!this.props.bgColor) {
	        return null;
	      }
	      return {
	        backgroundColor: this.props.bgColor,
	        color: this.props.fontColor
	      };
	    }
	  }, {
	    key: 'getTriangleStyle',
	    value: function getTriangleStyle() {
	      if (!this.props.bgColor) {
	        return null;
	      }
	      return {
	        borderTopColor: this.props.bgColor
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'message box title', style: this.getStyle() },
	        this.props.children,
	        _react2['default'].createElement('div', { className: 'triangle-down', style: this.getTriangleStyle() })
	      );
	    }
	  }]);
	
	  var _Message = Message;
	  Message = (0, _tcombReact.props)({
	    children: _tcombReact.t.Any,
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    fontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(Message) || Message;
	  return Message;
	})(_react2['default'].Component);
	
	exports['default'] = Message;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var Share = (function (_React$Component) {
	  _inherits(Share, _React$Component);
	
	  function Share() {
	    _classCallCheck(this, _Share);
	
	    _get(Object.getPrototypeOf(_Share.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Share, [{
	    key: 'doShare',
	    value: function doShare(type, evt) {
	      evt.preventDefault();
	      this.props.doShare(type);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.doShowShare) {
	        return null;
	      }
	      // <a className="share" onClick={this.doShare.bind(this, 'email')} title="Email" href="#"><div className="email"></div></a>
	      // <a className="share" onClick={this.doShare.bind(this, 'gplus')} title="Google Plus" href="#"><div className="gplus"></div></a>
	      return _react2['default'].createElement(
	        'div',
	        { id: 'container_share' },
	        _react2['default'].createElement(
	          'a',
	          { className: 'share', onClick: this.doShare.bind(this, 'facebook'), title: 'Facebook', href: '#' },
	          _react2['default'].createElement('div', { className: 'facebook' })
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: 'share', onClick: this.doShare.bind(this, 'linkedin'), title: 'LinkedIn', href: '#' },
	          _react2['default'].createElement('div', { className: 'linkedin' })
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: 'share', onClick: this.doShare.bind(this, 'twitter'), title: 'Twitter', href: '#' },
	          _react2['default'].createElement('div', { className: 'twitter' })
	        )
	      );
	    }
	  }]);
	
	  var _Share = Share;
	  Share = (0, _tcombReact.props)({
	    doShowShare: _tcombReact.t.Bool,
	    doShare: _tcombReact.t.Func
	  })(Share) || Share;
	  return Share;
	})(_react2['default'].Component);
	
	exports['default'] = Share;
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _componentsAdvBoxes = __webpack_require__(301);
	
	var _componentsAdvBoxes2 = _interopRequireDefault(_componentsAdvBoxes);
	
	var _componentsAdvBox = __webpack_require__(303);
	
	var _componentsAdvBox2 = _interopRequireDefault(_componentsAdvBox);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsConsole = __webpack_require__(305);
	
	var _componentsConsole2 = _interopRequireDefault(_componentsConsole);
	
	var _componentsProduct = __webpack_require__(311);
	
	var _componentsProduct2 = _interopRequireDefault(_componentsProduct);
	
	var _componentsShareBox = __webpack_require__(320);
	
	var _componentsShareBox2 = _interopRequireDefault(_componentsShareBox);
	
	var _componentsTips = __webpack_require__(321);
	
	var _componentsTips2 = _interopRequireDefault(_componentsTips);
	
	var _componentsLasts = __webpack_require__(323);
	
	var _componentsLasts2 = _interopRequireDefault(_componentsLasts);
	
	var _componentsProductDetails = __webpack_require__(314);
	
	var _componentsProductDetails2 = _interopRequireDefault(_componentsProductDetails);
	
	var _componentsProductCard = __webpack_require__(312);
	
	var _componentsProductCard2 = _interopRequireDefault(_componentsProductCard);
	
	var _componentsHeaderProduct = __webpack_require__(326);
	
	var _componentsHeaderProduct2 = _interopRequireDefault(_componentsHeaderProduct);
	
	var _componentsLucidTutorial = __webpack_require__(327);
	
	var _componentsLucidTutorial2 = _interopRequireDefault(_componentsLucidTutorial);
	
	var _domainStatusLucid = __webpack_require__(328);
	
	var _domainStatusLucid2 = _interopRequireDefault(_domainStatusLucid);
	
	var _tcombReact = __webpack_require__(168);
	
	var doShowBonus = false;
	var doShowTimeAgo = true;
	
	var Product = (function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product() {
	    var _this = this;
	
	    _classCallCheck(this, _Product);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Product.prototype), 'constructor', this).apply(this, args);
	
	    this.callback = function () {
	      _this.setState({ showModal: false });
	    };
	
	    this.getLucidTutorial = function () {
	      if (_this.props.showLucidTutorial && _this.state.showModal) {
	        return _react2['default'].createElement(_componentsLucidTutorial2['default'], { width: '600', status: _this.props.statusLucidTutorial, locale: _this.props.locale, callback: _this.callback });
	      }
	      return null;
	    };
	
	    this.state = {
	      showModal: true
	    };
	  }
	
	  _createClass(Product, [{
	    key: 'getSponsorTitle',
	    value: function getSponsorTitle() {
	      if (!this.props.sponsor.name) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'h1',
	        null,
	        this.props.sponsor.name
	      );
	    }
	  }, {
	    key: 'getSponsorDescription',
	    value: function getSponsorDescription() {
	      if (!this.props.sponsor.description) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'h2',
	        null,
	        _react2['default'].createElement(
	          _componentsMarkdownComponent2['default'],
	          null,
	          this.props.sponsor.description
	        )
	      );
	    }
	  }, {
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getAdvBoxes',
	    value: function getAdvBoxes() {
	      if (!this.props.advBoxes || this.props.advBoxes.length === 0) {
	        return null;
	      }
	
	      var advBoxes = this.props.advBoxes.map(function (advBox, index) {
	        function onClick() {
	          window.open(advBox.link);
	        }
	
	        return _react2['default'].createElement(_componentsAdvBox2['default'], {
	          key: index,
	          image: advBox.image,
	          title: advBox.title,
	          onClick: onClick });
	      });
	
	      return _react2['default'].createElement(_componentsAdvBoxes2['default'], { advBoxes: advBoxes, title: (0, _domainGet_bundle2['default'])(this.props.locale).product.title_adv });
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderProduct2['default'], {
	        user: this.props.user,
	        goLogin: this.props.goLogin,
	        goCatalog: this.props.goCatalog,
	        goLattices: this.props.goLattices,
	        goAccount: this.props.goAccount,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        locale: this.props.locale,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        isWelcome: _domainRegistered2['default'].is(this.props.user),
	        showTutorial: true
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getSponsorClaim',
	    value: function getSponsorClaim() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'cell sponsor-claim' },
	        this.getSponsorTitle(),
	        this.getSponsorDescription()
	      );
	    }
	  }, {
	    key: 'getSmallLayout',
	    value: function getSmallLayout() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	      return _react2['default'].createElement(
	        'div',
	        { className: 'product-mobile' },
	        this.getSponsorClaim(),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(_componentsProductCard2['default'], { locale: locale, product: product, themeBgFontColor: this.props.themeBgFontColor, themeBgColor: this.props.themeBgColor })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement(_componentsConsole2['default'], {
	            doShowConsole: this.props.doShowConsole,
	            locale: locale,
	            themeBgColor: this.props.themeBgColor,
	            themeBtnColor: this.props.themeBtnColor,
	            themeBgFontColor: this.props.themeBgFontColor,
	            themeBtnFontColor: this.props.themeBtnFontColor,
	            message: this.props.message,
	            product: product,
	            goBuildOrder: this.props.goBuildOrder,
	            goPurchase: this.props.goPurchase,
	            doReduce: this.props.doReduce,
	            oldPrice: this.props.oldPrice,
	            doShowBonus: doShowBonus,
	            doShowTimeAgo: doShowTimeAgo,
	            doShowProductName: true,
	            doShowArrowRight: false })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement(_componentsProductDetails2['default'], { locale: locale, product: product, themeBtnColor: this.props.themeBtnColor })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement(_componentsShareBox2['default'], { doShowShare: this.props.doShowShare, title: bundle.product.social, doShare: this.props.doShare })
	        )
	      );
	    }
	  }, {
	    key: 'getLasts',
	    value: function getLasts() {
	      return _react2['default'].createElement(_componentsLasts2['default'], { locale: this.props.locale, product: this.props.product });
	    }
	  }, {
	    key: 'getTips',
	    value: function getTips() {
	      return _react2['default'].createElement(_componentsTips2['default'], { locale: this.props.locale });
	    }
	  }, {
	    key: 'getLargeLayout',
	    value: function getLargeLayout() {
	      var _props2 = this.props;
	      var locale = _props2.locale;
	      var product = _props2.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	      return _react2['default'].createElement(
	        'div',
	        { className: 'product-desktop' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-35 medium-40 large-pull-right medium-pull-right' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(_componentsConsole2['default'], {
	              doShowConsole: this.props.doShowConsole,
	              locale: locale,
	              themeBgColor: this.props.themeBgColor,
	              themeBtnColor: this.props.themeBtnColor,
	              themeBgFontColor: this.props.themeBgFontColor,
	              themeBtnFontColor: this.props.themeBtnFontColor,
	              message: this.props.message,
	              product: product,
	              goBuildOrder: this.props.goBuildOrder,
	              goPurchase: this.props.goPurchase,
	              doReduce: this.props.doReduce,
	              oldPrice: this.props.oldPrice,
	              doShowBonus: doShowBonus,
	              doShowTimeAgo: doShowTimeAgo,
	              doShowProductName: true,
	              doShowArrowRight: false }),
	            this.getTips(),
	            this.getLasts(),
	            _react2['default'].createElement(_componentsShareBox2['default'], { doShowShare: this.props.doShowShare, title: bundle.product.social, doShare: this.props.doShare })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-65 medium-60 large-pull-left medium-pull-left' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(_componentsProduct2['default'], { showDetails: true, locale: locale, product: product, themeBtnColor: this.props.themeBtnColor, themeBgFontColor: this.props.themeBgFontColor, themeBgColor: this.props.themeBgColor })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, bgColor: this.getBgColor(), sponsor: this.getSponsor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        this.getLucidTutorial(),
	        _react2['default'].createElement(
	          'div',
	          { id: 'product' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-100 medium-100 small-hide' },
	              this.getLargeLayout()
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'small-100 large-hide medium-hide small-show' },
	              this.getSmallLayout()
	            )
	          ),
	          this.getAdvBoxes()
	        )
	      );
	    }
	  }]);
	
	  var _Product = Product;
	  Product = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    oldPrice: _tcombReact.t.maybe(_tcombReact.t.Num),
	    doShowConsole: _tcombReact.t.Bool,
	    doShowShare: _tcombReact.t.Bool,
	    advBoxes: _tcombReact.t.Arr,
	    doReduce: _tcombReact.t.Func,
	    doShare: _tcombReact.t.Func,
	    goBuildOrder: _tcombReact.t.Func,
	    goPurchase: _tcombReact.t.Func,
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goLogin: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goLattices: _tcombReact.t.maybe(_tcombReact.t.Func),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    showLucidTutorial: _tcombReact.t.maybe(_tcombReact.t.Bool),
	    statusLucidTutorial: _tcombReact.t.maybe(_domainStatusLucid2['default'])
	  })(Product) || Product;
	  return Product;
	})(_react2['default'].Component);
	
	exports['default'] = Product;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsFooter = __webpack_require__(294);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var Layout = (function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, _Layout);
	
	    _get(Object.getPrototypeOf(_Layout.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Layout, [{
	    key: 'getPartners',
	    value: function getPartners() {
	      if (_tcombReact.t.Nil.is(this.props.partners)) {
	        return null;
	      }
	
	      var partnersStyle = {
	        textAlign: this.props.partners.align
	      };
	      var logos = this.props.partners.logos.map(function (logo, index) {
	        return _react2['default'].createElement(
	          'a',
	          { key: index, href: logo.link, target: '_self' },
	          _react2['default'].createElement('img', { src: logo.image })
	        );
	      });
	      return _react2['default'].createElement(
	        'div',
	        { id: 'partners', style: partnersStyle },
	        logos
	      );
	    }
	  }, {
	    key: 'getFooter',
	    value: function getFooter() {
	      return _react2['default'].createElement(_componentsFooter2['default'], { locale: this.props.locale, doAcceptCookies: this.props.doAcceptCookies });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var containerHeader1172Style = {
	        backgroundColor: this.props.bgColor,
	        color: this.props.color
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { id: 'modal-container' }),
	        _react2['default'].createElement(
	          'div',
	          { id: 'view' },
	          this.getPartners(),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerHeader1172', style: containerHeader1172Style },
	            _react2['default'].createElement(
	              'div',
	              { id: 'containerHeader960' },
	              this.props.header,
	              this.props.sponsor
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerBody' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'container' },
	              this.props.children
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerFooter' },
	            this.getFooter()
	          ),
	          _react2['default'].createElement('div', { id: 'shield' }),
	          _react2['default'].createElement(
	            'div',
	            { id: 'ajax' },
	            _react2['default'].createElement('div', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Layout = Layout;
	  Layout = (0, _tcombReact.props)({
	    header: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    sponsor: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    children: _tcombReact.t.Any,
	    locale: _domainLocale2['default'],
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Layout) || Layout;
	  return Layout;
	})(_react2['default'].Component);
	
	exports['default'] = Layout;
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGetCopyright = __webpack_require__(295);
	
	var _domainGetCopyright2 = _interopRequireDefault(_domainGetCopyright);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _Conditions = __webpack_require__(296);
	
	var _Conditions2 = _interopRequireDefault(_Conditions);
	
	var _PolicyCookies = __webpack_require__(297);
	
	var _PolicyCookies2 = _interopRequireDefault(_PolicyCookies);
	
	var _HowItWorks = __webpack_require__(298);
	
	var _HowItWorks2 = _interopRequireDefault(_HowItWorks);
	
	var _CookiesDisclaimer = __webpack_require__(299);
	
	var _CookiesDisclaimer2 = _interopRequireDefault(_CookiesDisclaimer);
	
	var _tcombReact = __webpack_require__(168);
	
	var Footer = (function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, _Footer);
	
	    _get(Object.getPrototypeOf(_Footer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'footer' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              (0, _domainGetCopyright2['default'])()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(_Conditions2['default'], { locale: locale })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(_PolicyCookies2['default'], { locale: locale })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(_HowItWorks2['default'], { locale: locale })
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(_CookiesDisclaimer2['default'], { locale: locale, doAcceptCookies: this.props.doAcceptCookies })
	        )
	      );
	    }
	  }]);
	
	  var _Footer = Footer;
	  Footer = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func)
	  })(Footer) || Footer;
	  return Footer;
	})(_react2['default'].Component);
	
	exports['default'] = Footer;
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getCopyright;
	
	function getCopyright() {
	  //return 'Copyright &copy; madai';
	  return 'Copyright © Madai';
	}

	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _tcombReact = __webpack_require__(168);
	
	var Conditions = (function (_React$Component) {
	  _inherits(Conditions, _React$Component);
	
	  function Conditions() {
	    _classCallCheck(this, _Conditions);
	
	    _get(Object.getPrototypeOf(_Conditions.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Conditions, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      function getHref() {
	        if (locale.toJSON() === 'it_IT') {
	          return 'https://it.madai.com/terms.html';
	        } else {
	          return "https://madai.com/terms.html";
	        }
	        /*
	        const _locale = locale.toString();
	        const country = locale.country.toLowerCase();
	        if (_locale === 'en_ZA') {
	          return 'http://za.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'en_US') {
	          return 'http://us.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'it_IT') {
	          return 'http://it.madai.com/FAQ_it.html';
	        }
	        else {
	          return getMadaiURL() + country + '/terms-of-use.html';
	        }*/
	      }
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: getHref() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.conditions
	      );
	    }
	  }]);
	
	  var _Conditions = Conditions;
	  Conditions = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(Conditions) || Conditions;
	  return Conditions;
	})(_react2['default'].Component);
	
	exports['default'] = Conditions;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _tcombReact = __webpack_require__(168);
	
	var PolicyCookies = (function (_React$Component) {
	  _inherits(PolicyCookies, _React$Component);
	
	  function PolicyCookies() {
	    _classCallCheck(this, _PolicyCookies);
	
	    _get(Object.getPrototypeOf(_PolicyCookies.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PolicyCookies, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      function getHref() {
	        if (locale.toJSON() === 'it_IT') {
	          return 'https://it.madai.com/privacy.html';
	        } else {
	          return "https://madai.com/privacy.html";
	        }
	
	        /*const _locale = locale.toString();
	        const country = locale.country.toLowerCase();
	        if (_locale === 'en_ZA') {
	          return 'http://za.shop.madai.com/privacy-policy_en.html';
	        } else if (_locale === 'en_US') {
	          return 'http://us.shop.madai.com/privacy-policy_en.html';
	        } else if (_locale === 'it_IT') {
	          return 'http://it.madai.com/privacy-policy_it.html';
	        }
	        else {
	          return getMadaiURL() + country + '/privacy.html';
	        }*/
	      }
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: getHref() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.policy_cookies
	      );
	    }
	  }]);
	
	  var _PolicyCookies = PolicyCookies;
	  PolicyCookies = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(PolicyCookies) || PolicyCookies;
	  return PolicyCookies;
	})(_react2['default'].Component);
	
	exports['default'] = PolicyCookies;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _tcombReact = __webpack_require__(168);
	
	var HowItWorks = (function (_React$Component) {
	  _inherits(HowItWorks, _React$Component);
	
	  function HowItWorks() {
	    _classCallCheck(this, _HowItWorks);
	
	    _get(Object.getPrototypeOf(_HowItWorks.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HowItWorks, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      function getHref() {
	        if (locale.toJSON() === 'it_IT') {
	          return 'https://it.madai.com/faqs.html';
	        } else {
	          return "https://madai.com/faqs.html";
	        }
	        /*const _locale = locale.toString();
	        const country = locale.country.toLowerCase();
	        if (_locale === 'en_ZA') {
	          return 'http://za.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'en_US') {
	          return 'http://us.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'it_IT') {
	          return 'http://it.madai.com/FAQ_it.html';
	        }
	        else {
	          return getMadaiURL() + country + '/how-it-works.html';
	        }*/
	      }
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: getHref() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.how_it_works
	      );
	    }
	  }]);
	
	  var _HowItWorks = HowItWorks;
	  HowItWorks = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(HowItWorks) || HowItWorks;
	  return HowItWorks;
	})(_react2['default'].Component);
	
	exports['default'] = HowItWorks;
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGetPrivacyURL = __webpack_require__(300);
	
	var _domainGetPrivacyURL2 = _interopRequireDefault(_domainGetPrivacyURL);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _tcombReact = __webpack_require__(168);
	
	var _cookiesJs = __webpack_require__(249);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var CookiesDisclaimer = (function (_React$Component) {
	  _inherits(CookiesDisclaimer, _React$Component);
	
	  function CookiesDisclaimer() {
	    var _this = this;
	
	    _classCallCheck(this, _CookiesDisclaimer);
	
	    _get(Object.getPrototypeOf(_CookiesDisclaimer.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doAcceptCookies = function (evt) {
	      evt.preventDefault();
	
	      if (_this.props.doAcceptCookies && !_this.areCookiesAccepted()) {
	        _this.props.doAcceptCookies();
	      }
	    };
	  }
	
	  _createClass(CookiesDisclaimer, [{
	    key: 'areCookiesAccepted',
	    value: function areCookiesAccepted() {
	      return _cookiesJs2['default'].get('accept_cookies');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.doAcceptCookies) {
	        return null;
	      }
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).footer.cookies_disclaimer;
	      var description = (0, _lodashStringTemplate2['default'])(bundle.description)({
	        privacy_url: (0, _domainGetPrivacyURL2['default'])()
	      });
	
	      if (this.areCookiesAccepted()) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'cookies_disclaimer' },
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            _HTMLComponent2['default'],
	            null,
	            description
	          )
	        ),
	        _react2['default'].createElement(
	          'button',
	          { id: 'do_accept_cookies', onClick: this.doAcceptCookies, className: 'small' },
	          bundle.do_accept_cookies
	        )
	      );
	    }
	  }]);
	
	  var _CookiesDisclaimer = CookiesDisclaimer;
	  CookiesDisclaimer = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func)
	  })(CookiesDisclaimer) || CookiesDisclaimer;
	  return CookiesDisclaimer;
	})(_react2['default'].Component);
	
	exports['default'] = CookiesDisclaimer;
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getPrivacyURL;
	
	function getPrivacyURL() {
	  return 'http://it.madai.com/index.php/norme-sulla-privacy';
	}

	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxesColumn = __webpack_require__(302);
	
	var _BoxesColumn2 = _interopRequireDefault(_BoxesColumn);
	
	var _tcombReact = __webpack_require__(168);
	
	var AdvBoxes = (function (_React$Component) {
	  _inherits(AdvBoxes, _React$Component);
	
	  function AdvBoxes() {
	    _classCallCheck(this, _AdvBoxes);
	
	    _get(Object.getPrototypeOf(_AdvBoxes.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(AdvBoxes, [{
	    key: 'hasAdvBoxes',
	    value: function hasAdvBoxes() {
	      return this.props.advBoxes && this.props.advBoxes.length !== 0;
	    }
	  }, {
	    key: 'getBoxesInLargeColumn',
	    value: function getBoxesInLargeColumn() {
	      return this.props.advBoxes.map(function (advBox, index) {
	        return _react2['default'].createElement(_BoxesColumn2['default'], { key: 'large-' + index, boxes: advBox, width: 'large-33' });
	      });
	    }
	  }, {
	    key: 'getBoxesInSmallColumn',
	    value: function getBoxesInSmallColumn() {
	      return this.props.advBoxes.map(function (advBox, index) {
	        return _react2['default'].createElement(_BoxesColumn2['default'], { key: 'small-' + index, boxes: advBox, width: 'small-100' });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (!this.hasAdvBoxes()) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'adv_boxes' },
	        _react2['default'].createElement(
	          'h2',
	          null,
	          this.props.title
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'small-hide' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            this.getBoxesInLargeColumn()
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-hide medium-hide small-show' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            this.getBoxesInSmallColumn()
	          )
	        )
	      );
	    }
	  }]);
	
	  var _AdvBoxes = AdvBoxes;
	  AdvBoxes = (0, _tcombReact.props)({
	    advBoxes: _tcombReact.t.Arr,
	    title: _tcombReact.t.Str
	  })(AdvBoxes) || AdvBoxes;
	  return AdvBoxes;
	})(_react2['default'].Component);
	
	exports['default'] = AdvBoxes;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(168);
	
	var BoxesColumn = (function (_React$Component) {
	  _inherits(BoxesColumn, _React$Component);
	
	  function BoxesColumn() {
	    _classCallCheck(this, _BoxesColumn);
	
	    _get(Object.getPrototypeOf(_BoxesColumn.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(BoxesColumn, [{
	    key: 'getContainerClasses',
	    value: function getContainerClasses() {
	      var width = this.props.width;
	
	      return (0, _classnames2['default'])({
	        'large-50': width === 'large-50',
	        'large-33': width === 'large-33',
	        'small-100': width === 'small-100'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: this.getContainerClasses() },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          this.props.boxes
	        )
	      );
	    }
	  }]);
	
	  var _BoxesColumn = BoxesColumn;
	  BoxesColumn = (0, _tcombReact.props)({
	    width: _tcombReact.t.Str,
	    boxes: _tcombReact.t.Any
	  })(BoxesColumn) || BoxesColumn;
	  return BoxesColumn;
	})(_react2['default'].Component);
	
	exports['default'] = BoxesColumn;
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var AdvBox = (function (_React$Component) {
	  _inherits(AdvBox, _React$Component);
	
	  function AdvBox() {
	    _classCallCheck(this, _AdvBox);
	
	    _get(Object.getPrototypeOf(_AdvBox.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(AdvBox, [{
	    key: 'render',
	    value: function render() {
	      var title = this.props.title;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'adv_box border-radius-all', onClick: this.props.onClick },
	        _react2['default'].createElement('img', { alt: title, src: this.props.image }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'caption' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            title
	          )
	        )
	      );
	    }
	  }]);
	
	  var _AdvBox = AdvBox;
	  AdvBox = (0, _tcombReact.props)({
	    title: _tcombReact.t.Str,
	    image: _tcombReact.t.Str,
	    onClick: _tcombReact.t.Func
	  })(AdvBox) || AdvBox;
	  return AdvBox;
	})(_react2['default'].Component);
	
	exports['default'] = AdvBox;
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var Sponsor = (function (_React$Component) {
	  _inherits(Sponsor, _React$Component);
	
	  function Sponsor() {
	    _classCallCheck(this, _Sponsor);
	
	    _get(Object.getPrototypeOf(_Sponsor.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Sponsor, [{
	    key: 'hasSponsor',
	    value: function hasSponsor() {
	      return !!this.props.sponsor;
	    }
	  }, {
	    key: 'useWelcomeSponsor',
	    value: function useWelcomeSponsor() {
	      return !!this.props.options.isWelcome;
	    }
	  }, {
	    key: 'showTutorial',
	    value: function showTutorial() {
	      return !!this.props.options.showTutorial;
	    }
	  }, {
	    key: 'getDefaultImages',
	    value: function getDefaultImages() {
	      return {
	        logo: _react2['default'].createElement('img', { className: 'large-100', src: 'https://static.madai.com/pub/default_images_sponsor_madai/logo_madai_new.jpeg' }),
	        cover: _react2['default'].createElement('img', { className: 'large-100 large-pull-left', src: 'https://static.madai.com/pub/default_images_sponsor_madai/cover_image_new.jpg' }),
	        tutorial: null //(this.showTutorial()) ? <img className='large-100' src="https://static.madai.com/pub/default_images_sponsor_madai/tutorial_red.jpg" /> : null
	      };
	    }
	  }, {
	    key: 'getLogo',
	    value: function getLogo() {
	      if (this.useWelcomeSponsor()) {
	        return this.props.sponsor.welcome_logo || this.props.sponsor.logo;
	      } else {
	        return this.props.sponsor.logo;
	      }
	    }
	  }, {
	    key: 'getCover',
	    value: function getCover() {
	      if (this.useWelcomeSponsor()) {
	        return this.props.sponsor.welcome_image || this.props.sponsor.image;
	      } else {
	        return this.props.sponsor.image;
	      }
	    }
	  }, {
	    key: 'getTutorialImage',
	    value: function getTutorialImage() {
	      if (!this.showTutorial()) {
	        return null;
	      }
	      var src = this.getTutorialSrc();
	      if (_tcombReact.t.Nil.is(src)) {
	        return null;
	      }
	      return _react2['default'].createElement('img', { className: 'large-100', src: src });
	    }
	  }, {
	    key: 'getTutorialSrc',
	    value: function getTutorialSrc() {
	      if (this.useWelcomeSponsor()) {
	        return this.props.sponsor.welcome_tutorial || this.props.sponsor.tutorial;
	      } else {
	        return this.props.sponsor.tutorial;
	      }
	    }
	  }, {
	    key: 'getImages',
	    value: function getImages() {
	      if (!this.hasSponsor()) {
	        return this.getDefaultImages();
	      }
	      return {
	        logo: _react2['default'].createElement('img', { className: 'large-100', src: this.getLogo() }),
	        cover: _react2['default'].createElement('img', { className: 'large-100 large-pull-left', src: this.getCover() }),
	        tutorial: this.getTutorialImage()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var images = this.getImages();
	      return _react2['default'].createElement(
	        'div',
	        { id: 'sponsor' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100 small-hide' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-pull-left logo' },
	              images.logo
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-pull-left cover' },
	              images.cover
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'tutorial small-hide' },
	            images.tutorial
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Sponsor = Sponsor;
	  Sponsor = (0, _tcombReact.props)({
	    isWelcome: _tcombReact.t.maybe(_tcombReact.t.Bool),
	    locale: _tcombReact.t.Obj,
	    sponsor: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    options: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Sponsor) || Sponsor;
	  return Sponsor;
	})(_react2['default'].Component);
	
	exports['default'] = Sponsor;
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _Media = __webpack_require__(306);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _utilFormatDiscount = __webpack_require__(307);
	
	var _utilFormatDiscount2 = _interopRequireDefault(_utilFormatDiscount);
	
	var _utilPercentage = __webpack_require__(308);
	
	var _utilPercentage2 = _interopRequireDefault(_utilPercentage);
	
	var _utilFormatTimeAgo = __webpack_require__(309);
	
	var _utilFormatTimeAgo2 = _interopRequireDefault(_utilFormatTimeAgo);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _utilAnimatePrice = __webpack_require__(310);
	
	var _utilAnimatePrice2 = _interopRequireDefault(_utilAnimatePrice);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Console = (function (_React$Component) {
	  _inherits(Console, _React$Component);
	
	  function Console() {
	    var _this = this;
	
	    _classCallCheck(this, _Console);
	
	    _get(Object.getPrototypeOf(_Console.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goBuildOrder = function (evt) {
	      if (_this.props.product.min_buy_price && _this.props.product.runtime.price > _this.props.product.min_buy_price) {
	        evt.preventDefault();
	      } else {
	        evt.preventDefault();
	        _this.props.goBuildOrder();
	      }
	    };
	
	    this.doReduce = function (evt) {
	      evt.preventDefault();
	      _this.props.doReduce();
	    };
	
	    this.getButtonReduce = function () {
	      if (!_this.props.doReduce) {
	        return null;
	      }
	      var bundle = (0, _domainGet_bundle2['default'])(_this.props.locale).product;
	      return _react2['default'].createElement(
	        'button',
	        { id: 'do_reduce', onClick: _this.doReduce, className: 'big', style: _this.styleBtnColorConsole() },
	        bundle.console.do_reduce
	      );
	    };
	
	    this.getProductName = function () {
	      if (!_this.props.doShowProductName) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'h2',
	        { className: 'large-hide small-show' },
	        _this.props.product.name
	      );
	    };
	  }
	
	  _createClass(Console, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // 25, 23.5
	      //animatePrice(this.props.product.list_price, this.props.product.runtime.price, this.props.product);
	      (0, _utilAnimatePrice2['default'])(this.props.product.list_price, this.props.product.runtime.price, this.props.product);
	    }
	  }, {
	    key: 'styleBgColorConsole',
	    value: function styleBgColorConsole() {
	      return {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	    }
	  }, {
	    key: 'styleBtnColorConsole',
	    value: function styleBtnColorConsole() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'styleBorderRxColorConsole',
	    value: function styleBorderRxColorConsole() {
	      return { borderRightColor: this.props.themeBgColor };
	    }
	  }, {
	    key: 'styleBorderSxColorConsole',
	    value: function styleBorderSxColorConsole() {
	      return { borderLeftColor: this.props.themeBgColor };
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount() {
	      return this.props.product.format_amount(this.props.locale, this.props.product.list_price - this.props.product.runtime.price);
	    }
	  }, {
	    key: 'getTimeAgo',
	    value: function getTimeAgo() {
	      if (!this.props.doShowTimeAgo) {
	        return null;
	      }
	
	      var locale = this.props.locale;
	      //fixme
	      var timeagoLabel = (0, _lodashStringTemplate2['default'])((0, _domainGet_bundle2['default'])(locale).product.console.timeago)({
	        timeago: ""
	      });
	      var timeagoValue = (0, _utilFormatTimeAgo2['default'])(locale, this.props.product.runtime.delta);
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Media2['default'],
	          { className: 'timeago' },
	          timeagoLabel
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          timeagoValue
	        )
	      );
	    }
	  }, {
	    key: 'getPrice',
	    value: function getPrice() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	      var oldPrice = _props.oldPrice;
	
	      var price = !_tcombReact.t.Nil.is(oldPrice) ? oldPrice : product.runtime.price;
	      return product.format_amount(locale, price);
	    }
	  }, {
	    key: 'getBonus',
	    value: function getBonus() {
	      if (!this.props.doShowBonus) {
	        return null;
	      }
	
	      if (!this.props.product.runtime.bonus) {
	        return null;
	      }
	
	      var _props2 = this.props;
	      var locale = _props2.locale;
	      var product = _props2.product;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Media2['default'],
	          { className: 'bonus' },
	          _react2['default'].createElement(
	            'font',
	            { className: 'bonus-label' },
	            _react2['default'].createElement(
	              _HTMLComponent2['default'],
	              null,
	              (0, _domainGet_bundle2['default'])(locale).product.console.bonus
	            )
	          ),
	          '  ',
	          product.format_amount(locale, product.runtime.bonus)
	        )
	      );
	    }
	  }, {
	    key: 'getArrowLeft',
	    value: function getArrowLeft() {
	      if (this.props.message || this.props.doShowArrowRight) {
	        return null;
	      }
	      return _react2['default'].createElement('div', { className: 'triangle-left small-hide', style: this.styleBorderRxColorConsole() });
	    }
	  }, {
	    key: 'getArrowRight',
	    value: function getArrowRight() {
	      if (!this.props.doShowArrowRight) {
	        return null;
	      }
	      return _react2['default'].createElement('div', { className: 'triangle-right small-hide', style: this.styleBorderSxColorConsole() });
	    }
	  }, {
	    key: 'getAction',
	    value: function getAction() {
	      var product = this.props.product;
	
	      if (product.runtime.payments_overflow) {
	        return this.getPaymentsOverflowLink();
	      }
	      if (product.runtime.is_max_items_overflow) {
	        return this.getMaxItemsOverflowLabel();
	      }
	      return this.getBuildOrderButton();
	    }
	  }, {
	    key: 'getPaymentsOverflowLink',
	    value: function getPaymentsOverflowLink() {
	      var console_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).product.console;
	
	      var paymentOverflowLabel = console_bundle.payments_overflow[0];
	      var paymentOverflowValue = console_bundle.payments_overflow[1];
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Media2['default'],
	          { className: 'no-cart' },
	          paymentOverflowLabel
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', id: 'go_purchase', onClick: this.goPurchase.bind(this, this.props.product.runtime.payments_overflow) },
	            paymentOverflowValue
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getMaxItemsOverflowLabel',
	    value: function getMaxItemsOverflowLabel() {
	      var is_max_items_overflow = (0, _domainGet_bundle2['default'])(this.props.locale).product.console.is_max_items_overflow.split("\n");
	
	      var maxItemsOverflowLabel = is_max_items_overflow[0];
	      var maxItemsOverflowValue = is_max_items_overflow[1];
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Media2['default'],
	          { className: 'no-cart' },
	          maxItemsOverflowLabel
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          maxItemsOverflowValue
	        )
	      );
	    }
	  }, {
	    key: 'getBuildOrderButton',
	    value: function getBuildOrderButton() {
	      var style = {
	        color: this.props.themeBgFontColor,
	        border: '1px solid ' + this.props.themeBgFontColor
	      };
	
	      var _classname = (0, _classnames2['default'])({
	        'button_transparent': true,
	        'disabled': this.props.product.min_buy_price && this.props.product.runtime.price > this.props.product.min_buy_price
	      });
	
	      return _react2['default'].createElement(
	        'center',
	        null,
	        _react2['default'].createElement(
	          'button',
	          { id: 'go_build_order', className: _classname, style: style, onClick: this.goBuildOrder, href: '#' },
	          this.props.product.getBuyButtonLabel(this.props.locale)
	        ),
	        this.getBuilderButtonText()
	      );
	    }
	  }, {
	    key: 'getBuilderButtonText',
	    value: function getBuilderButtonText() {
	      if (!this.props.product.min_buy_price) {
	        return null;
	      }
	      if (this.props.product.runtime.price > this.props.product.min_buy_price) {
	
	        var label = (0, _lodashStringTemplate2['default'])((0, _domainGet_bundle2['default'])(this.props.locale).product.console.min_buy_price_text)({
	          min_buy_price: this.props.product.format_amount(this.props.locale, this.props.product.min_buy_price)
	        });
	
	        return _react2['default'].createElement(
	          'div',
	          { style: { marginTop: "10px", color: "#aaa" } },
	          _react2['default'].createElement(
	            'b',
	            null,
	            label
	          )
	        );
	      }
	    }
	  }, {
	    key: 'goPurchase',
	    value: function goPurchase(purchaseId, evt) {
	      evt.preventDefault();
	      this.props.goPurchase(purchaseId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.doShowConsole) {
	        return null;
	      }
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).product;
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'console', style: this.styleBgColorConsole() },
	        this.props.message,
	        _react2['default'].createElement(
	          'div',
	          { className: 'box' },
	          this.getProductName(),
	          _react2['default'].createElement(
	            'h1',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              bundle.console.price
	            ),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement(
	              'span',
	              { id: 'price' },
	              this.getDiscount()
	            )
	          ),
	          _react2['default'].createElement(
	            'h4',
	            { id: 'discount', style: { marginBottom: "10px" } },
	            bundle.console.cash_or_buy,
	            this.getPrice()
	          ),
	          this.getButtonReduce(),
	          this.getTimeAgo(),
	          this.getBonus(),
	          this.getAction(),
	          this.getArrowLeft(),
	          this.getArrowRight()
	        )
	      );
	    }
	  }]);
	
	  var _Console = Console;
	  Console = (0, _tcombReact.props)({
	    doShowConsole: _tcombReact.t.Bool,
	    locale: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    product: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    goPurchase: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goBuildOrder: _tcombReact.t.maybe(_tcombReact.t.Func),
	    doReduce: _tcombReact.t.maybe(_tcombReact.t.Func),
	    oldPrice: _tcombReact.t.maybe(_domainAmount2['default']),
	    doShowTimeAgo: _tcombReact.t.Bool,
	    doShowBonus: _tcombReact.t.Bool,
	    doShowProductName: _tcombReact.t.Bool,
	    doShowArrowRight: _tcombReact.t.Bool
	  })(Console) || Console;
	  return Console;
	})(_react2['default'].Component);
	
	exports['default'] = Console;
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(168);
	
	var Media = (function (_React$Component) {
	  _inherits(Media, _React$Component);
	
	  function Media() {
	    _classCallCheck(this, _Media);
	
	    _get(Object.getPrototypeOf(_Media.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Media, [{
	    key: 'getClasses',
	    value: function getClasses() {
	      var className = this.props.className;
	      var classes = {
	        'media': true
	      };
	      classes[className] = 'true';
	      return (0, _classnames2['default'])(classes);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: this.getClasses() },
	        _react2['default'].createElement(
	          'div',
	          { className: 'media-left' },
	          _react2['default'].createElement('div', { className: 'icon' })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'media-right' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  var _Media = Media;
	  Media = (0, _tcombReact.props)({
	    children: _tcombReact.t.Any,
	    className: _tcombReact.t.Str
	  })(Media) || Media;
	  return Media;
	})(_react2['default'].Component);
	
	exports['default'] = Media;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = format_discount;
	
	function format_discount(locale, discount) {
	  return locale.format_number(discount) + '%';
	}

	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = percentage;
	
	function percentage(total, part) {
	  if (total === 0) {
	    // salvo l'universo evitando una divisione per zero
	    return 0;
	  }
	  return 100 * (part - total) / total;
	}

	module.exports = exports["default"];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = format_timeago;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	function format_timeago(locale, delta) {
	  var seconds = delta / 1000;
	  var minutes = seconds / 60;
	  var hours = minutes / 60;
	  var days = hours / 24;
	  var bundle = (0, _domainGet_bundle2['default'])(locale).timeago;
	
	  return days > 3 ? (0, _lodashStringTemplate2['default'])(bundle.days3)({}) : days > 1 ? (0, _lodashStringTemplate2['default'])(bundle.days)({
	    dd: locale.format_integer(days)
	  }) : hours > 1 ? (0, _lodashStringTemplate2['default'])(bundle.hours)({
	    hh: locale.format_integer(hours)
	  }) : minutes > 1 ? (0, _lodashStringTemplate2['default'])(bundle.minutes)({
	    mm: locale.format_integer(minutes)
	  }) : bundle.seconds;
	}

	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = animatePrice;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _percentage = __webpack_require__(308);
	
	var _percentage2 = _interopRequireDefault(_percentage);
	
	var _formatDiscount = __webpack_require__(307);
	
	var _formatDiscount2 = _interopRequireDefault(_formatDiscount);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function animatePrice(from, to, product) {
	  to = from - to; //0.1
	  from = 0; // 0
	  _tcomb2['default'].assert(_tcomb2['default'].maybe(_domainAmount2['default']).is(from));
	  _tcomb2['default'].assert(_domainAmount2['default'].is(to));
	  _tcomb2['default'].assert(_domainProduct2['default'].is(product));
	
	  var timeout = undefined;
	
	  //const duration = 25;
	  //const rate = 5;
	  // const duration = 2000;
	  // const rate = 300;
	  var duration = 50;
	  var rate = 10;
	  var durationFadeIn = 700;
	  var $price = $('#console #price');
	  var $discount = $('#console #discount');
	  var $do_reduce = $('#console #do_reduce');
	  var $timeago = $('#console .clock');
	  var _t = 0;
	  var aumento_rate = duration / rate; // 5
	  var aumento = 0 + to; // 5
	  var aumento_valore = aumento / aumento_rate; // 1
	
	  var next_price = function next_price(_t) {
	    var v = _t * aumento_valore / rate;
	
	    return v;
	  };
	
	  var go = function go(rate) {
	    timeout = setTimeout(function () {
	      _t += aumento_rate;
	      var list_price_calculated = product.list_price; //25
	      var runtime_price_calculated = product.runtime.price;
	      var price_calculated = list_price_calculated - runtime_price_calculated;
	
	      // da testare il seguente
	      $price.html(product.format_amount(product.locale, next_price(_t)));
	      // corretto senza animazione
	      // $price.html(product.format_amount(product.locale, price_calculated))
	      if (_t < duration) {
	        go(_t);
	      } else {
	        // $discount.html(formatDiscount(product.locale, percentage(product.list_price, to))).css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
	        $discount.html("Cash out or buy at " + product.format_amount(product.locale, runtime_price_calculated)).css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
	        $do_reduce.css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
	        $timeago.css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
	      }
	    }, rate);
	  };
	
	  if (!_tcomb2['default'].Nil.is(from)) {
	    // se il prezzo non è cambiato, animazione per il goodfellow
	    if (from === to) {
	      $price.hide().fadeTo(durationFadeIn, 1);
	      $discount.hide().fadeTo(durationFadeIn, 1);
	      $do_reduce.hide().fadeTo(durationFadeIn, 1);
	    } else {
	      $discount.css('visibility', 'hidden');
	      $do_reduce.css('visibility', 'hidden');
	      $timeago.css('visibility', 'hidden');
	      go(rate);
	      return timeout;
	    }
	  }
	}

	module.exports = exports['default'];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _ProductCard = __webpack_require__(312);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	var _ProductDetails = __webpack_require__(314);
	
	var _ProductDetails2 = _interopRequireDefault(_ProductDetails);
	
	var _tcombReact = __webpack_require__(168);
	
	var Product = (function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product() {
	    _classCallCheck(this, _Product);
	
	    _get(Object.getPrototypeOf(_Product.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Product, [{
	    key: 'getDetails',
	    value: function getDetails() {
	      if (!this.props.showDetails) {
	        return null;
	      }
	
	      return _react2['default'].createElement(_ProductDetails2['default'], { locale: this.props.locale, product: this.props.product, themeBtnColor: this.props.themeBtnColor });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'product-display' },
	        _react2['default'].createElement(_ProductCard2['default'], { locale: this.props.locale, product: this.props.product, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor }),
	        this.getDetails()
	      );
	    }
	  }]);
	
	  var _Product = Product;
	  Product = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    showDetails: _tcombReact.t.Bool
	  })(Product) || Product;
	  return Product;
	})(_react2['default'].Component);
	
	exports['default'] = Product;
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _ProductBand = __webpack_require__(313);
	
	var _ProductBand2 = _interopRequireDefault(_ProductBand);
	
	var _tcombReact = __webpack_require__(168);
	
	var ProductCard = (function (_React$Component) {
	  _inherits(ProductCard, _React$Component);
	
	  function ProductCard() {
	    _classCallCheck(this, _ProductCard);
	
	    _get(Object.getPrototypeOf(_ProductCard.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProductCard, [{
	    key: 'render',
	    value: function render() {
	      var product = this.props.product;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'product_card' },
	        _react2['default'].createElement('img', { alt: product.name, src: product.image }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'product_header' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            product.name
	          ),
	          _react2['default'].createElement(
	            'h2',
	            null,
	            product.description
	          )
	        ),
	        _react2['default'].createElement(_ProductBand2['default'], { locale: this.props.locale, product: this.props.product, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor })
	      );
	    }
	  }]);
	
	  var _ProductCard = ProductCard;
	  ProductCard = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(ProductCard) || ProductCard;
	  return ProductCard;
	})(_react2['default'].Component);
	
	exports['default'] = ProductCard;
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _tcombReact = __webpack_require__(168);
	
	var ProductBand = (function (_React$Component) {
	  _inherits(ProductBand, _React$Component);
	
	  function ProductBand() {
	    _classCallCheck(this, _ProductBand);
	
	    _get(Object.getPrototypeOf(_ProductBand.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProductBand, [{
	    key: 'getListPrice',
	    value: function getListPrice() {
	      return _domainAmount2['default'].format(this.props.locale, this.props.product.currency, this.props.product.list_price);
	    }
	  }, {
	    key: 'getCurrency',
	    value: function getCurrency() {
	      return this.props.locale.locale_bundle().currency[this.props.product.currency];
	    }
	  }, {
	    key: 'getBestDeal',
	    value: function getBestDeal() {
	      return this.props.locale.format_integer(this.props.product.runtime.best.price);
	    }
	  }, {
	    key: 'getBestDealIcon',
	    value: function getBestDealIcon() {
	      if (!this.props.product.runtime || !this.props.product.runtime.best) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: 'best_deal' },
	        _react2['default'].createElement(
	          'div',
	          null,
	          (0, _domainGet_bundle2['default'])(this.props.locale).product.best_deal,
	          _react2['default'].createElement('br', null),
	          this.getCurrency(),
	          ' ',
	          this.getBestDeal()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styleBand = {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	      return _react2['default'].createElement(
	        'div',
	        { className: 'product_band', style: styleBand },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _react2['default'].createElement(
	            'del',
	            null,
	            this.getListPrice()
	          )
	        ),
	        this.getBestDealIcon()
	      );
	    }
	  }]);
	
	  var _ProductBand = ProductBand;
	  ProductBand = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(ProductBand) || ProductBand;
	  return ProductBand;
	})(_react2['default'].Component);
	
	exports['default'] = ProductBand;
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _ProductConditions = __webpack_require__(315);
	
	var _ProductConditions2 = _interopRequireDefault(_ProductConditions);
	
	var _ProductShippings = __webpack_require__(170);
	
	var _ProductShippings2 = _interopRequireDefault(_ProductShippings);
	
	var _ProductCustomPayments = __webpack_require__(317);
	
	var _ProductCustomPayments2 = _interopRequireDefault(_ProductCustomPayments);
	
	var _ProductPayments = __webpack_require__(319);
	
	var _ProductPayments2 = _interopRequireDefault(_ProductPayments);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _tcombReact = __webpack_require__(168);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ProductDetails = (function (_React$Component) {
	  _inherits(ProductDetails, _React$Component);
	
	  function ProductDetails() {
	    var _this = this;
	
	    _classCallCheck(this, _ProductDetails);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_ProductDetails.prototype), 'constructor', this).apply(this, args);
	
	    this.changeTab = function (newTab, evt) {
	      if (evt) {
	        evt.preventDefault();
	      }
	      _this.setState({ selected: newTab });
	    };
	
	    this.getClasses = function (tab) {
	      return (0, _classnames2['default'])({
	        'tabcontent': true,
	        'active': _this.state.selected === tab
	      });
	    };
	
	    this.getStyle = function (tab) {
	      if (tab !== _this.state.selected) {
	        return {
	          width: '25%',
	          fontWeight: 'normal'
	        };
	      }
	      return {
	        width: '25%',
	        fontWeight: 'normal',
	        borderBottom: '5px solid ' + _this.props.themeBtnColor
	      };
	    };
	
	    this.state = {
	      selected: 'details',
	      themeBtnColor: this.props.themeBtnColor || '#333'
	    };
	  }
	
	  /*componentWillReceiveProps = function (nextProps) {
	    if (nextProps.themeBtnColor !== this.state.themeBtnColor) {
	      this.setState({
	        themeBtnColor: nextProps.themeBtnColor
	      })
	    }
	  }*/
	
	  _createClass(ProductDetails, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var product = _props.product;
	      var locale = _props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	
	      var tabDetailsClasses = (0, _classnames2['default'])({
	        'tablinks': true,
	        'active': this.state.selected === 'details'
	      });
	
	      var tabConditionsClasses = (0, _classnames2['default'])({
	        'tablinks': true,
	        'active': this.state.selected === 'conditions'
	      });
	
	      var tabShippingsClasses = (0, _classnames2['default'])({
	        'tablinks': true,
	        'active': this.state.selected === 'shippings'
	      });
	
	      var tabPaymentsClasses = (0, _classnames2['default'])({
	        'tablinks': true,
	        'active': this.state.selected === 'payments'
	      });
	
	      var detailsClasses = (0, _classnames2['default'])({
	        'tabcontent': true,
	        'active': this.state.selected === 'details'
	      });
	
	      var conditionsClasses = (0, _classnames2['default'])({
	        'tabcontent': true,
	        'active': this.state.selected === 'conditions'
	      });
	
	      var shippingsClasses = (0, _classnames2['default'])({
	        'tabcontent': true,
	        'active': this.state.selected === 'shippings'
	      });
	
	      var paymentsClasses = (0, _classnames2['default'])({
	        'tabcontent': true,
	        'active': this.state.selected === 'payments'
	      });
	
	      var tabDetailsStyle = this.getStyle('details');
	      var tabConditionsStyle = this.getStyle('conditions');
	      var tabShippingsStyle = this.getStyle('shippings');
	      var tabPaymentsStyle = this.getStyle('payments');
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'light product_details' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'tab' },
	          _react2['default'].createElement(
	            'button',
	            { style: this.getStyle('details'), className: tabDetailsClasses, onClick: this.changeTab.bind(this, 'details') },
	            bundle.product.product.details
	          ),
	          _react2['default'].createElement(
	            'button',
	            { style: this.getStyle('conditions'), className: tabConditionsClasses, onClick: this.changeTab.bind(this, 'conditions') },
	            bundle.product.product.conditions.title
	          ),
	          _react2['default'].createElement(
	            'button',
	            { style: this.getStyle('shippings'), className: tabShippingsClasses, onClick: this.changeTab.bind(this, 'shippings') },
	            bundle.product.product.shippings
	          ),
	          _react2['default'].createElement(
	            'button',
	            { style: this.getStyle('payments'), className: tabPaymentsClasses, onClick: this.changeTab.bind(this, 'payments') },
	            bundle.product.product.payments
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { id: 'details', className: detailsClasses },
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            product.details
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { id: 'conditions', className: conditionsClasses },
	          _react2['default'].createElement(_ProductConditions2['default'], { locale: locale, product: product })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { id: 'shippings', className: shippingsClasses },
	          _react2['default'].createElement(_ProductShippings2['default'], { locale: locale, product: product })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { id: 'payments', className: paymentsClasses },
	          _react2['default'].createElement(_ProductCustomPayments2['default'], { locale: locale, customPayments: product.custom_payments }),
	          _react2['default'].createElement(_ProductPayments2['default'], { locale: locale, payments: product.payments })
	        )
	      );
	
	      /*return (
	        <div className="box light product_details">
	          <h3>{bundle.product.product.details}</h3>
	          <MarkdownComponent>{product.details}</MarkdownComponent>
	          <h3>{bundle.product.product.conditions.title}</h3>
	          <ProductConditions locale={locale} product={product}/>
	          <h3>{bundle.order.shippings.title}</h3>
	          <ProductShippings locale={locale} product={product}/>
	          <h3>{bundle.product.product.payments}</h3>
	          <ProductCustomPayments locale={locale} customPayments={product.custom_payments}/>
	          <ProductPayments locale={locale} payments={product.payments}/>
	        </div>
	      );*/
	    }
	  }]);
	
	  var _ProductDetails = ProductDetails;
	  ProductDetails = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(ProductDetails) || ProductDetails;
	  return ProductDetails;
	})(_react2['default'].Component);
	
	exports['default'] = ProductDetails;
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _tcombReact = __webpack_require__(168);
	
	var _StdTable = __webpack_require__(316);
	
	var _StdTable2 = _interopRequireDefault(_StdTable);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var ProductConditions = (function (_React$Component) {
	  _inherits(ProductConditions, _React$Component);
	
	  function ProductConditions() {
	    _classCallCheck(this, _ProductConditions);
	
	    _get(Object.getPrototypeOf(_ProductConditions.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProductConditions, [{
	    key: 'getDisplayShippingCountries',
	    value: function getDisplayShippingCountries() {
	      var _this = this;
	
	      return this.props.product.shipping_countries().map(function (c) {
	        return _this.props.locale.display_country(c);
	      }).join(', ');
	    }
	  }, {
	    key: 'getRows',
	    value: function getRows() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).product.product.conditions;
	
	      return [[bundle.end_date, (0, _lodashStringTemplate2['default'])(bundle.end_date_value)({
	        date: locale.format_date(product.end_date)
	      })], [bundle.nr_items, locale.format_integer(product.nr_items)], [bundle.max_items, locale.format_integer(product.max_items)], [bundle.min_price, product.is_min_price_hidden ? null : product.format_amount(locale, product.min_price)], [bundle.countries, !product.is_coupon ? this.getDisplayShippingCountries() : null], [bundle.gift_card, product.gift_card_not_supported ? " " : null], [bundle.bonus, product.bonus_not_supported ? " " : null]];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _StdTable2['default'],
	        null,
	        this.getRows()
	      );
	    }
	  }]);
	
	  var _ProductConditions = ProductConditions;
	  ProductConditions = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default']
	  })(ProductConditions) || ProductConditions;
	  return ProductConditions;
	})(_react2['default'].Component);
	
	exports['default'] = ProductConditions;
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var StdTable = (function (_React$Component) {
	  _inherits(StdTable, _React$Component);
	
	  function StdTable() {
	    _classCallCheck(this, _StdTable);
	
	    _get(Object.getPrototypeOf(_StdTable.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StdTable, [{
	    key: 'getRow',
	    value: function getRow(_ref, index) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var label = _ref2[0];
	      var value = _ref2[1];
	
	      if (_tcombReact.t.Nil.is(value)) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'tr',
	        { key: index },
	        _react2['default'].createElement(
	          'td',
	          { className: 'std-table-label' },
	          label
	        ),
	        _react2['default'].createElement(
	          'td',
	          { className: 'std-table-value' },
	          value
	        )
	      );
	    }
	  }, {
	    key: 'getRows',
	    value: function getRows() {
	      return this.props.children.map(this.getRow);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'table',
	        { className: 'std-table' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.getRows()
	        )
	      );
	    }
	  }]);
	
	  var _StdTable = StdTable;
	  StdTable = (0, _tcombReact.props)({
	    children: _tcombReact.t.Arr
	  })(StdTable) || StdTable;
	  return StdTable;
	})(_react2['default'].Component);
	
	exports['default'] = StdTable;
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _StdCustomPayment = __webpack_require__(318);
	
	var _StdCustomPayment2 = _interopRequireDefault(_StdCustomPayment);
	
	var _tcombReact = __webpack_require__(168);
	
	var ProductCustomPayments = (function (_React$Component) {
	  _inherits(ProductCustomPayments, _React$Component);
	
	  function ProductCustomPayments() {
	    _classCallCheck(this, _ProductCustomPayments);
	
	    _get(Object.getPrototypeOf(_ProductCustomPayments.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProductCustomPayments, [{
	    key: 'getCustomPayment',
	    value: function getCustomPayment(image, description, index) {
	      return _react2['default'].createElement(_StdCustomPayment2['default'], { key: index, description: description, image: image });
	    }
	  }, {
	    key: 'getCustomPayments',
	    value: function getCustomPayments() {
	      var _this = this;
	
	      return this.props.customPayments.map(function (customPayment, index) {
	        return _this.getCustomPayment(customPayment.image, customPayment.description, index);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.customPayments) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.getCustomPayments()
	      );
	    }
	  }]);
	
	  var _ProductCustomPayments = ProductCustomPayments;
	  ProductCustomPayments = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    customPayments: _tcombReact.t.maybe(_tcombReact.t.Arr)
	  })(ProductCustomPayments) || ProductCustomPayments;
	  return ProductCustomPayments;
	})(_react2['default'].Component);
	
	exports['default'] = ProductCustomPayments;
	module.exports = exports['default'];

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var StdCustomPayment = (function (_React$Component) {
	  _inherits(StdCustomPayment, _React$Component);
	
	  function StdCustomPayment() {
	    _classCallCheck(this, _StdCustomPayment);
	
	    _get(Object.getPrototypeOf(_StdCustomPayment.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StdCustomPayment, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'custom' },
	          _react2['default'].createElement('img', { src: this.props.image })
	        ),
	        _react2['default'].createElement(
	          _MarkdownComponent2['default'],
	          null,
	          this.props.description
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _StdCustomPayment = StdCustomPayment;
	  StdCustomPayment = (0, _tcombReact.props)({
	    image: _domainURL2['default'],
	    description: _tcombReact.t.Str
	  })(StdCustomPayment) || StdCustomPayment;
	  return StdCustomPayment;
	})(_react2['default'].Component);
	
	exports['default'] = StdCustomPayment;
	module.exports = exports['default'];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var ProductPayments = (function (_React$Component) {
	  _inherits(ProductPayments, _React$Component);
	
	  function ProductPayments() {
	    _classCallCheck(this, _ProductPayments);
	
	    _get(Object.getPrototypeOf(_ProductPayments.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProductPayments, [{
	    key: 'getPayment',
	    value: function getPayment(type, description, index) {
	      return _react2['default'].createElement(
	        'div',
	        { key: index },
	        _react2['default'].createElement('div', { className: type }),
	        _react2['default'].createElement(
	          _MarkdownComponent2['default'],
	          null,
	          description
	        )
	      );
	    }
	  }, {
	    key: 'getPayments',
	    value: function getPayments() {
	      var _this = this;
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).payment;
	      var payments = this.props.payments;
	      var clonePayments = [].concat(_toConsumableArray(payments));
	
	      return clonePayments.sort().reverse().map(function (type, index) {
	        return _this.getPayment(type, bundle[type], index);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.payments) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.getPayments()
	      );
	    }
	  }]);
	
	  var _ProductPayments = ProductPayments;
	  ProductPayments = (0, _tcombReact.props)({
	    locale: _tcombReact.t.Obj,
	    payments: _tcombReact.t.maybe(_tcombReact.t.list(_tcombReact.t.Str))
	  })(ProductPayments) || ProductPayments;
	  return ProductPayments;
	})(_react2['default'].Component);
	
	exports['default'] = ProductPayments;
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _Share = __webpack_require__(291);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var ShareBox = (function (_React$Component) {
	  _inherits(ShareBox, _React$Component);
	
	  function ShareBox() {
	    _classCallCheck(this, _ShareBox);
	
	    _get(Object.getPrototypeOf(_ShareBox.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ShareBox, [{
	    key: 'doShare',
	    value: function doShare(type, evt) {
	      evt.preventDefault();
	      this.props.doShare(type);
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (!this.props.title) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        _HTMLComponent2['default'],
	        null,
	        this.props.title
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.doShowShare) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'share_offer', className: 'box light' },
	        this.getTitle(),
	        _react2['default'].createElement(_Share2['default'], { doShowShare: this.props.doShowShare, doShare: this.props.doShare })
	      );
	    }
	  }]);
	
	  var _ShareBox = ShareBox;
	  ShareBox = (0, _tcombReact.props)({
	    title: _tcombReact.t.Str,
	    doShowShare: _tcombReact.t.Bool,
	    doShare: _tcombReact.t.Func
	  })(ShareBox) || ShareBox;
	  return ShareBox;
	})(_react2['default'].Component);
	
	exports['default'] = ShareBox;
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _utilShuffle = __webpack_require__(322);
	
	var _utilShuffle2 = _interopRequireDefault(_utilShuffle);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var Tips = (function (_React$Component) {
	  _inherits(Tips, _React$Component);
	
	  function Tips() {
	    _classCallCheck(this, _Tips);
	
	    _get(Object.getPrototypeOf(_Tips.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Tips, [{
	    key: 'getTip',
	    value: function getTip() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).product;
	      return (0, _utilShuffle2['default'])(bundle.tips.slides).map(function (tip, i) {
	        var classes = (0, _classnames2['default'])({
	          'tip': true,
	          'large-show': i === 0,
	          'large-hide': i !== 0
	        });
	
	        return _react2['default'].createElement(
	          'div',
	          { key: i, className: classes },
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            tip
	          )
	        );
	      });
	    }
	  }, {
	    key: 'showPrev',
	    value: function showPrev(evt) {
	      evt.preventDefault();
	      var selected = $('.tip.large-show');
	      selected.removeClass('large-show').addClass('large-hide');
	      if (selected.prev('.tip').length) {
	        selected.prev('.tip').removeClass('large-hide').addClass('large-show');
	      } else {
	        $('.tip').last().removeClass('large-hide').addClass('large-show');
	      }
	    }
	  }, {
	    key: 'showNext',
	    value: function showNext(evt) {
	      evt.preventDefault();
	      var selected = $('.tip.large-show');
	      selected.removeClass('large-show').addClass('large-hide');
	      if (selected.next('.tip').length) {
	        selected.next('.tip').removeClass('large-hide').addClass('large-show');
	      } else {
	        $('.tip').first().removeClass('large-hide').addClass('large-show');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).product;
	      return _react2['default'].createElement(
	        'div',
	        { id: 'tips', className: 'box help small-hide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title' },
	          _react2['default'].createElement(
	            'h2',
	            null,
	            _react2['default'].createElement(
	              'span',
	              null,
	              bundle.tips.title
	            )
	          )
	        ),
	        this.getTip(),
	        _react2['default'].createElement(
	          'div',
	          { id: 'tips_nav' },
	          _react2['default'].createElement(
	            'a',
	            { id: 'prev_tip', onClick: this.showPrev, href: '#' },
	            '«'
	          ),
	          bundle.tips.navigator,
	          _react2['default'].createElement(
	            'a',
	            { id: 'next_tip', onClick: this.showNext, href: '#' },
	            '»'
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Tips = Tips;
	  Tips = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(Tips) || Tips;
	  return Tips;
	})(_react2['default'].Component);
	
	exports['default'] = Tips;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = shuffle;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	// restituisce un array con gli elementi mischiati a caso
	
	function shuffle(xs) {
	  var random = function random(a, b) {
	    return Math.random() * (b - 1) + a;
	  };
	  var random_integer = function random_integer(a, b) {
	    return parseInt(random(a, b), 10);
	  };
	  xs = xs.slice();
	  var ys = [];
	  var i;
	  while (xs.length) {
	    i = random_integer(0, xs.length - 1);
	    ys.push(xs[i]);
	    xs = _jsdk2['default'].remove(xs, i);
	  }
	  return ys;
	}

	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _lodashArrayTake = __webpack_require__(324);
	
	var _lodashArrayTake2 = _interopRequireDefault(_lodashArrayTake);
	
	var _Deal = __webpack_require__(325);
	
	var _Deal2 = _interopRequireDefault(_Deal);
	
	var _utilFormatDiscount = __webpack_require__(307);
	
	var _utilFormatDiscount2 = _interopRequireDefault(_utilFormatDiscount);
	
	var _utilFormatTimeAgo = __webpack_require__(309);
	
	var _utilFormatTimeAgo2 = _interopRequireDefault(_utilFormatTimeAgo);
	
	var _utilPercentage = __webpack_require__(308);
	
	var _utilPercentage2 = _interopRequireDefault(_utilPercentage);
	
	var Lasts = (function (_React$Component) {
	  _inherits(Lasts, _React$Component);
	
	  function Lasts() {
	    _classCallCheck(this, _Lasts);
	
	    _get(Object.getPrototypeOf(_Lasts.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Lasts, [{
	    key: 'doShow',
	    value: function doShow() {
	      return this.props.product.runtime.lasts.length > 1;
	    }
	  }, {
	    key: 'getPrice',
	    value: function getPrice(last) {
	      return this.props.product.format_amount(this.props.locale, last.price);
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(last) {
	      var product = this.props.product;
	      return (0, _utilFormatDiscount2['default'])(this.props.locale, (0, _utilPercentage2['default'])(product.list_price, last.price));
	    }
	  }, {
	    key: 'getSaving',
	    value: function getSaving(last) {
	      var product = this.props.product;
	      return product.format_amount(this.props.locale, product.list_price - last.price);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta(last) {
	      // il delta non deve essere visibile per il primo last deal
	      /*if (index === 0) {
	        return null;
	      }*/
	      return (0, _utilFormatTimeAgo2['default'])(this.props.locale, last.delta);
	    }
	  }, {
	    key: 'getDeals',
	    value: function getDeals() {
	      var _this = this;
	
	      return (0, _lodashArrayTake2['default'])(this.props.product.runtime.lasts, 3).map(function (last, index) {
	        return _react2['default'].createElement(
	          'span',
	          { key: 'span' + index },
	          _react2['default'].createElement(_Deal2['default'], {
	            key: index,
	            locale: _this.props.locale,
	            price: _this.getPrice(last),
	            discount: _this.getDiscount(last),
	            saving: _this.getSaving(last),
	            delta: _this.getDelta(last, index) }),
	          _react2['default'].createElement('div', { className: 'divider' })
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.doShow()) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { id: 'last_deals', className: 'box dark small-hide' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'title' },
	            _react2['default'].createElement(
	              'h2',
	              null,
	              _react2['default'].createElement(
	                'span',
	                null,
	                (0, _domainGet_bundle2['default'])(this.props.locale).product.last_deals
	              )
	            )
	          ),
	          this.getDeals()
	        )
	      );
	    }
	  }]);
	
	  var _Lasts = Lasts;
	  Lasts = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default']
	  })(Lasts) || Lasts;
	  return Lasts;
	})(_react2['default'].Component);
	
	exports['default'] = Lasts;
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(135),
	    isIterateeCall = __webpack_require__(38);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (guard ? isIterateeCall(array, n, guard) : n == null) {
	    n = 1;
	  }
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var Deal = (function (_React$Component) {
	  _inherits(Deal, _React$Component);
	
	  function Deal() {
	    _classCallCheck(this, _Deal);
	
	    _get(Object.getPrototypeOf(_Deal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Deal, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'table',
	        { className: 'std-table' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'td',
	              { className: 'large-30' },
	              this.props.price
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'large-30' },
	              ' - ',
	              this.props.saving
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'large-30' },
	              this.props.delta
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Deal = Deal;
	  Deal = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    price: _tcombReact.t.Str,
	    discount: _tcombReact.t.Str,
	    saving: _tcombReact.t.Str,
	    delta: _tcombReact.t.maybe(_tcombReact.t.Str)
	  })(Deal) || Deal;
	  return Deal;
	})(_react2['default'].Component);
	
	exports['default'] = Deal;
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainVerified = __webpack_require__(111);
	
	var _domainVerified2 = _interopRequireDefault(_domainVerified);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainAnonymous = __webpack_require__(78);
	
	var _domainAnonymous2 = _interopRequireDefault(_domainAnonymous);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _tcombReact = __webpack_require__(168);
	
	var Product = (function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product() {
	    var _this = this;
	
	    _classCallCheck(this, _Product);
	
	    _get(Object.getPrototypeOf(_Product.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goAccount = function (evt) {
	      evt.preventDefault();
	      _this.props.goAccount();
	    };
	
	    this.goPurchases = function (evt) {
	      evt.preventDefault();
	      _this.props.goPurchases();
	    };
	
	    this.goChangePassword = function (evt) {
	      evt.preventDefault();
	      _this.props.goChangePassword();
	    };
	
	    this.doLogout = function (evt) {
	      evt.preventDefault();
	      _this.props.doLogout();
	    };
	
	    this.goLattices = function (evt) {
	      evt.preventDefault();
	      _this.props.goLattices();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	
	    this.goLogin = function (evt) {
	      evt.preventDefault();
	      _this.props.goLogin();
	    };
	  }
	
	  _createClass(Product, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(evt) {
	      evt.preventDefault();
	      var classes = document.getElementById('actions').className.split(' ');
	      if (classes.indexOf('show') === -1) {
	        document.getElementById('actions').className = 'large-100 show';
	      } else {
	        document.getElementById('actions').className = 'large-100 hide';
	      }
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      if (_domainAnonymous2['default'].is(this.props.user)) {
	        return(
	          //<a href='#' id='go_login' style={this.getColorStyle()} onClick={this.goLogin}>{get_bundle(this.props.locale).login.title}</a>
	          _react2['default'].createElement(
	            'button',
	            { id: 'go_login', style: this.styleBtnColor(), onClick: this.goLogin },
	            (0, _domainGet_bundle2['default'])(this.props.locale).login.title
	          )
	        );
	        //  return null;
	      }
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_actions', style: this.styleBtnColor(), onClick: this.toggle },
	        _react2['default'].createElement(
	          'span',
	          { className: 'container-email' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'email' },
	            this.props.user.email
	          )
	        )
	      )
	      //<a href='#' id='go_actions' style={this.styleBtnColor()} onClick={this.toggle}><span className="container-email"><span>{this.props.user.email}</span></span></a>
	      ;
	    }
	  }, {
	    key: 'getDxContent',
	    value: function getDxContent() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'actions', className: 'large-100 hide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement('div', { className: 'triangle-up' }),
	          this.getActions()
	        )
	      );
	    }
	  }, {
	    key: 'getActionsForVerified',
	    value: function getActionsForVerified() {
	      var navigation_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).navigation;
	
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goAccount },
	            navigation_bundle.go_account
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goPurchases },
	            navigation_bundle.go_purchases
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goChangePassword },
	            navigation_bundle.go_change_password
	          )
	        ),
	        _react2['default'].createElement('li', { className: 'divider' }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.doLogout },
	            navigation_bundle.do_logout
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getActionsForRegistered',
	    value: function getActionsForRegistered() {
	      var navigation_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).navigation;
	
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goPurchases },
	            navigation_bundle.go_purchases
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goChangePassword },
	            navigation_bundle.go_change_password
	          )
	        ),
	        _react2['default'].createElement('li', { className: 'divider' }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.doLogout },
	            navigation_bundle.do_logout
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      if (_domainAnonymous2['default'].is(this.props.user)) {
	        return null;
	      }
	
	      if (_domainVerified2['default'].is(this.props.user)) {
	        return this.getActionsForVerified();
	      } else if (_domainRegistered2['default'].is(this.props.user)) {
	        return this.getActionsForRegistered();
	      }
	    }
	  }, {
	    key: 'getGoLatticesLink',
	    value: function getGoLatticesLink() {
	      if (!this.props.goLattices) {
	        return null;
	      }
	
	      //return (<a href='#' id='go_lattices' style={this.getColorStyle()} onClick={this.goLattices}>{get_bundle(this.props.locale).navigation.go_lattices}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_lattices', onClick: this.goLattices, style: this.styleBtnColor() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_lattices
	      );
	    }
	  }, {
	    key: 'getGoCatalogLink',
	    value: function getGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goLattices) {
	        style.marginLeft = '20px';
	      }
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_catalog
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getGoLatticesLink(),
	              this.getGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getEmail()
	            )
	          ),
	          this.getDxContent()
	        )
	      );
	    }
	  }]);
	
	  var _Product = Product;
	  Product = (0, _tcombReact.props)({
	    goAccount: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    goLogin: _tcombReact.t.Func,
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goLattices: _tcombReact.t.maybe(_tcombReact.t.Func),
	    user: _domainUser2['default'],
	    locale: _tcombReact.t.Obj,
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(Product) || Product;
	  return Product;
	})(_react2['default'].Component);
	
	exports['default'] = Product;
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainStatusLucid = __webpack_require__(328);
	
	var _domainStatusLucid2 = _interopRequireDefault(_domainStatusLucid);
	
	var _componentsFooter = __webpack_require__(294);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _tcombReact = __webpack_require__(168);
	
	var LucidTutorial = (function (_React$Component) {
	  _inherits(LucidTutorial, _React$Component);
	
	  function LucidTutorial() {
	    var _this = this;
	
	    _classCallCheck(this, _LucidTutorial);
	
	    _get(Object.getPrototypeOf(_LucidTutorial.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doContinue = function (evt) {
	      evt.preventDefault();
	      _this.props.callback(true);
	    };
	
	    this.getContentKo = function () {
	      var bundle = (0, _domainGet_bundle2['default'])(_this.props.locale).lucid;
	      var style = {
	        maxWidth: _this.props.width
	      };
	      return _react2['default'].createElement(
	        'div',
	        { className: 'web-modal' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-body', style: style },
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-header' },
	            _react2['default'].createElement(
	              'h1',
	              null,
	              bundle.popupKO.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-section' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.popupKO.msg
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2['default'].createElement(
	              'button',
	              { onClick: _this.doContinue },
	              bundle.btn
	            )
	          )
	        )
	      );
	    };
	
	    this.getContentOk = function () {
	      var bundle = (0, _domainGet_bundle2['default'])(_this.props.locale).lucid;
	      var style = {
	        maxWidth: _this.props.width
	      };
	      return _react2['default'].createElement(
	        'div',
	        { className: 'web-modal' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-body', style: style },
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-header' },
	            _react2['default'].createElement(
	              'h1',
	              null,
	              bundle.popupOK.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-section' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.popupOK.msg
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2['default'].createElement(
	              'button',
	              { onClick: _this.doContinue },
	              bundle.btn
	            )
	          )
	        )
	      );
	    };
	
	    this.getContent = function () {
	      if (_this.props.status === 'ok') {
	        return _this.getContentOk();
	      }
	      if (_this.props.status === 'ko') {
	        return _this.getContentKo();
	      }
	    };
	  }
	
	  _createClass(LucidTutorial, [{
	    key: 'scrollTop',
	    value: function scrollTop() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollTop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { className: 'overlay' }),
	        this.getContent()
	      );
	    }
	  }]);
	
	  var _LucidTutorial = LucidTutorial;
	  LucidTutorial = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    callback: _tcombReact.t.Function,
	    status: _tcombReact.t.maybe(_domainStatusLucid2['default'])
	  })(LucidTutorial) || LucidTutorial;
	  return LucidTutorial;
	})(_react2['default'].Component);
	
	exports['default'] = LucidTutorial;
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var StatusLucid = _tcomb2['default'].enums.of(['ok', 'ko']);
	
	module.exports = StatusLucid;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainWidget = __webpack_require__(238);
	
	var _domainWidget2 = _interopRequireDefault(_domainWidget);
	
	var _componentsWidgetLayout = __webpack_require__(330);
	
	var _componentsWidgetLayout2 = _interopRequireDefault(_componentsWidgetLayout);
	
	var _componentsConsole = __webpack_require__(305);
	
	var _componentsConsole2 = _interopRequireDefault(_componentsConsole);
	
	var _componentsProduct = __webpack_require__(311);
	
	var _componentsProduct2 = _interopRequireDefault(_componentsProduct);
	
	var _componentsWidgetHeader = __webpack_require__(332);
	
	var _componentsWidgetHeader2 = _interopRequireDefault(_componentsWidgetHeader);
	
	var _tcombReact = __webpack_require__(168);
	
	var doShowBonus = false;
	var doShowTimeAgo = false;
	
	var ProductWidget = (function (_React$Component) {
	  _inherits(ProductWidget, _React$Component);
	
	  function ProductWidget() {
	    _classCallCheck(this, _ProductWidget);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_ProductWidget.prototype), 'constructor', this).apply(this, args);
	  }
	
	  _createClass(ProductWidget, [{
	    key: 'getWidgetFooterImage',
	    value: function getWidgetFooterImage() {
	      if (!this.props.widget) {
	        return null;
	      }
	      return this.props.widget.footer_image;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsWidgetHeader2['default'], { widget: this.props.widget });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'product-desktop' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-35 large-pull-right' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(_componentsConsole2['default'], {
	              doShowConsole: this.props.doShowConsole,
	              locale: locale,
	              themeBgColor: this.props.themeBgColor,
	              themeBtnColor: this.props.themeBtnColor,
	              themeBgFontColor: this.props.themeBgFontColor,
	              themeBtnFontColor: this.props.themeBtnFontColor,
	              message: this.props.message,
	              product: product,
	              goBuildOrder: this.props.goBuildOrder,
	              goPurchase: this.props.goPurchase,
	              doReduce: this.props.doReduce,
	              oldPrice: this.props.oldPrice,
	              doShowTimeAgo: doShowTimeAgo,
	              doShowBonus: doShowBonus,
	              doShowProductName: true,
	              doShowArrowRight: false })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-65 large-pull-left' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(_componentsProduct2['default'], { showDetails: false, locale: locale, product: product, themeBgFontColor: this.props.themeBgFontColor, themeBgColor: this.props.themeBgColor })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsWidgetLayout2['default'],
	        { header: this.getHeader(), locale: locale, miniSiteURL: this.props.miniSiteURL, footerImage: this.getWidgetFooterImage() },
	        _react2['default'].createElement(
	          'div',
	          { id: 'product' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-100' },
	              this.getContent()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ProductWidget = ProductWidget;
	  ProductWidget = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    oldPrice: _tcombReact.t.maybe(_tcombReact.t.Num),
	    doShowConsole: _tcombReact.t.Bool,
	    doReduce: _tcombReact.t.Func,
	    goBuildOrder: _tcombReact.t.Func,
	    goPurchase: _tcombReact.t.Func,
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    widget: _tcombReact.t.maybe(_domainWidget2['default']),
	    miniSiteURL: _domainURL2['default']
	  })(ProductWidget) || ProductWidget;
	  return ProductWidget;
	})(_react2['default'].Component);
	
	exports['default'] = ProductWidget;
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _componentsWidgetFooter = __webpack_require__(331);
	
	var _componentsWidgetFooter2 = _interopRequireDefault(_componentsWidgetFooter);
	
	var _tcombReact = __webpack_require__(168);
	
	var WidgetLayout = (function (_React$Component) {
	  _inherits(WidgetLayout, _React$Component);
	
	  function WidgetLayout() {
	    _classCallCheck(this, _WidgetLayout);
	
	    _get(Object.getPrototypeOf(_WidgetLayout.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(WidgetLayout, [{
	    key: 'getFooter',
	    value: function getFooter() {
	      if (!this.props.miniSiteURL && !this.props.footerImage) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'div',
	        { id: 'containerFooter' },
	        _react2['default'].createElement(_componentsWidgetFooter2['default'], { locale: this.props.locale, miniSiteURL: this.props.miniSiteURL, footerImage: this.props.footerImage })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { id: 'modal-container' }),
	        _react2['default'].createElement(
	          'div',
	          { id: 'view', className: 'widget' },
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerHeader' },
	            this.props.header
	          ),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerBody' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'container' },
	              this.props.children
	            )
	          ),
	          this.getFooter(),
	          _react2['default'].createElement('div', { id: 'shield' }),
	          _react2['default'].createElement(
	            'div',
	            { id: 'ajax' },
	            _react2['default'].createElement('div', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  var _WidgetLayout = WidgetLayout;
	  WidgetLayout = (0, _tcombReact.props)({
	    header: _tcombReact.t.Obj,
	    children: _tcombReact.t.Any,
	    locale: _domainLocale2['default'],
	    miniSiteURL: _tcombReact.t.maybe(_domainURL2['default']),
	    footerImage: _tcombReact.t.maybe(_domainURL2['default'])
	  })(WidgetLayout) || WidgetLayout;
	  return WidgetLayout;
	})(_react2['default'].Component);
	
	exports['default'] = WidgetLayout;
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _componentsHTMLComponent = __webpack_require__(167);
	
	var _componentsHTMLComponent2 = _interopRequireDefault(_componentsHTMLComponent);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _tcombReact = __webpack_require__(168);
	
	var WidgetFooter = (function (_React$Component) {
	  _inherits(WidgetFooter, _React$Component);
	
	  function WidgetFooter() {
	    _classCallCheck(this, _WidgetFooter);
	
	    _get(Object.getPrototypeOf(_WidgetFooter.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(WidgetFooter, [{
	    key: 'getFooterImage',
	    value: function getFooterImage() {
	      if (!this.props.footerImage) {
	        return null;
	      }
	      return _react2['default'].createElement('img', { src: this.props.footerImage });
	    }
	  }, {
	    key: 'getMoreDetailsLink',
	    value: function getMoreDetailsLink() {
	      if (!this.props.miniSiteURL) {
	        return null;
	      }
	
	      var locale = this.props.locale;
	      var moreDetailsLink = (0, _lodashStringTemplate2['default'])((0, _domainGet_bundle2['default'])(locale).widget.moreDetails)({
	        miniSiteURL: this.props.miniSiteURL
	      });
	      return _react2['default'].createElement(
	        'div',
	        { className: 'cell' },
	        _react2['default'].createElement(
	          _componentsHTMLComponent2['default'],
	          null,
	          moreDetailsLink
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'footer' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            this.getMoreDetailsLink(),
	            this.getFooterImage()
	          )
	        )
	      );
	    }
	  }]);
	
	  var _WidgetFooter = WidgetFooter;
	  WidgetFooter = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    miniSiteURL: _tcomb2['default'].maybe(_domainURL2['default']),
	    footerImage: _tcomb2['default'].maybe(_domainURL2['default'])
	  })(WidgetFooter) || WidgetFooter;
	  return WidgetFooter;
	})(_react2['default'].Component);
	
	exports['default'] = WidgetFooter;
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainWidget = __webpack_require__(238);
	
	var _domainWidget2 = _interopRequireDefault(_domainWidget);
	
	var _tcombReact = __webpack_require__(168);
	
	var WidgetHeader = (function (_React$Component) {
	  _inherits(WidgetHeader, _React$Component);
	
	  function WidgetHeader() {
	    _classCallCheck(this, _WidgetHeader);
	
	    _get(Object.getPrototypeOf(_WidgetHeader.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(WidgetHeader, [{
	    key: 'render',
	    value: function render() {
	      var widget = this.props.widget;
	
	      if (!widget) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'WidgetHeader' },
	        _react2['default'].createElement('img', { src: widget.header_image })
	      );
	    }
	  }]);
	
	  var _WidgetHeader = WidgetHeader;
	  WidgetHeader = (0, _tcombReact.props)({
	    widget: _tcombReact.t.maybe(_domainWidget2['default'])
	  })(WidgetHeader) || WidgetHeader;
	  return WidgetHeader;
	})(_react2['default'].Component);
	
	exports['default'] = WidgetHeader;
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsMessage = __webpack_require__(290);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsHTMLComponent = __webpack_require__(167);
	
	var _componentsHTMLComponent2 = _interopRequireDefault(_componentsHTMLComponent);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _componentsSocialLogins = __webpack_require__(334);
	
	var _componentsSocialLogins2 = _interopRequireDefault(_componentsSocialLogins);
	
	var _componentsHeaderRegister = __webpack_require__(335);
	
	var _componentsHeaderRegister2 = _interopRequireDefault(_componentsHeaderRegister);
	
	var _domainEmail = __webpack_require__(80);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _utilGetConditions = __webpack_require__(336);
	
	var _utilGetConditions2 = _interopRequireDefault(_utilGetConditions);
	
	var _utilGetPolicy = __webpack_require__(337);
	
	var _utilGetPolicy2 = _interopRequireDefault(_utilGetPolicy);
	
	var _tcombReact = __webpack_require__(168);
	
	var FormType = _tcombReact.t.struct({
	  email: _domainEmail2['default']
	});
	
	var ThirdPartiesFormType = undefined;
	
	var value =  false ? {
	  email: 'verified@domain.com',
	  password: 'verified'
	} : {};
	
	var thirdPartiesFormValues =  false ? {
	  privacy_rcs: 'true',
	  privacy_other: 'true',
	  privacy_tracking: 'true'
	} : {};
	
	var Register = (function (_React$Component) {
	  _inherits(Register, _React$Component);
	
	  function Register() {
	    var _this = this;
	
	    _classCallCheck(this, _Register);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Register.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        if (_this.props.hasThirdPartiesPrivacy) {
	          var valueThirdParties = _this.refs.thirdPartiesForm.getValue();
	          if (valueThirdParties) {
	            _this.props.doRegister(value.email, valueThirdParties.privacy_rcs, valueThirdParties.privacy_other, valueThirdParties.privacy_tracking);
	          }
	        } else {
	          _this.props.doRegister(value.email, null, null, null);
	        }
	      }
	    };
	
	    this.state = {
	      options: this.getOptions(),
	      thirdPartiesFormOptions: this.getThirdPartiesFormOptions()
	    };
	  }
	
	  _createClass(Register, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        auto: 'none'
	      };
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).register;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.safe
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getThirdPartiesFormOptions',
	    value: function getThirdPartiesFormOptions() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).register;
	
	      var bool = _tcombReact.t.enums({
	        'true': _react2['default'].createElement(
	          'strong',
	          null,
	          _react2['default'].createElement(
	            _componentsHTMLComponent2['default'],
	            null,
	            bundle.accept
	          )
	        ),
	        'false': _react2['default'].createElement(
	          _componentsHTMLComponent2['default'],
	          null,
	          bundle.no_accept
	        )
	      });
	
	      ThirdPartiesFormType = _tcombReact.t.struct({
	        privacy_rcs: bool,
	        privacy_other: bool,
	        privacy_tracking: bool
	      });
	
	      return {
	        fields: {
	          privacy_rcs: {
	            label: _react2['default'].createElement(
	              _componentsHTMLComponent2['default'],
	              null,
	              bundle.privacy_rcs
	            ),
	            factory: _tcombReact.t.form.Radio
	          },
	          privacy_other: {
	            label: _react2['default'].createElement(
	              _componentsHTMLComponent2['default'],
	              null,
	              bundle.privacy_other
	            ),
	            factory: _tcombReact.t.form.Radio
	          },
	          privacy_tracking: {
	            label: _react2['default'].createElement(
	              _componentsHTMLComponent2['default'],
	              null,
	              bundle.privacy_tracking
	            ),
	            factory: _tcombReact.t.form.Radio
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        is_welcome: true,
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      var message = this.props.message ? this.props.message : (0, _domainGet_bundle2['default'])(this.props.locale).register.message;
	      return _react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        message
	      );
	    }
	  }, {
	    key: 'getThirdPartiesForm',
	    value: function getThirdPartiesForm() {
	      if (!this.props.hasThirdPartiesPrivacy) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'div',
	        { id: 'form_third_parties', className: 'box light' },
	        _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(
	            _componentsHTMLComponent2['default'],
	            null,
	            (0, _domainGet_bundle2['default'])(this.props.locale).register.third_parties_privacy_intro
	          ),
	          _react2['default'].createElement(_tcombReact.t.form.Form, {
	            ref: 'thirdPartiesForm',
	            type: ThirdPartiesFormType,
	            options: this.state.thirdPartiesFormOptions,
	            value: thirdPartiesFormValues })
	        )
	      );
	    }
	  }, {
	    key: 'getDisclaimer',
	    value: function getDisclaimer() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).landing;
	      var disclaimer = (0, _lodashStringTemplate2['default'])(bundle.do_register_hint)({
	        button: bundle.do_register,
	        conditions: (0, _utilGetConditions2['default'])(locale),
	        policy: (0, _utilGetPolicy2['default'])(locale)
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'disclaimer' },
	        _react2['default'].createElement(
	          'small',
	          null,
	          _react2['default'].createElement(
	            _componentsHTMLComponent2['default'],
	            null,
	            disclaimer
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderRegister2['default'], {
	        goCatalog: this.props.goCatalog,
	        goProduct: this.props.goProduct,
	        goLogin: this.props.goLogin,
	        locale: this.props.locale,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).landing;
	      var doRegisterStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'register' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide ' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 medium-40 large-pull-right medium-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'actions' },
	                  this.getMessage(),
	                  _react2['default'].createElement(_componentsSocialLogins2['default'], {
	                    title: bundle.go_logins,
	                    goFacebook: this.props.goFacebook,
	                    goGoogle: this.props.goGoogle,
	                    goTwitter: this.props.goTwitter,
	                    goMicrosoft: this.props.goMicrosoft,
	                    goLogin: this.props.goLogin }),
	                  _react2['default'].createElement(
	                    'div',
	                    { id: 'form', className: 'box light' },
	                    _react2['default'].createElement(
	                      'h2',
	                      { className: '' },
	                      bundle.do_register_title
	                    ),
	                    _react2['default'].createElement(
	                      'form',
	                      { onSubmit: this.onSubmit },
	                      _react2['default'].createElement(_tcombReact.t.form.Form, {
	                        ref: 'form',
	                        type: FormType,
	                        options: this.state.options,
	                        value: value }),
	                      _react2['default'].createElement(
	                        'button',
	                        { id: 'do_register', className: 'btn', style: doRegisterStyle },
	                        bundle.do_register
	                      ),
	                      this.getDisclaimer()
	                    )
	                  ),
	                  this.getThirdPartiesForm()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Register = Register;
	  Register = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    message: _tcombReact.t.maybe(_tcombReact.t.Str),
	    hasThirdPartiesPrivacy: _tcombReact.t.maybe(_tcombReact.t.Bool),
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goFacebook: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goGoogle: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goMicrosoft: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goTwitter: _tcombReact.t.maybe(_tcombReact.t.Func),
	    doRegister: _tcombReact.t.maybe(_tcombReact.t.Func),
	    doAcceptCookies: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goLogin: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Register) || Register;
	  return Register;
	})(_react2['default'].Component);
	
	exports['default'] = Register;
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var SocialLogins = (function (_React$Component) {
	  _inherits(SocialLogins, _React$Component);
	
	  function SocialLogins() {
	    var _this = this;
	
	    _classCallCheck(this, _SocialLogins);
	
	    _get(Object.getPrototypeOf(_SocialLogins.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goFacebook = function (evt) {
	      evt.preventDefault();
	      _this.props.goFacebook();
	    };
	
	    this.goGoogle = function (evt) {
	      evt.preventDefault();
	      _this.props.goGoogle();
	    };
	
	    this.goTwitter = function (evt) {
	      evt.preventDefault();
	      _this.props.goTwitter();
	    };
	
	    this.goMicrosoft = function (evt) {
	      evt.preventDefault();
	      _this.props.goMicrosoft();
	    };
	
	    this.goLogin = function (evt) {
	      evt.preventDefault();
	      _this.props.goLogin();
	    };
	  }
	
	  _createClass(SocialLogins, [{
	    key: 'getMadaiLogin',
	    value: function getMadaiLogin() {
	      if (!this.props.goLogin) {
	        return null;
	      }
	
	      return _react2['default'].createElement('div', { id: 'go_madai_login', onClick: this.goLogin, title: 'Madai' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      /* <div id="go_twitter_login" onClick={this.goTwitter} title="Twitter"></div> */
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'logins', className: 'box light' },
	        _react2['default'].createElement(
	          'h2',
	          null,
	          this.props.title
	        ),
	        _react2['default'].createElement(
	          'div',
	          { id: 'logins-container' },
	          _react2['default'].createElement('div', { id: 'go_google_login', onClick: this.goGoogle, title: 'Google' }),
	          _react2['default'].createElement('div', { id: 'go_microsoft_login', onClick: this.goMicrosoft, title: 'Microsoft' }),
	          this.getMadaiLogin()
	        )
	      );
	    }
	  }]);
	
	  var _SocialLogins = SocialLogins;
	  SocialLogins = (0, _tcombReact.props)({
	    title: _tcombReact.t.Str,
	    goFacebook: _tcombReact.t.Func,
	    goGoogle: _tcombReact.t.Func,
	    goTwitter: _tcombReact.t.Func,
	    goMicrosoft: _tcombReact.t.Func,
	    goLogin: _tcombReact.t.maybe(_tcombReact.t.Func)
	  })(SocialLogins) || SocialLogins;
	  return SocialLogins;
	})(_react2['default'].Component);
	
	exports['default'] = SocialLogins;
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var Register = (function (_React$Component) {
	  _inherits(Register, _React$Component);
	
	  function Register() {
	    var _this = this;
	
	    _classCallCheck(this, _Register);
	
	    _get(Object.getPrototypeOf(_Register.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	
	    this.goLogin = function (evt) {
	      evt.preventDefault();
	      _this.props.goLogin();
	    };
	  }
	
	  _createClass(Register, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'getGoProductLink',
	    value: function getGoProductLink() {
	      if (!this.props.goProduct) {
	        return null;
	      }
	      //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{get_bundle(this.props.locale).navigation.go_product}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_product', style: this.styleBtnColor(), onClick: this.goProduct },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_product
	      );
	    }
	  }, {
	    key: 'getGoCatalogLink',
	    value: function getGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goProduct) {
	        style.marginLeft = '20px';
	      }
	
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_catalog
	      );
	    }
	  }, {
	    key: 'getGoLoginLink',
	    value: function getGoLoginLink() {
	      //return (<a href='#' id='go_login' style={this.getColorStyle()}  onClick={this.goLogin}>{get_bundle(this.props.locale).login.title}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_login', style: this.styleBtnColor(), onClick: this.goLogin },
	        (0, _domainGet_bundle2['default'])(this.props.locale).login.title
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getGoProductLink(),
	              this.getGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getGoLoginLink()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Register = Register;
	  Register = (0, _tcombReact.props)({
	    locale: _tcombReact.t.Obj,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goLogin: _tcombReact.t.Func,
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(Register) || Register;
	  return Register;
	})(_react2['default'].Component);
	
	exports['default'] = Register;
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getConditions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var madai_url = (0, _domainGetMadaiURL2['default'])();
	
	function getConditions(locale) {
	  function getHref() {
	    //return "https://madai.com/privacy_us.html"
	    var _locale = locale.toString();
	    var country = locale.country.toLowerCase();
	    if (_locale === 'en_GB') {
	      return 'https://uk.madai.com/terms.html';
	    } else if (_locale === 'en_US') {
	      return 'https://madai.com/terms.html';
	    } else if (_locale === 'it_IT') {
	      return 'https://it.madai.com/terms.html';
	    } else {
	      return 'https://madai.com/terms.html';
	    }
	  }
	
	  return '<a target="_blank" href="' + getHref() + '">' + (0, _domainGet_bundle2['default'])(locale).footer.conditions + '</a>';
	}

	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getPolicy;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var madai_url = (0, _domainGetMadaiURL2['default'])();
	
	function getPolicy(locale) {
	  function getHref() {
	    //return "https://madai.com/faq_us.html"
	    var _locale = locale.toString();
	    var country = locale.country.toLowerCase();
	    if (_locale === 'en_GB') {
	      return 'https://uk.madai.com/privacy.html';
	    } else if (_locale === 'en_US') {
	      return 'https://madai.com/privacy.html';
	    } else if (_locale === 'it_IT') {
	      return 'https://it.madai.com/privacy.html';
	    } else {
	      return 'https://madai.com/privacy.html';
	    }
	  }
	
	  return '<a target="_blank" href="' + getHref() + '">' + (0, _domainGet_bundle2['default'])(locale).footer.policy + '</a>';
	}

	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHeaderLogin = __webpack_require__(339);
	
	var _componentsHeaderLogin2 = _interopRequireDefault(_componentsHeaderLogin);
	
	var _componentsContentLogin = __webpack_require__(340);
	
	var _componentsContentLogin2 = _interopRequireDefault(_componentsContentLogin);
	
	var _tcombReact = __webpack_require__(168);
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    _classCallCheck(this, _Login);
	
	    _get(Object.getPrototypeOf(_Login.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Login, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderLogin2['default'], {
	        locale: this.props.locale,
	        goRegister: this.props.goRegister,
	        goProduct: this.props.goProduct,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentLogin2['default'], {
	          locale: locale,
	          message: this.props.message,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBtnColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          themeBtnFontColor: this.props.themeBtnFontColor,
	          doLogin: this.props.doLogin,
	          goResendPassword: this.props.goResendPassword,
	          goFacebookLogin: this.props.goFacebook,
	          goGoogleLogin: this.props.goGoogle,
	          goTwitterLogin: this.props.goTwitter,
	          goMicrosoftLogin: this.props.goMicrosoft })
	      );
	    }
	  }]);
	
	  var _Login = Login;
	  Login = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    goResendPassword: _tcombReact.t.Func,
	    doLogin: _tcombReact.t.Func,
	    goFacebook: _tcombReact.t.Func,
	    goGoogle: _tcombReact.t.Func,
	    goTwitter: _tcombReact.t.Func,
	    goMicrosoft: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    goRegister: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Login) || Login;
	  return Login;
	})(_react2['default'].Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    var _this = this;
	
	    _classCallCheck(this, _Login);
	
	    _get(Object.getPrototypeOf(_Login.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goRegister = function (evt) {
	      evt.preventDefault();
	      _this.props.goRegister();
	    };
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	  }
	
	  _createClass(Login, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'getGoRegisterLink',
	    value: function getGoRegisterLink() {
	      if (!this.props.goRegister) {
	        return null;
	      }
	      //return (<a href='#' id='go_register' style={this.getColorStyle()} onClick={this.goRegister}>{get_bundle(this.props.locale).login.go_register}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_register', style: this.styleBtnColor(), onClick: this.goRegister },
	        (0, _domainGet_bundle2['default'])(this.props.locale).login.go_register
	      );
	    }
	  }, {
	    key: 'goGoProductLink',
	    value: function goGoProductLink() {
	      if (!this.props.goProduct) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_product', style: this.styleBtnColor(), onClick: this.goProduct },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_product
	      );
	      //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{get_bundle(this.props.locale).navigation.go_product}</a>);
	    }
	  }, {
	    key: 'goGoCatalogLink',
	    value: function goGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goProduct) {
	        style.marginLeft = '20px';
	      }
	
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_catalog
	      );
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.goRegister) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goGoProductLink(),
	              this.goGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getGoRegisterLink()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Login = Login;
	  Login = (0, _tcombReact.props)({
	    locale: _tcombReact.t.Obj,
	    goRegister: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(Login) || Login;
	  return Login;
	})(_react2['default'].Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainEmail = __webpack_require__(80);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainPassword = __webpack_require__(272);
	
	var _domainPassword2 = _interopRequireDefault(_domainPassword);
	
	var _Message = __webpack_require__(290);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _Alert = __webpack_require__(233);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _SocialLogins = __webpack_require__(334);
	
	var _SocialLogins2 = _interopRequireDefault(_SocialLogins);
	
	var _tcombReact = __webpack_require__(168);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var FormType = _tcombForm2['default'].struct({
	  email: _domainEmail2['default'],
	  password: _domainPassword2['default']
	});
	
	var value =  false ? {
	  email: 'verified@domain.com',
	  password: 'verified'
	} : {};
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    var _this = this;
	
	    _classCallCheck(this, _Login);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Login.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doLogin(value.email, value.password);
	      }
	    };
	
	    this.goResendPassword = function (evt) {
	      evt.preventDefault();
	      _this.props.goResendPassword();
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(Login, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).login;
	      return {
	        fields: {
	          email: {
	            label: bundle.email
	          },
	          password: {
	            type: 'password',
	            label: bundle.password
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).login;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle.claim.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle.claim.remember
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getDefaultMessage',
	    value: function getDefaultMessage() {
	      return _react2['default'].createElement(
	        _Message2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        (0, _domainGet_bundle2['default'])(this.props.locale).login.title
	      );
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      if (this.props.message) {
	        return this.props.message;
	      }
	
	      return this.getDefaultMessage();
	    }
	  }, {
	    key: 'getAlert',
	    value: function getAlert() {
	      if (!this.props.message) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        _Alert2['default'],
	        { type: 'warning' },
	        _react2['default'].createElement(
	          _MarkdownComponent2['default'],
	          null,
	          (0, _domainGet_bundle2['default'])(this.props.locale).login.warning
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).login;
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        'div',
	        { id: 'login', className: 'cols' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-100' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide ' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { id: 'login_actions' },
	                  this.getMessage(),
	                  _react2['default'].createElement(
	                    'div',
	                    { id: 'form', className: 'box light' },
	                    _react2['default'].createElement(
	                      'form',
	                      { onSubmit: this.onSubmit },
	                      _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	                        ref: 'form',
	                        type: FormType,
	                        options: this.state.options,
	                        value: value }),
	                      _react2['default'].createElement(
	                        'p',
	                        null,
	                        _react2['default'].createElement(
	                          'a',
	                          { href: '#', id: 'go_resend_password', onClick: this.goResendPassword },
	                          bundle.go_resend_password
	                        )
	                      ),
	                      _react2['default'].createElement(
	                        'button',
	                        { id: 'do_login', className: 'btn', style: btnStyle },
	                        bundle.do_login
	                      )
	                    )
	                  ),
	                  _react2['default'].createElement(_SocialLogins2['default'], {
	                    title: bundle.other_logins,
	                    goFacebook: this.props.goFacebookLogin,
	                    goGoogle: this.props.goGoogleLogin,
	                    goTwitter: this.props.goTwitterLogin,
	                    goMicrosoft: this.props.goMicrosoftLogin }),
	                  this.getAlert()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Login = Login;
	  Login = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    goResendPassword: _tcombForm2['default'].Func,
	    doLogin: _tcombForm2['default'].Func,
	    goFacebookLogin: _tcombForm2['default'].Func,
	    goGoogleLogin: _tcombForm2['default'].Func,
	    goTwitterLogin: _tcombForm2['default'].Func,
	    goMicrosoftLogin: _tcombForm2['default'].Func,
	    goRegister: _tcombForm2['default'].maybe(_tcombForm2['default'].Func)
	  })(Login) || Login;
	  return Login;
	})(_react2['default'].Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsDefaultUi = __webpack_require__(342);
	
	var _componentsDefaultUi2 = _interopRequireDefault(_componentsDefaultUi);
	
	var _componentsHTMLComponent = __webpack_require__(167);
	
	var _componentsHTMLComponent2 = _interopRequireDefault(_componentsHTMLComponent);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _utilPrivacyRcsUrl = __webpack_require__(343);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _tcombReact = __webpack_require__(168);
	
	var RcsPrivacy = (function (_React$Component) {
	  _inherits(RcsPrivacy, _React$Component);
	
	  function RcsPrivacy() {
	    var _this = this;
	
	    _classCallCheck(this, _RcsPrivacy);
	
	    _get(Object.getPrototypeOf(_RcsPrivacy.prototype), 'constructor', this).apply(this, arguments);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      _this.props.doAcceptRcsPrivacy();
	    };
	  }
	
	  _createClass(RcsPrivacy, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getDisclaimer',
	    value: function getDisclaimer() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).rcs_privacy;
	      var getLink = '<a href="' + (0, _utilPrivacyRcsUrl.privacyRcsUrl)() + '" target="_blanck">' + bundle.privacy + '</a>';
	
	      var msg = (0, _lodashStringTemplate2['default'])(bundle.do_continue_hint)({
	        privacy: getLink
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'disclaimer' },
	        _react2['default'].createElement(
	          'small',
	          null,
	          _react2['default'].createElement(
	            _componentsHTMLComponent2['default'],
	            null,
	            msg
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).rcs_privacy;
	
	      var boxStyle = {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { sponsor: this.getSponsor(), partners: this.props.partners, bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          _componentsDefaultUi2['default'],
	          { id: 'rcs_privacy', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'cols' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'large-100' },
	                    _react2['default'].createElement(
	                      'div',
	                      { className: 'cell' },
	                      _react2['default'].createElement(
	                        'h1',
	                        null,
	                        bundle.free.title
	                      ),
	                      _react2['default'].createElement(
	                        'p',
	                        null,
	                        bundle.free.subtitle
	                      )
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'cols' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'large-100' },
	                    _react2['default'].createElement(
	                      'div',
	                      { className: 'cell' },
	                      _react2['default'].createElement(
	                        'h1',
	                        null,
	                        bundle.unique.title
	                      ),
	                      _react2['default'].createElement(
	                        'p',
	                        null,
	                        bundle.unique.subtitle
	                      )
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'cols' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'large-100' },
	                    _react2['default'].createElement(
	                      'div',
	                      { className: 'cell' },
	                      _react2['default'].createElement(
	                        'h1',
	                        null,
	                        bundle.safe.title
	                      ),
	                      _react2['default'].createElement(
	                        'p',
	                        null,
	                        bundle.safe.subtitle
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { id: 'form', className: 'box', style: boxStyle },
	                _react2['default'].createElement(
	                  'form',
	                  { onSubmit: this.onSubmit },
	                  this.getDisclaimer(),
	                  _react2['default'].createElement(
	                    'button',
	                    { id: 'do_accept_rcs_privacy', style: btnStyle, className: 'btn' },
	                    bundle.do_accept_rcs_privacy
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _RcsPrivacy = RcsPrivacy;
	  RcsPrivacy = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    doAcceptCookies: _tcombReact.t.Func,
	    doAcceptRcsPrivacy: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(RcsPrivacy) || RcsPrivacy;
	  return RcsPrivacy;
	})(_react2['default'].Component);
	
	exports['default'] = RcsPrivacy;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var DefaultUi = (function (_React$Component) {
	  _inherits(DefaultUi, _React$Component);
	
	  function DefaultUi() {
	    _classCallCheck(this, _DefaultUi);
	
	    _get(Object.getPrototypeOf(_DefaultUi.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DefaultUi, [{
	    key: 'render',
	    value: function render() {
	      var titleStyle = {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	      return _react2['default'].createElement(
	        'div',
	        { id: this.props.id },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell default-ui' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'box dark default-ui-title', style: titleStyle },
	                _react2['default'].createElement(
	                  'h1',
	                  { className: 'large-text-center' },
	                  _react2['default'].createElement(
	                    _HTMLComponent2['default'],
	                    null,
	                    this.props.title
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'box light default-ui-content' },
	                this.props.children
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _DefaultUi = DefaultUi;
	  DefaultUi = (0, _tcombReact.props)({
	    id: _tcombReact.t.Str,
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    title: _tcombReact.t.Str,
	    children: _tcombReact.t.Any,
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(DefaultUi) || DefaultUi;
	  return DefaultUi;
	})(_react2['default'].Component);
	
	exports['default'] = DefaultUi;
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.privacyRcsUrl = privacyRcsUrl;
	
	function privacyRcsUrl() {
	  return 'http://it.madai.com/index.php/norme-sulla-privacy'; //FIXME
	}

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentChangePassword = __webpack_require__(346);
	
	var _componentsContentChangePassword2 = _interopRequireDefault(_componentsContentChangePassword);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(168);
	
	var ChangePassword = (function (_React$Component) {
	  _inherits(ChangePassword, _React$Component);
	
	  function ChangePassword() {
	    _classCallCheck(this, _ChangePassword);
	
	    _get(Object.getPrototypeOf(_ChangePassword.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], { user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentChangePassword2['default'], {
	          locale: locale,
	          doChangePassword: this.props.doChangePassword,
	          user: this.props.user,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBtnColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          themeBtnFontColor: this.props.themeBtnFontColor,
	          message: this.props.message,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goChangePassword,
	          doLogout: this.props.doLogout,
	          doAcceptCookies: this.props.doAcceptCookies })
	      );
	    }
	  }]);
	
	  var _ChangePassword = ChangePassword;
	  ChangePassword = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    doChangePassword: _tcombForm2['default'].Func,
	    user: _domainUser2['default'],
	    sponsor: _tcombForm2['default'].maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    goProduct: _tcombForm2['default'].Func,
	    partners: _tcombForm2['default'].maybe(_tcombForm2['default'].Obj)
	  })(ChangePassword) || ChangePassword;
	  return ChangePassword;
	})(_react2['default'].Component);
	
	exports['default'] = ChangePassword;
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainVerified = __webpack_require__(111);
	
	var _domainVerified2 = _interopRequireDefault(_domainVerified);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainAnonymous = __webpack_require__(78);
	
	var _domainAnonymous2 = _interopRequireDefault(_domainAnonymous);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var User = (function (_React$Component) {
	  _inherits(User, _React$Component);
	
	  function User() {
	    var _this = this;
	
	    _classCallCheck(this, _User);
	
	    _get(Object.getPrototypeOf(_User.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goAccount = function (evt) {
	      evt.preventDefault();
	      _this.props.goAccount();
	    };
	
	    this.goPurchases = function (evt) {
	      evt.preventDefault();
	      _this.props.goPurchases();
	    };
	
	    this.goChangePassword = function (evt) {
	      evt.preventDefault();
	      _this.props.goChangePassword();
	    };
	
	    this.doLogout = function (evt) {
	      evt.preventDefault();
	      _this.props.doLogout();
	    };
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	  }
	
	  _createClass(User, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(evt) {
	      evt.preventDefault();
	      var classes = document.getElementById('actions').className.split(' ');
	      if (classes.indexOf('show') === -1) {
	        document.getElementById('actions').className = 'large-100 show';
	      } else {
	        document.getElementById('actions').className = 'large-100 hide';
	      }
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      if (_domainAnonymous2['default'].is(this.props.user)) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_actions', style: this.styleBtnColor(), onClick: this.toggle },
	        _react2['default'].createElement(
	          'span',
	          { className: 'container-email' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'email' },
	            this.props.user.email
	          )
	        )
	      )
	
	      //<a href='#' id='go_actions' style={this.getColorStyle()} onClick={this.toggle}><span className="container-email"><span>{this.props.user.email}</span></span></a>
	      ;
	    }
	  }, {
	    key: 'getDxContent',
	    value: function getDxContent() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'actions', className: 'large-100 hide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement('div', { className: 'triangle-up' }),
	          this.getActions()
	        )
	      );
	    }
	  }, {
	    key: 'getActionsForVerified',
	    value: function getActionsForVerified() {
	      var navigation_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).navigation;
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goAccount },
	            navigation_bundle.go_account
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goPurchases },
	            navigation_bundle.go_purchases
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goChangePassword },
	            navigation_bundle.go_change_password
	          )
	        ),
	        _react2['default'].createElement('li', { className: 'divider' }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.doLogout },
	            navigation_bundle.do_logout
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getActionsForRegistered',
	    value: function getActionsForRegistered() {
	      var navigation_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).navigation;
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goPurchases },
	            navigation_bundle.go_purchases
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goChangePassword },
	            navigation_bundle.go_change_password
	          )
	        ),
	        _react2['default'].createElement('li', { className: 'divider' }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.doLogout },
	            navigation_bundle.do_logout
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      if (_domainAnonymous2['default'].is(this.props.user)) {
	        return null;
	      }
	      if (_domainVerified2['default'].is(this.props.user)) {
	        return this.getActionsForVerified();
	      } else if (_domainRegistered2['default'].is(this.props.user)) {
	        return this.getActionsForRegistered();
	      }
	    }
	  }, {
	    key: 'goGoProductLink',
	    value: function goGoProductLink() {
	      if (!this.props.goProduct) {
	        return null;
	      }
	      //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{get_bundle(this.props.locale).navigation.go_product}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_product', style: this.styleBtnColor(), onClick: this.goProduct },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_product
	      );
	    }
	  }, {
	    key: 'goGoCatalogLink',
	    value: function goGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goProduct) {
	        style.marginLeft = '20px';
	      }
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_catalog
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goGoProductLink(),
	              this.goGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getEmail()
	            )
	          ),
	          this.getDxContent()
	        )
	      );
	    }
	  }]);
	
	  var _User = User;
	  User = (0, _tcombReact.props)({
	    goAccount: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    user: _domainUser2['default'],
	    locale: _tcombReact.t.Obj,
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(User) || User;
	  return User;
	})(_react2['default'].Component);
	
	exports['default'] = User;
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainPassword = __webpack_require__(272);
	
	var _domainPassword2 = _interopRequireDefault(_domainPassword);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _DefaultUi = __webpack_require__(342);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _Alert = __webpack_require__(233);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(168);
	
	var FormType = _tcombForm2['default'].struct({
	  old_password: _domainPassword2['default'],
	  new_password: _domainPassword2['default'],
	  confirm_password: _domainPassword2['default']
	});
	
	var ChangePassword = (function (_React$Component) {
	  _inherits(ChangePassword, _React$Component);
	
	  function ChangePassword() {
	    var _this = this;
	
	    _classCallCheck(this, _ChangePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_ChangePassword.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var bundle = (0, _domainGet_bundle2['default'])(_this.props.locale).change_password;
	      var value = _this.refs.form.getValue();
	
	      if (value) {
	        if (value.new_password !== value.confirm_password) {
	          _reactDom2['default'].render(_react2['default'].createElement(
	            _Alert2['default'],
	            { type: 'error' },
	            bundle['confirm_password_error']
	          ), document.getElementById('message'));
	        } else {
	          _this.props.doChangePassword(value.old_password, value.new_password);
	        }
	      }
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).change_password;
	      return {
	        fields: {
	          old_password: {
	            label: bundle.current_password,
	            type: 'password',
	            minLength: 6
	          },
	          new_password: {
	            label: bundle.new_password,
	            type: 'password',
	            minLength: 6
	          },
	          confirm_password: {
	            label: bundle.confirm_password,
	            type: 'password',
	            minLength: 6
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).change_password;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'change_password', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { id: 'message' },
	          this.props.message
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.onSubmit },
	          _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	            ref: 'form',
	            type: FormType,
	            options: this.state.options }),
	          _react2['default'].createElement(
	            'button',
	            { className: 'btn', style: btnStyle },
	            bundle.do_save
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ChangePassword = ChangePassword;
	  ChangePassword = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    doChangePassword: _tcombForm2['default'].Func,
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func
	  })(ChangePassword) || ChangePassword;
	  return ChangePassword;
	})(_react2['default'].Component);
	
	exports['default'] = ChangePassword;
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentPurchases = __webpack_require__(348);
	
	var _componentsContentPurchases2 = _interopRequireDefault(_componentsContentPurchases);
	
	var _tcombReact = __webpack_require__(168);
	
	var _lodashCollectionReduce = __webpack_require__(355);
	
	var _lodashCollectionReduce2 = _interopRequireDefault(_lodashCollectionReduce);
	
	var Purchases = (function (_React$Component) {
	  _inherits(Purchases, _React$Component);
	
	  function Purchases() {
	    _classCallCheck(this, _Purchases);
	
	    _get(Object.getPrototypeOf(_Purchases.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Purchases, [{
	    key: 'trasformPurchasesInObj',
	
	    // TODO nello user i purchases sono un oggetto mentro nella prodotto sono un array.
	    value: function trasformPurchasesInObj() {
	      return (0, _lodashCollectionReduce2['default'])(this.props.purchases, function (memo, current) {
	        memo[current.id] = current;return memo;
	      }, {});
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentPurchases2['default'], {
	          locale: locale,
	          purchases: this.trasformPurchasesInObj(),
	          user: this.props.user,
	          themeBgColor: this.props.themeBgColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          goPurchase: this.props.goPurchase,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goPurchases,
	          doLogout: this.props.doLogout,
	          doAcceptCookies: this.props.doAcceptCookies })
	      );
	    }
	  }]);
	
	  var _Purchases = Purchases;
	  Purchases = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    purchases: _tcombReact.t.Arr,
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    sponsor: _domainSponsor2['default'],
	    goPurchase: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Purchases) || Purchases;
	  return Purchases;
	})(_react2['default'].Component);
	
	exports['default'] = Purchases;
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainIsEmpty = __webpack_require__(349);
	
	var _domainIsEmpty2 = _interopRequireDefault(_domainIsEmpty);
	
	var _Table = __webpack_require__(350);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _DefaultUi = __webpack_require__(342);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _lodashCollectionSortByOrder = __webpack_require__(351);
	
	var _lodashCollectionSortByOrder2 = _interopRequireDefault(_lodashCollectionSortByOrder);
	
	var _tcombReact = __webpack_require__(168);
	
	var Purchases = (function (_React$Component) {
	  _inherits(Purchases, _React$Component);
	
	  function Purchases() {
	    _classCallCheck(this, _Purchases);
	
	    _get(Object.getPrototypeOf(_Purchases.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Purchases, [{
	    key: 'onClick',
	    value: function onClick(id, evt) {
	      evt.preventDefault();
	      this.props.goPurchase(id);
	    }
	  }, {
	    key: 'hasRows',
	    value: function hasRows() {
	      return this.props.purchases && !(0, _domainIsEmpty2['default'])(this.props.purchases);
	    }
	  }, {
	    key: 'getRow',
	    value: function getRow(bundle, purchase) {
	      return _react2['default'].createElement(
	        'tr',
	        { key: purchase.id },
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.onClick.bind(this, purchase.id), href: '#' },
	            purchase.product
	          )
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _domainAmount2['default'].format(this.props.locale, purchase.currency, purchase.amount)
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          bundle.status[purchase.status]
	        )
	      );
	    }
	  }, {
	    key: 'getRowsTable',
	    value: function getRowsTable(bundle) {
	      var _this = this;
	
	      return (0, _lodashCollectionSortByOrder2['default'])(this.props.purchases, 'tick', 'desc').map(function (purchase) {
	        return _this.getRow(bundle, purchase);
	      });
	    }
	  }, {
	    key: 'getContentHTML',
	    value: function getContentHTML(rows, bundle) {
	      var striped = true;
	      if (this.hasRows()) {
	        return _react2['default'].createElement(
	          _Table2['default'],
	          { columns: bundle.table, striped: striped },
	          rows
	        );
	      } else {
	        return _react2['default'].createElement(
	          'em',
	          null,
	          bundle.no_purchases
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).purchases;
	      var rows = this.getRowsTable(bundle);
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'purchases', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getContentHTML(rows, bundle)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Purchases = Purchases;
	  Purchases = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    purchases: _tcombReact.t.Obj,
	    user: _domainUser2['default'],
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goPurchase: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func
	  })(Purchases) || Purchases;
	  return Purchases;
	})(_react2['default'].Component);
	
	exports['default'] = Purchases;
	module.exports = exports['default'];

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = isEmpty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function isEmpty(x) {
	  _tcomb2['default'].assert(_tcomb2['default'].Obj.is(x));
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      return false;
	    }
	  }
	  return true;
	}

	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(168);
	
	var Table = (function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  function Table() {
	    _classCallCheck(this, _Table);
	
	    _get(Object.getPrototypeOf(_Table.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      var className = {
	        table: true,
	        'table-striped': this.props.striped
	      };
	      return _react2['default'].createElement(
	        'table',
	        { className: (0, _classnames2['default'])(className) },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            this.props.columns.map(function (column, i) {
	              return _react2['default'].createElement(
	                'th',
	                { key: i },
	                column
	              );
	            })
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  var _Table = Table;
	  Table = (0, _tcombReact.props)({
	    striped: _tcombReact.t.Bool,
	    columns: _tcombReact.t.Arr,
	    children: _tcombReact.t.Any
	  })(Table) || Table;
	  return Table;
	})(_react2['default'].Component);
	
	exports['default'] = Table;
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortByOrder = __webpack_require__(352),
	    isArray = __webpack_require__(18),
	    isIterateeCall = __webpack_require__(38);
	
	/**
	 * This method is like `_.sortByAll` except that it allows specifying the
	 * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	 * values are sorted in ascending order. Otherwise, a value is sorted in
	 * ascending order if its corresponding order is "asc", and descending if "desc".
	 *
	 * If a property name is provided for an iteratee the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If an object is provided for an iteratee the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {boolean[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 42 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // sort by `user` in ascending order and by `age` in descending order
	 * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	 * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 */
	function sortByOrder(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (guard && isIterateeCall(iteratees, orders, guard)) {
	    orders = undefined;
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseSortByOrder(collection, iteratees, orders);
	}
	
	module.exports = sortByOrder;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(353),
	    baseCallback = __webpack_require__(121),
	    baseMap = __webpack_require__(259),
	    baseSortBy = __webpack_require__(260),
	    compareMultiple = __webpack_require__(354);
	
	/**
	 * The base implementation of `_.sortByOrder` without param guards.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {boolean[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseSortByOrder(collection, iteratees, orders) {
	  var index = -1;
	
	  iteratees = arrayMap(iteratees, function(iteratee) { return baseCallback(iteratee); });
	
	  var result = baseMap(collection, function(value) {
	    var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseSortByOrder;


/***/ },
/* 353 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(262);
	
	/**
	 * Used by `_.sortByOrder` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	 * a value is sorted in ascending order if its corresponding order is "asc", and
	 * descending if "desc".
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * ((order === 'asc' || order === true) ? 1 : -1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(356),
	    baseEach = __webpack_require__(117),
	    createReduce = __webpack_require__(357);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` through `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not provided the first element of `collection` is used as the initial
	 * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	 * and `sortByOrder`
	 *
	 * @static
	 * @memberOf _
	 * @alias foldl, inject
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.reduce([1, 2], function(total, n) {
	 *   return total + n;
	 * });
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	 *   result[key] = n * 3;
	 *   return result;
	 * }, {});
	 * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	 */
	var reduce = createReduce(arrayReduce, baseEach);
	
	module.exports = reduce;


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initFromArray] Specify using the first element of `array`
	 *  as the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initFromArray) {
	  var index = -1,
	      length = array.length;
	
	  if (initFromArray && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(121),
	    baseReduce = __webpack_require__(358),
	    isArray = __webpack_require__(18);
	
	/**
	 * Creates a function for `_.reduce` or `_.reduceRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createReduce(arrayFunc, eachFunc) {
	  return function(collection, iteratee, accumulator, thisArg) {
	    var initFromArray = arguments.length < 3;
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	      : baseReduce(collection, baseCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	  };
	}
	
	module.exports = createReduce;


/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight` without support
	 * for callback shorthands and `this` binding, which iterates over `collection`
	 * using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initFromCollection Specify using the first or last element
	 *  of `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initFromCollection
	      ? (initFromCollection = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentAccount = __webpack_require__(360);
	
	var _componentsContentAccount2 = _interopRequireDefault(_componentsContentAccount);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(168);
	
	var Account = (function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account() {
	    _classCallCheck(this, _Account);
	
	    _get(Object.getPrototypeOf(_Account.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Account, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentAccount2['default'], {
	          districts: this.props.districts,
	          loadDistricts: this.props.loadDistricts,
	          doUpdateAccount: this.props.doUpdateAccount,
	          locale: this.props.locale,
	          user: this.props.user,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBtnColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          themeBtnFontColor: this.props.themeBtnFontColor,
	          doAcceptCookies: this.props.doAcceptCookies,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goPurchases,
	          doLogout: this.props.doLogout,
	          message: this.props.message })
	      );
	    }
	  }]);
	
	  var _Account = Account;
	  Account = (0, _tcombReact.props)({
	    districts: _tcombForm2['default'].Arr,
	    loadDistricts: _tcombForm2['default'].Func,
	    doUpdateAccount: _tcombForm2['default'].Func,
	    locale: _domainLocale2['default'],
	    sponsor: _domainSponsor2['default'],
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    doAcceptCookies: _tcombForm2['default'].Func,
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    goProduct: _tcombForm2['default'].Func,
	    partners: _tcombForm2['default'].maybe(_tcombForm2['default'].Obj)
	  })(Account) || Account;
	  return Account;
	})(_react2['default'].Component);
	
	exports['default'] = Account;
	module.exports = exports['default'];

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultUi = __webpack_require__(342);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGender = __webpack_require__(113);
	
	var _domainGender2 = _interopRequireDefault(_domainGender);
	
	var _domainCom_Locale = __webpack_require__(361);
	
	var _domainCom_Locale2 = _interopRequireDefault(_domainCom_Locale);
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _utilGetConditions = __webpack_require__(336);
	
	var _utilGetConditions2 = _interopRequireDefault(_utilGetConditions);
	
	var _utilGetPolicy = __webpack_require__(337);
	
	var _utilGetPolicy2 = _interopRequireDefault(_utilGetPolicy);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(168);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var Account = (function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account() {
	    var _this = this;
	
	    _classCallCheck(this, _Account);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Account.prototype), 'constructor', this).apply(this, args);
	
	    this.onChange = function (value) {
	      if (value.country) {
	        if (value.country !== _this.state.value.country) {
	          _this.props.loadDistricts(value.country, function (districts) {
	            _this.districts = districts;
	            value.district = null;
	            _this.setState({
	              value: value,
	              options: _this.getOptions(value)
	            });
	          });
	        } else {
	          _this.setState({
	            value: value
	          });
	        }
	      } else {
	        _this.setState({
	          value: value,
	          options: _this.getOptions(value)
	        });
	      }
	    };
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	
	      if (value) {
	        _this.props.doUpdateAccount(value.name, value.surname, value.gender, value.birth_date.getTime(), value.country, value.district, value.zip, value.com_locale);
	      }
	    };
	
	    this.districts = this.props.districts;
	    var value = this.getValue();
	    this.state = {
	      value: value,
	      options: this.getOptions(value)
	    };
	  }
	
	  _createClass(Account, [{
	    key: 'getCountriesOptions',
	    value: function getCountriesOptions() {
	      return _domainCountries2['default'].to_options(this.props.locale).map(function (country) {
	        return {
	          value: country[0],
	          text: country[1]
	        };
	      });
	    }
	  }, {
	    key: 'getGenderOptions',
	    value: function getGenderOptions() {
	      return (0, _domainGet_bundle2['default'])(this.props.locale).user.gender_options.map(function (option) {
	        return {
	          value: option[0],
	          text: option[1]
	        };
	      });
	    }
	  }, {
	    key: 'getComLocaleOptions',
	    value: function getComLocaleOptions() {
	      var locale = this.props.locale;
	      var options = [];
	      for (var com_locale in _domainCom_Locale2['default'].meta.map) {
	        var l = _domainLocale2['default'].of(com_locale);
	        options.push({
	          value: com_locale,
	          text: locale.display_language(l.language) + ' (' + locale.display_country(l.country) + ')'
	        });
	      }
	      return options;
	    }
	  }, {
	    key: 'getDistrictsOptions',
	    value: function getDistrictsOptions(country) {
	      if (!country) {
	        return [];
	      }
	
	      return this.districts.map(function (district) {
	        return {
	          value: district[0],
	          text: district[1]
	        };
	      });
	    }
	  }, {
	    key: 'getDistrictsArray',
	    value: function getDistrictsArray() {
	      return this.districts.map(function (district) {
	        return district[0];
	      });
	    }
	  }, {
	    key: 'getCountriesArray',
	    value: function getCountriesArray() {
	      var countriesElements = [];
	      for (var country in _domainCountries2['default'].data) {
	        countriesElements.push(country);
	      }
	      return countriesElements;
	    }
	  }, {
	    key: 'getFormType',
	    value: function getFormType() {
	
	      var districtsArray = this.getDistrictsArray();
	      var District = _tcombForm2['default'].enums.of(districtsArray);
	
	      var countriesArray = this.getCountriesArray();
	      var CountryDomain = _tcombForm2['default'].enums.of(countriesArray);
	
	      return _tcombForm2['default'].struct({
	        name: _tcombForm2['default'].maybe(_tcombForm2['default'].Str),
	        surname: _tcombForm2['default'].maybe(_tcombForm2['default'].Str),
	        gender: _domainGender2['default'],
	        birth_date: _tcombForm2['default'].Dat,
	        country: CountryDomain,
	        district: District,
	        zip: _tcombForm2['default'].Str,
	        com_locale: _domainCom_Locale2['default'],
	        email: _tcombForm2['default'].Str,
	        mobile: _tcombForm2['default'].Str
	      }, 'Account');
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions(value) {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).user;
	
	      return {
	        config: {
	          horizontal: {
	            md: [3, 9],
	            sm: [6, 6]
	          }
	        },
	        fields: {
	          name: {
	            label: bundle.name
	          },
	          surname: {
	            label: bundle.surname
	          },
	          gender: {
	            label: bundle.gender,
	            options: this.getGenderOptions()
	          },
	          birth_date: {
	            label: bundle.birth_date,
	            order: locale.getTcombFormDateOrder()
	          },
	          country: {
	            label: bundle.country,
	            options: this.getCountriesOptions(),
	            help: bundle.country_hint
	          },
	          district: {
	            label: bundle.district,
	            options: this.getDistrictsOptions(value.country)
	          },
	          zip: {
	            label: bundle.zip
	          },
	          com_locale: {
	            label: bundle.locale,
	            options: this.getComLocaleOptions(),
	            help: bundle.locale_hint
	          },
	          email: {
	            label: bundle.email,
	            type: 'static'
	          },
	          mobile: {
	            label: bundle.mobile,
	            type: 'static'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      var user = this.props.user;
	
	      return {
	        name: user.name,
	        surname: user.surname,
	        gender: user.gender,
	        birth_date: new Date(user.birth_date),
	        country: user.country,
	        district: user.district,
	        zip: user.zip,
	        com_locale: user.com_locale.toJSON(),
	        email: user.email,
	        mobile: user.mobile
	      };
	    }
	  }, {
	    key: 'getHelp',
	    value: function getHelp() {
	      return _react2['default'].createElement(
	        _MarkdownComponent2['default'],
	        null,
	        (0, _domainGet_bundle2['default'])(this.props.locale)['account']['help']
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).account;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'account', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 medium-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'alert info help' },
	                this.getHelp()
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70 medium-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.props.message,
	              _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	                  ref: 'form',
	                  type: this.getFormType(),
	                  options: this.state.options,
	                  value: this.state.value,
	                  onChange: this.onChange }),
	                _react2['default'].createElement(
	                  'button',
	                  { className: 'large-left-30p small-left-0p btn', style: btnStyle },
	                  bundle.do_save
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'large-left-30p small-left-0p disclaimer' },
	                  _react2['default'].createElement(
	                    'small',
	                    null,
	                    _react2['default'].createElement(
	                      _HTMLComponent2['default'],
	                      null,
	                      (0, _lodashStringTemplate2['default'])(bundle.disclaimer)({
	                        conditions: (0, _utilGetConditions2['default'])(locale),
	                        policy: (0, _utilGetPolicy2['default'])(locale)
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Account = Account;
	  Account = (0, _tcombReact.props)({
	    districts: _tcombForm2['default'].Arr,
	    loadDistricts: _tcombForm2['default'].Func,
	    doUpdateAccount: _tcombForm2['default'].Func,
	    locale: _tcombForm2['default'].Obj,
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    doAcceptCookies: _tcombForm2['default'].Func,
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement)
	  })(Account) || Account;
	  return Account;
	})(_react2['default'].Component);
	
	exports['default'] = Account;
	module.exports = exports['default'];

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Com_Locale = _tcomb2['default'].enums.of('fr_FR en_GB en_US es_ES it_IT en_ZA de_DE pt_BR');
	
	module.exports = Com_Locale;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _componentsHeaderResendPassword = __webpack_require__(363);
	
	var _componentsHeaderResendPassword2 = _interopRequireDefault(_componentsHeaderResendPassword);
	
	var _componentsContentResendPassword = __webpack_require__(364);
	
	var _componentsContentResendPassword2 = _interopRequireDefault(_componentsContentResendPassword);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombReact = __webpack_require__(168);
	
	var ResendPassword = (function (_React$Component) {
	  _inherits(ResendPassword, _React$Component);
	
	  function ResendPassword() {
	    _classCallCheck(this, _ResendPassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_ResendPassword.prototype), 'constructor', this).apply(this, args);
	  }
	
	  _createClass(ResendPassword, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderResendPassword2['default'], {
	        goLogin: this.props.goLogin,
	        goLoginLabel: (0, _domainGet_bundle2['default'])(this.props.locale).resend_password.go_login,
	        goProduct: this.props.goProduct,
	        goProductLabel: (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_product,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: this.props.locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentResendPassword2['default'], {
	          locale: this.props.locale,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBtnColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          themeBtnFontColor: this.props.themeBtnFontColor,
	          goLogin: this.props.goLogin,
	          doAcceptCookies: this.props.doAcceptCookies,
	          doResendPassword: this.props.doResendPassword,
	          message: this.props.message })
	      );
	    }
	  }]);
	
	  var _ResendPassword = ResendPassword;
	  ResendPassword = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    goLogin: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    doAcceptCookies: _tcombReact.t.Func,
	    doResendPassword: _tcombReact.t.Func,
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(ResendPassword) || ResendPassword;
	  return ResendPassword;
	})(_react2['default'].Component);
	
	exports['default'] = ResendPassword;
	module.exports = exports['default'];

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(168);
	
	var ResendPassword = (function (_React$Component) {
	  _inherits(ResendPassword, _React$Component);
	
	  function ResendPassword() {
	    var _this = this;
	
	    _classCallCheck(this, _ResendPassword);
	
	    _get(Object.getPrototypeOf(_ResendPassword.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goLogin = function (evt) {
	      evt.preventDefault();
	      _this.props.goLogin();
	    };
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	  }
	
	  _createClass(ResendPassword, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'goGoProductLink',
	    value: function goGoProductLink() {
	      if (!this.props.goProduct) {
	        return null;
	      }
	      //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{this.props.goProductLabel}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_product', style: this.styleBtnColor(), onClick: this.goProduct },
	        this.props.goProductLabel
	      );
	    }
	  }, {
	    key: 'goGoCatalogLink',
	    value: function goGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goProduct) {
	        style.marginLeft = '20px';
	      }
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{this.props.goCatalogLabel}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        this.props.goCatalogLabel
	      );
	    }
	  }, {
	    key: 'goLoginLink',
	    value: function goLoginLink() {
	      if (!this.props.goLogin) {
	        return null;
	      }
	      //return <a href="#" id="go_login" style={this.getColorStyle()} onClick={this.goLogin}>{this.props.goLoginLabel}</a>
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_login', style: this.styleBtnColor(), onClick: this.goLogin },
	        this.props.goLoginLabel
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goGoProductLink(),
	              this.goGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goLoginLink()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ResendPassword = ResendPassword;
	  ResendPassword = (0, _tcombReact.props)({
	    goLogin: _tcombReact.t.Func,
	    goLoginLabel: _tcombReact.t.Str,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goProductLabel: _tcombReact.t.maybe(_tcombReact.t.Str),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalogLabel: _tcombReact.t.maybe(_tcombReact.t.Str),
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(ResendPassword) || ResendPassword;
	  return ResendPassword;
	})(_react2['default'].Component);
	
	exports['default'] = ResendPassword;
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainEmail = __webpack_require__(80);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _componentsMessage = __webpack_require__(290);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(168);
	
	var FormType = _tcombForm2['default'].struct({
	  email: _domainEmail2['default']
	});
	
	var ResendPassword = (function (_React$Component) {
	  _inherits(ResendPassword, _React$Component);
	
	  function ResendPassword() {
	    var _this = this;
	
	    _classCallCheck(this, _ResendPassword);
	
	    _get(Object.getPrototypeOf(_ResendPassword.prototype), 'constructor', this).apply(this, arguments);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doResendPassword(value.email);
	      }
	    };
	  }
	
	  _createClass(ResendPassword, [{
	    key: 'getFormOptions',
	    value: function getFormOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).resend_password;
	
	      return {
	        fields: {
	          email: {
	            help: bundle.email_hint
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).login;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.remember
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getDefaultMessage',
	    value: function getDefaultMessage() {
	      return _react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        (0, _domainGet_bundle2['default'])(this.props.locale).resend_password.title
	      );
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      if (this.props.message) {
	        return this.props.message;
	      }
	
	      return this.getDefaultMessage();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).resend_password;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'resend_password', className: 'cols' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-100' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell border-radius-all' },
	                this.getMessage(),
	                _react2['default'].createElement(
	                  'div',
	                  { id: 'form', className: 'box light' },
	                  _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	                      ref: 'form',
	                      type: FormType,
	                      options: this.getFormOptions() }),
	                    _react2['default'].createElement(
	                      'button',
	                      { className: 'btn', style: btnStyle },
	                      bundle.do_resend_password
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ResendPassword = ResendPassword;
	  ResendPassword = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    goLogin: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    doResendPassword: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement)
	  })(ResendPassword) || ResendPassword;
	  return ResendPassword;
	})(_react2['default'].Component);
	
	exports['default'] = ResendPassword;
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _componentsContentNoCookies = __webpack_require__(366);
	
	var _componentsContentNoCookies2 = _interopRequireDefault(_componentsContentNoCookies);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _tcombReact = __webpack_require__(168);
	
	var NoCookies = (function (_React$Component) {
	  _inherits(NoCookies, _React$Component);
	
	  function NoCookies() {
	    _classCallCheck(this, _NoCookies);
	
	    _get(Object.getPrototypeOf(_NoCookies.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NoCookies, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { locale: locale },
	        _react2['default'].createElement(_componentsContentNoCookies2['default'], { locale: locale })
	      );
	    }
	  }]);
	
	  var _NoCookies = NoCookies;
	  NoCookies = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(NoCookies) || NoCookies;
	  return NoCookies;
	})(_react2['default'].Component);
	
	exports['default'] = NoCookies;
	module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _componentsDefaultUi = __webpack_require__(342);
	
	var _componentsDefaultUi2 = _interopRequireDefault(_componentsDefaultUi);
	
	var _tcombReact = __webpack_require__(168);
	
	var NoCookies = (function (_React$Component) {
	  _inherits(NoCookies, _React$Component);
	
	  function NoCookies() {
	    _classCallCheck(this, _NoCookies);
	
	    _get(Object.getPrototypeOf(_NoCookies.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NoCookies, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	
	      return _react2['default'].createElement(
	        _componentsDefaultUi2['default'],
	        { id: 'no_cookies', title: bundle.no_cookies.title },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              bundle.no_cookies.body
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _NoCookies = NoCookies;
	  NoCookies = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(NoCookies) || NoCookies;
	  return NoCookies;
	})(_react2['default'].Component);
	
	exports['default'] = NoCookies;
	module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jsdk = __webpack_require__(1);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainCurrency = __webpack_require__(156);
	
	var _domainCurrency2 = _interopRequireDefault(_domainCurrency);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainMobile = __webpack_require__(112);
	
	var _domainMobile2 = _interopRequireDefault(_domainMobile);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsMessage = __webpack_require__(290);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsHTMLComponent = __webpack_require__(167);
	
	var _componentsHTMLComponent2 = _interopRequireDefault(_componentsHTMLComponent);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var RequestPin = (function (_React$Component) {
	  _inherits(RequestPin, _React$Component);
	
	  function RequestPin() {
	    var _this = this;
	
	    _classCallCheck(this, _RequestPin);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_RequestPin.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doRequestPin(value.country, value.mobile);
	      }
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  /*
	  <div className="cell">
	                  <div className="cols">
	                    <div className="large-30 medium-100">
	                      <div className="cell">
	                        <Alert type="success">
	                          <MarkdownComponent>{this.getVerifyText()}</MarkdownComponent>
	                        </Alert>
	                        <Alert type="info">
	                          <MarkdownComponent>{bundle.mobile_help}</MarkdownComponent>
	                        </Alert>
	                      </div>
	                    </div>
	                    <div className="large-70 medium-100">
	              */
	
	  _createClass(RequestPin, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getCountriesArray',
	    value: function getCountriesArray() {
	      var countriesElements = [];
	      for (var country in _domainCountries2['default'].data) {
	        countriesElements.push(country);
	      }
	      return countriesElements;
	    }
	  }, {
	    key: 'getFormType',
	    value: function getFormType() {
	      var countriesArray = this.getCountriesArray();
	      var CountryDomain = _tcombReact.t.enums.of(countriesArray);
	
	      return _tcombReact.t.struct({
	        country: CountryDomain,
	        mobile: _domainMobile2['default']
	      });
	    }
	  }, {
	    key: 'getCountriesOptions',
	    value: function getCountriesOptions() {
	      return _domainCountries2['default'].to_options(this.props.locale).map(function (country) {
	        return {
	          value: country[0],
	          text: country[1]
	        };
	      });
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).request_pin;
	
	      return {
	        fields: {
	          country: {
	            label: bundle.country,
	            options: this.getCountriesOptions()
	          },
	          mobile: {
	            label: bundle.mobile,
	            help: bundle.sub_title
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).request_pin;
	      var bonus = _domainAmount2['default'].format(locale, this.props.currency, _domainCountries2['default'].bonus(locale.country));
	
	      // backup messaggio con il bonus "title": "Verify your mobile phone to continue buying or to reduce the price. <br/>Immediately {{=bonus}} discount more for you!",
	
	      return (0, _jsdk.mustache)(bundle.title)({
	        bonus: bonus
	      });
	    }
	  }, {
	    key: 'getVerifyText',
	    value: function getVerifyText() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).request_pin;
	      var bonus = _domainAmount2['default'].format(locale, this.props.currency, _domainCountries2['default'].bonus(locale.country));
	
	      return (0, _jsdk.mustache)(bundle.verify)({
	        bonus: bonus
	      });
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).request_pin;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.safe
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.free
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      return _react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          _componentsHTMLComponent2['default'],
	          null,
	          this.getTitle()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).request_pin;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'request_pin', className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell border-radius-all' },
	                this.props.message,
	                this.getMessage(),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box light' },
	                  _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(_tcombReact.t.form.Form, {
	                      ref: 'form',
	                      type: this.getFormType(),
	                      options: this.state.options }),
	                    _react2['default'].createElement(
	                      'button',
	                      { className: 'btn', style: btnStyle },
	                      bundle.do_request_pin
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _RequestPin = RequestPin;
	  RequestPin = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    currency: _domainCurrency2['default'],
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    doRequestPin: _tcombReact.t.Func,
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    goProduct: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(RequestPin) || RequestPin;
	  return RequestPin;
	})(_react2['default'].Component);
	
	exports['default'] = RequestPin;
	module.exports = exports['default'];

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainMobile = __webpack_require__(112);
	
	var _domainMobile2 = _interopRequireDefault(_domainMobile);
	
	var _domainCountry = __webpack_require__(60);
	
	var _domainCountry2 = _interopRequireDefault(_domainCountry);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainPin = __webpack_require__(275);
	
	var _domainPin2 = _interopRequireDefault(_domainPin);
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsMessage = __webpack_require__(290);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _componentsAlert = __webpack_require__(233);
	
	var _componentsAlert2 = _interopRequireDefault(_componentsAlert);
	
	var _tcombReact = __webpack_require__(168);
	
	var InsertPin = (function (_React$Component) {
	  _inherits(InsertPin, _React$Component);
	
	  function InsertPin() {
	    var _this = this;
	
	    _classCallCheck(this, _InsertPin);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_InsertPin.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doInsertPin(value.code);
	      }
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(InsertPin, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getFormType',
	    value: function getFormType() {
	      return _tcombReact.t.struct({
	        code: _domainPin2['default']
	      });
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        auto: 'none'
	      };
	    }
	  }, {
	    key: 'getMobile',
	    value: function getMobile() {
	      return _domainCountries2['default'].format_mobile(this.props.country, this.props.mobile);
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).request_pin;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.safe
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.free
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      return _react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        (0, _domainGet_bundle2['default'])(this.props.locale).insert_pin.title
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).insert_pin;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'insert_pin', className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell border-radius-all' },
	                this.getMessage(),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box light' },
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    bundle.sub_title,
	                    ' ',
	                    this.getMobile()
	                  ),
	                  _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(_tcombReact.t.form.Form, {
	                      ref: 'form',
	                      type: this.getFormType(),
	                      options: this.state.options }),
	                    _react2['default'].createElement(
	                      'button',
	                      { className: 'btn', style: btnStyle },
	                      bundle.do_insert_pin
	                    )
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'warning' },
	                  _react2['default'].createElement(
	                    _componentsMarkdownComponent2['default'],
	                    null,
	                    bundle.help
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _InsertPin = InsertPin;
	  InsertPin = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    country: _domainCountry2['default'],
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    mobile: _domainMobile2['default'],
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    doInsertPin: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(InsertPin) || InsertPin;
	  return InsertPin;
	})(_react2['default'].Component);
	
	exports['default'] = InsertPin;
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainGender = __webpack_require__(113);
	
	var _domainGender2 = _interopRequireDefault(_domainGender);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsMessage = __webpack_require__(290);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var Verify = (function (_React$Component) {
	  _inherits(Verify, _React$Component);
	
	  function Verify() {
	    var _this = this;
	
	    _classCallCheck(this, _Verify);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Verify.prototype), 'constructor', this).apply(this, args);
	
	    this.onChange = function (value) {
	      if (value.country) {
	        if (value.country !== _this.state.value.country) {
	          _this.props.loadDistricts(value.country, function (districts) {
	            _this.districts = districts;
	            value.district = null;
	            _this.setState({
	              value: value,
	              options: _this.getOptions(value)
	            });
	          });
	        } else {
	          _this.setState({
	            value: value
	          });
	        }
	      } else {
	        _this.setState({
	          value: value,
	          options: _this.getOptions(value)
	        });
	      }
	    };
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doVerify(value.gender, value.birth_date.getTime(), value.country, value.district, value.zip);
	      }
	    };
	
	    this.districts = this.props.districts;
	    var value = this.getValue(this.props.country);
	    this.state = {
	      options: this.getOptions(value),
	      value: value
	    };
	  }
	
	  _createClass(Verify, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue(country) {
	      return {
	        gender: null,
	        birth_date: null,
	        country: country,
	        district: null,
	        zip: null
	      };
	    }
	  }, {
	    key: 'getDistrictsArray',
	    value: function getDistrictsArray() {
	      return this.districts.map(function (district) {
	        return district[0];
	      });
	    }
	  }, {
	    key: 'getCountriesArray',
	    value: function getCountriesArray() {
	      var countriesElements = [];
	      for (var country in _domainCountries2['default'].data) {
	        countriesElements.push(country);
	      }
	      return countriesElements;
	    }
	  }, {
	    key: 'getFormType',
	    value: function getFormType() {
	      var districtsArray = this.getDistrictsArray();
	      var District = _tcombReact.t.enums.of(districtsArray);
	
	      var countriesArray = this.getCountriesArray();
	      var CountryDomain = _tcombReact.t.enums.of(countriesArray);
	
	      return _tcombReact.t.struct({
	        gender: _domainGender2['default'],
	        birth_date: _tcombReact.t.Dat,
	        country: CountryDomain,
	        district: District,
	        zip: _tcombReact.t.Str
	      }, 'Verify');
	    }
	  }, {
	    key: 'getGenderOptions',
	    value: function getGenderOptions() {
	      return (0, _domainGet_bundle2['default'])(this.props.locale).user.gender_options.map(function (option) {
	        return {
	          value: option[0],
	          text: option[1]
	        };
	      });
	    }
	  }, {
	    key: 'getCountriesOptions',
	    value: function getCountriesOptions() {
	      return _domainCountries2['default'].to_options(this.props.locale).map(function (country) {
	        return {
	          value: country[0],
	          text: country[1]
	        };
	      });
	    }
	  }, {
	    key: 'getDistrictsOptions',
	    value: function getDistrictsOptions(country) {
	      if (!country) {
	        return [];
	      }
	
	      return this.districts.map(function (district) {
	        return {
	          value: district[0],
	          text: district[1]
	        };
	      });
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions(value) {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).user;
	      return {
	        fields: {
	          gender: {
	            label: bundle.gender,
	            options: this.getGenderOptions()
	          },
	          birth_date: {
	            label: bundle.birth_date,
	            order: locale.getTcombFormDateOrder()
	          },
	          country: {
	            label: bundle.country,
	            options: this.getCountriesOptions(),
	            help: bundle.country_hint
	          },
	          district: {
	            label: bundle.district,
	            options: this.getDistrictsOptions(value.country)
	          },
	          zip: {
	            label: bundle.zip
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getMobile',
	    value: function getMobile() {
	      return _domainCountries2['default'].format_mobile(this.props.country, this.props.mobile);
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).verify;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.safe
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      return _react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        (0, _domainGet_bundle2['default'])(this.props.locale).verify.title,
	        _react2['default'].createElement('br', null),
	        (0, _domainGet_bundle2['default'])(this.props.locale).verify.sub_title
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).verify;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'verify', className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell border-radius-all' },
	                this.getMessage(),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box light' },
	                  _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(_tcombReact.t.form.Form, {
	                      ref: 'form',
	                      type: this.getFormType(),
	                      options: this.state.options,
	                      value: this.state.value,
	                      onChange: this.onChange }),
	                    _react2['default'].createElement(
	                      'button',
	                      { className: 'btn', style: btnStyle },
	                      bundle.do_verify
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Verify = Verify;
	  Verify = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    districts: _tcombReact.t.Arr,
	    country: _tcombReact.t.Str,
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    loadDistricts: _tcombReact.t.Func,
	    lib_url: _domainURL2['default'],
	    doVerify: _tcombReact.t.Func,
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goProduct: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Verify) || Verify;
	  return Verify;
	})(_react2['default'].Component);
	
	exports['default'] = Verify;
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombReact = __webpack_require__(168);
	
	var ProductNotAvailable = (function (_React$Component) {
	  _inherits(ProductNotAvailable, _React$Component);
	
	  function ProductNotAvailable() {
	    var _this = this;
	
	    _classCallCheck(this, _ProductNotAvailable);
	
	    _get(Object.getPrototypeOf(_ProductNotAvailable.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	  }
	
	  _createClass(ProductNotAvailable, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getGoCatalogLink',
	    value: function getGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        'button',
	        { className: 'message_button', style: btnStyle, onClick: this.props.goCatalog },
	        (0, _domainGet_bundle2['default'])(this.props.locale).product_not_available.go_catalog
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        is_welcome: true,
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getStyleMessage',
	    value: function getStyleMessage() {
	      if (!this.props.themeBgColor) {
	        return null;
	      }
	      return {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).product_not_available;
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { sponsor: this.getSponsor(), partners: this.props.partners, bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'product_not_available' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'product-box' },
	                  _react2['default'].createElement('img', { alt: product.name, src: product.image }),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'caption' },
	                    _react2['default'].createElement(
	                      'h1',
	                      null,
	                      product.name
	                    ),
	                    _react2['default'].createElement(
	                      'p',
	                      null,
	                      product.description
	                    )
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box dark message border-radius-all', style: this.getStyleMessage() },
	                  _react2['default'].createElement(
	                    'h2',
	                    null,
	                    bundle.title
	                  ),
	                  _react2['default'].createElement('br', null),
	                  this.getGoCatalogLink()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ProductNotAvailable = ProductNotAvailable;
	  ProductNotAvailable = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    showLatticeUrl: _tcombReact.t.Bool,
	    goCatalog: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(ProductNotAvailable) || ProductNotAvailable;
	  return ProductNotAvailable;
	})(_react2['default'].Component);
	
	exports['default'] = ProductNotAvailable;
	module.exports = exports['default'];

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsShare = __webpack_require__(291);
	
	var _componentsShare2 = _interopRequireDefault(_componentsShare);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var ItemSold = (function (_React$Component) {
	  _inherits(ItemSold, _React$Component);
	
	  function ItemSold() {
	    _classCallCheck(this, _ItemSold);
	
	    _get(Object.getPrototypeOf(_ItemSold.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ItemSold, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getGoProductLink',
	    value: function getGoProductLink() {
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        'button',
	        { className: 'message_button', style: btnStyle, onClick: this.props.goProduct },
	        (0, _domainGet_bundle2['default'])(this.props.locale).item_sold.go_product
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getStyleMessage',
	    value: function getStyleMessage() {
	      if (!this.props.themeBgColor && !this.props.themeBgFontColor) {
	        return null;
	      }
	      return {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).item_sold;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { sponsor: this.getSponsor(), partners: this.props.partners, bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'item_sold' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'product-box' },
	                  _react2['default'].createElement('img', { alt: product.name, src: product.image }),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'caption' },
	                    _react2['default'].createElement(
	                      'h1',
	                      null,
	                      product.name
	                    ),
	                    _react2['default'].createElement(
	                      'p',
	                      null,
	                      product.description
	                    )
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box dark message border-radius-all', style: this.getStyleMessage() },
	                  _react2['default'].createElement(
	                    'h2',
	                    null,
	                    bundle.title
	                  ),
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    _react2['default'].createElement(
	                      _componentsMarkdownComponent2['default'],
	                      null,
	                      bundle.message
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box light' },
	                  _react2['default'].createElement(
	                    'div',
	                    { id: 'share_offer' },
	                    _react2['default'].createElement(_componentsShare2['default'], { doShowShare: true, doShare: this.props.doShare })
	                  ),
	                  this.getGoProductLink()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ItemSold = ItemSold;
	  ItemSold = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goProduct: _tcombReact.t.Func,
	    doShare: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(ItemSold) || ItemSold;
	  return ItemSold;
	})(_react2['default'].Component);
	
	exports['default'] = ItemSold;
	module.exports = exports['default'];

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainWidget = __webpack_require__(238);
	
	var _domainWidget2 = _interopRequireDefault(_domainWidget);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsWidgetLayout = __webpack_require__(330);
	
	var _componentsWidgetLayout2 = _interopRequireDefault(_componentsWidgetLayout);
	
	var _componentsWidgetHeader = __webpack_require__(332);
	
	var _componentsWidgetHeader2 = _interopRequireDefault(_componentsWidgetHeader);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var ItemSold = (function (_React$Component) {
	  _inherits(ItemSold, _React$Component);
	
	  function ItemSold() {
	    _classCallCheck(this, _ItemSold);
	
	    _get(Object.getPrototypeOf(_ItemSold.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ItemSold, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getGoProductLink',
	    value: function getGoProductLink() {
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        'button',
	        { className: 'message_button', style: btnStyle, onClick: this.props.goProduct },
	        (0, _domainGet_bundle2['default'])(this.props.locale).item_sold.go_product
	      );
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsWidgetHeader2['default'], { widget: this.props.widget });
	    }
	  }, {
	    key: 'getStyleMessage',
	    value: function getStyleMessage() {
	      if (!this.props.themeBgColor && !this.props.themeBgFontColor) {
	        return null;
	      }
	      return {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	    }
	  }, {
	    key: 'getWidgetFooterImage',
	    value: function getWidgetFooterImage() {
	      return this.props.widget.footer_image;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).item_sold;
	
	      return _react2['default'].createElement(
	        _componentsWidgetLayout2['default'],
	        { header: this.getHeader(), locale: locale, miniSiteURL: this.props.miniSiteURL, footerImage: this.getWidgetFooterImage() },
	        _react2['default'].createElement(
	          'div',
	          { id: 'item_sold' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'product-box' },
	                  _react2['default'].createElement('img', { alt: product.name, src: product.image }),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'caption' },
	                    _react2['default'].createElement(
	                      'h1',
	                      null,
	                      product.name
	                    ),
	                    _react2['default'].createElement(
	                      'p',
	                      null,
	                      product.description
	                    )
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box dark message border-radius-all', style: this.getStyleMessage() },
	                  _react2['default'].createElement(
	                    'h2',
	                    null,
	                    bundle.title
	                  ),
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    _react2['default'].createElement(
	                      _componentsMarkdownComponent2['default'],
	                      null,
	                      bundle.message
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box light' },
	                  this.getGoProductLink()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ItemSold = ItemSold;
	  ItemSold = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goProduct: _tcombReact.t.Func,
	    widget: _tcombReact.t.maybe(_domainWidget2['default']),
	    miniSiteURL: _domainURL2['default']
	  })(ItemSold) || ItemSold;
	  return ItemSold;
	})(_react2['default'].Component);
	
	exports['default'] = ItemSold;
	module.exports = exports['default'];

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHTMLComponent = __webpack_require__(167);
	
	var _componentsHTMLComponent2 = _interopRequireDefault(_componentsHTMLComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var ChangeLattice = (function (_React$Component) {
	  _inherits(ChangeLattice, _React$Component);
	
	  function ChangeLattice() {
	    var _this = this;
	
	    _classCallCheck(this, _ChangeLattice);
	
	    _get(Object.getPrototypeOf(_ChangeLattice.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goReducer = function (evt) {
	      evt.preventDefault();
	      _this.props.goReducer();
	    };
	  }
	
	  _createClass(ChangeLattice, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getGoReducerLink',
	    value: function getGoReducerLink() {
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        'button',
	        { className: 'message_button', style: btnStyle, onClick: this.props.goReducer },
	        (0, _domainGet_bundle2['default'])(this.props.locale).change_lattice.go_reducer
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getStyleMessage',
	    value: function getStyleMessage() {
	      if (!this.props.themeBgColor && !this.props.themeBgColor) {
	        return null;
	      }
	      return {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	      var sponsor = _props.sponsor;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).change_lattice;
	      var title = (0, _lodashStringTemplate2['default'])(bundle.thanks)({
	        name: sponsor.welcome_name || sponsor.name
	      });
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { sponsor: this.getSponsor(), partners: this.props.partners, bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'change_lattice' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'product-box' },
	                  _react2['default'].createElement('img', { alt: product.name, src: product.image }),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'caption' },
	                    _react2['default'].createElement(
	                      'h1',
	                      null,
	                      product.name
	                    ),
	                    _react2['default'].createElement(
	                      'p',
	                      null,
	                      product.description
	                    )
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-50 small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box dark message border-radius-all', style: this.getStyleMessage() },
	                  _react2['default'].createElement(
	                    'h2',
	                    null,
	                    _react2['default'].createElement(
	                      _componentsHTMLComponent2['default'],
	                      null,
	                      title
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    bundle.title
	                  ),
	                  _react2['default'].createElement('br', null),
	                  this.getGoReducerLink()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ChangeLattice = ChangeLattice;
	  ChangeLattice = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goReducer: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(ChangeLattice) || ChangeLattice;
	  return ChangeLattice;
	})(_react2['default'].Component);
	
	exports['default'] = ChangeLattice;
	module.exports = exports['default'];

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var ApproveOrderError = (function (_React$Component) {
	  _inherits(ApproveOrderError, _React$Component);
	
	  function ApproveOrderError() {
	    var _this = this;
	
	    _classCallCheck(this, _ApproveOrderError);
	
	    _get(Object.getPrototypeOf(_ApproveOrderError.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goPurchases = function (evt) {
	      evt.preventDefault();
	      _this.props.goPurchases();
	    };
	  }
	
	  _createClass(ApproveOrderError, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getLink',
	    value: function getLink() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).approve_order_error;
	      switch (this.props.err.name) {
	        case 'product sold out':
	        case 'out of time':
	          // vai a vedere altri prodotti
	          if (_tcombReact.t.Func.is(this.props.goCatalog)) {
	            return _react2['default'].createElement(
	              'a',
	              { href: '#', className: 'next', onClick: this.goCatalog },
	              bundle.go_catalog
	            );
	          }
	          break;
	        case 'item sold':
	        case 'max items reached':
	          // torna al prodotto
	          return _react2['default'].createElement(
	            'a',
	            { href: '#', className: 'next', onClick: this.goProduct },
	            bundle.go_product
	          );
	        case 'pending payment':
	          // vai ai pagamenti
	          return _react2['default'].createElement(
	            'a',
	            { href: '#', className: 'next', onClick: this.goPurchases },
	            bundle.go_purchases
	          );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var err = _props.err;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).approve_order_error;
	      var name = err.name;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { sponsor: this.getSponsor(), partners: this.props.partners, bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'approve_order_error' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'box dark error title' },
	            _react2['default'].createElement(
	              'h1',
	              { className: 'large-text-center' },
	              bundle.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'box light' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'alert warning' },
	              _react2['default'].createElement(
	                _componentsMarkdownComponent2['default'],
	                null,
	                bundle[name]
	              )
	            ),
	            this.getLink()
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ApproveOrderError = ApproveOrderError;
	  ApproveOrderError = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    err: _tcombReact.t.Obj,
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goPurchases: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(ApproveOrderError) || ApproveOrderError;
	  return ApproveOrderError;
	})(_react2['default'].Component);
	
	exports['default'] = ApproveOrderError;
	module.exports = exports['default'];

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainPurchase = __webpack_require__(276);
	
	var _domainPurchase2 = _interopRequireDefault(_domainPurchase);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainCustom_Payment = __webpack_require__(162);
	
	var _domainCustom_Payment2 = _interopRequireDefault(_domainCustom_Payment);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentPurchase = __webpack_require__(376);
	
	var _componentsContentPurchase2 = _interopRequireDefault(_componentsContentPurchase);
	
	var _tcombReact = __webpack_require__(168);
	
	var Purchase = (function (_React$Component) {
	  _inherits(Purchase, _React$Component);
	
	  function Purchase() {
	    _classCallCheck(this, _Purchase);
	
	    _get(Object.getPrototypeOf(_Purchase.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Purchase, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], { user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentPurchase2['default'], {
	          locale: locale,
	          purchase: this.props.purchase,
	          pending_purchase_message: this.props.pending_purchase_message,
	          user: this.props.user,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goPurchases,
	          doLogout: this.props.doLogout,
	          doAcceptCookies: this.props.doAcceptCookies,
	          message: this.props.message,
	          share_purchase: this.props.share_purchase,
	          custom_payments: this.props.custom_payments,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBtnColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          themeBtnFontColor: this.props.themeBtnFontColor,
	          doSendGiftCardCode: this.props.doSendGiftCardCode })
	      );
	    }
	  }]);
	
	  var _Purchase = Purchase;
	  Purchase = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    purchase: _domainPurchase2['default'],
	    pending_purchase_message: _tcombReact.t.maybe(_tcombReact.t.Str),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    goAccount: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    share_purchase: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    custom_payments: _tcombReact.t.maybe(_tcombReact.t.list(_domainCustom_Payment2['default'])),
	    doSendGiftCardCode: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Purchase) || Purchase;
	  return Purchase;
	})(_react2['default'].Component);
	
	exports['default'] = Purchase;
	module.exports = exports['default'];

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _StdTable = __webpack_require__(316);
	
	var _StdTable2 = _interopRequireDefault(_StdTable);
	
	var _StdCustomPayment = __webpack_require__(318);
	
	var _StdCustomPayment2 = _interopRequireDefault(_StdCustomPayment);
	
	var _DefaultUi = __webpack_require__(342);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _Alert = __webpack_require__(233);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _MarkdownComponent = __webpack_require__(166);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _PurchasePaymentGateway = __webpack_require__(377);
	
	var _PurchasePaymentGateway2 = _interopRequireDefault(_PurchasePaymentGateway);
	
	var _PurchaseStripeGateway = __webpack_require__(378);
	
	var _PurchaseStripeGateway2 = _interopRequireDefault(_PurchaseStripeGateway);
	
	var _PurchaseStripeScaGateway = __webpack_require__(379);
	
	var _PurchaseStripeScaGateway2 = _interopRequireDefault(_PurchaseStripeScaGateway);
	
	var _PurchasePaymentUrl = __webpack_require__(381);
	
	var _PurchasePaymentUrl2 = _interopRequireDefault(_PurchasePaymentUrl);
	
	var _tcombForm = __webpack_require__(81);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(168);
	
	var _lodashStringTemplate = __webpack_require__(63);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var FormType = _tcombForm2['default'].struct({
	  madaiCoupon: _tcombForm2['default'].Str
	}, 'madaiCoupon');
	
	var Purchase = (function (_React$Component) {
	  _inherits(Purchase, _React$Component);
	
	  function Purchase() {
	    var _this = this;
	
	    _classCallCheck(this, _Purchase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Purchase.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doSendGiftCardCode(value.madaiCoupon);
	      }
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(Purchase, [{
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.props.purchase.status;
	    }
	  }, {
	    key: 'isPending',
	    value: function isPending() {
	      return this.getStatus() === 'PENDING';
	    }
	  }, {
	    key: 'isPaid',
	    value: function isPaid() {
	      return this.getStatus() === 'PAID';
	    }
	  }, {
	    key: 'isShipped',
	    value: function isShipped() {
	      return this.getStatus() === 'SHIPPED';
	    }
	  }, {
	    key: 'isCanceled',
	    value: function isCanceled() {
	      return this.getStatus() === 'SHIPPED';
	    }
	  }, {
	    key: 'hasInvoice',
	    value: function hasInvoice() {
	      return this.props.purchase.invoice;
	    }
	  }, {
	    key: 'hasGiftCardCodeAssigned',
	    value: function hasGiftCardCodeAssigned() {
	      return this.props.purchase.gift_card_code !== null;
	    }
	  }, {
	    key: 'showGiftCardForm',
	    value: function showGiftCardForm() {
	      return !this.props.purchase.gift_card_not_supported && this.isPending() && !this.hasGiftCardCodeAssigned();
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal() {
	      return this.props.purchase.amount + (this.props.purchase.domicile ? this.props.purchase.domicile.shipping.cost : 0);
	    }
	  }, {
	    key: 'getTotalLabel',
	    value: function getTotalLabel(bundle) {
	      return _tcombForm2['default'].Num.is(this.props.purchase.payment_amount) ? bundle.summary.total : bundle.summary.payment_total;
	    }
	  }, {
	    key: 'getPaymentMessage',
	    value: function getPaymentMessage() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).template_message;
	      if (this.isPending()) {
	        if (this.props.pending_purchase_message) {
	          return _react2['default'].createElement(
	            _Alert2['default'],
	            { type: 'warning' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              this.props.pending_purchase_message
	            )
	          );
	        } else {
	          return _react2['default'].createElement(
	            _Alert2['default'],
	            { type: 'warning' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle['purchase.PENDING']
	            )
	          );
	        }
	      } else if (this.isPaid() || this.isShipped()) {
	        return _react2['default'].createElement(
	          _Alert2['default'],
	          { type: 'success' },
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            bundle['purchase.PAID']
	          )
	        );
	      } else if (this.isCanceled()) {
	        return _react2['default'].createElement(
	          _Alert2['default'],
	          { type: 'error' },
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            bundle['purchase.CANCELED']
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'getSummaryRows',
	    value: function getSummaryRows() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var purchase = _props.purchase;
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	
	      var total = this.getTotal();
	
	      var summary_rows = [[bundle.summary.price, _domainAmount2['default'].format(locale, purchase.currency, purchase.amount)], [bundle.summary.shipping, _domainAmount2['default'].format(locale, purchase.currency, purchase.domicile ? purchase.domicile.shipping.cost : 0)], [this.getTotalLabel(bundle), _domainAmount2['default'].format(locale, purchase.currency, total)]];
	      if (_tcombForm2['default'].Num.is(purchase.payment_amount)) {
	        var gift_card_discount = total - purchase.payment_amount;
	        summary_rows.push([bundle.summary.gift_card_discount, ' - ' + _domainAmount2['default'].format(locale, purchase.currency, gift_card_discount)], [bundle.summary.payment_total, _domainAmount2['default'].format(locale, purchase.currency, purchase.payment_amount)]);
	      }
	      return summary_rows;
	    }
	  }, {
	    key: 'getSummary',
	    value: function getSummary() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'summary' },
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _domainGet_bundle2['default'])(this.props.locale).order.summary.title
	        ),
	        _react2['default'].createElement(
	          _StdTable2['default'],
	          null,
	          this.getSummaryRows()
	        )
	      );
	    }
	  }, {
	    key: 'getDetailRows',
	    value: function getDetailRows(bundle) {
	      return [[bundle.summary.id, this.props.purchase.id], [bundle.summary.tick, this.props.locale.format_date(this.props.purchase.tick)], [bundle.summary.product, this.props.purchase.product], [bundle.summary.quantity, '1']];
	    }
	  }, {
	    key: 'getDetail',
	    value: function getDetail() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          bundle.summary.details_title
	        ),
	        _react2['default'].createElement(
	          _StdTable2['default'],
	          null,
	          this.getDetailRows(bundle)
	        )
	      );
	    }
	  }, {
	    key: 'getCustomPayments',
	    value: function getCustomPayments() {
	      return this.props.custom_payments.map(function (custom_payment, index) {
	        return _react2['default'].createElement(_StdCustomPayment2['default'], { key: index, description: custom_payment.purchase_description, image: custom_payment.image });
	      });
	    }
	  }, {
	    key: 'getPaymentGateways',
	    value: function getPaymentGateways() {
	      var _this2 = this;
	
	      return this.props.purchase.payment.gateways.map(function (gateway, index) {
	        if (gateway.type === 'stripe') {
	          //return null
	          return _react2['default'].createElement(
	            _PurchaseStripeGateway2['default'],
	            { key: index, html: gateway.html },
	            (0, _domainGet_bundle2['default'])(_this2.props.locale).payment[gateway.type]
	          );
	        } else if (gateway.type === 'stripe_sca') {
	          var stripe_sca = JSON.parse(gateway.html);
	          console.log(stripe_sca);
	          return _react2['default'].createElement(
	            _PurchaseStripeScaGateway2['default'],
	            { key: index, stripe_sca: stripe_sca },
	            (0, _domainGet_bundle2['default'])(_this2.props.locale).payment['stripe']
	          );
	        } else {
	          return _react2['default'].createElement(
	            _PurchasePaymentGateway2['default'],
	            { key: index, html: gateway.html },
	            (0, _domainGet_bundle2['default'])(_this2.props.locale).payment[gateway.type]
	          );
	        }
	      });
	    }
	  }, {
	    key: 'getPaymentUrl',
	    value: function getPaymentUrl() {
	      return _react2['default'].createElement(_PurchasePaymentUrl2['default'], { url: this.props.purchase.payment.url, label: (0, _domainGet_bundle2['default'])(this.props.locale).go_payment });
	    }
	  }, {
	    key: 'getPayment',
	    value: function getPayment() {
	      if (this.props.purchase.payment) {
	        if (this.props.purchase.payment.gateways) {
	          return this.getPaymentGateways();
	        } else {
	          return this.getPaymentUrl();
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getPaymentsSection',
	    value: function getPaymentsSection(bundle) {
	      if (!this.isPending()) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          bundle.payment
	        ),
	        this.getCustomPayments(),
	        this.getPayment()
	      );
	    }
	  }, {
	    key: 'getDomicilieRows',
	    value: function getDomicilieRows(domicile) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order.domicile;
	      return [[bundle.name, domicile.name], [bundle.surname, domicile.surname], [bundle.address, domicile.address], [bundle.co, domicile.co], [bundle.town, domicile.town], [bundle.district, domicile.district], [bundle.zip, domicile.zip], [bundle.country, this.props.locale.display_country(domicile.shipping.country)], [bundle.email, domicile.email], [bundle.mobile, domicile.mobile], [bundle.alt_email, domicile.alt_email], [bundle.alt_mobile, domicile.alt_mobile]];
	    }
	  }, {
	    key: 'getCouponRows',
	    value: function getCouponRows(coupon) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order.domicile;
	      return [[bundle.name, coupon.name], [bundle.surname, coupon.surname], [bundle.email, coupon.email], [bundle.mobile, coupon.mobile]];
	    }
	  }, {
	    key: 'getContact',
	    value: function getContact() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      if (this.props.purchase.domicile) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.domicile.title
	          ),
	          _react2['default'].createElement(
	            _StdTable2['default'],
	            null,
	            this.getDomicilieRows(this.props.purchase.domicile)
	          )
	        );
	      } else if (this.props.purchase.coupon) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.coupon.title
	          ),
	          _react2['default'].createElement(
	            _StdTable2['default'],
	            null,
	            this.getCouponRows(this.props.purchase.coupon)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getInvoice',
	    value: function getInvoice() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      if (!this.props.purchase.invoice) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          bundle.invoice.title
	        ),
	        _react2['default'].createElement(
	          _StdTable2['default'],
	          null,
	          this.getInvoiceRows(this.props.purchase.invoice)
	        )
	      );
	    }
	  }, {
	    key: 'getInvoiceRows',
	    value: function getInvoiceRows(invoice) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return [[bundle.invoice.name, invoice.name], [bundle.invoice.vat, invoice.vat], [bundle.invoice.address, invoice.address], [bundle.invoice.town, invoice.town], [bundle.invoice.district, invoice.district], [bundle.invoice.zip, invoice.zip]];
	    }
	  }, {
	    key: 'getGiftCardSection',
	    value: function getGiftCardSection(bundle) {
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      if (this.hasGiftCardCodeAssigned()) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.gift_card.assigned_title
	          ),
	          _react2['default'].createElement(
	            _HTMLComponent2['default'],
	            null,
	            (0, _lodashStringTemplate2['default'])(bundle.gift_card.assigned)({
	              gift_card_code: this.props.purchase.gift_card_code
	            })
	          )
	        );
	      } else if (this.showGiftCardForm()) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.gift_card.title
	          ),
	          _react2['default'].createElement(
	            'form',
	            { onSubmit: this.onSubmit },
	            _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	              ref: 'form',
	              type: FormType,
	              options: this.state.options }),
	            _react2['default'].createElement(
	              'button',
	              { className: 'btn', style: btnStyle },
	              bundle.gift_card.do_send_gift_card_code
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return {
	        fields: {
	          madaiCoupon: {
	            label: bundle.gift_card.label,
	            help: bundle.gift_card.hint
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).order;
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'purchase', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.props.message,
	              this.getPaymentMessage(),
	              this.getSummary(),
	              this.getPaymentsSection(bundle),
	              this.getGiftCardSection(bundle),
	              _react2['default'].createElement('hr', null),
	              this.getDetail(),
	              this.getContact(),
	              this.getInvoice(),
	              this.props.share_purchase
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Purchase = Purchase;
	  Purchase = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    purchase: _tcombForm2['default'].Obj,
	    pending_purchase_message: _tcombForm2['default'].maybe(_tcombForm2['default'].Str),
	    user: _domainUser2['default'],
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    share_purchase: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    custom_payments: _tcombForm2['default'].maybe(_tcombForm2['default'].list(_tcombForm2['default'].Obj)),
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    doSendGiftCardCode: _tcombForm2['default'].Func
	  })(Purchase) || Purchase;
	  return Purchase;
	})(_react2['default'].Component);
	
	exports['default'] = Purchase;
	module.exports = exports['default'];

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HTMLComponent = __webpack_require__(167);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _tcombReact = __webpack_require__(168);
	
	var PurchasePaymentGateway = (function (_React$Component) {
	  _inherits(PurchasePaymentGateway, _React$Component);
	
	  function PurchasePaymentGateway() {
	    _classCallCheck(this, _PurchasePaymentGateway);
	
	    _get(Object.getPrototypeOf(_PurchasePaymentGateway.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PurchasePaymentGateway, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _HTMLComponent2['default'],
	          null,
	          this.props.html
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _PurchasePaymentGateway = PurchasePaymentGateway;
	  PurchasePaymentGateway = (0, _tcombReact.props)({
	    html: _tcombReact.t.Str,
	    children: _tcombReact.t.Any
	  })(PurchasePaymentGateway) || PurchasePaymentGateway;
	  return PurchasePaymentGateway;
	})(_react2['default'].Component);
	
	exports['default'] = PurchasePaymentGateway;
	module.exports = exports['default'];

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var PurchaseStripeGateway = (function (_React$Component) {
	  _inherits(PurchaseStripeGateway, _React$Component);
	
	  function PurchaseStripeGateway() {
	    _classCallCheck(this, _PurchaseStripeGateway);
	
	    _get(Object.getPrototypeOf(_PurchaseStripeGateway.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PurchaseStripeGateway, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $('#stripeGatway').html(this.props.html);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { id: 'stripeGatway' }),
	        _react2['default'].createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _PurchaseStripeGateway = PurchaseStripeGateway;
	  PurchaseStripeGateway = (0, _tcombReact.props)({
	    html: _tcombReact.t.Str,
	    children: _tcombReact.t.Any
	  })(PurchaseStripeGateway) || PurchaseStripeGateway;
	  return PurchaseStripeGateway;
	})(_react2['default'].Component);
	
	exports['default'] = PurchaseStripeGateway;
	module.exports = exports['default'];

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(168);
	
	var _utilStripeCheckoutButton = __webpack_require__(380);
	
	var _utilStripeCheckoutButton2 = _interopRequireDefault(_utilStripeCheckoutButton);
	
	var PurchaseStripeScaGateway = (function (_React$Component) {
	  _inherits(PurchaseStripeScaGateway, _React$Component);
	
	  function PurchaseStripeScaGateway() {
	    var _this = this;
	
	    _classCallCheck(this, _PurchaseStripeScaGateway);
	
	    _get(Object.getPrototypeOf(_PurchaseStripeScaGateway.prototype), 'constructor', this).apply(this, arguments);
	
	    this.onClickPayment = function () {
	      var stripe_sca = _this.props.stripe_sca;
	      (0, _utilStripeCheckoutButton2['default'])(stripe_sca.sessionId, stripe_sca.publicKey);
	    };
	  }
	
	  _createClass(PurchaseStripeScaGateway, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { id: 'stripeScaGatway' },
	          _react2['default'].createElement(
	            'button',
	            { id: 'checkout-button-sca', onClick: this.onClickPayment.bind(this), /*className="stripe-button-el"*/style: { fontSize: '13px' } },
	            _react2['default'].createElement(
	              'span',
	              null,
	              'Pay with Card'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _PurchaseStripeScaGateway = PurchaseStripeScaGateway;
	  PurchaseStripeScaGateway = (0, _tcombReact.props)({
	    stripe_sca: _tcombReact.t.Any,
	    children: _tcombReact.t.Any
	  })(PurchaseStripeScaGateway) || PurchaseStripeScaGateway;
	  return PurchaseStripeScaGateway;
	})(_react2['default'].Component);
	
	exports['default'] = PurchaseStripeScaGateway;
	module.exports = exports['default'];

	/*componentDidMount() {
	  $('#stripeScaGatway').html('<button id="checkout-button" onClick={this.onClickPayment} className="stripe-button"><span>Pay with Carddddddddddddd</span></button>');    
	}
	*/

/***/ },
/* 380 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = stripeCheckoutButton;
	
	function stripeCheckoutButton(sessionId, publicKey) {
	    if (Stripe) {
	        var stripe = Stripe(publicKey);
	        stripe.redirectToCheckout({
	            sessionId: sessionId
	        }).then(function (result) {});
	    }
	}

	module.exports = exports["default"];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _tcombReact = __webpack_require__(168);
	
	var PurchasePaymentUrl = (function (_React$Component) {
	  _inherits(PurchasePaymentUrl, _React$Component);
	
	  function PurchasePaymentUrl() {
	    _classCallCheck(this, _PurchasePaymentUrl);
	
	    _get(Object.getPrototypeOf(_PurchasePaymentUrl.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PurchasePaymentUrl, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'a',
	        { target: '_top', href: this.props.url },
	        this.props.label
	      );
	    }
	  }]);
	
	  var _PurchasePaymentUrl = PurchasePaymentUrl;
	  PurchasePaymentUrl = (0, _tcombReact.props)({
	    url: _domainURL2['default'],
	    label: _tcombReact.t.Str
	  })(PurchasePaymentUrl) || PurchasePaymentUrl;
	  return PurchasePaymentUrl;
	})(_react2['default'].Component);
	
	exports['default'] = PurchasePaymentUrl;
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jsdk = __webpack_require__(1);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsProductCustomPayments = __webpack_require__(317);
	
	var _componentsProductCustomPayments2 = _interopRequireDefault(_componentsProductCustomPayments);
	
	var _componentsProductPayments = __webpack_require__(319);
	
	var _componentsProductPayments2 = _interopRequireDefault(_componentsProductPayments);
	
	var _componentsStdTable = __webpack_require__(316);
	
	var _componentsStdTable2 = _interopRequireDefault(_componentsStdTable);
	
	var _componentsDefaultUi = __webpack_require__(342);
	
	var _componentsDefaultUi2 = _interopRequireDefault(_componentsDefaultUi);
	
	var _componentsCouponContactForm = __webpack_require__(383);
	
	var _componentsCouponContactForm2 = _interopRequireDefault(_componentsCouponContactForm);
	
	var _componentsDomicileContactForm = __webpack_require__(384);
	
	var _componentsDomicileContactForm2 = _interopRequireDefault(_componentsDomicileContactForm);
	
	var _componentsInvoiceForm = __webpack_require__(385);
	
	var _componentsInvoiceForm2 = _interopRequireDefault(_componentsInvoiceForm);
	
	var _componentsCouponShipping = __webpack_require__(169);
	
	var _componentsCouponShipping2 = _interopRequireDefault(_componentsCouponShipping);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _tcombReact = __webpack_require__(168);
	
	var _reactSelect = __webpack_require__(386);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var CONTACT_FORM_REF = 'ContactForm';
	
	function myRenderSelect(locals) {
	  var options = locals.options.filter(function (o) {
	    return o.value;
	  }).map(function (o) {
	    return { value: o.value, label: o.text };
	  });
	
	  function onChange(o) {
	    locals.onChange(o ? o.value : '');
	  }
	
	  return _react2['default'].createElement(_reactSelect2['default'], { options: options, value: locals.value, onChange: onChange });
	}
	
	var BuildOrder = (function (_React$Component) {
	  _inherits(BuildOrder, _React$Component);
	
	  function BuildOrder() {
	    var _this = this;
	
	    _classCallCheck(this, _BuildOrder);
	
	    _get(Object.getPrototypeOf(_BuildOrder.prototype), 'constructor', this).apply(this, arguments);
	
	    this.onShippingFormChange = function (value) {
	      var _props = _this.props;
	      var product = _props.product;
	      var locale = _props.locale;
	
	      var shipping = (0, _jsdk.find)(product.shippings, value.shipping_id);
	      var cost = shipping ? shipping.cost : 0;
	      var total = product.format_amount(locale, product.runtime.price + cost);
	      $('#order_total_cost').html(total);
	      var country = shipping ? locale.display_country(shipping.country) : '';
	      _this.refs[CONTACT_FORM_REF].setCountry(country);
	    };
	
	    this.goApproveOrder = function (evt) {
	      evt.preventDefault();
	      var contactValue = null;
	      var invoiceValue = null;
	      var shipping_id = null;
	
	      var product = _this.props.product;
	
	      if (!product.is_coupon && product.shippings.length > 1) {
	        shipping_id = _this.refs.ShippingsForm.getValue().shipping_id;
	      }
	
	      contactValue = _this.getContactFormValue();
	
	      if (!contactValue) {
	        return;
	      }
	
	      var contactValueMixed = (0, _jsdk.mixin)((0, _jsdk.copy)(contactValue), { shipping_id: shipping_id });
	
	      if (product.is_invoiced && contactValue.go_invoice_form) {
	        invoiceValue = _this.refs.InvoiceForm.refs.InvoiceForm.getValue();
	        if (!invoiceValue) {
	          return;
	        }
	      }
	      _this.props.goApproveOrder(contactValueMixed, invoiceValue);
	    };
	  }
	
	  _createClass(BuildOrder, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getContact',
	    value: function getContact() {
	      var _props2 = this.props;
	      var locale = _props2.locale;
	      var user = _props2.user;
	      var order = _props2.order;
	      var product = _props2.product;
	
	      if (this.props.product.is_coupon) {
	        return _react2['default'].createElement(_componentsCouponContactForm2['default'], { locale: locale, user: user, order: order, product: product, ref: CONTACT_FORM_REF });
	      } else {
	        return _react2['default'].createElement(_componentsDomicileContactForm2['default'], { locale: locale, user: user, order: order, product: product, ref: CONTACT_FORM_REF });
	      }
	    }
	  }, {
	    key: 'getInvoice',
	    value: function getInvoice() {
	      if (!this.props.order || !this.props.product.is_invoiced) {
	        return null;
	      }
	
	      var _props3 = this.props;
	      var locale = _props3.locale;
	      var user = _props3.user;
	      var order = _props3.order;
	      var product = _props3.product;
	
	      return _react2['default'].createElement(_componentsInvoiceForm2['default'], { locale: locale, user: user, order: order, product: product, doShow: !!this.props.order.invoice, ref: 'InvoiceForm' });
	    }
	  }, {
	    key: 'getSummary',
	    value: function getSummary() {
	      var _props4 = this.props;
	      var locale = _props4.locale;
	      var product = _props4.product;
	
	      var order_bundle = (0, _domainGet_bundle2['default'])(locale).order;
	
	      var data = [[order_bundle.summary.quantity, '1'], [order_bundle.summary.list_price, product.format_amount(locale, product.list_price)], [order_bundle.summary.price, product.format_amount(locale, product.runtime.price)], [order_bundle.summary.redeemed_value, product.format_amount(locale, product.list_price - product.runtime.price)]];
	      return _react2['default'].createElement(
	        _componentsStdTable2['default'],
	        null,
	        data
	      );
	    }
	  }, {
	    key: 'getShippingOptions',
	    value: function getShippingOptions() {
	      var _props5 = this.props;
	      var locale = _props5.locale;
	      var product = _props5.product;
	
	      var omit_country = product.shipping_countries.length === 1;
	
	      return product.shippings.map(function (shipping) {
	        var text = product.display_shipping(locale, shipping, omit_country);
	        return {
	          value: shipping.id,
	          text: text
	        };
	      });
	    }
	  }, {
	    key: 'getShippingsEnum',
	    value: function getShippingsEnum() {
	      return this.getShippingOptions().map(function (shipping) {
	        return shipping.value;
	      });
	    }
	  }, {
	    key: 'getShippingsFormType',
	    value: function getShippingsFormType() {
	      var Shippings = _tcombReact.t.enums.of(this.getShippingsEnum());
	      return _tcombReact.t.struct({
	        shipping_id: Shippings
	      }, 'Shipping');
	    }
	  }, {
	    key: 'getShippingsFormOptions',
	    value: function getShippingsFormOptions() {
	      return {
	        auto: 'none',
	        fields: {
	          shipping_id: {
	            template: myRenderSelect,
	            options: this.getShippingOptions()
	          }
	        }
	      };
	    }
	  }, {
	    key: 'hasShipping',
	    value: function hasShipping() {
	      return this.props.order && this.props.order.domicile && this.props.order.domicile.shipping;
	    }
	  }, {
	    key: 'getDefaultShippingValue',
	    value: function getDefaultShippingValue() {
	      if (!this.hasShipping()) {
	        return null;
	      }
	      return this.props.order.domicile.shipping.id;
	    }
	  }, {
	    key: 'getShippingsSection',
	    value: function getShippingsSection() {
	      var _props6 = this.props;
	      var locale = _props6.locale;
	      var product = _props6.product;
	
	      if (product.is_coupon) {
	        return _react2['default'].createElement(_componentsCouponShipping2['default'], {
	          locale: locale,
	          currency: product.currency });
	      } else if (product.is_coupon || product.shippings.length === 1) {
	        return product.display_shippings(locale);
	      } else {
	        var value = {
	          shipping_id: this.getDefaultShippingValue()
	        };
	        return _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(_tcombReact.t.form.Form, {
	            ref: 'ShippingsForm',
	            type: this.getShippingsFormType(),
	            options: this.getShippingsFormOptions(),
	            onChange: this.onShippingFormChange,
	            value: value })
	        );
	      }
	    }
	  }, {
	    key: 'getContactFormValue',
	    value: function getContactFormValue() {
	      if (this.props.product.is_coupon) {
	        return this.refs.ContactForm.refs.CouponContactForm.getValue();
	      }
	      return this.refs.ContactForm.refs.DomicileContactForm.getValue();
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props;
	      var locale = _props7.locale;
	      var product = _props7.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).build_order;
	      var order_bundle = (0, _domainGet_bundle2['default'])(locale).order;
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          _componentsDefaultUi2['default'],
	          { id: 'build_order', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 medium-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement('img', { className: 'product-image', src: product.image }),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  bundle.product.payment
	                ),
	                _react2['default'].createElement(_componentsProductCustomPayments2['default'], { locale: locale, customPayments: this.props.product.custom_payments }),
	                _react2['default'].createElement(_componentsProductPayments2['default'], { locale: locale, payments: this.props.product.payments })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 medium-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'h2',
	                  null,
	                  product.name
	                ),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  order_bundle.summary.title
	                ),
	                this.getSummary(),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  order_bundle.shippings.title
	                ),
	                this.getShippingsSection(),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'large-hide medium-show' },
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    bundle.product.payment
	                  ),
	                  _react2['default'].createElement(_componentsProductCustomPayments2['default'], { locale: locale, customPayments: this.props.product.custom_payments }),
	                  _react2['default'].createElement(_componentsProductPayments2['default'], { locale: locale, payments: this.props.product.payments })
	                ),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  order_bundle.domicile.title
	                ),
	                this.getContact(),
	                this.getInvoice(),
	                _react2['default'].createElement(
	                  'button',
	                  { id: 'go_approve_order', className: 'large-left-30p small-left-0p', onClick: this.goApproveOrder, style: btnStyle },
	                  bundle.go_approve_order
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _BuildOrder = BuildOrder;
	  BuildOrder = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    order: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goApproveOrder: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(BuildOrder) || BuildOrder;
	  return BuildOrder;
	})(_react2['default'].Component);
	
	exports['default'] = BuildOrder;
	module.exports = exports['default'];
	/*<Select options={this.getShippingOptions().map(s => ({value: s.value, label: s.text}))} />*/ /*<h3>{order_bundle.summary.total} <span id='order_total_cost'>{product.total(locale)}</span></h3>*/

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainOrder = __webpack_require__(266);
	
	var _domainOrder2 = _interopRequireDefault(_domainOrder);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainVerified = __webpack_require__(111);
	
	var _domainVerified2 = _interopRequireDefault(_domainVerified);
	
	var _domainEmail = __webpack_require__(80);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _domainMobile = __webpack_require__(112);
	
	var _domainMobile2 = _interopRequireDefault(_domainMobile);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _tcombReact = __webpack_require__(168);
	
	var CouponContactForm = (function (_React$Component) {
	  _inherits(CouponContactForm, _React$Component);
	
	  function CouponContactForm() {
	    var _this = this;
	
	    _classCallCheck(this, _CouponContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_CouponContactForm.prototype), 'constructor', this).apply(this, args);
	
	    this.onChange = function (value) {
	      if (value.go_invoice_form !== _this.state.value.go_invoice_form) {
	        $('#invoice_form').toggle();
	      }
	
	      _this.setState({
	        value: value
	      });
	    };
	
	    this.state = {
	      value: this.getInitialValue()
	    };
	  }
	
	  _createClass(CouponContactForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.CouponContactForm.getValue();
	    }
	  }, {
	    key: 'getCountriesOptions',
	    value: function getCountriesOptions() {
	      var _this2 = this;
	
	      return _domainCountries2['default'].to_options(this.props.locale).map(function (country) {
	        return {
	          value: country[0],
	          text: _domainCountries2['default'].format_area(_this2.props.locale, country[0])
	        };
	      });
	    }
	  }, {
	    key: 'getCountriesArray',
	    value: function getCountriesArray() {
	      var countriesElements = [];
	      for (var country in _domainCountries2['default'].data) {
	        countriesElements.push(country);
	      }
	      return countriesElements;
	    }
	  }, {
	    key: 'getTypeForm',
	    value: function getTypeForm() {
	      var user = this.props.user;
	
	      var countriesArray = this.getCountriesArray();
	      var MobileCountry = _tcombReact.t.enums.of(countriesArray);
	
	      var CouponType = {
	        coupon_name: _tcombReact.t.Str,
	        coupon_surname: _tcombReact.t.Str,
	        email: _domainEmail2['default']
	      };
	
	      if (_domainRegistered2['default'].is(user)) {
	        CouponType.mobile_country = MobileCountry;
	        CouponType.mobile = _domainMobile2['default'];
	      } else if (_domainVerified2['default'].is(user)) {
	        CouponType.mobile = _domainMobile2['default'];
	      }
	
	      if (this.props.product.is_invoiced) {
	        CouponType.go_invoice_form = _tcombReact.t.Bool;
	      }
	      return _tcombReact.t.struct(CouponType, 'CouponContact');
	    }
	  }, {
	    key: 'getOptionsForm',
	    value: function getOptionsForm() {
	      var user = this.props.user;
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	
	      return {
	        config: { horizontal: {
	            md: [3, 9],
	            sm: [6, 6]
	          }
	        },
	        fields: {
	          coupon_name: {
	            label: bundle.coupon.name
	          },
	          coupon_surname: {
	            label: bundle.coupon.surname,
	            help: bundle.coupon.surname_hint
	          },
	          email: {
	            label: bundle.coupon.email,
	            type: 'static'
	          },
	          mobile_country: {
	            label: bundle.coupon.mobile_country,
	            options: this.getCountriesOptions()
	          },
	          mobile: {
	            label: bundle.coupon.mobile,
	            help: _domainRegistered2['default'].is(user) ? bundle.coupon.mobile_hint : '',
	            type: _domainVerified2['default'].is(user) ? 'static' : null
	          },
	          go_invoice_form: {
	            label: bundle.is_invoiced
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getInitialValue',
	    value: function getInitialValue() {
	      var order = this.props.order;
	      var doShowInvoice = !!order.invoice;
	      return {
	        coupon_name: order.coupon.name,
	        coupon_surname: order.coupon.surname,
	        email: order.coupon.email,
	        mobile_country: order.coupon.mobile_country,
	        mobile: order.coupon.mobile,
	        go_invoice_form: doShowInvoice
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'form-horizontal' },
	        _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(_tcombReact.t.form.Form, {
	            ref: 'CouponContactForm',
	            type: this.getTypeForm(),
	            options: this.getOptionsForm(),
	            value: this.state.value,
	            onChange: this.onChange })
	        )
	      );
	    }
	  }]);
	
	  var _CouponContactForm = CouponContactForm;
	  CouponContactForm = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    user: _domainUser2['default'],
	    order: _tcombReact.t.maybe(_domainOrder2['default'])
	  })(CouponContactForm) || CouponContactForm;
	  return CouponContactForm;
	})(_react2['default'].Component);
	
	exports['default'] = CouponContactForm;
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainVerified = __webpack_require__(111);
	
	var _domainVerified2 = _interopRequireDefault(_domainVerified);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainEmail = __webpack_require__(80);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _domainMobile = __webpack_require__(112);
	
	var _domainMobile2 = _interopRequireDefault(_domainMobile);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	//import Order from '../domain/Order';
	
	var _domainCountries = __webpack_require__(254);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _tcombReact = __webpack_require__(168);
	
	var DomicileContactForm = (function (_React$Component) {
	  _inherits(DomicileContactForm, _React$Component);
	
	  function DomicileContactForm() {
	    var _this = this;
	
	    _classCallCheck(this, _DomicileContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_DomicileContactForm.prototype), 'constructor', this).apply(this, args);
	
	    this.onChange = function (value) {
	      if (value.go_invoice_form !== _this.state.value.go_invoice_form) {
	        $('#invoice_form').toggle();
	      }
	
	      _this.setState({
	        value: value
	      });
	    };
	
	    this.state = {
	      value: this.getInitialValue()
	    };
	  }
	
	  _createClass(DomicileContactForm, [{
	    key: 'getCountriesOptions',
	    value: function getCountriesOptions() {
	      var _this2 = this;
	
	      return _domainCountries2['default'].to_options(this.props.locale).map(function (country) {
	        return {
	          value: country[0],
	          text: _domainCountries2['default'].format_area(_this2.props.locale, country[0])
	        };
	      });
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.DomicileContactForm.getValue();
	    }
	  }, {
	    key: 'getCountriesArray',
	    value: function getCountriesArray() {
	      var countriesElements = [];
	      for (var country in _domainCountries2['default'].data) {
	        countriesElements.push(country);
	      }
	      return countriesElements;
	    }
	  }, {
	    key: 'getTypeForm',
	    value: function getTypeForm() {
	      var user = this.props.user;
	
	      var countriesArray = this.getCountriesArray();
	      var MobileCountry = _tcombReact.t.enums.of(countriesArray);
	
	      var DomicileType = {
	        name: _tcombReact.t.Str,
	        surname: _tcombReact.t.Str,
	        address: _tcombReact.t.Str,
	        co: _tcombReact.t.Str,
	        town: _tcombReact.t.Str,
	        district: _tcombReact.t.Str,
	        zip: _tcombReact.t.Str,
	        country: _tcombReact.t.Str,
	        email: _domainEmail2['default']
	      };
	
	      if (_domainRegistered2['default'].is(user)) {
	        DomicileType.mobile_country = MobileCountry;
	        DomicileType.mobile = _domainMobile2['default'];
	      } else if (_domainVerified2['default'].is(user)) {
	        DomicileType.mobile = _domainMobile2['default'];
	      }
	
	      DomicileType.alt_email = _tcombReact.t.maybe(_domainEmail2['default']);
	      DomicileType.alt_mobile = _tcombReact.t.maybe(_domainMobile2['default']);
	
	      if (this.props.product.is_invoiced) {
	        DomicileType.go_invoice_form = _tcombReact.t.Bool;
	      }
	
	      return _tcombReact.t.struct(DomicileType, 'DomicileContact');
	    }
	  }, {
	    key: 'getOptionsForm',
	    value: function getOptionsForm() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).order;
	
	      return {
	        config: { horizontal: {
	            md: [3, 9],
	            sm: [6, 6]
	          }
	        },
	        fields: {
	          name: {
	            label: bundle.domicile.name
	          },
	          surname: {
	            label: bundle.domicile.surname
	          },
	          address: {
	            label: bundle.domicile.address
	          },
	          co: {
	            label: bundle.domicile.co,
	            help: bundle.domicile.co_hint
	          },
	          town: {
	            label: bundle.domicile.town
	          },
	          district: {
	            label: bundle.domicile.district
	          },
	          zip: {
	            label: bundle.domicile.zip
	          },
	          country: {
	            label: bundle.domicile.country,
	            type: 'static',
	            attrs: {
	              className: 'domicileCountry'
	            }
	          },
	          email: {
	            label: bundle.domicile.email,
	            type: 'static'
	          },
	          mobile_country: {
	            label: bundle.domicile.mobile_country,
	            options: this.getCountriesOptions(),
	            type: _domainVerified2['default'].is(this.props.user) ? 'static' : null
	          },
	          mobile: {
	            label: bundle.domicile.mobile,
	            type: _domainVerified2['default'].is(this.props.user) ? 'static' : null,
	            error: function error(currentValue) {
	              if (currentValue && !_domainMobile2['default'].is(currentValue)) {
	                return locale.language_bundle().validation.digits;
	              }
	            }
	          },
	          alt_email: {
	            label: bundle.domicile.alt_email,
	            help: bundle.domicile.alt_email_hint
	          },
	          alt_mobile: {
	            label: bundle.domicile.alt_mobile,
	            help: bundle.domicile.alt_mobile_hint
	          },
	          go_invoice_form: {
	            label: bundle.is_invoiced
	          }
	        }
	      };
	    }
	  }, {
	    key: 'hasShipping',
	    value: function hasShipping() {
	      return this.props.order && this.props.order.domicile && this.props.order.domicile.shipping;
	    }
	  }, {
	    key: 'getCountryLabel',
	    value: function getCountryLabel() {
	      var _props = this.props;
	      var product = _props.product;
	      var locale = _props.locale;
	      var order = _props.order;
	
	      if (!this.hasShipping()) {
	        var shipping_countries = product.shipping_countries;
	        if (shipping_countries.length === 1) {
	          return locale.display_country(shipping_countries[0]);
	        } else {
	          return (0, _domainGet_bundle2['default'])(locale).order.domicile.country_label;
	        }
	      }
	      return locale.display_country(order.domicile.shipping.country);
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      this.setState({ value: _tcombReact.t.update(this.state.value, { country: { $set: country } }) });
	    }
	  }, {
	    key: 'getInitialValue',
	    value: function getInitialValue() {
	      var order = this.props.order;
	
	      if (!order || !order.domicile) {
	        return {
	          email: this.props.user.email,
	          mobile: this.props.user.mobile
	        };
	      }
	      return {
	        name: order.domicile.name,
	        surname: order.domicile.surname,
	        address: order.domicile.address,
	        co: order.domicile.co,
	        town: order.domicile.town,
	        district: order.domicile.district,
	        zip: order.domicile.zip,
	        country: this.getCountryLabel(),
	        email: this.props.user.email,
	        mobile_country: order.domicile.mobile_country,
	        mobile: this.props.user.mobile,
	        alt_email: order.domicile.alt_email,
	        alt_mobile: order.domicile.alt_mobile,
	        go_invoice_form: !!order.invoice
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'form-horizontal' },
	        _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(_tcombReact.t.form.Form, {
	            ref: 'DomicileContactForm',
	            type: this.getTypeForm(),
	            options: this.getOptionsForm(),
	            value: this.state.value,
	            onChange: this.onChange })
	        )
	      );
	    }
	  }]);
	
	  var _DomicileContactForm = DomicileContactForm;
	  DomicileContactForm = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    user: _domainUser2['default'],
	    order: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(DomicileContactForm) || DomicileContactForm;
	  return DomicileContactForm;
	})(_react2['default'].Component);
	
	exports['default'] = DomicileContactForm;
	module.exports = exports['default'];

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _tcombReact = __webpack_require__(168);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var InvoiceForm = (function (_React$Component) {
	  _inherits(InvoiceForm, _React$Component);
	
	  function InvoiceForm() {
	    _classCallCheck(this, _InvoiceForm);
	
	    _get(Object.getPrototypeOf(_InvoiceForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(InvoiceForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.InvoiceForm.getValue();
	    }
	  }, {
	    key: 'getTypeForm',
	    value: function getTypeForm() {
	      return _tcombReact.t.struct({
	        invoice_name: _tcombReact.t.Str,
	        invoice_vat: _tcombReact.t.Str,
	        invoice_address: _tcombReact.t.Str,
	        invoice_town: _tcombReact.t.Str,
	        invoice_district: _tcombReact.t.Str,
	        invoice_zip: _tcombReact.t.Str
	      }, 'Invoice');
	    }
	  }, {
	    key: 'getOptionsForm',
	    value: function getOptionsForm() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	
	      return {
	        config: { horizontal: {
	            md: [3, 9],
	            sm: [6, 6]
	          }
	        },
	        fields: {
	          invoice_name: {
	            label: bundle.invoice.name
	          },
	          invoice_vat: {
	            label: bundle.invoice.vat
	          },
	          invoice_address: {
	            label: bundle.invoice.address
	          },
	          invoice_town: {
	            label: bundle.invoice.town
	          },
	          invoice_district: {
	            label: bundle.invoice.district
	          },
	          invoice_zip: {
	            label: bundle.invoice.zip
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getInitialValue',
	    value: function getInitialValue() {
	      var order = this.props.order;
	      return {
	        invoice_name: order.invoice ? order.invoice.name : null,
	        invoice_vat: order.invoice ? order.invoice.vat : null,
	        invoice_address: order.invoice ? order.invoice.address : null,
	        invoice_town: order.invoice ? order.invoice.town : null,
	        invoice_district: order.invoice ? order.invoice.district : null,
	        invoice_zip: order.invoice ? order.invoice.zip : null
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var classes = (0, _classnames2['default'])({
	        'form-horizontal': true,
	        'large-hide': !this.props.doShow
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { className: classes, id: 'invoice_form' },
	        _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(_tcombReact.t.form.Form, {
	            ref: 'InvoiceForm',
	            type: this.getTypeForm(),
	            options: this.getOptionsForm(),
	            value: this.getInitialValue() })
	        )
	      );
	    }
	  }]);
	
	  var _InvoiceForm = InvoiceForm;
	  InvoiceForm = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    user: _domainUser2['default'],
	    order: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    doShow: _tcombReact.t.Bool
	  })(InvoiceForm) || InvoiceForm;
	  return InvoiceForm;
	})(_react2['default'].Component);
	
	exports['default'] = InvoiceForm;
	module.exports = exports['default'];

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(387);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsStripDiacritics = __webpack_require__(388);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var _Async = __webpack_require__(389);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Option = __webpack_require__(390);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(391);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		if (typeof value === 'object') {
			return JSON.stringify(value);
		} else {
			return value;
		}
	}
	
	var Select = _react2['default'].createClass({
	
		statics: { Async: _Async2['default'] },
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			allowCreate: _react2['default'].PropTypes.bool, // whether to allow creation of new entries
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: _react2['default'].PropTypes.string, // title for the "clear" control when multi: true
			clearValueText: _react2['default'].PropTypes.string, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			newOptionCreator: _react2['default'].PropTypes.func, // factory to create new options when allowCreate set
			noResultsText: _react2['default'].PropTypes.string, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			placeholder: _react2['default'].PropTypes.string, // field placeholder, displayed when there's no value
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				allowCreate: false,
				backspaceRemoves: true,
				clearAllText: 'Clear all',
				clearValueText: 'Clear value',
				clearable: true,
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: true,
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				multi: false,
				noResultsText: 'No results found',
				optionComponent: _Option2['default'],
				placeholder: 'Select...',
				searchable: true,
				simpleValue: false,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isLoading: false,
				isOpen: false,
				isPseudoFocused: false
			};
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputValue !== this.state.inputValue && this.props.onInputChange) {
				this.props.onInputChange(this.state.inputValue);
			}
			if (this._scrollToFocusedOptionOnUpdate && this.refs.focused && this.refs.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.refs.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.refs.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
		},
	
		focus: function focus() {
			if (!this.refs.input) return;
			this.refs.input.focus();
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		closeMenu: function closeMenu() {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi
			});
		},
	
		handleInputFocus: function handleInputFocus(event) {
			var isOpen = this.state.isOpen || this._openAfterFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			if (document.activeElement.isEqualNode(this.refs.menu)) {
				return;
			}
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			this.setState({
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			});
		},
	
		handleInputChange: function handleInputChange(event) {
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: event.target.value
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen) {
						return;
					}
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				// case 188: // ,
				// 	if (this.props.allowCreate && this.props.multi) {
				// 		event.preventDefault();
				// 		event.stopPropagation();
				// 		this.selectFocusedOption();
				// 	} else {
				// 		return;
				// 	}
				// break;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		getValueArray: function getValueArray() {
			var value = this.props.value;
			if (this.props.multi) {
				if (typeof value === 'string') value = value.split(this.props.delimiter);
				if (!Array.isArray(value)) {
					if (!value) return [];
					value = [value];
				}
				return value.map(this.expandValue).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value);
			return expandedValue ? [expandedValue] : [];
		},
	
		expandValue: function expandValue(value) {
			if (typeof value !== 'string' && typeof value !== 'number') return value;
			var _props = this.props;
			var options = _props.options;
			var valueKey = _props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this = this;
	
			if (!this.props.onChange) return;
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			if (this.props.multi) {
				this.addValue(value);
				this.setState({
					inputValue: ''
				});
			} else {
				this.setValue(value);
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray();
			this.setValue(valueArray.concat(value));
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray();
			if (!valueArray.length) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray();
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(null);
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.filter(function (i) {
				return !i.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || options[dir === 'next' ? 0 : options.length - 1]
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i]) {
					focusedIndex = i;
					break;
				}
			}
			var focusedOption = options[0];
			if (dir === 'next' && focusedIndex > -1 && focusedIndex < options.length - 1) {
				focusedOption = options[focusedIndex + 1];
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedOption = options[focusedIndex - 1];
				} else {
					focusedOption = options[options.length - 1];
				}
			}
			this.setState({
				focusedOption: focusedOption
			});
		},
	
		selectFocusedOption: function selectFocusedOption() {
			// if (this.props.allowCreate && !this.state.focusedOption) {
			// 	return this.selectValue(this.state.inputValue);
			// }
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this2 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							disabled: _this2.props.disabled,
							key: 'value-' + i + '-' + value[_this2.props.valueKey],
							onClick: onClick,
							onRemove: _this2.removeValue,
							value: value
						},
						renderLabel(value)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray) {
			var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
			if (this.props.disabled || !this.props.searchable) {
				if (this.props.multi && valueArray.length) return;
				return _react2['default'].createElement(
					'div',
					{ className: className },
					' '
				);
			}
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, this.props.inputProps, {
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				minWidth: '5',
				ref: 'input',
				value: this.state.inputValue
			}));
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText, 'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText, onMouseDown: this.clearValue, onTouchEnd: this.clearValue },
				_react2['default'].createElement('span', { className: 'Select-clear', dangerouslySetInnerHTML: { __html: '&times;' } })
			);
		},
	
		renderArrow: function renderArrow() {
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-arrow-zone', onMouseDown: this.handleMouseDownOnArrow },
				_react2['default'].createElement('span', { className: 'Select-arrow', onMouseDown: this.handleMouseDownOnArrow })
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var _this3 = this;
	
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (typeof this.props.filterOptions === 'function') {
				return this.props.filterOptions.call(this, options, filterValue, excludeOptions);
			} else if (this.props.filterOptions) {
				if (this.props.ignoreAccents) {
					filterValue = (0, _utilsStripDiacritics2['default'])(filterValue);
				}
				if (this.props.ignoreCase) {
					filterValue = filterValue.toLowerCase();
				}
				if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
					return i[_this3.props.valueKey];
				});
				return options.filter(function (option) {
					if (excludeOptions && excludeOptions.indexOf(option[_this3.props.valueKey]) > -1) return false;
					if (_this3.props.filterOption) return _this3.props.filterOption.call(_this3, option, filterValue);
					if (!filterValue) return true;
					var valueTest = String(option[_this3.props.valueKey]);
					var labelTest = String(option[_this3.props.labelKey]);
					if (_this3.props.ignoreAccents) {
						if (_this3.props.matchProp !== 'label') valueTest = (0, _utilsStripDiacritics2['default'])(valueTest);
						if (_this3.props.matchProp !== 'value') labelTest = (0, _utilsStripDiacritics2['default'])(labelTest);
					}
					if (_this3.props.ignoreCase) {
						if (_this3.props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
						if (_this3.props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
					}
					return _this3.props.matchPos === 'start' ? _this3.props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || _this3.props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : _this3.props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || _this3.props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
				});
			} else {
				return options;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			var _this4 = this;
	
			if (options && options.length) {
				var _ret = (function () {
					var Option = _this4.props.optionComponent;
					var renderLabel = _this4.props.optionRenderer || _this4.getOptionLabel;
					return {
						v: options.map(function (option, i) {
							var isSelected = valueArray && valueArray.indexOf(option) > -1;
							var isFocused = option === focusedOption;
							var optionRef = isFocused ? 'focused' : null;
							var optionClass = (0, _classnames2['default'])({
								'Select-option': true,
								'is-selected': isSelected,
								'is-focused': isFocused,
								'is-disabled': option.disabled
							});
							return _react2['default'].createElement(
								Option,
								{
									className: optionClass,
									isDisabled: option.disabled,
									isFocused: isFocused,
									key: 'option-' + i + '-' + option[_this4.props.valueKey],
									onSelect: _this4.selectValue,
									onFocus: _this4.focusOption,
									option: option,
									isSelected: isSelected,
									ref: optionRef
								},
								renderLabel(option)
							);
						})
					};
				})();
	
				if (typeof _ret === 'object') return _ret.v;
			} else {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this5 = this;
	
			if (!this.props.name) return;
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this5.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', { type: 'hidden', ref: 'value', name: this.props.name, value: value, disabled: this.props.disabled });
		},
	
		getFocusableOption: function getFocusableOption(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && options.indexOf(focusedOption) > -1) return focusedOption;
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return options[i];
			}
		},
	
		render: function render() {
			var valueArray = this.getValueArray();
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOption = this._focusedOption = this.getFocusableOption(valueArray[0]);
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
			return _react2['default'].createElement(
				'div',
				{ ref: 'wrapper', className: className, style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: 'control', className: 'Select-control', style: this.props.style, onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray),
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? _react2['default'].createElement(
					'div',
					{ ref: 'menuContainer', className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2['default'].createElement(
						'div',
						{ ref: 'menu', className: 'Select-menu', style: this.props.menuStyle, onScroll: this.handleMenuScroll, onMouseDown: this.handleMouseDownOnMenu },
						this.renderMenu(options, !this.props.multi ? valueArray : null, focusedOption)
					)
				) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(3);
	
	var sizerStyle = { position: 'absolute', visibility: 'hidden', height: 0, width: 0, overflow: 'scroll', whiteSpace: 'nowrap' };
	
	var nextFrame = typeof window !== 'undefined' ? (function () {
		return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
			window.setTimeout(callback, 1000 / 60);
		};
	})() : undefined; // If window is undefined, then we can't define a nextFrame function
	
	var AutosizeInput = React.createClass({
		displayName: 'AutosizeInput',
	
		propTypes: {
			value: React.PropTypes.any, // field value
			defaultValue: React.PropTypes.any, // default field value
			onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
			style: React.PropTypes.object, // css styles for the outer element
			className: React.PropTypes.string, // className for the outer element
			minWidth: React.PropTypes.oneOfType([// minimum width for input element
			React.PropTypes.number, React.PropTypes.string]),
			inputStyle: React.PropTypes.object, // css styles for the input element
			inputClassName: React.PropTypes.string // className for the input element
		},
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth
			};
		},
		componentDidMount: function componentDidMount() {
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate() {
			this.queueUpdateInputWidth();
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.isMounted() || !window.getComputedStyle) {
				return;
			}
			var inputStyle = window.getComputedStyle(this.refs.input);
			var widthNode = this.refs.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			if (this.props.placeholder) {
				var placeholderNode = this.refs.placeholderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			}
		},
		queueUpdateInputWidth: function queueUpdateInputWidth() {
			nextFrame(this.updateInputWidth);
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.isMounted() || typeof this.refs.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder) {
				newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.refs.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.refs.input;
		},
		focus: function focus() {
			this.refs.input.focus();
		},
		select: function select() {
			this.refs.input.select();
		},
		render: function render() {
			var escapedValue = (this.props.value || '').replace(/\&/g, '&amp;').replace(/ /g, '&nbsp;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth;
			inputStyle.boxSizing = 'content-box';
			var placeholder = this.props.placeholder ? React.createElement(
				'div',
				{ ref: 'placeholderSizer', style: sizerStyle },
				this.props.placeholder
			) : null;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('input', _extends({}, this.props, { ref: 'input', className: this.props.inputClassName, style: inputStyle })),
				React.createElement('div', { ref: 'sizer', style: sizerStyle, dangerouslySetInnerHTML: { __html: escapedValue } }),
				placeholder
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 388 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(386);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(388);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var requestId = 0;
	
	function initCache(cache) {
		if (cache && typeof cache !== 'object') {
			cache = {};
		}
		return cache ? cache : null;
	}
	
	function updateCache(cache, input, data) {
		if (!cache) return;
		cache[input] = data;
	}
	
	function getFromCache(cache, input) {
		if (!cache) return;
		for (var i = 0; i <= input.length; i++) {
			var cacheKey = input.slice(0, i);
			if (cache[cacheKey] && (input === cacheKey || cache[cacheKey].complete)) {
				return cache[cacheKey];
			}
		}
	}
	
	function thenPromise(promise, callback) {
		if (!promise || typeof promise.then !== 'function') return;
		promise.then(function (data) {
			callback(null, data);
		}, function (err) {
			callback(err);
		});
	}
	
	var Async = _react2['default'].createClass({
		displayName: 'Async',
	
		propTypes: {
			cache: _react2['default'].PropTypes.any, // object to use to cache results, can be null to disable cache
			loadOptions: _react2['default'].PropTypes.func.isRequired, // function to call to load options asynchronously
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering (shared with Select)
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering (shared with Select)
			isLoading: _react2['default'].PropTypes.bool, // overrides the isLoading state when set to true
			loadingPlaceholder: _react2['default'].PropTypes.string, // replaces the placeholder while options are loading
			minimumInput: _react2['default'].PropTypes.number, // the minimum number of characters that trigger loadOptions
			noResultsText: _react2['default'].PropTypes.string, // placeholder displayed when there are no matching search results (shared with Select)
			placeholder: _react2['default'].PropTypes.string, // field placeholder, displayed when there's no value (shared with Select)
			searchingText: _react2['default'].PropTypes.string, // message to display while options are loading
			searchPromptText: _react2['default'].PropTypes.string },
		// label to prompt for search input
		getDefaultProps: function getDefaultProps() {
			return {
				cache: true,
				ignoreAccents: true,
				ignoreCase: true,
				loadingPlaceholder: 'Loading...',
				minimumInput: 0,
				searchingText: 'Searching...',
				searchPromptText: 'Type to search'
			};
		},
		getInitialState: function getInitialState() {
			return {
				cache: initCache(this.props.cache),
				isLoading: false,
				options: []
			};
		},
		componentWillMount: function componentWillMount() {
			this._lastInput = '';
		},
		componentDidMount: function componentDidMount() {
			this.loadOptions('');
		},
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			if (nextProps.cache !== this.props.cache) {
				this.setState({
					cache: initCache(nextProps.cache)
				});
			}
		},
		resetState: function resetState() {
			this._currentRequestId = -1;
			this.setState({
				isLoading: false,
				options: []
			});
		},
		getResponseHandler: function getResponseHandler(input) {
			var _this = this;
	
			var _requestId = this._currentRequestId = requestId++;
			return function (err, data) {
				if (err) throw err;
				if (!_this.isMounted()) return;
				updateCache(_this.state.cache, input, data);
				if (_requestId !== _this._currentRequestId) return;
				_this.setState({
					isLoading: false,
					options: data && data.options || []
				});
			};
		},
		loadOptions: function loadOptions(input) {
			if (this.props.ignoreAccents) input = (0, _utilsStripDiacritics2['default'])(input);
			if (this.props.ignoreCase) input = input.toLowerCase();
			this._lastInput = input;
			if (input.length < this.props.minimumInput) {
				return this.resetState();
			}
			var cacheResult = getFromCache(this.state.cache, input);
			if (cacheResult) {
				return this.setState({
					options: cacheResult.options
				});
			}
			this.setState({
				isLoading: true
			});
			var responseHandler = this.getResponseHandler(input);
			thenPromise(this.props.loadOptions(input, responseHandler), responseHandler);
		},
		render: function render() {
			var noResultsText = this.props.noResultsText;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;
	
			if (this.props.isLoading) isLoading = true;
			var placeholder = isLoading ? this.props.loadingPlaceholder : this.props.placeholder;
			if (!options.length) {
				if (this._lastInput.length < this.props.minimumInput) noResultsText = this.props.searchPromptText;
				if (isLoading) noResultsText = this.props.searchingText;
			}
			return _react2['default'].createElement(_Select2['default'], _extends({}, this.props, {
				isLoading: isLoading,
				noResultsText: noResultsText,
				onInputChange: this.loadOptions,
				options: options,
				placeholder: placeholder
			}));
		}
	});
	
	module.exports = Async;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired },
		// object that is base for that option
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
		handleMouseEnter: function handleMouseEnter(event) {
			this.props.onFocus(this.props.option, event);
		},
		handleMouseMove: function handleMouseMove(event) {
			if (this.props.focused) return;
			this.props.onFocus(this.props.option, event);
		},
		render: function render() {
			var option = this.props.option;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					onMouseDown: this.onRemove,
					onTouchEnd: this.onRemove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.props.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainAmount = __webpack_require__(155);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainReducer = __webpack_require__(172);
	
	var _domainReducer2 = _interopRequireDefault(_domainReducer);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsConsole = __webpack_require__(305);
	
	var _componentsConsole2 = _interopRequireDefault(_componentsConsole);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _tcombReact = __webpack_require__(168);
	
	var ReducerView = (function (_React$Component) {
	  _inherits(ReducerView, _React$Component);
	
	  function ReducerView() {
	    var _this = this;
	
	    _classCallCheck(this, _ReducerView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_ReducerView.prototype), 'constructor', this).apply(this, args);
	
	    var do_reduce = function do_reduce(value) {
	      _this.props.do_reduce(value);
	    };
	    var do_skip = function do_skip() {
	      _this.props.do_skip();
	    };
	
	    var getStyleBtnColor = function getStyleBtnColor() {
	      return 'style="background-color:' + _this.props.themeBtnColor + '; color:' + _this.props.themeBtnFontColor + '"'; //, color:"' + this.props.themeBtnFontColor + '"'
	    };
	
	    var reducer_sandbox = {
	      locale: this.props.locale,
	      like_url: this.props.like_url,
	      gplus_url: this.props.gplus_url,
	      context: this.props.context,
	      default_privacy: this.props.sponsor ? this.props.sponsor.privacy : null,
	      do_reduce: do_reduce,
	      do_skip: do_skip,
	      styleBtnColor: getStyleBtnColor()
	    };
	
	    this.state = {
	      reducer: this.props.reducer.to_widget(reducer_sandbox)
	    };
	  }
	
	  _createClass(ReducerView, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getListPrice',
	    value: function getListPrice() {
	      return _domainAmount2['default'].format(this.props.locale, this.props.product.currency, this.props.product.list_price);
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        is_welcome: _domainRegistered2['default'].is(this.props.user),
	        showTutorial: false
	      };
	
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getReducerContent',
	    value: function getReducerContent() {
	      return _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: this.state.reducer.to_html() } });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.state.reducer.start();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.state.reducer.stop();
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.go_product,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getProductName',
	    value: function getProductName() {
	      return _react2['default'].createElement(
	        'h2',
	        { className: 'large-text-center' },
	        this.props.product.name
	      );
	    }
	  }, {
	    key: 'getReducer',
	    value: function getReducer() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var themeBgColor = _props.themeBgColor;
	      var themeBgFontColor = _props.themeBgFontColor;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).reducer;
	
	      var styleBgColor = {
	        backgroundColor: themeBgColor,
	        color: themeBgFontColor
	      };
	      var styleBorderRxColor = {
	        borderRightColor: themeBgColor
	      };
	
	      var triangleLeft = _react2['default'].createElement('div', { className: 'triangle-left medium-hide', style: styleBorderRxColor });
	      /* {triangleLeft} */
	      return _react2['default'].createElement(
	        'div',
	        { className: 'cell' },
	        _react2['default'].createElement(
	          'div',
	          { id: 'reducer_container' },
	          _react2['default'].createElement(
	            'div',
	            { id: 'reducer_title', className: 'box dark', style: styleBgColor },
	            _react2['default'].createElement(
	              'h1',
	              { className: 'large-text-center' },
	              bundle.title
	            ),
	            this.getProductName()
	          ),
	          this.getReducerContent()
	        )
	      );
	    }
	  }, {
	    key: 'getConsole',
	    value: function getConsole() {
	      var _props2 = this.props;
	      var product = _props2.product;
	      var locale = _props2.locale;
	
	      var doShowBonus = false;
	      var doShowTimeAgo = true;
	      var doShowConsole = true;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'cell' },
	        _react2['default'].createElement(_componentsConsole2['default'], {
	          doShowConsole: doShowConsole,
	          locale: locale,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBtnColor,
	          themeBgFontColor: this.props.themeBgFontColor,
	          themeBtnFontColor: this.props.themeBtnFontColor,
	          // message={this.props.message}
	          product: product,
	          goBuildOrder: this.props.goBuildOrder,
	          goPurchase: this.props.goPurchase,
	          // doReduce={this.props.doReduce}
	          oldPrice: this.props.oldPrice,
	          doShowBonus: doShowBonus,
	          doShowTimeAgo: doShowTimeAgo,
	          doShowProductName: false,
	          doShowArrowRight: true })
	      );
	      /*return (
	        <div className='cell'>
	          <div id='reducer_product'>
	            <div className='cell'>
	              <h3>{product.name}</h3>
	              <p>{product.description}</p>
	              <h3><del>{this.getListPrice()}</del></h3>
	            </div>
	            <img src={product.image}/>
	          </div>
	        </div>
	      );*/
	    }
	  }, {
	    key: 'getProductBox',
	    value: function getProductBox() {
	      var product = this.props.product;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'cell' },
	        _react2['default'].createElement(
	          'div',
	          { id: 'reducer_product' },
	          _react2['default'].createElement('img', { src: product.image }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              'h3',
	              null,
	              product.name
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              product.description
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getSmallLayout',
	    value: function getSmallLayout() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'small-100' },
	        this.getConsole(),
	        this.getReducer(),
	        this.getProductBox()
	      );
	    }
	  }, {
	    key: 'getLargeLayout',
	    value: function getLargeLayout() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'large-100' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-30' },
	          this.getConsole(),
	          this.getProductBox()
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-70' },
	          this.getReducer()
	        )
	      );
	    }
	  }, {
	    key: 'getReducerLayoutOld',
	    value: function getReducerLayoutOld() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-100 small-hide' },
	          this.getLargeLayout()
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'small-100 small-show large-hide' },
	          this.getSmallLayout()
	        )
	      );
	    }
	  }, {
	    key: 'getReducerLayout',
	    value: function getReducerLayout() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-30 small-100' },
	          this.getConsole(),
	          _react2['default'].createElement(
	            'div',
	            { className: 'small-hide' },
	            this.getProductBox()
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-70 small-100' },
	          this.getReducer()
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'small-100 small-show large-hide' },
	          this.getProductBox()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'reducer' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            this.getReducerLayout()
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ReducerView = ReducerView;
	  ReducerView = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    user: _domainUser2['default'],
	    product: _domainProduct2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    reducer: _domainReducer2['default'],
	    context: _tcombReact.t.Obj,
	    like_url: _tcombReact.t.Str,
	    gplus_url: _tcombReact.t.Str,
	    go_product: _tcombReact.t.Func,
	    do_reduce: _tcombReact.t.Func,
	    do_skip: _tcombReact.t.Func,
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goAccount: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    goBuildOrder: _tcombReact.t.maybe(_tcombReact.t.Func),
	    oldPrice: _tcombReact.t.maybe(_tcombReact.t.Num),
	    goPurchase: _tcombReact.t.Func
	  })(ReducerView) || ReducerView;
	  return ReducerView;
	})(_react2['default'].Component);
	
	exports['default'] = ReducerView;
	module.exports = exports['default'];

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainURL = __webpack_require__(160);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainWidget = __webpack_require__(238);
	
	var _domainWidget2 = _interopRequireDefault(_domainWidget);
	
	var _domainReducer = __webpack_require__(172);
	
	var _domainReducer2 = _interopRequireDefault(_domainReducer);
	
	var _componentsWidgetLayout = __webpack_require__(330);
	
	var _componentsWidgetLayout2 = _interopRequireDefault(_componentsWidgetLayout);
	
	var _componentsWidgetHeader = __webpack_require__(332);
	
	var _componentsWidgetHeader2 = _interopRequireDefault(_componentsWidgetHeader);
	
	var _tcombReact = __webpack_require__(168);
	
	var Reducer = (function (_React$Component) {
	  _inherits(Reducer, _React$Component);
	
	  function Reducer() {
	    var _this = this;
	
	    _classCallCheck(this, _Reducer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Reducer.prototype), 'constructor', this).apply(this, args);
	
	    var do_reduce = function do_reduce(value) {
	      _this.props.do_reduce(value);
	    };
	    var do_skip = function do_skip() {
	      _this.props.do_skip();
	    };
	
	    var getStyleBtnColor = function getStyleBtnColor() {
	      return 'style="background-color:' + _this.props.themeBtnColor + '; color:' + _this.props.themeBtnFontColor + '"'; //, color:"' + this.props.themeBtnFontColor + '"'
	    };
	
	    var reducer_sandbox = {
	      locale: this.props.locale,
	      like_url: this.props.like_url,
	      gplus_url: this.props.gplus_url,
	      context: this.props.context,
	      default_privacy: this.props.sponsor ? this.props.sponsor.privacy : null,
	      do_reduce: do_reduce,
	      do_skip: do_skip,
	      styleBtnColor: getStyleBtnColor()
	    };
	
	    this.state = {
	      reducer: this.props.reducer.to_widget(reducer_sandbox)
	    };
	  }
	
	  _createClass(Reducer, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsWidgetHeader2['default'], { widget: this.props.widget });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      return _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: this.state.reducer.to_html() } });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.state.reducer.start();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.state.reducer.stop();
	    }
	  }, {
	    key: 'getReducerLayout',
	    value: function getReducerLayout() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var themeBgColor = _props.themeBgColor;
	      var themeBgFontColor = _props.themeBgFontColor;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).reducer;
	
	      var styleBgColor = {
	        backgroundColor: themeBgColor,
	        color: themeBgFontColor
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'cell' },
	        _react2['default'].createElement(
	          'div',
	          { id: 'reducer_container' },
	          _react2['default'].createElement(
	            'div',
	            { id: 'reducer_title', className: 'box dark', style: styleBgColor },
	            _react2['default'].createElement(
	              'h1',
	              { className: 'large-text-center' },
	              bundle.title
	            )
	          ),
	          this.getContent()
	        )
	      );
	    }
	  }, {
	    key: 'getWidgetFooterImage',
	    value: function getWidgetFooterImage() {
	      if (!this.props.widget) {
	        return null;
	      }
	      return this.props.widget.footer_image;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      console.log("render");
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsWidgetLayout2['default'],
	        { header: this.getHeader(), locale: locale, miniSiteURL: this.props.miniSiteURL, footerImage: this.getWidgetFooterImage() },
	        _react2['default'].createElement(
	          'div',
	          { id: 'reducer' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            this.getReducerLayout()
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Reducer = Reducer;
	  Reducer = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    reducer: _domainReducer2['default'],
	    context: _tcombReact.t.Obj,
	    like_url: _tcombReact.t.Str,
	    gplus_url: _tcombReact.t.Str,
	    do_reduce: _tcombReact.t.Func,
	    do_skip: _tcombReact.t.Func,
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    widget: _tcombReact.t.maybe(_domainWidget2['default']),
	    miniSiteURL: _domainURL2['default']
	  })(Reducer) || Reducer;
	  return Reducer;
	})(_react2['default'].Component);
	
	exports['default'] = Reducer;
	module.exports = exports['default'];

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainProduct = __webpack_require__(143);
	
	var _domainProduct2 = _interopRequireDefault(_domainProduct);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainOrder = __webpack_require__(266);
	
	var _domainOrder2 = _interopRequireDefault(_domainOrder);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsAlert = __webpack_require__(233);
	
	var _componentsAlert2 = _interopRequireDefault(_componentsAlert);
	
	var _componentsProductCustomPayments = __webpack_require__(317);
	
	var _componentsProductCustomPayments2 = _interopRequireDefault(_componentsProductCustomPayments);
	
	var _componentsProductPayments = __webpack_require__(319);
	
	var _componentsProductPayments2 = _interopRequireDefault(_componentsProductPayments);
	
	var _componentsMarkdownComponent = __webpack_require__(166);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _componentsStdTable = __webpack_require__(316);
	
	var _componentsStdTable2 = _interopRequireDefault(_componentsStdTable);
	
	var _componentsDefaultUi = __webpack_require__(342);
	
	var _componentsDefaultUi2 = _interopRequireDefault(_componentsDefaultUi);
	
	var _componentsConditions = __webpack_require__(296);
	
	var _componentsConditions2 = _interopRequireDefault(_componentsConditions);
	
	var _componentsPolicy = __webpack_require__(395);
	
	var _componentsPolicy2 = _interopRequireDefault(_componentsPolicy);
	
	var _componentsCouponShipping = __webpack_require__(169);
	
	var _componentsCouponShipping2 = _interopRequireDefault(_componentsCouponShipping);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _tcombReact = __webpack_require__(168);
	
	var ApproveOrder = (function (_React$Component) {
	  _inherits(ApproveOrder, _React$Component);
	
	  function ApproveOrder() {
	    var _this = this;
	
	    _classCallCheck(this, _ApproveOrder);
	
	    _get(Object.getPrototypeOf(_ApproveOrder.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doApproveOrder = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.PrivacyForm.getValue();
	      if (value) {
	        _this.props.doApproveOrder(_this.props.order);
	      }
	    };
	
	    this.goBuildOrder = function (evt) {
	      evt.preventDefault();
	      _this.props.goBuildOrder(_this.props.order);
	    };
	  }
	
	  _createClass(ApproveOrder, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.goProduct,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getShipping',
	    value: function getShipping() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var product = _props.product;
	      var order = _props.order;
	
	      if (product.is_coupon) {
	        return _react2['default'].createElement(_componentsCouponShipping2['default'], {
	          locale: locale,
	          currency: product.currency });
	      }
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          null,
	          product.format_amount(locale, order.domicile.shipping.cost)
	        ),
	        _react2['default'].createElement(
	          _componentsMarkdownComponent2['default'],
	          null,
	          order.domicile.shipping.description
	        )
	      );
	    }
	  }, {
	    key: 'getSummary',
	    value: function getSummary() {
	      var _props2 = this.props;
	      var locale = _props2.locale;
	      var product = _props2.product;
	
	      var order_bundle = (0, _domainGet_bundle2['default'])(locale).order;
	
	      var data = [[order_bundle.summary.quantity, '1'], [order_bundle.summary.list_price, product.format_amount(locale, product.list_price)], [order_bundle.summary.price, product.format_amount(locale, product.runtime.price)]];
	      return _react2['default'].createElement(
	        _componentsStdTable2['default'],
	        null,
	        data
	      );
	    }
	  }, {
	    key: 'getBonusMessage',
	    value: function getBonusMessage() {
	      var _props3 = this.props;
	      var locale = _props3.locale;
	      var product = _props3.product;
	
	      if (!product.runtime.bonus || product.bonus_not_supported) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        _componentsAlert2['default'],
	        { type: 'warning' },
	        (0, _domainGet_bundle2['default'])(locale)['template_message']['approve_order.bonus_warning']
	      );
	    }
	  }, {
	    key: 'getPayment',
	    value: function getPayment() {
	      var _props4 = this.props;
	      var locale = _props4.locale;
	      var product = _props4.product;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _domainGet_bundle2['default'])(locale).product.payment
	        ),
	        _react2['default'].createElement(_componentsProductCustomPayments2['default'], { locale: locale, customPayments: product.custom_payments }),
	        _react2['default'].createElement(_componentsProductPayments2['default'], { locale: locale, payments: product.payments })
	      );
	    }
	  }, {
	    key: 'getDomicilieRows',
	    value: function getDomicilieRows(domicile) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order.domicile;
	      return [[bundle.name, domicile.name], [bundle.surname, domicile.surname], [bundle.address, domicile.address], [bundle.co, domicile.co], [bundle.town, domicile.town], [bundle.district, domicile.district], [bundle.zip, domicile.zip], [bundle.country, this.props.locale.display_country(domicile.shipping.country)], [bundle.email, domicile.email], [bundle.mobile, domicile.mobile], [bundle.alt_email, domicile.alt_email], [bundle.alt_mobile, domicile.alt_mobile]];
	    }
	  }, {
	    key: 'getCouponRows',
	    value: function getCouponRows(coupon) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order.coupon;
	      return [[bundle.name, coupon.name], [bundle.surname, coupon.surname], [bundle.email, coupon.email], [bundle.mobile, coupon.mobile]];
	    }
	  }, {
	    key: 'getContact',
	    value: function getContact() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      if (this.props.order.domicile) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.domicile.title
	          ),
	          _react2['default'].createElement(
	            _componentsStdTable2['default'],
	            null,
	            this.getDomicilieRows(this.props.order.domicile)
	          )
	        );
	      } else if (this.props.order.coupon) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.coupon.title
	          ),
	          _react2['default'].createElement(
	            _componentsStdTable2['default'],
	            null,
	            this.getCouponRows(this.props.order.coupon)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getInvoice',
	    value: function getInvoice() {
	      if (!this.props.order.invoice) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _domainGet_bundle2['default'])(this.props.locale).order.invoice.title
	        ),
	        _react2['default'].createElement(
	          _componentsStdTable2['default'],
	          null,
	          this.getInvoiceRows(this.props.order.invoice)
	        )
	      );
	    }
	  }, {
	    key: 'getInvoiceRows',
	    value: function getInvoiceRows(invoice) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return [[bundle.invoice.name, invoice.name], [bundle.invoice.vat, invoice.vat], [bundle.invoice.address, invoice.address], [bundle.invoice.town, invoice.town], [bundle.invoice.district, invoice.district], [bundle.invoice.zip, invoice.zip]];
	    }
	  }, {
	    key: 'getTypeForm',
	    value: function getTypeForm() {
	
	      var BoolTrue = _tcombReact.t.subtype(_tcombReact.t.Bool, function (x) {
	        return x;
	      });
	
	      var type = {
	        conditions: BoolTrue,
	        policy: BoolTrue
	      };
	
	      if (this.props.product.hasPrivacy()) {
	        type.privacy = BoolTrue;
	      }
	
	      return _tcombReact.t.struct(type, 'PrivacyForm');
	    }
	  }, {
	    key: 'getOptionsForm',
	    value: function getOptionsForm() {
	      var locale = this.props.locale;
	
	      var getErrorMessage = function getErrorMessage() {
	        var bundle = locale.language_bundle();
	        return bundle.validation.any;
	      };
	      return {
	        config: { horizontal: {
	            md: [3, 9],
	            sm: [6, 6]
	          }
	        },
	        fields: {
	          conditions: {
	            label: _react2['default'].createElement(_componentsConditions2['default'], { locale: locale }),
	            error: getErrorMessage()
	          },
	          policy: {
	            label: _react2['default'].createElement(_componentsPolicy2['default'], { locale: locale }),
	            error: getErrorMessage()
	          },
	          privacy: {
	            label: _react2['default'].createElement(
	              'a',
	              { href: '#', id: 'go_product_privacy', onClick: this.productPrivacyToggle },
	              (0, _domainGet_bundle2['default'])(locale).approve_order.privacy.product
	            ),
	            error: getErrorMessage()
	          }
	        }
	      };
	    }
	  }, {
	    key: 'productPrivacyToggle',
	    value: function productPrivacyToggle() {
	      $('#product_privacy').toggle();
	    }
	  }, {
	    key: 'getPrivacyForm',
	    value: function getPrivacyForm() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'form-horizontal' },
	        _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(_tcombReact.t.form.Form, {
	            ref: 'PrivacyForm',
	            type: this.getTypeForm(),
	            options: this.getOptionsForm() })
	        ),
	        this.getProductPrivacy()
	      );
	    }
	  }, {
	    key: 'getProductPrivacy',
	    value: function getProductPrivacy() {
	      if (!this.props.product.hasPrivacy()) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'div',
	        { id: 'product_privacy', className: 'box light large-hide' },
	        this.props.product.privacy
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props;
	      var locale = _props5.locale;
	      var product = _props5.product;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).approve_order;
	      var order_bundle = (0, _domainGet_bundle2['default'])(locale).order;
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          _componentsDefaultUi2['default'],
	          { id: 'approve_order', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'a',
	                  { id: 'go_build_order', onClick: this.goBuildOrder, className: 'back', href: '#' },
	                  bundle.go_build_order
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 medium-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement('img', { className: 'product-image', src: product.image }),
	                this.getPayment()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 medium-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.props.message,
	                _react2['default'].createElement(
	                  'h2',
	                  null,
	                  product.name
	                ),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  order_bundle.summary.title
	                ),
	                this.getSummary(),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  order_bundle.shippings.title
	                ),
	                this.getShipping(),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'large-hide medium-show' },
	                  this.getPayment()
	                ),
	                this.getContact(),
	                this.getInvoice(),
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  bundle.privacy.title
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  bundle.privacy.disclaimer
	                ),
	                this.getPrivacyForm(),
	                this.getBonusMessage(),
	                _react2['default'].createElement(
	                  'button',
	                  { id: 'do_approve_order', className: 'large-left-30p small-left-0p', onClick: this.doApproveOrder, style: btnStyle },
	                  product.getBuyButtonLabel(locale)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ApproveOrder = ApproveOrder;
	  ApproveOrder = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    product: _domainProduct2['default'],
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    order: _tcombReact.t.maybe(_domainOrder2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    message: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    goBuildOrder: _tcombReact.t.Func,
	    doApproveOrder: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func,
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(ApproveOrder) || ApproveOrder;
	  return ApproveOrder;
	})(_react2['default'].Component);
	
	exports['default'] = ApproveOrder;
	module.exports = exports['default'];

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainGetMadaiURL = __webpack_require__(247);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _tcombReact = __webpack_require__(168);
	
	var Policy = (function (_React$Component) {
	  _inherits(Policy, _React$Component);
	
	  function Policy() {
	    var _this = this;
	
	    _classCallCheck(this, _Policy);
	
	    _get(Object.getPrototypeOf(_Policy.prototype), 'constructor', this).apply(this, arguments);
	
	    this.getHRef = function () {
	      if (_this.props.locale.toJSON() === 'it_IT') {
	        return 'https://it.madai.com/privacy.html';
	      }
	      return 'https://madai.com/privacy.html';
	    };
	  }
	
	  _createClass(Policy, [{
	    key: 'render',
	    value: function render() {
	
	      //const href = "https://madai.com/faq_us.html"
	      //const href = getMadaiURL() + this.props.locale.country.toLowerCase() + '/privacy.html';
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: this.getHRef() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.policy
	      );
	    }
	  }]);
	
	  var _Policy = Policy;
	  Policy = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(Policy) || Policy;
	  return Policy;
	})(_react2['default'].Component);
	
	exports['default'] = Policy;
	module.exports = exports['default'];

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _domainRegistered = __webpack_require__(79);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainColor = __webpack_require__(161);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(54);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsHeaderUser = __webpack_require__(345);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _tcombReact = __webpack_require__(168);
	
	var Captcha = (function (_React$Component) {
	  _inherits(Captcha, _React$Component);
	
	  function Captcha() {
	    _classCallCheck(this, _Captcha);
	
	    _get(Object.getPrototypeOf(_Captcha.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Captcha, [{
	    key: 'getColor',
	    value: function getColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.color;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goPurchases: this.props.goPurchases,
	        goChangePassword: this.props.goChangePassword,
	        doLogout: this.props.doLogout,
	        goProduct: this.props.go_product,
	        user: this.props.user,
	        color: this.getColor(),
	        themeBtnColor: this.props.themeBtnColor,
	        themeBtnFontColor: this.props.themeBtnFontColor });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        is_welcome: _domainRegistered2['default'].is(this.props.user),
	        showTutorial: false
	      };
	
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).captcha;
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), partners: this.props.partners, sponsor: this.getSponsor(), bgColor: this.getBgColor(), locale: locale },
	        _react2['default'].createElement(
	          'div',
	          { id: 'captcha' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            _react2['default'].createElement(
	              'strong',
	              null,
	              bundle.disclaimer
	            )
	          ),
	          _react2['default'].createElement('iframe', { id: 'captcha_iframe', src: this.props.captcha_url })
	        )
	      );
	    }
	  }]);
	
	  var _Captcha = Captcha;
	  Captcha = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    user: _domainUser2['default'],
	    sponsor: _tcombReact.t.maybe(_domainSponsor2['default']),
	    go_product: _tcombReact.t.Func,
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goAccount: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    captcha_url: _tcombReact.t.Str,
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(Captcha) || Captcha;
	  return Captcha;
	})(_react2['default'].Component);
	
	exports['default'] = Captcha;
	module.exports = exports['default'];

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(49);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(55);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainWidget = __webpack_require__(238);
	
	var _domainWidget2 = _interopRequireDefault(_domainWidget);
	
	var _componentsWidgetLayout = __webpack_require__(330);
	
	var _componentsWidgetLayout2 = _interopRequireDefault(_componentsWidgetLayout);
	
	var _componentsWidgetHeader = __webpack_require__(332);
	
	var _componentsWidgetHeader2 = _interopRequireDefault(_componentsWidgetHeader);
	
	var _tcombReact = __webpack_require__(168);
	
	var Captcha = (function (_React$Component) {
	  _inherits(Captcha, _React$Component);
	
	  function Captcha() {
	    _classCallCheck(this, _Captcha);
	
	    _get(Object.getPrototypeOf(_Captcha.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Captcha, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsWidgetHeader2['default'], { widget: this.props.widget });
	    }
	  }, {
	    key: 'getWidgetFooterImage',
	    value: function getWidgetFooterImage() {
	      if (!this.props.widget) {
	        return null;
	      }
	      return this.props.widget.footer_image;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).captcha;
	      return _react2['default'].createElement(
	        _componentsWidgetLayout2['default'],
	        { header: this.getHeader(), locale: locale },
	        _react2['default'].createElement(
	          'div',
	          { id: 'captcha' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            _react2['default'].createElement(
	              'strong',
	              null,
	              bundle.disclaimer
	            )
	          ),
	          _react2['default'].createElement('iframe', { id: 'captcha_iframe', src: this.props.captcha_url })
	        )
	      );
	    }
	  }]);
	
	  var _Captcha = Captcha;
	  Captcha = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    captcha_url: _tcombReact.t.Str,
	    widget: _tcombReact.t.maybe(_domainWidget2['default'])
	  })(Captcha) || Captcha;
	  return Captcha;
	})(_react2['default'].Component);
	
	exports['default'] = Captcha;
	module.exports = exports['default'];

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainSponsor = __webpack_require__(159);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(293);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(304);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombReact = __webpack_require__(168);
	
	var UnexpectedError = (function (_React$Component) {
	  _inherits(UnexpectedError, _React$Component);
	
	  function UnexpectedError() {
	    var _this = this;
	
	    _classCallCheck(this, _UnexpectedError);
	
	    _get(Object.getPrototypeOf(_UnexpectedError.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doRefresh = function (evt) {
	      evt.preventDefault();
	      _this.props.doRefresh();
	    };
	  }
	
	  _createClass(UnexpectedError, [{
	    key: 'getBgColor',
	    value: function getBgColor() {
	      if (!this.props.sponsor) {
	        return null;
	      }
	      return this.props.sponsor.bg_color;
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { sponsor: this.props.sponsor, locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { locale: this.props.locale, sponsor: this.getSponsor(), bgColor: this.getBgColor(), doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'unexpected_error' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            'An unexpected error has occured :-('
	          ),
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Please try again after a few moments: ',
	            _react2['default'].createElement(
	              'a',
	              { href: '#', target: '_self', onClick: this.doRefresh },
	              'click here'
	            )
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'If you continue to receive this page, please contact customer service at ',
	            _react2['default'].createElement(
	              'a',
	              { href: 'mailto:support@madai.com', target: '_new' },
	              'support@madai.com'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _UnexpectedError = UnexpectedError;
	  UnexpectedError = (0, _tcombReact.props)({
	    locale: _tcombReact.t.Obj,
	    sponsor: _domainSponsor2['default'],
	    doAcceptCookies: _tcombReact.t.Func,
	    doRefresh: _tcombReact.t.Func,
	    err: _tcombReact.t.Obj
	  })(UnexpectedError) || UnexpectedError;
	  return UnexpectedError;
	})(_react2['default'].Component);
	
	exports['default'] = UnexpectedError;
	module.exports = exports['default'];

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(86);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var getHelp = function getHelp(help) {
	  if (!help) {
	    return null;
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'hint' },
	    help
	  );
	};
	
	var getError = function getError(error, hasError) {
	  if (!hasError || !error) {
	    return null;
	  }
	  return _react2['default'].createElement(
	    'div',
	    { className: 'error' },
	    error
	  );
	};
	
	var isHorizontal = function isHorizontal(locals) {
	  return locals && locals.config && locals.config.horizontal;
	};
	
	var getStackedForm = function getStackedForm(locals) {
	  return locals.order.map(function (inputLabel, index) {
	    return getStackedContainerComponent(locals.inputs[inputLabel], index);
	  });
	};
	
	var getInlineForm = function getInlineForm(locals) {
	  return locals.order.map(function (inputLabel, index) {
	    return getInlineContainerComponent(locals.inputs[inputLabel], index);
	  });
	};
	
	var getInlineContainerComponent = function getInlineContainerComponent(input, index) {
	  var _opts = {
	    'form-group': true,
	    'nr-form-cells-2': true
	  };
	  _opts['form-group-' + index] = true;
	  var classes = (0, _classnames2['default'])(_opts);
	  return _react2['default'].createElement(
	    'div',
	    { key: index, className: classes },
	    input
	  );
	};
	
	var getStackedContainerComponent = function getStackedContainerComponent(input, index) {
	  var _opts = {
	    'form-group': true,
	    'nr-form-cells-1': true
	  };
	  _opts['form-group-' + index] = true;
	  var classes = (0, _classnames2['default'])(_opts);
	  return _react2['default'].createElement(
	    'div',
	    { key: index, className: classes },
	    input
	  );
	};
	
	function struct(locals) {
	  if (isHorizontal(locals)) {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'form form-inline' },
	      getInlineForm(locals)
	    );
	  }
	  return _react2['default'].createElement(
	    'div',
	    { className: 'form form-stacked' },
	    getStackedForm(locals)
	  );
	}
	
	var getHiddenTextbox = function getHiddenTextbox(hiddenTextbox) {
	  return _react2['default'].createElement('input', { type: 'hidden', value: hiddenTextbox.value, name: hiddenTextbox.name });
	};
	
	var getStaticTextbox = function getStaticTextbox(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: 'form-cell form-cell-0' },
	      _react2['default'].createElement(
	        'label',
	        null,
	        locals.label
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: 'form-cell form-cell-1' },
	      locals.value
	    )
	  );
	};
	
	function getInputClasses(hasError) {
	  return (0, _classnames2['default'])({
	    'form-cell': true,
	    'form-cell-1': true,
	    'has-error': hasError
	  });
	}
	
	function getLabel(label, hasError) {
	  if (!label) {
	    return null;
	  }
	  var labelClasses = (0, _classnames2['default'])({
	    'form-cell': true,
	    'form-cell-0': true,
	    'has-error': hasError
	  });
	  return _react2['default'].createElement(
	    'div',
	    { className: labelClasses },
	    _react2['default'].createElement(
	      'label',
	      null,
	      label
	    )
	  );
	}
	
	function textbox(locals) {
	  if (locals.type === 'hidden') {
	    return getHiddenTextbox(locals);
	  }
	
	  if (locals.type === 'static') {
	    return getStaticTextbox(locals);
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getTextboxInput(locals)
	      )
	    )
	  );
	}
	
	function getTextboxInput(locals) {
	  var _onChange = function _onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var name = locals.attrs['name'];
	
	  var tag = _react2['default'].createElement('input', { id: locals.attrs[name], type: locals.type, value: locals.value, onChange: _onChange });
	  if (locals.type === 'textarea') {
	    tag = _react2['default'].createElement('textarea', { id: locals.attrs[name], type: locals.type, value: locals.value, onChange: _onChange });
	  }
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal
	  });
	  if (locals.type !== 'textarea') {
	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      tag,
	      getError(locals.error, locals.hasError),
	      getHelp(locals.help)
	    );
	  }
	}
	
	function getCheckboxInput(locals) {
	  var _onChange = function _onChange(evt) {
	    return locals.onChange(evt.target.checked);
	  };
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal ? true : false
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: classes },
	    _react2['default'].createElement('input', { id: locals.attrs.id, type: 'checkbox', disbled: locals.disabled, value: locals.value, onChange: _onChange })
	  );
	}
	
	function checkbox(locals) {
	  var inputClasses = (0, _classnames2['default'])({
	    'form-cell': true,
	    'form-cell-0': true,
	    'has-error': locals.hasError
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: inputClasses },
	      getCheckboxInput(locals)
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'label',
	        null,
	        locals.label
	      ),
	      getError(locals.error, locals.hasError),
	      getHelp(locals.help)
	    )
	  );
	}
	
	function select(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getSelectInput(locals)
	      )
	    )
	  );
	}
	
	function getSelectInput(locals) {
	  var _onChange = function _onChange(evt) {
	    var value = locals.isMultiple ? Array.prototype.slice.call(evt.target.options).filter(function (option) {
	      return option.selected;
	    }).map(function (option) {
	      return option.value;
	    }) : evt.target.value;
	    locals.onChange(value);
	  };
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal ? true : false
	  });
	
	  var getOptions = function getOptions() {
	    return locals.options.map(function (opt, index) {
	      return _react2['default'].createElement(
	        'option',
	        { key: index, value: opt.value },
	        opt.text
	      );
	    });
	  };
	
	  return _react2['default'].createElement(
	    'div',
	    { className: classes },
	    _react2['default'].createElement(
	      'select',
	      { id: locals.attrs.id, multiple: locals.multiple, disbled: locals.disabled, value: locals.value, onChange: _onChange },
	      getOptions()
	    ),
	    getError(locals.error, locals.hasError),
	    getHelp(locals.help)
	  );
	}
	
	function radio(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getRadioInput(locals)
	      )
	    )
	  );
	}
	
	function getRadioInput(locals) {
	  var _onChange = function _onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var id = locals.attrs.id;
	  return locals.options.map(function (opt, index) {
	    var isChecked = opt.value === locals.value;
	    var optId = id + '_' + index;
	
	    return _react2['default'].createElement(
	      'div',
	      { key: index, id: locals.attrs.name },
	      _react2['default'].createElement(
	        'div',
	        { className: 'group-input' },
	        _react2['default'].createElement('input', { id: optId, type: 'radio', disabled: locals.disabled, checked: isChecked, value: opt.value, onChange: _onChange })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'group-label' },
	        opt.text
	      )
	    );
	  });
	}
	
	function range(n) {
	  var result = [];
	  for (var i = 1; i <= n; i++) {
	    result.push(i);
	  }
	  return result;
	}
	
	function padLeft(x, len) {
	  var str = String(x);
	  var times = len - str.length;
	  for (var i = 0; i < times; i++) {
	    str = '0' + str;
	  }
	  return str;
	}
	
	function toOption(value, text, key) {
	  return _react2['default'].createElement(
	    'option',
	    { key: key, value: value },
	    text
	  );
	}
	
	var nullOption = function nullOption(key) {
	  return [toOption('', '-', key + '-0')];
	};
	
	var optionsDays = nullOption('days').concat(range(31).map(function (i) {
	  return toOption(i, padLeft(i, 2), 'days-' + i);
	}));
	
	var optionsMonths = nullOption('months').concat(range(12).map(function (i) {
	  return toOption(i - 1, padLeft(i, 2), 'months-' + i);
	}));
	
	function date(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getDateInput(locals)
	      )
	    )
	  );
	}
	
	function getDateInput(locals) {
	  var value = locals.value.slice();
	
	  var onDayChange = function onDayChange(evt) {
	    value[2] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  };
	
	  var onMonthChange = function onMonthChange(evt) {
	    value[1] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  };
	
	  var onYearChange = function onYearChange(evt) {
	    value[0] = evt.target.value.trim() === '' ? null : evt.target.value.trim();
	    locals.onChange(value);
	  };
	
	  var days = function days() {
	    return _react2['default'].createElement(
	      'select',
	      { key: 'days', className: 'days', disabled: locals.disabled, value: value[2], onChange: onDayChange },
	      optionsDays
	    );
	  };
	
	  var months = function months() {
	    return _react2['default'].createElement(
	      'select',
	      { key: 'months', className: 'months', disabled: locals.disabled, value: value[1], onChange: onMonthChange },
	      optionsMonths
	    );
	  };
	
	  var years = function years() {
	    return _react2['default'].createElement('input', { key: 'years', className: 'years', type: 'text', disabled: locals.disabled, maxLength: 4, size: 4, value: value[0], onChange: onYearChange });
	  };
	
	  var parts = {
	    D: days(),
	    M: months(),
	    YY: years()
	  };
	
	  var children = locals.order.map(function (id) {
	    return parts[id];
	  });
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal ? true : false
	  });
	  return _react2['default'].createElement(
	    'div',
	    { className: classes },
	    children,
	    getError(locals.error, locals.hasError),
	    getHelp(locals.help)
	  );
	}
	
	function list() {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    'list'
	  );
	}
	
	exports['default'] = {
	  textbox: textbox,
	  checkbox: checkbox,
	  select: select,
	  radio: radio,
	  date: date,
	  struct: struct,
	  list: list
	};
	module.exports = exports['default'];

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Checkboxes_Input2 = __webpack_require__(401);
	
	var _Checkboxes_Input3 = _interopRequireDefault(_Checkboxes_Input2);
	
	exports.Checkboxes_Input = _Checkboxes_Input3['default'];
	
	var _Routing_Checkboxes_Input2 = __webpack_require__(402);
	
	var _Routing_Checkboxes_Input3 = _interopRequireDefault(_Routing_Checkboxes_Input2);
	
	exports.Routing_Checkboxes_Input = _Routing_Checkboxes_Input3['default'];
	
	var _Field_Component_Input2 = __webpack_require__(403);
	
	var _Field_Component_Input3 = _interopRequireDefault(_Field_Component_Input2);
	
	exports.Field_Component_Input = _Field_Component_Input3['default'];
	
	var _Gplus_Input2 = __webpack_require__(404);
	
	var _Gplus_Input3 = _interopRequireDefault(_Gplus_Input2);
	
	exports.Gplus_Input = _Gplus_Input3['default'];
	
	var _Like_Input2 = __webpack_require__(405);
	
	var _Like_Input3 = _interopRequireDefault(_Like_Input2);
	
	exports.Like_Input = _Like_Input3['default'];
	
	var _Matrix_Input2 = __webpack_require__(406);
	
	var _Matrix_Input3 = _interopRequireDefault(_Matrix_Input2);
	
	exports.Matrix_Input = _Matrix_Input3['default'];
	
	var _Select_Component_Input2 = __webpack_require__(408);
	
	var _Select_Component_Input3 = _interopRequireDefault(_Select_Component_Input2);
	
	exports.Select_Component_Input = _Select_Component_Input3['default'];
	
	//export * from '../base';
	__webpack_require__(409);

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainStyleCheckboxes_Style = __webpack_require__(219);
	
	var _webDomainStyleCheckboxes_Style2 = _interopRequireDefault(_webDomainStyleCheckboxes_Style);
	
	var _webDomainCheckboxes_Other = __webpack_require__(220);
	
	var _webDomainCheckboxes_Other2 = _interopRequireDefault(_webDomainCheckboxes_Other);
	
	var _webDomainGet_bundle = __webpack_require__(49);
	
	var _webDomainGet_bundle2 = _interopRequireDefault(_webDomainGet_bundle);
	
	var _webDomainValidation = __webpack_require__(196);
	
	var _webDomainValidation2 = _interopRequireDefault(_webDomainValidation);
	
	var _webDomainArr_Schema = __webpack_require__(218);
	
	var _webDomainArr_Schema2 = _interopRequireDefault(_webDomainArr_Schema);
	
	var Checkboxes_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  style: _webDomainStyleCheckboxes_Style2['default'],
	  options: _tcomb2['default'].list(_tcomb2['default'].tuple([_tcomb2['default'].Str, _tcomb2['default'].Str, _tcomb2['default'].maybe(_tcomb2['default'].Bool)])),
	  schema: _webDomainArr_Schema2['default'],
	  other: _tcomb2['default'].maybe(_webDomainCheckboxes_Other2['default']),
	  other_label: _tcomb2['default'].maybe(_tcomb2['default'].String)
	}, 'Checkboxes_Input');
	
	/*
	export default function Checkboxes_Input(id, style, options, schema, other) {
	  jsdk.assert(jsdk.UUID.is(id));
	  jsdk.assert(Checkboxes_Style.is(style));
	  jsdk.assert(jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str, jsdk.Maybe(jsdk.Bool)])).is(options));
	  jsdk.assert(jsdk.Arr_Schema.is(schema));
	  jsdk.assert(jsdk.Maybe(Checkboxes_Other).is(other));
	
	  this.type = 'reducer/checkboxes';
	  this.id = id;
	  this.style = style;
	  this.options = options;
	  this.schema = schema;
	  this.other = other;
	  return jsdk.freeze(this);
	}
	
	Checkboxes_Input.is = function(x) {
	  return x instanceof Checkboxes_Input;
	};
	
	Checkboxes_Input.of = function(x) {
	  jsdk.assert(jsdk.Obj.is(x));
	  return new Checkboxes_Input(
	    jsdk.UUID.of(x.id),
	    Checkboxes_Style.of(x.style),
	    jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str, jsdk.Maybe(jsdk.Bool)])).of(x.options),
	    jsdk.Arr_Schema.of(x.schema),
	    jsdk.Maybe(Checkboxes_Other).of(x.other)
	  );
	};
	*/
	
	Checkboxes_Input.prototype.focus = function () {
	
	  // se l'utente ha scelto l'opzione altro non metto il focus perchè lo perderebbe la textbox
	  // altrimenti metto il focus sulla prima checkbox
	
	  if (!(this.other && $('#' + this.other.option_id).is(':checked'))) {
	    $('#' + this.id + ' input[type=checkbox]:nth(0)').focus();
	  }
	};
	
	Checkboxes_Input.prototype.block_but = function (id) {
	  this.options.forEach(function (option) {
	    if (option[0] !== id) {
	      $('#' + option[0]).prop('disabled', true).prop('checked', false);
	    }
	  });
	  if (this.other) {
	    $('#' + this.other.option_id).prop('disabled', true).prop('checked', false);
	    $('#' + this.other.textbox_id).prop('disabled', true).val('');
	  }
	};
	
	Checkboxes_Input.prototype.unblock = function () {
	  $('#' + this.id + ' input[type=checkbox]').prop('disabled', false);
	  if (this.other) {
	    $('#' + this.other.textbox_id).prop('disabled', false);
	  }
	};
	
	Checkboxes_Input.prototype.start = function () {
	  var self = this;
	  $('#' + this.id).on('change', 'input[type=checkbox]', function () {
	    var is_exclusive = $(this).attr('is_exclusive') === 'true';
	    if (is_exclusive) {
	      var is_checked = $(this).is(':checked');
	      if (is_checked) {
	        var id = $(this).attr('id');
	        self.block_but(id);
	      } else {
	        self.unblock();
	      }
	    }
	  });
	};
	
	Checkboxes_Input.prototype.stop = function () {
	  $('#' + this.id).off();
	};
	
	Checkboxes_Input.prototype.to_html = function (value, locale) {
	
	  var self = this;
	  var bundle = (0, _webDomainGet_bundle2['default'])(locale).reducer;
	
	  var options = this.options.slice();
	
	  // Se c'è l'opzione altro aggiungo una option in ultima posizione
	  if (this.other) {
	    var other_option = [this.other.option_id, this.other_label || bundle.other];
	    options.push(other_option);
	  }
	
	  // I margini vanno sul contenitore
	  var styles = _jsdk2['default'].split_margins(this.style);
	
	  // Converto le option in una tabella a due colonne
	  // nella prima metto le checkbox, nella seconda le label
	  var option_to_table_row = function option_to_table_row(option) {
	    return '<div class="group-input">' + _jsdk2['default'].dom.checkbox({
	      id: option[0],
	      is_exclusive: option[2]
	    }) + '</div>' + '<div class="group-label">' + option[1] + '</div>';
	  };
	
	  var attrs = {
	    id: self.id,
	    style: styles.other
	  };
	
	  var html = _jsdk2['default'].dom.div(options.map(option_to_table_row).join(''), attrs);
	
	  // Se c'è l'opzione altro aggiungo una textbox alla fine
	  if (this.other) {
	    html += _jsdk2['default'].dom.textbox({
	      id: this.other.textbox_id
	    });
	  }
	
	  return _jsdk2['default'].Form.wrap_input(this.id, html, styles.margins);
	};
	
	Checkboxes_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Checkboxes_Input.prototype.value = function (locale) {
	  //jsdk.assert(Locale.is(locale));
	  //recupero i valori delle checkbox
	  var option_values = this.options.map(function (option) {
	    return [option[0], $('#' + option[0]).is(':checked')];
	  });
	  if (this.other) {
	    // se c'è l'opzione altro recupero il valore della checkbox altro
	    option_values.push([this.other.option_id, $('#' + this.other.option_id).is(':checked')]);
	  }
	  //calcolo quanti sono i true per la validazione
	  var trues = option_values.filter(function (x) {
	    return x[1] === true;
	  });
	  var validation = this.schema.validate(trues);
	
	  if (validation.rule === null) {
	    if (this.other && option_values[option_values.length - 1][1]) {
	      // se l'utente ha selezionato anche l'opzione altro..
	      var textbox_id = this.other.textbox_id;
	      var textbox_value = $('#' + textbox_id).val(); // recupero il valore della textbox
	      var textbox_validation = this.other.schema.validate(textbox_value); // valido la textbox
	      if (textbox_validation.rule) {
	        // se la textbox non va bene, gli metto il focus
	        $('#' + textbox_id).focus();
	        validation = textbox_validation;
	      } else {
	        // se è andato tutto bene, concateno i valori delle checkbox e della textbox
	        option_values.push([textbox_id, textbox_validation.x]);
	        validation = new _webDomainValidation2['default']({ x: option_values });
	      }
	    } else {
	      validation = new _webDomainValidation2['default']({ x: option_values });
	    }
	  }
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('reducer/checkboxes', Checkboxes_Input);
	
	exports['default'] = Checkboxes_Input;
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainStyleCheckboxes_Style = __webpack_require__(219);
	
	var _webDomainStyleCheckboxes_Style2 = _interopRequireDefault(_webDomainStyleCheckboxes_Style);
	
	var _webDomainCheckboxes_Other = __webpack_require__(220);
	
	var _webDomainCheckboxes_Other2 = _interopRequireDefault(_webDomainCheckboxes_Other);
	
	var _webDomainGet_bundle = __webpack_require__(49);
	
	var _webDomainGet_bundle2 = _interopRequireDefault(_webDomainGet_bundle);
	
	var _webDomainValidation = __webpack_require__(196);
	
	var _webDomainValidation2 = _interopRequireDefault(_webDomainValidation);
	
	var _webDomainArr_Schema = __webpack_require__(218);
	
	var _webDomainArr_Schema2 = _interopRequireDefault(_webDomainArr_Schema);
	
	var _lodashCollectionSortBy = __webpack_require__(258);
	
	var _lodashCollectionSortBy2 = _interopRequireDefault(_lodashCollectionSortBy);
	
	var Routing_Checkboxes_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  style: _webDomainStyleCheckboxes_Style2['default'],
	  options: _tcomb2['default'].list(_tcomb2['default'].tuple([_tcomb2['default'].Str, _tcomb2['default'].Str, _tcomb2['default'].maybe(_tcomb2['default'].Bool), _tcomb2['default'].maybe(_tcomb2['default'].Number)])),
	  schema: _webDomainArr_Schema2['default'],
	  other: _tcomb2['default'].maybe(_webDomainCheckboxes_Other2['default']),
	  other_label: _tcomb2['default'].maybe(_tcomb2['default'].String)
	}, 'Routing_Checkboxes_Input');
	
	Routing_Checkboxes_Input.prototype.focus = function () {
	
	  // se l'utente ha scelto l'opzione altro non metto il focus perchè lo perderebbe la textbox
	  // altrimenti metto il focus sulla prima checkbox
	
	  if (!(this.other && $('#' + this.other.option_id).is(':checked'))) {
	    $('#' + this.id + ' input[type=checkbox]:nth(0)').focus();
	  }
	};
	
	Routing_Checkboxes_Input.prototype.block_but = function (id) {
	  this.options.forEach(function (option) {
	    if (option[0] !== id) {
	      $('#' + option[0]).prop('disabled', true).prop('checked', false);
	    }
	  });
	  if (this.other) {
	    $('#' + this.other.option_id).prop('disabled', true).prop('checked', false);
	    $('#' + this.other.textbox_id).prop('disabled', true).val('');
	  }
	};
	
	Routing_Checkboxes_Input.prototype.unblock = function () {
	  $('#' + this.id + ' input[type=checkbox]').prop('disabled', false);
	  if (this.other) {
	    $('#' + this.other.textbox_id).prop('disabled', false);
	  }
	};
	
	Routing_Checkboxes_Input.prototype.start = function () {
	  var self = this;
	  $('#' + this.id).on('change', 'input[type=checkbox]', function () {
	
	    var getCheckedOptions = function getCheckedOptions() {
	      var optionsTrue = [];
	      for (var i = 0; i < self.options.length; i++) {
	        if ($('#' + self.options[i][0]).is(":checked")) {
	          optionsTrue.push(self.options[i]);
	        }
	      }
	      return optionsTrue;
	    };
	
	    var getValueOfCheckboxWithHigherPriority = function getValueOfCheckboxWithHigherPriority() {
	      var checkedOptions = getCheckedOptions();
	      if (checkedOptions.length === 0) {
	        return '';
	      }
	      return (0, _lodashCollectionSortBy2['default'])(checkedOptions, 'priority')[0][0];
	    };
	
	    $('#' + self.id + '_select').val(getValueOfCheckboxWithHigherPriority());
	
	    var is_exclusive = $(this).attr('is_exclusive') === 'true';
	    if (is_exclusive) {
	      var is_checked = $(this).is(':checked');
	      if (is_checked) {
	        var id = $(this).attr('id');
	        self.block_but(id);
	      } else {
	        self.unblock();
	      }
	    }
	  });
	};
	
	Routing_Checkboxes_Input.prototype.stop = function () {
	  $('#' + this.id).off();
	};
	
	Routing_Checkboxes_Input.prototype.to_html = function (value, locale) {
	
	  var self = this;
	  var bundle = (0, _webDomainGet_bundle2['default'])(locale).reducer;
	
	  var options = this.options.slice();
	
	  // Se c'è l'opzione altro aggiungo una option in ultima posizione
	  if (this.other) {
	    var other_option = [this.other.option_id, this.other_label || bundle.other];
	    options.push(other_option);
	  }
	
	  // I margini vanno sul contenitore
	  var styles = _jsdk2['default'].split_margins(this.style);
	
	  // Converto le option in una tabella a due colonne
	  // nella prima metto le checkbox, nella seconda le label
	  var option_to_table_row = function option_to_table_row(option) {
	    return '<div class="group-input">' + _jsdk2['default'].dom.checkbox({
	      id: option[0],
	      is_exclusive: option[2]
	    }) + '</div>' + '<div class="group-label">' + option[1] + '</div>';
	  };
	
	  var attrs = {
	    id: self.id,
	    style: styles.other
	  };
	
	  var html = _jsdk2['default'].dom.div(options.map(option_to_table_row).join(''), attrs);
	
	  // Se c'è l'opzione altro aggiungo una textbox alla fine
	  if (this.other) {
	    html += _jsdk2['default'].dom.textbox({
	      id: this.other.textbox_id
	    });
	  }
	
	  var _attrs = {
	    id: self.id + '_select',
	    'style': 'display: none'
	  };
	  var create_options = function create_options(option) {
	    return [option[0], option[1]];
	  };
	  var _options = [_jsdk2['default'].EMPTY_OPTION].concat(this.options.map(create_options));
	  html += _jsdk2['default'].dom.select_of_options(_options, _attrs, null);
	
	  return _jsdk2['default'].Form.wrap_input(this.id, html, styles.margins);
	};
	
	Routing_Checkboxes_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Routing_Checkboxes_Input.prototype.value = function (locale) {
	  //jsdk.assert(Locale.is(locale));
	  //recupero i valori delle checkbox
	  var option_values = this.options.map(function (option) {
	    return [option[0], $('#' + option[0]).is(':checked')];
	  });
	  if (this.other) {
	    // se c'è l'opzione altro recupero il valore della checkbox altro
	    option_values.push([this.other.option_id, $('#' + this.other.option_id).is(':checked')]);
	  }
	  option_values.push([this.id, $('#' + this.id + '_select').val()]);
	
	  //calcolo quanti sono i true per la validazione
	  var trues = option_values.filter(function (x) {
	    return x[1] === true;
	  });
	  var validation = this.schema.validate(trues);
	
	  if (validation.rule === null) {
	    if (this.other && option_values[option_values.length - 1][1]) {
	      // se l'utente ha selezionato anche l'opzione altro..
	      var textbox_id = this.other.textbox_id;
	      var textbox_value = $('#' + textbox_id).val(); // recupero il valore della textbox
	      var textbox_validation = this.other.schema.validate(textbox_value); // valido la textbox
	      if (textbox_validation.rule) {
	        // se la textbox non va bene, gli metto il focus
	        $('#' + textbox_id).focus();
	        validation = textbox_validation;
	      } else {
	        // se è andato tutto bene, concateno i valori delle checkbox e della textbox
	        option_values.push([textbox_id, textbox_validation.x]);
	        validation = new _webDomainValidation2['default']({ x: option_values });
	      }
	    } else {
	      validation = new _webDomainValidation2['default']({ x: option_values });
	    }
	  }
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('reducer/routing_checkboxes', Routing_Checkboxes_Input);
	
	exports['default'] = Routing_Checkboxes_Input;
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _webDomainStyleField_Style = __webpack_require__(226);
	
	var _webDomainStyleField_Style2 = _interopRequireDefault(_webDomainStyleField_Style);
	
	var _webDomainField_Target = __webpack_require__(227);
	
	var _webDomainField_Target2 = _interopRequireDefault(_webDomainField_Target);
	
	var _webDomainCountries = __webpack_require__(254);
	
	var _webDomainCountries2 = _interopRequireDefault(_webDomainCountries);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainValidation = __webpack_require__(196);
	
	var _webDomainValidation2 = _interopRequireDefault(_webDomainValidation);
	
	var _webDomainVerified = __webpack_require__(111);
	
	var _webDomainVerified2 = _interopRequireDefault(_webDomainVerified);
	
	var _webDomainRule = __webpack_require__(197);
	
	var _webDomainRule2 = _interopRequireDefault(_webDomainRule);
	
	var _webDomainGet_bundle = __webpack_require__(49);
	
	var _webDomainGet_bundle2 = _interopRequireDefault(_webDomainGet_bundle);
	
	var _std_table = function _std_table(data) {
	  return '<table class="std-table">' + data.map(function (pair) {
	    _jsdk2['default'].assert(!_jsdk2['default'].Nil.is(pair[0]));
	    return pair[1] ? '<tr><td class="std-table-label">' + pair[0] + '</td><td class="std-table-value">' + _jsdk2['default'].escape_html(pair[1]) + '</td></tr>' : '';
	  }).join('') + '</table>';
	};
	
	var Field_Component_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  style: _webDomainStyleField_Style2['default'],
	  targets: _tcomb2['default'].list(_webDomainField_Target2['default']),
	  owner: _tcomb2['default'].Str
	}, 'Field_Component_Input');
	
	/*
	function Field_Component_Input(id, style, targets, owner) {
	  jsdk.assert(jsdk.UUID.is(id));
	  jsdk.assert(Field_Style.is(style));
	  jsdk.assert(jsdk.List(Field_Target).is(targets));
	  jsdk.assert(jsdk.Str.is(owner));
	  this.type = 'reducer/field';
	  this.id = id;
	  this.style = style;
	  this.targets = targets;
	  this.owner = owner;
	  return jsdk.freeze(this);
	}
	Field_Component_Input.is = function(x) {
	  return x instanceof Field_Component_Input;
	};
	Field_Component_Input.of = function(x) {
	  return new Field_Component_Input(
	    jsdk.UUID.of(x.id),
	    Field_Style.of(x.style),
	    jsdk.List(Field_Target).of(x.targets),
	    jsdk.Str.of(x.owner)
	  );
	};
	*/
	Field_Component_Input.prototype.to_html = function (value, locale, context) {
	  //jsdk.assert(jsdk.Obj.is(context));
	  //jsdk.assert(jsdk.Obj.is(context.fields));
	  var bundle = (0, _webDomainGet_bundle2['default'])(locale).reducer;
	  var data = this.targets.map(function (target) {
	    return ['<strong>' + bundle.targets[target.field] + '</strong>', context.fields[target.field]];
	  });
	  var targets = _std_table(data);
	
	  var styles = _jsdk2['default'].split_margins(this.style);
	
	  var html = _jsdk2['default'].dom.div(_jsdk2['default'].template(bundle.field)({
	    targets: targets,
	    owner: this.owner
	  }), {
	    id: this.id,
	    style: this.style
	  });
	
	  return _jsdk2['default'].Form.wrap_input(this.id, html, styles.margins);
	};
	
	Field_Component_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Field_Component_Input.prototype.value = function (locale, context) {
	  var _this = this;
	
	  var ret = null;
	  var isMobileRequest = function isMobileRequest() {
	    return _this.targets.some(function (target) {
	      return target.field === 'mobile';
	    });
	  };
	  if (_webDomainVerified2['default'].is(context.user) && isMobileRequest() && context.user.mobile_country !== locale.country) {
	    var prefix = _webDomainCountries2['default'].area(locale.country);
	    ret = new _webDomainValidation2['default']({ x: null, rule: new _webDomainRule2['default']({ name: 'mobile_number_not_allowed', args: [prefix] }) });
	    this.set_error(ret.rule ? ret.rule.localize(locale) : '');
	  }
	  if (!ret) {
	    ret = new _webDomainValidation2['default']({ x: this.targets.map(function (target) {
	        return [target.id, context.user[target.field]];
	      }), rule: null });
	  }
	  return ret;
	};
	_jsdk2['default'].Form.add_input('reducer/field', Field_Component_Input);
	
	exports['default'] = Field_Component_Input;
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainURL = __webpack_require__(160);
	
	var _webDomainURL2 = _interopRequireDefault(_webDomainURL);
	
	var _webDomainReducer = __webpack_require__(172);
	
	var _webDomainReducer2 = _interopRequireDefault(_webDomainReducer);
	
	var Gplus_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  url: _webDomainURL2['default'],
	  gplus_url: _tcomb2['default'].Str
	}, 'Gplus_Input');
	/*
	export default function Gplus_Input(id, url, gplus_url) {
	  jsdk.assert(jsdk.UUID.is(id));
	  jsdk.assert(jsdk.URL.is(url));
	  jsdk.assert(jsdk.Str.is(gplus_url));
	  this.type = 'reducer/gplus';
	  this.id = id;
	  this.url = url;
	  this.gplus_url = gplus_url;
	  return jsdk.freeze(this);
	}
	
	Gplus_Input.is = function(x) {
	  return x instanceof Gplus_Input;
	};
	
	Gplus_Input.of = function(x) {
	  jsdk.assert(jsdk.Obj.is(x));
	  return new Gplus_Input(
	    jsdk.UUID.of(x.id),
	    jsdk.URL.of(x.url),
	    jsdk.Str.of(x.gplus_url)
	  );
	};
	*/
	Gplus_Input.prototype.to_html = function (value, locale) {
	  var id = this.id;
	  var src = _jsdk2['default'].to_url(this.gplus_url, {
	    id: id,
	    url: this.url,
	    locale: locale
	  });
	  var html = '<div class="gplus-containter"><iframe src="' + src + '"></iframe></div>';
	  return _jsdk2['default'].Form.wrap_input(id, html, {});
	};
	
	Gplus_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Gplus_Input.prototype.value = function (locale) {
	  var id = this.id;
	  var b = _webDomainReducer2['default'].has_gplus(id);
	  var validation = new _jsdk2['default'].Bool_Schema([true]).validate(b);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('reducer/gplus', Gplus_Input);
	
	exports['default'] = Gplus_Input;
	module.exports = exports['default'];

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainURL = __webpack_require__(160);
	
	var _webDomainURL2 = _interopRequireDefault(_webDomainURL);
	
	var _webDomainReducer = __webpack_require__(172);
	
	var _webDomainReducer2 = _interopRequireDefault(_webDomainReducer);
	
	var Like_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  url: _webDomainURL2['default'],
	  like_url: _tcomb2['default'].Str
	}, 'Like_Input');
	/*
	export default function Like_Input(id, url, like_url) {
	  jsdk.assert(jsdk.UUID.is(id));
	  jsdk.assert(jsdk.URL.is(url));
	  jsdk.assert(jsdk.Str.is(like_url));
	  this.type = 'reducer/like';
	  this.id = id;
	  this.url = url;
	  this.like_url = like_url;
	  return jsdk.freeze(this);
	}
	
	Like_Input.is = function(x) {
	  return x instanceof Like_Input;
	};
	
	Like_Input.of = function(x) {
	  jsdk.assert(jsdk.Obj.is(x));
	  return new Like_Input(
	    jsdk.UUID.of(x.id),
	    jsdk.URL.of(x.url),
	    jsdk.Str.of(x.like_url)
	  );
	};
	*/
	Like_Input.prototype.to_html = function (value, locale) {
	  var id = this.id;
	  var src = _jsdk2['default'].to_url(this.like_url, {
	    id: id,
	    url: this.url,
	    locale: locale
	  });
	  var html = '<div class="like-containter"><iframe src="' + src + '"></iframe></div>';
	  return _jsdk2['default'].Form.wrap_input(id, html, {});
	};
	
	Like_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Like_Input.prototype.value = function (locale) {
	  var id = this.id;
	  var b = _webDomainReducer2['default'].prototype.has_like(id);
	  var validation = new _jsdk2['default'].Bool_Schema([true]).validate(b);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('reducer/like', Like_Input);
	
	exports['default'] = Like_Input;
	module.exports = exports['default'];

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainArr_Schema = __webpack_require__(218);
	
	var _webDomainArr_Schema2 = _interopRequireDefault(_webDomainArr_Schema);
	
	var _webDomainValidation = __webpack_require__(196);
	
	var _webDomainValidation2 = _interopRequireDefault(_webDomainValidation);
	
	var _webDomainStyleMatrix_Style = __webpack_require__(407);
	
	var _webDomainStyleMatrix_Style2 = _interopRequireDefault(_webDomainStyleMatrix_Style);
	
	var Matrix_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  style: _webDomainStyleMatrix_Style2['default'],
	  questions: _tcomb2['default'].list(_tcomb2['default'].tuple([_tcomb2['default'].Str, _tcomb2['default'].Str])),
	  options: _tcomb2['default'].list(_tcomb2['default'].tuple([_tcomb2['default'].Str, _tcomb2['default'].Str])),
	  schema: _webDomainArr_Schema2['default']
	}, 'Matrix_Input');
	
	Matrix_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Matrix_Input.prototype.focus = function () {
	  $('#' + this.id + ' [name=' + this.questions[0][0] + ']:nth(0)').focus();
	};
	Matrix_Input.prototype.to_html = function () {
	  var self = this;
	  var columns = this.options.map(function (option) {
	    return option[1];
	  });
	  columns.unshift('&nbsp;');
	  var rows = this.questions.map(function (question) {
	    var row = self.options.map(function (option) {
	      return _jsdk2['default'].dom.radio({
	        name: question[0],
	        value: option[0]
	      });
	    });
	    row.unshift(String(question[1]));
	    return row;
	  });
	  // i margini vanno sul contenitore
	  var styles = _jsdk2['default'].split_margins(this.style);
	  var html = '<div id="' + this.id + '" style="overflow: auto;">' + _jsdk2['default'].table(columns, rows, {
	    'class': ['table'],
	    style: styles.other
	  }) + '</div>';
	  return _jsdk2['default'].Form.wrap_input(this.id, html, styles.margins);
	};
	
	Matrix_Input.prototype.value = function (locale) {
	  //jsdk.assert(Locale.is(locale));
	  var self = this;
	  var values = [];
	  this.questions.forEach(function (question) {
	    values.push([question[0], $('#' + self.id + ' input[name=' + question[0] + ']:checked').val() || null]);
	  });
	
	  //calcolo quanti sono non nulli per la validazione
	  var not_nulls = values.filter(function (pair) {
	    return pair[1] !== null;
	  });
	  var validation = this.schema.validate(not_nulls);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation.rule ? validation : new _webDomainValidation2['default']({ x: values, rule: null });
	};
	
	_jsdk2['default'].Form.add_input('reducer/matrix', Matrix_Input);
	
	exports['default'] = Matrix_Input;
	module.exports = exports['default'];

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Margin_Bottom_Style = __webpack_require__(188);
	
	var _Margin_Bottom_Style2 = _interopRequireDefault(_Margin_Bottom_Style);
	
	var Matrix_Style = _Margin_Bottom_Style2['default'];
	
	module.exports = Matrix_Style;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainUUID = __webpack_require__(44);
	
	var _webDomainUUID2 = _interopRequireDefault(_webDomainUUID);
	
	var _webDomainValidation = __webpack_require__(196);
	
	var _webDomainValidation2 = _interopRequireDefault(_webDomainValidation);
	
	var _webDomainSelect_Other = __webpack_require__(204);
	
	var _webDomainSelect_Other2 = _interopRequireDefault(_webDomainSelect_Other);
	
	var _webDomainSelect_Render_As = __webpack_require__(203);
	
	var _webDomainSelect_Render_As2 = _interopRequireDefault(_webDomainSelect_Render_As);
	
	var _webDomainGet_bundle = __webpack_require__(49);
	
	var _webDomainGet_bundle2 = _interopRequireDefault(_webDomainGet_bundle);
	
	var _webDomainStr_Schema = __webpack_require__(193);
	
	var _webDomainStr_Schema2 = _interopRequireDefault(_webDomainStr_Schema);
	
	var _webDomainStyleMargin_Bottom_Style = __webpack_require__(188);
	
	var _webDomainStyleMargin_Bottom_Style2 = _interopRequireDefault(_webDomainStyleMargin_Bottom_Style);
	
	var Select_Component_Input = _tcomb2['default'].struct({
	  id: _webDomainUUID2['default'],
	  style: _webDomainStyleMargin_Bottom_Style2['default'],
	  options: _tcomb2['default'].list(_tcomb2['default'].tuple([_tcomb2['default'].Str, _tcomb2['default'].Str])),
	  schema: _webDomainStr_Schema2['default'],
	  render_as: _webDomainSelect_Render_As2['default'],
	  other: _tcomb2['default'].maybe(_webDomainSelect_Other2['default']),
	  other_label: _tcomb2['default'].maybe(_tcomb2['default'].String)
	}, 'Select_Component_Input');
	
	/*
	const Select_Component_Style = jsdk.Interface({
	  'margin-bottom': jsdk.Maybe(Style_Distance)
	});
	
	export default function Select_Component_Input(id, style, options, schema, render_as, other) {
	  jsdk.assert(jsdk.UUID.is(id));
	  jsdk.assert(Select_Component_Style.is(style));
	  jsdk.assert(jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str])).is(options));
	  jsdk.assert(jsdk.Str_Schema.is(schema));
	  jsdk.assert(Select_Render_As.is(render_as));
	  jsdk.assert(jsdk.Maybe(Select_Other).is(other));
	
	  this.type = 'reducer/select';
	  this.id = id;
	  this.style = style;
	  this.options = options;
	  this.schema = schema;
	  this.render_as = render_as;
	  this.other = other;
	  return jsdk.freeze(this);
	}
	
	Select_Component_Input.is = function(x) {
	  return x instanceof Select_Component_Input;
	};
	
	Select_Component_Input.of = function(x) {
	  jsdk.assert(jsdk.Obj.is(x));
	  return new Select_Component_Input(
	    jsdk.UUID.of(x.id),
	    Select_Component_Style.of(x.style),
	    jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str])).of(x.options),
	    jsdk.Str_Schema.of(x.schema),
	    Select_Render_As.of(x.render_as),
	    jsdk.Maybe(Select_Other).of(x.other)
	  );
	};
	*/
	
	Select_Component_Input.prototype.to_html = function (value, locale) {
	
	  // i margini vanno sul contenitore
	  var styles = _jsdk2['default'].split_margins(this.style);
	
	  var html = '';
	
	  if (this.render_as === 'textbox') {
	
	    html = _jsdk2['default'].dom.textbox({
	      id: this.id
	    });
	  } else {
	
	    var bundle = (0, _webDomainGet_bundle2['default'])(locale).reducer;
	
	    // faccio una copia in modo da non modificare l'originale
	    var options = this.options.slice();
	
	    // se c'è l'opziona altro aggiungo una option in ultima posizione
	    if (this.other) {
	      options.push([this.other.textbox_id, this.other_label || bundle.other]);
	    }
	
	    if (this.render_as === 'radio') {
	      html = _jsdk2['default'].radio_group(options, this.id, {
	        id: this.id,
	        style: styles.other
	      });
	    } else {
	      options.unshift(_jsdk2['default'].EMPTY_OPTION);
	      html = _jsdk2['default'].dom.select_of_options(options, {
	        id: this.id
	      });
	    }
	
	    // se c'è l'opzione altro aggiungo la textbox
	    if (this.other) {
	      html += _jsdk2['default'].dom.textbox({
	        id: this.other.textbox_id
	      });
	    }
	  }
	
	  return _jsdk2['default'].Form.wrap_input(this.id, html, styles.margins);
	};
	
	Select_Component_Input.prototype.focus = function () {
	
	  // nel caso l'utente abbia già selezionato una opzione non metto il focus
	  // questo evita di perdere il focus dalla textbox se c'è l'opzione altro
	  if (this.other && this.input() === this.other.textbox_id) {
	    return;
	  }
	
	  if (this.render_as === 'radio') {
	    // se è un gruppo di radio metto il focus sulla prima
	    $('#' + this.id + ' input[type=radio]:nth(0)').focus();
	  } else {
	    // altrimenti metto il focus sulla select o sulla textbox
	    $('#' + this.id).focus();
	  }
	};
	
	Select_Component_Input.prototype.input = function () {
	
	  if (this.render_as === 'radio') {
	
	    return $('#' + this.id + ' input[type=radio]:checked').val() || '';
	  } else if (this.render_as === 'select') {
	
	    return $('#' + this.id).val();
	  } else {
	
	    var text = $('#' + this.id).val();
	    if (text) {
	      var option = _jsdk2['default'].find(this.options, function (option) {
	        return option[1] === text;
	      });
	      return option ? option[0] : 'option_not_found';
	    }
	    return '';
	  }
	};
	
	Select_Component_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Select_Component_Input.prototype.value = function (locale) {
	  //jsdk.assert(Locale.is(locale));
	  // recupero il valore selezionato dall'utente e lo valido
	  var input = this.input();
	  var schema = this.schema;
	  if (this.render_as === 'textbox') {
	    schema = _jsdk2['default'].copy(schema);
	    schema.any = this.options.map(_jsdk2['default'].prop(0));
	    schema = _jsdk2['default'].Str_Schema.of(schema);
	  }
	  var validation = schema.validate(input);
	
	  if (validation.rule === null) {
	    // se c'è l'opzione altro e se l'utente l'ha selezionata..
	    if (this.other && input === this.other.textbox_id) {
	      var textbox_id = this.other.textbox_id;
	      // recupero il valore della textbox
	      var textbox_value = $('#' + textbox_id).val();
	      // valido la textbox
	      var textbox_validation = this.other.schema.validate(textbox_value);
	      if (textbox_validation.rule) {
	        // se la textbox non va bene, gli metto il focus
	        $('#' + textbox_id).focus();
	        validation = textbox_validation;
	      } else {
	        // se invece è andato tutto bene, concateno i valori della radio e della textbox
	        validation = new _webDomainValidation2['default']({ x: [[this.id, validation.x], [textbox_id, textbox_validation.x]] });
	      }
	    } else {
	      validation = new _webDomainValidation2['default']({ x: [[this.id, validation.x]] });
	    }
	  }
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('reducer/select', Select_Component_Input);
	
	exports['default'] = Select_Component_Input;
	module.exports = exports['default'];

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Checkbox_Input2 = __webpack_require__(410);
	
	var _Checkbox_Input3 = _interopRequireDefault(_Checkbox_Input2);
	
	exports.Checkbox_Input = _Checkbox_Input3['default'];
	
	var _Date_Input2 = __webpack_require__(412);
	
	var _Date_Input3 = _interopRequireDefault(_Date_Input2);
	
	exports.Date_Input = _Date_Input3['default'];
	
	var _Radio_Input2 = __webpack_require__(413);
	
	var _Radio_Input3 = _interopRequireDefault(_Radio_Input2);
	
	exports.Radio_Input = _Radio_Input3['default'];
	
	var _Select_Input2 = __webpack_require__(414);
	
	var _Select_Input3 = _interopRequireDefault(_Select_Input2);
	
	exports.Select_Input = _Select_Input3['default'];
	
	var _Textbox_Input2 = __webpack_require__(415);
	
	var _Textbox_Input3 = _interopRequireDefault(_Textbox_Input2);
	
	exports.Textbox_Input = _Textbox_Input3['default'];

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainBool_Schema = __webpack_require__(411);
	
	var _webDomainBool_Schema2 = _interopRequireDefault(_webDomainBool_Schema);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var Checkbox_Input = _tcomb2['default'].struct({
	  id: _tcomb2['default'].Str,
	  schema: _webDomainBool_Schema2['default'],
	  attrs: _tcomb2['default'].maybe(_tcomb2['default'].Obj),
	  hint: _tcomb2['default'].maybe(_tcomb2['default'].Str)
	}, 'Checkbox_Input');
	
	/*
	
	function Checkbox_Input(id, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(Bool_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'checkbox';
	  this.id = id;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Checkbox_Input.is = function(x) {
	  return x instanceof Checkbox_Input;
	};
	
	Checkbox_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Checkbox_Input(
	    Str.of(x.id),
	    Bool_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	*/
	Checkbox_Input.prototype.to_html = function (value) {
	  //t.assert(t.maybe(JSON_Value).is(value));
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var attrs = !_tcomb2['default'].Nil.is(this.attrs) ? _jsdk2['default'].copy(this.attrs) : {};
	  attrs.id = id;
	  attrs.checked = value;
	  var styles = _jsdk2['default'].split_margins(attrs.style);
	  attrs.style = styles.other;
	  return _jsdk2['default'].Form.wrap_input(id, _jsdk2['default'].dom.checkbox(attrs), styles.margins, this.hint);
	};
	
	Checkbox_Input.prototype.focus = function () {
	  $('#' + this.id).focus();
	};
	
	Checkbox_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Checkbox_Input.prototype.value = function (locale) {
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var checked = $('#' + id).is(':checked');
	  var validation = this.schema.validate(checked, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('checkbox', Checkbox_Input);
	
	module.exports = Checkbox_Input;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Validation_Monad = __webpack_require__(195);
	
	var _Validation_Monad2 = _interopRequireDefault(_Validation_Monad);
	
	var Bool_Schema = _tcomb2['default'].struct({
	  any: _tcomb2['default'].maybe(_tcomb2['default'].list(_tcomb2['default'].Bool))
	}, 'Bool_Schema');
	
	Bool_Schema.prototype.validate = function (b) {
	  b = _tcomb2['default'].Boolean(b);
	
	  var actions = [];
	  actions.push(_Validation_Monad2['default'].bool);
	  if (!_tcomb2['default'].Nil.is(this.any)) {
	    actions.push(_Validation_Monad2['default'].any(this.any, false));
	  }
	  return _Validation_Monad2['default'].pipe(b, actions);
	};
	module.exports = Bool_Schema;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainDate_Schema = __webpack_require__(214);
	
	var _webDomainDate_Schema2 = _interopRequireDefault(_webDomainDate_Schema);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var Date_Input = _tcomb2['default'].struct({
	  id: _tcomb2['default'].Str,
	  is_accurate: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  schema: _webDomainDate_Schema2['default'],
	  attrs: _tcomb2['default'].maybe(_tcomb2['default'].Obj),
	  hint: _tcomb2['default'].maybe(_tcomb2['default'].Str)
	}, 'Date_Input');
	
	/*
	function Date_Input(id, is_accurate, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(Maybe(Bool).is(is_accurate));
	  assert(Date_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'date';
	  this.id = id;
	  this.is_accurate = is_accurate;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	
	
	Date_Input.is = function(x) {
	  return x instanceof Date_Input;
	};
	
	Date_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Date_Input(
	    Str.of(x.id),
	    Maybe(Bool).of(x.is_accurate),
	    Date_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	*/
	Date_Input.prototype.to_html = function (value, locale) {
	  //t.assert(t.maybe(JSON_Value).is(value));
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var order = this.is_accurate ? locale.locale_bundle().date.accurate_order : locale.locale_bundle().date.order;
	  var attrs = !_tcomb2['default'].Nil.is(this.attrs) ? _jsdk2['default'].copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = _jsdk2['default'].split_margins(attrs.style);
	  attrs.style = styles.other;
	  return _jsdk2['default'].Form.wrap_input(id, _jsdk2['default'].date(attrs, value, order), styles.margins, this.hint);
	};
	
	Date_Input.prototype.focus = function () {
	  $('#' + this.id).children().get(0).focus();
	};
	
	Date_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Date_Input.prototype.value = function (locale) {
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var value = [$('#' + id + " .years").val(), $('#' + id + " .months").val(), $('#' + id + " .days").val()];
	  if (this.is_accurate) {
	    value.push($('#' + id + " .hours").val(), $('#' + id + " .minutes").val());
	  }
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('date', Date_Input);
	
	exports['default'] = Date_Input;
	module.exports = exports['default'];

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainDate_Schema = __webpack_require__(214);
	
	var _webDomainDate_Schema2 = _interopRequireDefault(_webDomainDate_Schema);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var Radio_Input = _tcomb2['default'].struct({
	  id: _tcomb2['default'].Str,
	  options: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  schema: _webDomainDate_Schema2['default'],
	  attrs: _tcomb2['default'].maybe(_tcomb2['default'].Obj),
	  hint: _tcomb2['default'].maybe(_tcomb2['default'].Str)
	}, 'Radio_Input');
	/*
	
	function Radio_Input(id, options, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(List(Str_Option).is(options));
	  assert(Str_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'radio';
	  this.id = id;
	  this.options = options;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Radio_Input.is = function(x) {
	  return x instanceof Radio_Input;
	};
	
	Radio_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Radio_Input(
	    Str.of(x.id),
	    List(Str_Option).of(x.options),
	    Str_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	*/
	
	function radio_group(options, name, attrs, value) {
	  attrs = attrs || {};
	  attrs['class'] = attrs['class'] || [];
	
	  var opt = function opt(option) {
	    //t.assert([t.tuple([t.Str, t.Str])].is(option));
	    return '<div class="group-input">' + _jsdk2['default'].dom.radio({
	      value: option[0],
	      name: name,
	      checked: option[0] === value
	    }) + '</div><div class="group-label">' + option[1] + '</div>';
	  };
	
	  return _jsdk2['default'].dom.div(options.map(opt).join(''), attrs);
	}
	
	Radio_Input.prototype.to_html = function (value) {
	  //t.assert(t.maybe(JSON_Value).is(value));
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var attrs = !_tcomb2['default'].Nil.is(this.attrs) ? _jsdk2['default'].copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = _jsdk2['default'].split_margins(attrs.style);
	  attrs.style = styles.other;
	  return _jsdk2['default'].Form.wrap_input(id, radio_group(this.options, id, attrs, value), styles.margins, this.hint);
	};
	
	Radio_Input.prototype.focus = function () {
	  $('#' + this.id + ' input[type=radio]').get(0).focus();
	};
	
	Radio_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Radio_Input.prototype.value = function (locale) {
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var value = $('#' + id + ' input[type=radio]:checked').val() || "";
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('radio', Radio_Input);
	
	exports['default'] = Radio_Input;
	module.exports = exports['default'];

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _webDomainStr_Schema = __webpack_require__(193);
	
	var _webDomainStr_Schema2 = _interopRequireDefault(_webDomainStr_Schema);
	
	var Select_Input = _tcomb2['default'].struct({
	  id: _tcomb2['default'].Str,
	  options: _tcomb2['default'].list(_tcomb2['default'].tuple([_tcomb2['default'].Str, _tcomb2['default'].Str])),
	  schema: _webDomainStr_Schema2['default'],
	  attrs: _tcomb2['default'].maybe(_tcomb2['default'].Obj),
	  hint: _tcomb2['default'].maybe(_tcomb2['default'].Str)
	}, 'Select_Input');
	/*
	function Select_Input(id, options, schema, attrs, hint) {
	  assert(Str.is(id));
	  assert(List(Str_Option).is(options));
	  assert(Str_Schema.is(schema));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'select';
	  this.id = id;
	  this.options = options;
	  this.schema = schema;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Select_Input.is = function(x) {
	  return x instanceof Select_Input;
	};
	
	Select_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Select_Input(
	    Str.of(x.id),
	    List(Str_Option).of(x.options),
	    Str_Schema.of(x.schema),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	*/
	Select_Input.prototype.to_html = function (value) {
	  //t.assert(t.maybe(JSON_Value).is(value));
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var options = [_jsdk2['default'].EMPTY_OPTION].concat(this.options);
	  var attrs = !_tcomb2['default'].Nil.is(this.attrs) ? _jsdk2['default'].copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = _jsdk2['default'].split_margins(attrs.style);
	  attrs.style = styles.other;
	  return _jsdk2['default'].Form.wrap_input(id, _jsdk2['default'].dom.select_of_options(options, attrs, value), styles.margins, this.hint);
	};
	
	Select_Input.prototype.focus = function () {
	  $('#' + this.id).focus();
	};
	
	Select_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Select_Input.prototype.value = function (locale) {
	  //t.assert(Locale.is(locale));
	  var value = $('#' + this.id).val();
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('select', Select_Input);
	
	exports['default'] = Select_Input;
	module.exports = exports['default'];

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsdk = __webpack_require__(1);
	
	var _jsdk2 = _interopRequireDefault(_jsdk);
	
	var _tcomb = __webpack_require__(6);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _webDomainJSON_Value = __webpack_require__(230);
	
	var _webDomainJSON_Value2 = _interopRequireDefault(_webDomainJSON_Value);
	
	var _webDomainStr_Schema = __webpack_require__(193);
	
	var _webDomainStr_Schema2 = _interopRequireDefault(_webDomainStr_Schema);
	
	var _webDomainNum_Schema = __webpack_require__(200);
	
	var _webDomainNum_Schema2 = _interopRequireDefault(_webDomainNum_Schema);
	
	var Textbox_Input_Schema = _tcomb2['default'].union([_webDomainStr_Schema2['default'], _webDomainNum_Schema2['default']]);
	
	Textbox_Input_Schema.dispatch = function (obj) {
	  switch (obj.type) {
	    case 'string':
	      return _webDomainStr_Schema2['default'];
	    case 'number':
	      return _webDomainNum_Schema2['default'];
	  }
	  return obj.constructor;
	};
	
	var Textbox_Input = _tcomb2['default'].struct({
	  id: _tcomb2['default'].Str,
	  schema: Textbox_Input_Schema,
	  is_multiline: _tcomb2['default'].maybe(_tcomb2['default'].Bool),
	  attrs: _tcomb2['default'].maybe(_tcomb2['default'].Obj),
	  hint: _tcomb2['default'].maybe(_tcomb2['default'].Str)
	}, 'Textbox_Input');
	
	/*
	function Textbox_Input(id, schema, is_multiline, attrs, hint) {
	  assert(Str.is(id));
	  assert(Textbox_Input_Schema.is(schema));
	  assert(Maybe(Bool).is(is_multiline));
	  assert(Maybe(Obj).is(attrs));
	  assert(Maybe(Str).is(hint));
	  this.type = 'textbox';
	  this.id = id;
	  this.schema = schema;
	  this.is_multiline = is_multiline;
	  this.attrs = attrs;
	  this.hint = hint;
	  return freeze(this);
	}
	
	Textbox_Input.is = function(x) {
	  return x instanceof Textbox_Input;
	};
	
	Textbox_Input.of = function(x) {
	  assert(Obj.is(x));
	  return new Textbox_Input(
	    Str.of(x.id),
	    Textbox_Input_Schema.of(x.schema),
	    Maybe(Bool).of(x.is_multiline),
	    Maybe(Obj).of(x.attrs),
	    Maybe(Str).of(x.hint)
	  );
	};
	*/
	
	Textbox_Input.prototype.to_html = function (value, locale) {
	  //t.assert(t.maybe(JSON_Value).is(value));
	  //t.assert(Locale.is(locale));
	  var id = this.id;
	  var attrs = !_tcomb2['default'].Nil.is(this.attrs) ? _jsdk2['default'].copy(this.attrs) : {};
	  attrs.id = id;
	  var styles = _jsdk2['default'].split_margins(attrs.style);
	  attrs.style = styles.other;
	  if (this.is_multiline) {
	    return _jsdk2['default'].Form.wrap_input(id, _jsdk2['default'].dom.textarea(value, attrs), styles.margins, this.hint);
	  }
	  var jsdkLocale = _jsdk2['default'].Locale.of(locale.language + '_' + locale.country); //fixme
	  attrs.value = _webDomainJSON_Value2['default'].format(jsdkLocale, this.schema, value);
	  return _jsdk2['default'].Form.wrap_input(id, _jsdk2['default'].dom.textbox(attrs), styles.margins, this.hint);
	};
	
	Textbox_Input.prototype.focus = function () {
	  $('#' + this.id).focus();
	};
	
	Textbox_Input.prototype.set_error = function (message) {
	  $("#" + this.id + "_error").html(message);
	};
	
	Textbox_Input.prototype.value = function (locale) {
	  //jsdk.assert(Locale.is(locale));
	  var value = $('#' + this.id).val();
	  var validation = this.schema.validate(value, locale);
	  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
	  return validation;
	};
	
	_jsdk2['default'].Form.add_input('textbox', Textbox_Input);
	
	exports['default'] = Textbox_Input;
	module.exports = exports['default'];

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** product.min.js
 **/